/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddSitelinkSets
// ====================================================

export interface AddSitelinkSets_addSitelinkSets_addedSitelinkSets {
  __typename: "GdAddSitelinkSetPayloadItem";
  id: GraphQlLong;
}

export interface AddSitelinkSets_addSitelinkSets_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddSitelinkSets_addSitelinkSets_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddSitelinkSets_addSitelinkSets_validationResult {
  __typename: "GdValidationResult";
  errors: AddSitelinkSets_addSitelinkSets_validationResult_errors[];
  warnings: AddSitelinkSets_addSitelinkSets_validationResult_warnings[];
}

export interface AddSitelinkSets_addSitelinkSets {
  __typename: "GdAddSitelinkSetsPayload";
  addedSitelinkSets: (AddSitelinkSets_addSitelinkSets_addedSitelinkSets | null)[];
  validationResult: AddSitelinkSets_addSitelinkSets_validationResult | null;
}

export interface AddSitelinkSets_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface AddSitelinkSets {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addSitelinkSets: AddSitelinkSets_addSitelinkSets;
  getClientMutationId: AddSitelinkSets_getClientMutationId;
}

export interface AddSitelinkSetsVariables {
  input: GdAddSitelinkSetsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateAdPrices
// ====================================================

export interface updateAdPrices_updateAdPrices_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface updateAdPrices_updateAdPrices {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (updateAdPrices_updateAdPrices_updatedAds | null)[];
}

export interface updateAdPrices {
  updateAdPrices: updateAdPrices_updateAdPrices;
}

export interface updateAdPricesVariables {
  input: GdUpdateAdPriceInput[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAdsMutation
// ====================================================

export interface UpdateAdsMutation_updateAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface UpdateAdsMutation_updateAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateAdsMutation_updateAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateAdsMutation_updateAds_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateAdsMutation_updateAds_validationResult_errors[];
  warnings: UpdateAdsMutation_updateAds_validationResult_warnings[];
}

export interface UpdateAdsMutation_updateAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (UpdateAdsMutation_updateAds_updatedAds | null)[];
  validationResult: UpdateAdsMutation_updateAds_validationResult | null;
}

export interface UpdateAdsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface UpdateAdsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateAds: UpdateAdsMutation_updateAds;
  getClientMutationId: UpdateAdsMutation_getClientMutationId;
}

export interface UpdateAdsMutationVariables {
  input: GdUpdateAdsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAdsMutation
// ====================================================

export interface AddAdsMutation_addAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface AddAdsMutation_addAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddAdsMutation_addAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddAdsMutation_addAds_validationResult {
  __typename: "GdValidationResult";
  errors: AddAdsMutation_addAds_validationResult_errors[];
  warnings: AddAdsMutation_addAds_validationResult_warnings[];
}

export interface AddAdsMutation_addAds {
  __typename: "GdAddAdsPayload";
  addedAds: (AddAdsMutation_addAds_addedAds | null)[];
  validationResult: AddAdsMutation_addAds_validationResult | null;
}

export interface AddAdsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface AddAdsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addAds: AddAdsMutation_addAds;
  getClientMutationId: AddAdsMutation_getClientMutationId;
}

export interface AddAdsMutationVariables {
  input: GdAddAdsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveAdsMutation
// ====================================================

export interface SaveAdsMutation_addAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_addAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_addAds_validationResult_errors[];
  warnings: SaveAdsMutation_addAds_validationResult_warnings[];
}

export interface SaveAdsMutation_addAds {
  __typename: "GdAddAdsPayload";
  addedAds: (SaveAdsMutation_addAds_addedAds | null)[];
  validationResult: SaveAdsMutation_addAds_validationResult | null;
}

export interface SaveAdsMutation_updateAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_updateAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_updateAds_validationResult_errors[];
  warnings: SaveAdsMutation_updateAds_validationResult_warnings[];
}

export interface SaveAdsMutation_updateAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (SaveAdsMutation_updateAds_updatedAds | null)[];
  validationResult: SaveAdsMutation_updateAds_validationResult | null;
}

export interface SaveAdsMutation_updateSmartAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_updateSmartAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateSmartAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateSmartAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_updateSmartAds_validationResult_errors[];
  warnings: SaveAdsMutation_updateSmartAds_validationResult_warnings[];
}

export interface SaveAdsMutation_updateSmartAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (SaveAdsMutation_updateSmartAds_updatedAds | null)[];
  validationResult: SaveAdsMutation_updateSmartAds_validationResult | null;
}

export interface SaveAdsMutation_addSmartAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_addSmartAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addSmartAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addSmartAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_addSmartAds_validationResult_errors[];
  warnings: SaveAdsMutation_addSmartAds_validationResult_warnings[];
}

export interface SaveAdsMutation_addSmartAds {
  __typename: "GdAddAdsPayload";
  addedAds: (SaveAdsMutation_addSmartAds_addedAds | null)[];
  validationResult: SaveAdsMutation_addSmartAds_validationResult | null;
}

export interface SaveAdsMutation_addCpmAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_addCpmAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addCpmAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addCpmAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_addCpmAds_validationResult_errors[];
  warnings: SaveAdsMutation_addCpmAds_validationResult_warnings[];
}

export interface SaveAdsMutation_addCpmAds {
  __typename: "GdAddAdsPayload";
  addedAds: (SaveAdsMutation_addCpmAds_addedAds | null)[];
  validationResult: SaveAdsMutation_addCpmAds_validationResult | null;
}

export interface SaveAdsMutation_updateCpmAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_updateCpmAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateCpmAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateCpmAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_updateCpmAds_validationResult_errors[];
  warnings: SaveAdsMutation_updateCpmAds_validationResult_warnings[];
}

export interface SaveAdsMutation_updateCpmAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (SaveAdsMutation_updateCpmAds_updatedAds | null)[];
  validationResult: SaveAdsMutation_updateCpmAds_validationResult | null;
}

export interface SaveAdsMutation_addMcBannerAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_addMcBannerAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addMcBannerAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addMcBannerAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_addMcBannerAds_validationResult_errors[];
  warnings: SaveAdsMutation_addMcBannerAds_validationResult_warnings[];
}

export interface SaveAdsMutation_addMcBannerAds {
  __typename: "GdAddAdsPayload";
  addedAds: (SaveAdsMutation_addMcBannerAds_addedAds | null)[];
  validationResult: SaveAdsMutation_addMcBannerAds_validationResult | null;
}

export interface SaveAdsMutation_updateMcBannerAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_updateMcBannerAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateMcBannerAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateMcBannerAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_updateMcBannerAds_validationResult_errors[];
  warnings: SaveAdsMutation_updateMcBannerAds_validationResult_warnings[];
}

export interface SaveAdsMutation_updateMcBannerAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (SaveAdsMutation_updateMcBannerAds_updatedAds | null)[];
  validationResult: SaveAdsMutation_updateMcBannerAds_validationResult | null;
}

export interface SaveAdsMutation_addContentPromotionAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_addContentPromotionAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addContentPromotionAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_addContentPromotionAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_addContentPromotionAds_validationResult_errors[];
  warnings: SaveAdsMutation_addContentPromotionAds_validationResult_warnings[];
}

export interface SaveAdsMutation_addContentPromotionAds {
  __typename: "GdAddAdsPayload";
  addedAds: (SaveAdsMutation_addContentPromotionAds_addedAds | null)[];
  validationResult: SaveAdsMutation_addContentPromotionAds_validationResult | null;
}

export interface SaveAdsMutation_updateContentPromotionAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveAdsMutation_updateContentPromotionAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateContentPromotionAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_updateContentPromotionAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_updateContentPromotionAds_validationResult_errors[];
  warnings: SaveAdsMutation_updateContentPromotionAds_validationResult_warnings[];
}

export interface SaveAdsMutation_updateContentPromotionAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (SaveAdsMutation_updateContentPromotionAds_updatedAds | null)[];
  validationResult: SaveAdsMutation_updateContentPromotionAds_validationResult | null;
}

export interface SaveAdsMutation_deleteAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_deleteAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdsMutation_deleteAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdsMutation_deleteAds_validationResult_errors[];
  warnings: SaveAdsMutation_deleteAds_validationResult_warnings[];
}

export interface SaveAdsMutation_deleteAds {
  __typename: "GdAdsMassActionPayload";
  validationResult: SaveAdsMutation_deleteAds_validationResult | null;
}

export interface SaveAdsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface SaveAdsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addAds: SaveAdsMutation_addAds;
  updateAds: SaveAdsMutation_updateAds;
  updateSmartAds: SaveAdsMutation_updateSmartAds;
  addSmartAds: SaveAdsMutation_addSmartAds;
  addCpmAds: SaveAdsMutation_addCpmAds;
  updateCpmAds: SaveAdsMutation_updateCpmAds;
  addMcBannerAds: SaveAdsMutation_addMcBannerAds;
  updateMcBannerAds: SaveAdsMutation_updateMcBannerAds;
  addContentPromotionAds: SaveAdsMutation_addContentPromotionAds;
  updateContentPromotionAds: SaveAdsMutation_updateContentPromotionAds;
  deleteAds: SaveAdsMutation_deleteAds;
  getClientMutationId: SaveAdsMutation_getClientMutationId;
}

export interface SaveAdsMutationVariables {
  addInput: GdAddAdsInput;
  updateInput: GdUpdateAdsInput;
  updateSmartAds: GdUpdateSmartAdsInput;
  smartAds: GdAddSmartAdsInput;
  addCpmAdsInput: GdAddCpmAdsInput;
  updateCpmAdsInput: GdUpdateCpmAdsInput;
  deleteInput: GdAdsMassActionInput;
  addMcBannerInput: GdAddMcBannerAdsInput;
  updateMcBannerInput: GdUpdateMcBannerAdsInput;
  addContentPromotionAdsInput: GdAddContentPromotionAdsInput;
  updateContentPromotionAdsInput: GdUpdateContentPromotionAdsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveInternalAdsMutation
// ====================================================

export interface SaveInternalAdsMutation_addInternalAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveInternalAdsMutation_addInternalAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveInternalAdsMutation_addInternalAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveInternalAdsMutation_addInternalAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveInternalAdsMutation_addInternalAds_validationResult_errors[];
  warnings: SaveInternalAdsMutation_addInternalAds_validationResult_warnings[];
}

export interface SaveInternalAdsMutation_addInternalAds {
  __typename: "GdAddAdsPayload";
  addedAds: (SaveInternalAdsMutation_addInternalAds_addedAds | null)[];
  validationResult: SaveInternalAdsMutation_addInternalAds_validationResult | null;
}

export interface SaveInternalAdsMutation_updateInternalAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface SaveInternalAdsMutation_updateInternalAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveInternalAdsMutation_updateInternalAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveInternalAdsMutation_updateInternalAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveInternalAdsMutation_updateInternalAds_validationResult_errors[];
  warnings: SaveInternalAdsMutation_updateInternalAds_validationResult_warnings[];
}

export interface SaveInternalAdsMutation_updateInternalAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (SaveInternalAdsMutation_updateInternalAds_updatedAds | null)[];
  validationResult: SaveInternalAdsMutation_updateInternalAds_validationResult | null;
}

export interface SaveInternalAdsMutation_deleteAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveInternalAdsMutation_deleteAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveInternalAdsMutation_deleteAds_validationResult {
  __typename: "GdValidationResult";
  errors: SaveInternalAdsMutation_deleteAds_validationResult_errors[];
  warnings: SaveInternalAdsMutation_deleteAds_validationResult_warnings[];
}

export interface SaveInternalAdsMutation_deleteAds {
  __typename: "GdAdsMassActionPayload";
  validationResult: SaveInternalAdsMutation_deleteAds_validationResult | null;
}

export interface SaveInternalAdsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface SaveInternalAdsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addInternalAds: SaveInternalAdsMutation_addInternalAds;
  updateInternalAds: SaveInternalAdsMutation_updateInternalAds;
  deleteAds: SaveInternalAdsMutation_deleteAds;
  getClientMutationId: SaveInternalAdsMutation_getClientMutationId;
}

export interface SaveInternalAdsMutationVariables {
  addInput: GdAddInternalAdsInput;
  updateInput: GdUpdateInternalAdsInput;
  deleteInput: GdAdsMassActionInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddVCards
// ====================================================

export interface AddVCards_addVcards_addedVcards {
  __typename: "GdAddVcardsPayloadItem";
  id: GraphQlLong;
}

export interface AddVCards_addVcards_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddVCards_addVcards_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddVCards_addVcards_validationResult {
  __typename: "GdValidationResult";
  errors: AddVCards_addVcards_validationResult_errors[];
  warnings: AddVCards_addVcards_validationResult_warnings[];
}

export interface AddVCards_addVcards {
  __typename: "GdAddVcardsPayload";
  addedVcards: AddVCards_addVcards_addedVcards[];
  validationResult: AddVCards_addVcards_validationResult | null;
}

export interface AddVCards {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addVcards: AddVCards_addVcards;
}

export interface AddVCardsVariables {
  input: GdAddVcardsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ArchiveAds
// ====================================================

export interface ArchiveAds_archiveAds {
  __typename: "GdAdsMassActionPayload";
  processedAdIds: GraphQlLong[];
  skippedAdIds: GraphQlLong[];
}

export interface ArchiveAds {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  archiveAds: ArchiveAds_archiveAds;
}

export interface ArchiveAdsVariables {
  input: GdAdsMassActionInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UnarchiveAds
// ====================================================

export interface UnarchiveAds_unarchiveAds {
  __typename: "GdAdsMassActionPayload";
  processedAdIds: GraphQlLong[];
  skippedAdIds: GraphQlLong[];
}

export interface UnarchiveAds {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  unarchiveAds: UnarchiveAds_unarchiveAds;
}

export interface UnarchiveAdsVariables {
  input: GdAdsMassActionInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SuspendAds
// ====================================================

export interface SuspendAds_suspendAds {
  __typename: "GdAdsMassActionPayload";
  processedAdIds: GraphQlLong[];
  skippedAdIds: GraphQlLong[];
}

export interface SuspendAds {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  suspendAds: SuspendAds_suspendAds;
}

export interface SuspendAdsVariables {
  input: GdAdsMassActionInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResumeAds
// ====================================================

export interface ResumeAds_resumeAds {
  __typename: "GdAdsMassActionPayload";
  processedAdIds: GraphQlLong[];
  skippedAdIds: GraphQlLong[];
}

export interface ResumeAds {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  resumeAds: ResumeAds_resumeAds;
}

export interface ResumeAdsVariables {
  input: GdAdsMassActionInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteAds
// ====================================================

export interface DeleteAds_deleteAds {
  __typename: "GdAdsMassActionPayload";
  processedAdIds: GraphQlLong[];
  skippedAdIds: GraphQlLong[];
}

export interface DeleteAds {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  deleteAds: DeleteAds_deleteAds;
}

export interface DeleteAdsVariables {
  input: GdAdsMassActionInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateImageSmartCenters
// ====================================================

export interface UpdateImageSmartCenters_updateSmartCenters_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateImageSmartCenters_updateSmartCenters_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateImageSmartCenters_updateSmartCenters_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateImageSmartCenters_updateSmartCenters_validationResult_errors[];
  warnings: UpdateImageSmartCenters_updateSmartCenters_validationResult_warnings[];
}

export interface UpdateImageSmartCenters_updateSmartCenters_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UpdateImageSmartCenters_updateSmartCenters_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UpdateImageSmartCenters_updateSmartCenters_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UpdateImageSmartCenters_updateSmartCenters_image_formats {
  __typename: "GdImageFormat";
  imageSize: UpdateImageSmartCenters_updateSmartCenters_image_formats_imageSize;
  path: string;
  smartCenters: UpdateImageSmartCenters_updateSmartCenters_image_formats_smartCenters[] | null;
}

export interface UpdateImageSmartCenters_updateSmartCenters_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UpdateImageSmartCenters_updateSmartCenters_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: UpdateImageSmartCenters_updateSmartCenters_image_formats[] | null;
}

export interface UpdateImageSmartCenters_updateSmartCenters {
  __typename: "GdUpdateSmartCentersPayload";
  validationResult: UpdateImageSmartCenters_updateSmartCenters_validationResult | null;
  image: UpdateImageSmartCenters_updateSmartCenters_image;
}

export interface UpdateImageSmartCenters_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface UpdateImageSmartCenters {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateSmartCenters: UpdateImageSmartCenters_updateSmartCenters;
  getClientMutationId: UpdateImageSmartCenters_getClientMutationId;
}

export interface UpdateImageSmartCentersVariables {
  input: GdUpdateSmartCentersInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateVideoAddition
// ====================================================

export interface GenerateVideoAddition_generateVideoAddition {
  __typename: "GdSmartCreative" | "GdCanvasCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  previewUrl: string;
  width: GraphQlLong | null;
}

export interface GenerateVideoAddition {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  generateVideoAddition: (GenerateVideoAddition_generateVideoAddition | null)[] | null;
}

export interface GenerateVideoAdditionVariables {
  input: GdGenerateVideoAdditionInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RejectAutoOrganizations
// ====================================================

export interface RejectAutoOrganizations_rejectAutoOrganizations_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface RejectAutoOrganizations_rejectAutoOrganizations_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface RejectAutoOrganizations_rejectAutoOrganizations_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface RejectAutoOrganizations_rejectAutoOrganizations_validationResult {
  __typename: "GdValidationResult";
  errors: RejectAutoOrganizations_rejectAutoOrganizations_validationResult_errors[];
  warnings: RejectAutoOrganizations_rejectAutoOrganizations_validationResult_warnings[];
}

export interface RejectAutoOrganizations_rejectAutoOrganizations {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (RejectAutoOrganizations_rejectAutoOrganizations_updatedAds | null)[];
  validationResult: RejectAutoOrganizations_rejectAutoOrganizations_validationResult | null;
}

export interface RejectAutoOrganizations {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * Мутация для отклонения привязки автоматически предложенной организации
   */
  rejectAutoOrganizations: RejectAutoOrganizations_rejectAutoOrganizations;
}

export interface RejectAutoOrganizationsVariables {
  permalinks: GdUpdateOrganizationInput[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveCallouts
// ====================================================

export interface SaveCallouts_saveCallouts_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveCallouts_saveCallouts_validationResult_warnings {
  __typename: "GdDefect";
  params: GraphQlObjectScalar | null;
  path: string;
  code: string;
}

export interface SaveCallouts_saveCallouts_validationResult {
  __typename: "GdValidationResult";
  errors: SaveCallouts_saveCallouts_validationResult_errors[];
  warnings: SaveCallouts_saveCallouts_validationResult_warnings[];
}

export interface SaveCallouts_saveCallouts {
  __typename: "GdSaveCalloutsPayload";
  calloutIds: GraphQlLong[];
  validationResult: SaveCallouts_saveCallouts_validationResult | null;
}

export interface SaveCallouts {
  saveCallouts: SaveCallouts_saveCallouts;
}

export interface SaveCalloutsVariables {
  input: GdSaveCalloutsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteCallouts
// ====================================================

export interface DeleteCallouts_deleteCallouts_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface DeleteCallouts_deleteCallouts_validationResult_warnings {
  __typename: "GdDefect";
  params: GraphQlObjectScalar | null;
  path: string;
  code: string;
}

export interface DeleteCallouts_deleteCallouts_validationResult {
  __typename: "GdValidationResult";
  errors: DeleteCallouts_deleteCallouts_validationResult_errors[];
  warnings: DeleteCallouts_deleteCallouts_validationResult_warnings[];
}

export interface DeleteCallouts_deleteCallouts {
  __typename: "GdDeleteCalloutsPayload";
  calloutIds: GraphQlLong[];
  validationResult: DeleteCallouts_deleteCallouts_validationResult | null;
}

export interface DeleteCallouts {
  deleteCallouts: DeleteCallouts_deleteCallouts;
}

export interface DeleteCalloutsVariables {
  input: GdDeleteCalloutsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCampaigns
// ====================================================

export interface UpdateCampaigns_updateCampaigns_updatedCampaigns {
  __typename: "GdUpdateCampaignPayloadItem";
  id: GraphQlLong;
}

export interface UpdateCampaigns_updateCampaigns_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateCampaigns_updateCampaigns_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateCampaigns_updateCampaigns_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateCampaigns_updateCampaigns_validationResult_errors[];
  warnings: UpdateCampaigns_updateCampaigns_validationResult_warnings[];
}

export interface UpdateCampaigns_updateCampaigns {
  __typename: "GdUpdateCampaignPayload";
  updatedCampaigns: (UpdateCampaigns_updateCampaigns_updatedCampaigns | null)[];
  validationResult: UpdateCampaigns_updateCampaigns_validationResult | null;
}

export interface UpdateCampaigns_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface UpdateCampaigns {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateCampaigns: UpdateCampaigns_updateCampaigns;
  getClientMutationId: UpdateCampaigns_getClientMutationId;
}

export interface UpdateCampaignsVariables {
  input: GdUpdateCampaignsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FindOrCreateExperimentsConditions
// ====================================================

export interface FindOrCreateExperimentsConditions_findOrCreateExperimentsConditions_addedConditions {
  __typename: "GdCreateRetargetingConditionForExperimentsPayloadItem";
  retargetingConditionId: GraphQlLong | null;
  statisticRetargetingConditionId: GraphQlLong;
}

export interface FindOrCreateExperimentsConditions_findOrCreateExperimentsConditions_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface FindOrCreateExperimentsConditions_findOrCreateExperimentsConditions_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface FindOrCreateExperimentsConditions_findOrCreateExperimentsConditions_validationResult {
  __typename: "GdValidationResult";
  errors: FindOrCreateExperimentsConditions_findOrCreateExperimentsConditions_validationResult_errors[];
  warnings: FindOrCreateExperimentsConditions_findOrCreateExperimentsConditions_validationResult_warnings[];
}

export interface FindOrCreateExperimentsConditions_findOrCreateExperimentsConditions {
  __typename: "GdCreateRetargetingConditionForExperimentsPayload";
  addedConditions: FindOrCreateExperimentsConditions_findOrCreateExperimentsConditions_addedConditions[] | null;
  validationResult: FindOrCreateExperimentsConditions_findOrCreateExperimentsConditions_validationResult | null;
}

export interface FindOrCreateExperimentsConditions_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface FindOrCreateExperimentsConditions {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  findOrCreateExperimentsConditions: FindOrCreateExperimentsConditions_findOrCreateExperimentsConditions;
  getClientMutationId: FindOrCreateExperimentsConditions_getClientMutationId;
}

export interface FindOrCreateExperimentsConditionsVariables {
  input: GdCreateRetargetingConditionForExperimentsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GetOrCreateMetrikaGoalsByCounter
// ====================================================

export interface GetOrCreateMetrikaGoalsByCounter_getOrCreateMetrikaGoalsByCounter_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  name: string;
  type: GdGoalType;
}

export interface GetOrCreateMetrikaGoalsByCounter_getOrCreateMetrikaGoalsByCounter_payForConversionGoals {
  __typename: "GdGoal";
  id: GraphQlLong;
  name: string;
  type: GdGoalType;
}

export interface GetOrCreateMetrikaGoalsByCounter_getOrCreateMetrikaGoalsByCounter {
  __typename: "GdMetrikaGoalsByCounterPayload";
  goals: GetOrCreateMetrikaGoalsByCounter_getOrCreateMetrikaGoalsByCounter_goals[] | null;
  payForConversionGoals: GetOrCreateMetrikaGoalsByCounter_getOrCreateMetrikaGoalsByCounter_payForConversionGoals[];
  isMetrikaAvailable: boolean;
}

export interface GetOrCreateMetrikaGoalsByCounter {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  getOrCreateMetrikaGoalsByCounter: GetOrCreateMetrikaGoalsByCounter_getOrCreateMetrikaGoalsByCounter;
}

export interface GetOrCreateMetrikaGoalsByCounterVariables {
  input: GdMetrikaGoalsByCounterInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddCampaigns
// ====================================================

export interface AddCampaigns_addCampaigns_addedCampaigns {
  __typename: "GdAddCampaignPayloadItem";
  id: GraphQlLong;
}

export interface AddCampaigns_addCampaigns_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddCampaigns_addCampaigns_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddCampaigns_addCampaigns_validationResult {
  __typename: "GdValidationResult";
  errors: AddCampaigns_addCampaigns_validationResult_errors[];
  warnings: AddCampaigns_addCampaigns_validationResult_warnings[];
}

export interface AddCampaigns_addCampaigns {
  __typename: "GdAddCampaignPayload";
  addedCampaigns: (AddCampaigns_addCampaigns_addedCampaigns | null)[];
  validationResult: AddCampaigns_addCampaigns_validationResult | null;
}

export interface AddCampaigns_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface AddCampaigns {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addCampaigns: AddCampaigns_addCampaigns;
  getClientMutationId: AddCampaigns_getClientMutationId;
}

export interface AddCampaignsVariables {
  input: GdAddCampaignsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteBrandLiftForCampaigns
// ====================================================

export interface DeleteBrandLiftForCampaigns_deleteBrandLiftForCampaigns {
  __typename: "GdCampaignIdsList";
  campaignIds: GraphQlLong[];
}

export interface DeleteBrandLiftForCampaigns {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  deleteBrandLiftForCampaigns: DeleteBrandLiftForCampaigns_deleteBrandLiftForCampaigns;
}

export interface DeleteBrandLiftForCampaignsVariables {
  input: GdCampaignIdsListInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddDialogMutation
// ====================================================

export interface AddDialogMutation_addDialog_dialog {
  __typename: "GdDialog";
  clientId: GraphQlLong;
  id: GraphQlLong | null;
  isActive: boolean;
  name: string;
  skillId: string;
}

export interface AddDialogMutation_addDialog_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddDialogMutation_addDialog_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddDialogMutation_addDialog_validationResult {
  __typename: "GdValidationResult";
  errors: AddDialogMutation_addDialog_validationResult_errors[];
  warnings: AddDialogMutation_addDialog_validationResult_warnings[];
}

export interface AddDialogMutation_addDialog {
  __typename: "GdAddDialogPayload";
  dialog: AddDialogMutation_addDialog_dialog | null;
  validationResult: AddDialogMutation_addDialog_validationResult | null;
}

export interface AddDialogMutation {
  addDialog: AddDialogMutation_addDialog;
}

export interface AddDialogMutationVariables {
  input: GdAddDialogRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RequestFlServiceByClientMutation
// ====================================================

export interface RequestFlServiceByClientMutation_requestFlServiceByClient_freelancerProject_freelancer {
  __typename: "GdFreelancerBase" | "GdFreelancerFull";
  login: string;
}

export interface RequestFlServiceByClientMutation_requestFlServiceByClient_freelancerProject {
  __typename: "GdFreelancerProject";
  id: GraphQlLong;
  startedTime: GraphQlLocalDateTime | null;
  createdTime: GraphQlLocalDateTime;
  freelancer: RequestFlServiceByClientMutation_requestFlServiceByClient_freelancerProject_freelancer | null;
}

export interface RequestFlServiceByClientMutation_requestFlServiceByClient {
  __typename: "GdRequestFlServiceByClientRequestPayload";
  freelancerId: GraphQlLong;
  clientId: GraphQlLong;
  freelancerProject: RequestFlServiceByClientMutation_requestFlServiceByClient_freelancerProject;
}

export interface RequestFlServiceByClientMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  requestFlServiceByClient: RequestFlServiceByClientMutation_requestFlServiceByClient;
}

export interface RequestFlServiceByClientMutationVariables {
  input: GdRequestFlServiceByClientRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AcceptFIServiceByFreelancerMutation
// ====================================================

export interface AcceptFIServiceByFreelancerMutation_acceptFlServiceByFreelancer_freelancerProject {
  __typename: "GdFreelancerProject";
  id: GraphQlLong;
  updatedTime: GraphQlLocalDateTime;
}

export interface AcceptFIServiceByFreelancerMutation_acceptFlServiceByFreelancer {
  __typename: "GdAcceptFlServiceByFreelancerRequestPayload";
  freelancerProject: AcceptFIServiceByFreelancerMutation_acceptFlServiceByFreelancer_freelancerProject;
}

export interface AcceptFIServiceByFreelancerMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  acceptFlServiceByFreelancer: AcceptFIServiceByFreelancerMutation_acceptFlServiceByFreelancer;
}

export interface AcceptFIServiceByFreelancerMutationVariables {
  input: GdAcceptFlServiceByFreelancerRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CancelFIServiceByFreelancerMutation
// ====================================================

export interface CancelFIServiceByFreelancerMutation_cancelFlServiceByFreelancer_freelancerProject {
  __typename: "GdFreelancerProject";
  id: GraphQlLong;
  updatedTime: GraphQlLocalDateTime;
}

export interface CancelFIServiceByFreelancerMutation_cancelFlServiceByFreelancer {
  __typename: "GdCancelFlServiceByFreelancerRequestPayload";
  freelancerProject: CancelFIServiceByFreelancerMutation_cancelFlServiceByFreelancer_freelancerProject;
}

export interface CancelFIServiceByFreelancerMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  cancelFlServiceByFreelancer: CancelFIServiceByFreelancerMutation_cancelFlServiceByFreelancer;
}

export interface CancelFIServiceByFreelancerMutationVariables {
  input: GdCancelFlServiceByFreelancerRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CancelFlServiceByClientMutation
// ====================================================

export interface CancelFlServiceByClientMutation_cancelFlServiceByClient_freelancerProject {
  __typename: "GdFreelancerProject";
  id: GraphQlLong;
  status: GdFreelancerProjectStatus;
}

export interface CancelFlServiceByClientMutation_cancelFlServiceByClient {
  __typename: "GdCancelFlServiceByClientRequestPayload";
  freelancerId: GraphQlLong;
  clientId: GraphQlLong;
  freelancerProject: CancelFlServiceByClientMutation_cancelFlServiceByClient_freelancerProject;
}

export interface CancelFlServiceByClientMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  cancelFlServiceByClient: CancelFlServiceByClientMutation_cancelFlServiceByClient;
}

export interface CancelFlServiceByClientMutationVariables {
  input: GdCancelFlServiceByClientRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateFreelancerStatusMutation
// ====================================================

export interface UpdateFreelancerStatusMutation_updateFreelancerStatus_freelancer {
  __typename: "GdFreelancerBase" | "GdFreelancerFull";
  status: GdFreelancerStatus;
}

export interface UpdateFreelancerStatusMutation_updateFreelancerStatus {
  __typename: "GdUpdateFreelancerCardRequestPayload";
  freelancer: UpdateFreelancerStatusMutation_updateFreelancerStatus_freelancer;
}

export interface UpdateFreelancerStatusMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateFreelancerStatus: UpdateFreelancerStatusMutation_updateFreelancerStatus;
}

export interface UpdateFreelancerStatusMutationVariables {
  input: GdUpdateFlStatusRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddFeedbackForFreelancerMutation
// ====================================================

export interface AddFeedbackForFreelancerMutation_addFeedbackForFreelancer_feedback_authorInfo {
  __typename: "GdUserPublicInfo";
  avatarUrl: string;
  login: string;
  name: string;
  userId: GraphQlLong;
}

export interface AddFeedbackForFreelancerMutation_addFeedbackForFreelancer_feedback {
  __typename: "GdFreelancerFeedback";
  authorInfo: AddFeedbackForFreelancerMutation_addFeedbackForFreelancer_feedback_authorInfo | null;
  authorUid: GraphQlLong;
  createdTime: GraphQlLocalDateTime;
  feedbackId: string;
  feedbackText: string;
  freelancerId: GraphQlLong;
  overallMark: GraphQlLong;
  willRecommend: boolean | null;
  moderationStatus: GdFreelancerUgcModerationStatus;
}

export interface AddFeedbackForFreelancerMutation_addFeedbackForFreelancer {
  __typename: "GdAddFeedbackForFreelancerPayload";
  feedback: AddFeedbackForFreelancerMutation_addFeedbackForFreelancer_feedback;
}

export interface AddFeedbackForFreelancerMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addFeedbackForFreelancer: AddFeedbackForFreelancerMutation_addFeedbackForFreelancer;
}

export interface AddFeedbackForFreelancerMutationVariables {
  input: GdAddFeedbackForFreelancerRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateFreelancerFeedbackMutation
// ====================================================

export interface UpdateFreelancerFeedbackMutation_updateFreelancerFeedback_feedback_authorInfo {
  __typename: "GdUserPublicInfo";
  avatarUrl: string;
  login: string;
  name: string;
  userId: GraphQlLong;
}

export interface UpdateFreelancerFeedbackMutation_updateFreelancerFeedback_feedback {
  __typename: "GdFreelancerFeedback";
  authorInfo: UpdateFreelancerFeedbackMutation_updateFreelancerFeedback_feedback_authorInfo | null;
  authorUid: GraphQlLong;
  createdTime: GraphQlLocalDateTime;
  feedbackId: string;
  feedbackText: string;
  freelancerId: GraphQlLong;
  overallMark: GraphQlLong;
  willRecommend: boolean | null;
  moderationStatus: GdFreelancerUgcModerationStatus;
}

export interface UpdateFreelancerFeedbackMutation_updateFreelancerFeedback {
  __typename: "GdUpdateFreelancerFeedbackPayload";
  feedback: UpdateFreelancerFeedbackMutation_updateFreelancerFeedback_feedback;
}

export interface UpdateFreelancerFeedbackMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateFreelancerFeedback: UpdateFreelancerFeedbackMutation_updateFreelancerFeedback;
}

export interface UpdateFreelancerFeedbackMutationVariables {
  input: GdUpdateFreelancerFeedbackRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteFreelancerFeedbackMutation
// ====================================================

export interface DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback_validationResult {
  __typename: "GdValidationResult";
  errors: DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback_validationResult_errors[];
  warnings: DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback_validationResult_warnings[];
}

export interface DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback {
  __typename: "GdDeleteFreelancerFeedbackPayload";
  feedbackId: string;
  validationResult: DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback_validationResult | null;
}

export interface DeleteFreelancerFeedbackMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  deleteFreelancerFeedback: DeleteFreelancerFeedbackMutation_deleteFreelancerFeedback;
}

export interface DeleteFreelancerFeedbackMutationVariables {
  input: GdDeleteFreelancerFeedbackRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateUserPhoneMutation
// ====================================================

export interface UpdateUserPhoneMutation_updateUserPhone_user {
  __typename: "GdUserInfo";
  phone: string | null;
}

export interface UpdateUserPhoneMutation_updateUserPhone {
  __typename: "GdUpdateUserPayload";
  user: UpdateUserPhoneMutation_updateUserPhone_user;
}

export interface UpdateUserPhoneMutation {
  /**
   * Обновление номера у subjectUser
   */
  updateUserPhone: UpdateUserPhoneMutation_updateUserPhone;
}

export interface UpdateUserPhoneMutationVariables {
  input: GdUpdateUserPhoneInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateFreelancerCardMutation
// ====================================================

export interface UpdateFreelancerCardMutation_updateFreelancerCard_validationResult_errors {
  __typename: "GdDefect";
  code: string;
}

export interface UpdateFreelancerCardMutation_updateFreelancerCard_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateFreelancerCardMutation_updateFreelancerCard_validationResult_errors[];
}

export interface UpdateFreelancerCardMutation_updateFreelancerCard {
  __typename: "GdUpdateFreelancerCardRequestPayload";
  validationResult: UpdateFreelancerCardMutation_updateFreelancerCard_validationResult | null;
}

export interface UpdateFreelancerCardMutation_updateFreelancerSkills_validationResult_errors {
  __typename: "GdDefect";
  code: string;
}

export interface UpdateFreelancerCardMutation_updateFreelancerSkills_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateFreelancerCardMutation_updateFreelancerSkills_validationResult_errors[];
}

export interface UpdateFreelancerCardMutation_updateFreelancerSkills {
  __typename: "GdUpdateFreelancerSkillsPayload";
  validationResult: UpdateFreelancerCardMutation_updateFreelancerSkills_validationResult | null;
}

export interface UpdateFreelancerCardMutation_updateFreelancer_validationResult_errors {
  __typename: "GdDefect";
  code: string;
}

export interface UpdateFreelancerCardMutation_updateFreelancer_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateFreelancerCardMutation_updateFreelancer_validationResult_errors[];
}

export interface UpdateFreelancerCardMutation_updateFreelancer {
  __typename: "GdUpdateFreelancerPayload";
  validationResult: UpdateFreelancerCardMutation_updateFreelancer_validationResult | null;
}

export interface UpdateFreelancerCardMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateFreelancerCard: UpdateFreelancerCardMutation_updateFreelancerCard;
  updateFreelancerSkills: UpdateFreelancerCardMutation_updateFreelancerSkills;
  updateFreelancer: UpdateFreelancerCardMutation_updateFreelancer;
}

export interface UpdateFreelancerCardMutationVariables {
  commonInput: GdUpdateFreelancerCardInput;
  skillsInput: GdUpdateFreelancerSkillInput;
  regionInput: GdUpdateFreelancerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: getMutationId
// ====================================================

export interface getMutationId_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface getMutationId {
  getClientMutationId: getMutationId_getClientMutationId;
}

export interface getMutationIdVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveAdGroup
// ====================================================

export interface SaveAdGroup_addTextAdGroups_addedAdGroupItems {
  __typename: "GdAddAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface SaveAdGroup_addTextAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdGroup_addTextAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdGroup_addTextAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdGroup_addTextAdGroups_validationResult_errors[];
  warnings: SaveAdGroup_addTextAdGroups_validationResult_warnings[];
}

export interface SaveAdGroup_addTextAdGroups {
  __typename: "GdAddAdGroupPayload";
  addedAdGroupItems: (SaveAdGroup_addTextAdGroups_addedAdGroupItems | null)[];
  validationResult: SaveAdGroup_addTextAdGroups_validationResult | null;
}

export interface SaveAdGroup_updateTextAdGroup_updatedAdGroupItems {
  __typename: "GdUpdateAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface SaveAdGroup_updateTextAdGroup_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdGroup_updateTextAdGroup_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdGroup_updateTextAdGroup_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdGroup_updateTextAdGroup_validationResult_errors[];
  warnings: SaveAdGroup_updateTextAdGroup_validationResult_warnings[];
}

export interface SaveAdGroup_updateTextAdGroup {
  __typename: "GdUpdateAdGroupPayload";
  updatedAdGroupItems: (SaveAdGroup_updateTextAdGroup_updatedAdGroupItems | null)[];
  validationResult: SaveAdGroup_updateTextAdGroup_validationResult | null;
}

export interface SaveAdGroup_updateSmartAdGroups_updatedAdGroupItems {
  __typename: "GdUpdateAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface SaveAdGroup_updateSmartAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdGroup_updateSmartAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdGroup_updateSmartAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdGroup_updateSmartAdGroups_validationResult_errors[];
  warnings: SaveAdGroup_updateSmartAdGroups_validationResult_warnings[];
}

export interface SaveAdGroup_updateSmartAdGroups {
  __typename: "GdUpdateAdGroupPayload";
  updatedAdGroupItems: (SaveAdGroup_updateSmartAdGroups_updatedAdGroupItems | null)[];
  validationResult: SaveAdGroup_updateSmartAdGroups_validationResult | null;
}

export interface SaveAdGroup_updateMcBannerAdGroup_updatedAdGroupItems {
  __typename: "GdUpdateAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface SaveAdGroup_updateMcBannerAdGroup_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdGroup_updateMcBannerAdGroup_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdGroup_updateMcBannerAdGroup_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdGroup_updateMcBannerAdGroup_validationResult_errors[];
  warnings: SaveAdGroup_updateMcBannerAdGroup_validationResult_warnings[];
}

export interface SaveAdGroup_updateMcBannerAdGroup {
  __typename: "GdUpdateAdGroupPayload";
  updatedAdGroupItems: (SaveAdGroup_updateMcBannerAdGroup_updatedAdGroupItems | null)[];
  validationResult: SaveAdGroup_updateMcBannerAdGroup_validationResult | null;
}

export interface SaveAdGroup_addContentPromotionAdGroups_addedAdGroupItems {
  __typename: "GdAddAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface SaveAdGroup_addContentPromotionAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdGroup_addContentPromotionAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdGroup_addContentPromotionAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdGroup_addContentPromotionAdGroups_validationResult_errors[];
  warnings: SaveAdGroup_addContentPromotionAdGroups_validationResult_warnings[];
}

export interface SaveAdGroup_addContentPromotionAdGroups {
  __typename: "GdAddAdGroupPayload";
  addedAdGroupItems: (SaveAdGroup_addContentPromotionAdGroups_addedAdGroupItems | null)[];
  validationResult: SaveAdGroup_addContentPromotionAdGroups_validationResult | null;
}

export interface SaveAdGroup_updateContentPromotionAdGroups_updatedAdGroupItems {
  __typename: "GdUpdateAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface SaveAdGroup_updateContentPromotionAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdGroup_updateContentPromotionAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface SaveAdGroup_updateContentPromotionAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: SaveAdGroup_updateContentPromotionAdGroups_validationResult_errors[];
  warnings: SaveAdGroup_updateContentPromotionAdGroups_validationResult_warnings[];
}

export interface SaveAdGroup_updateContentPromotionAdGroups {
  __typename: "GdUpdateAdGroupPayload";
  updatedAdGroupItems: (SaveAdGroup_updateContentPromotionAdGroups_updatedAdGroupItems | null)[];
  validationResult: SaveAdGroup_updateContentPromotionAdGroups_validationResult | null;
}

export interface SaveAdGroup_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface SaveAdGroup {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addTextAdGroups: SaveAdGroup_addTextAdGroups;
  updateTextAdGroup: SaveAdGroup_updateTextAdGroup;
  updateSmartAdGroups: SaveAdGroup_updateSmartAdGroups;
  updateMcBannerAdGroup: SaveAdGroup_updateMcBannerAdGroup;
  addContentPromotionAdGroups: SaveAdGroup_addContentPromotionAdGroups;
  updateContentPromotionAdGroups: SaveAdGroup_updateContentPromotionAdGroups;
  getClientMutationId: SaveAdGroup_getClientMutationId;
}

export interface SaveAdGroupVariables {
  textAddInput: GdAddTextAdGroupItemInput[];
  textUpdateInput: GdUpdateTextAdGroupItemInput[];
  smartUpdateInput: GdUpdatePerformanceAdGroupItemInput[];
  mcBannerUpdateInput: GdUpdateMcBannerAdGroupItemInput[];
  contentPromotionAddInput: GdAddContentPromotionAdGroupItemInput[];
  contentPromotionUpdateInput: GdUpdateContentPromotionAdGroupItemInput[];
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateTextAdGroup
// ====================================================

export interface CreateTextAdGroup_addTextAdGroups_addedAdGroupItems {
  __typename: "GdAddAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface CreateTextAdGroup_addTextAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface CreateTextAdGroup_addTextAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface CreateTextAdGroup_addTextAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: CreateTextAdGroup_addTextAdGroups_validationResult_errors[];
  warnings: CreateTextAdGroup_addTextAdGroups_validationResult_warnings[];
}

export interface CreateTextAdGroup_addTextAdGroups {
  __typename: "GdAddAdGroupPayload";
  addedAdGroupItems: (CreateTextAdGroup_addTextAdGroups_addedAdGroupItems | null)[];
  validationResult: CreateTextAdGroup_addTextAdGroups_validationResult | null;
}

export interface CreateTextAdGroup_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface CreateTextAdGroup {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addTextAdGroups: CreateTextAdGroup_addTextAdGroups;
  getClientMutationId: CreateTextAdGroup_getClientMutationId;
}

export interface CreateTextAdGroupVariables {
  textInput: GdAddTextAdGroupItemInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddSmartFilters
// ====================================================

export interface AddSmartFilters_addSmartFilters_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddSmartFilters_addSmartFilters_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddSmartFilters_addSmartFilters_validationResult {
  __typename: "GdValidationResult";
  errors: AddSmartFilters_addSmartFilters_validationResult_errors[];
  warnings: AddSmartFilters_addSmartFilters_validationResult_warnings[];
}

export interface AddSmartFilters_addSmartFilters {
  __typename: "GdAddSmartFiltersPayload";
  validationResult: AddSmartFilters_addSmartFilters_validationResult | null;
}

export interface AddSmartFilters_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface AddSmartFilters {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addSmartFilters: AddSmartFilters_addSmartFilters;
  getClientMutationId: AddSmartFilters_getClientMutationId;
}

export interface AddSmartFiltersVariables {
  input: GdAddSmartFiltersInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteSmartFilters
// ====================================================

export interface DeleteSmartFilters_deleteFilters_deletedItems {
  __typename: "GdDeleteSmartFilterPayloadItem";
  id: GraphQlLong | null;
}

export interface DeleteSmartFilters_deleteFilters_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface DeleteSmartFilters_deleteFilters_validationResult {
  __typename: "GdValidationResult";
  errors: DeleteSmartFilters_deleteFilters_validationResult_errors[];
}

export interface DeleteSmartFilters_deleteFilters {
  __typename: "GdDeleteSmartFilterPayload";
  deletedItems: (DeleteSmartFilters_deleteFilters_deletedItems | null)[];
  validationResult: DeleteSmartFilters_deleteFilters_validationResult | null;
}

export interface DeleteSmartFilters_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface DeleteSmartFilters {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  deleteFilters: DeleteSmartFilters_deleteFilters;
  getClientMutationId: DeleteSmartFilters_getClientMutationId;
}

export interface DeleteSmartFiltersVariables {
  input: GdDeleteSmartFilterInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSmartFilters
// ====================================================

export interface UpdateSmartFilters_updateFilters_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateSmartFilters_updateFilters_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateSmartFilters_updateFilters_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateSmartFilters_updateFilters_validationResult_errors[];
  warnings: UpdateSmartFilters_updateFilters_validationResult_warnings[];
}

export interface UpdateSmartFilters_updateFilters_updatedItems {
  __typename: "GdUpdateSmartFiltersPayloadItem";
  id: GraphQlLong;
}

export interface UpdateSmartFilters_updateFilters {
  __typename: "GdUpdateSmartFiltersPayload";
  validationResult: UpdateSmartFilters_updateFilters_validationResult | null;
  updatedItems: (UpdateSmartFilters_updateFilters_updatedItems | null)[];
}

export interface UpdateSmartFilters_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface UpdateSmartFilters {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateFilters: UpdateSmartFilters_updateFilters;
  getClientMutationId: UpdateSmartFilters_getClientMutationId;
}

export interface UpdateSmartFiltersVariables {
  input: GdUpdateSmartFiltersInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateMcBannerAdGroup
// ====================================================

export interface CreateMcBannerAdGroup_addMcBannerAdGroups_addedAdGroupItems {
  __typename: "GdAddAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface CreateMcBannerAdGroup_addMcBannerAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface CreateMcBannerAdGroup_addMcBannerAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface CreateMcBannerAdGroup_addMcBannerAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: CreateMcBannerAdGroup_addMcBannerAdGroups_validationResult_errors[];
  warnings: CreateMcBannerAdGroup_addMcBannerAdGroups_validationResult_warnings[];
}

export interface CreateMcBannerAdGroup_addMcBannerAdGroups {
  __typename: "GdAddAdGroupPayload";
  addedAdGroupItems: (CreateMcBannerAdGroup_addMcBannerAdGroups_addedAdGroupItems | null)[];
  validationResult: CreateMcBannerAdGroup_addMcBannerAdGroups_validationResult | null;
}

export interface CreateMcBannerAdGroup_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface CreateMcBannerAdGroup {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addMcBannerAdGroups: CreateMcBannerAdGroup_addMcBannerAdGroups;
  getClientMutationId: CreateMcBannerAdGroup_getClientMutationId;
}

export interface CreateMcBannerAdGroupVariables {
  mcBannerInput: GdAddMcBannerAdGroupItemInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateSmartAdGroup
// ====================================================

export interface CreateSmartAdGroup_addSmartAdGroups_addedAdGroupItems {
  __typename: "GdAddAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface CreateSmartAdGroup_addSmartAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface CreateSmartAdGroup_addSmartAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface CreateSmartAdGroup_addSmartAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: CreateSmartAdGroup_addSmartAdGroups_validationResult_errors[];
  warnings: CreateSmartAdGroup_addSmartAdGroups_validationResult_warnings[];
}

export interface CreateSmartAdGroup_addSmartAdGroups {
  __typename: "GdAddAdGroupPayload";
  addedAdGroupItems: (CreateSmartAdGroup_addSmartAdGroups_addedAdGroupItems | null)[];
  validationResult: CreateSmartAdGroup_addSmartAdGroups_validationResult | null;
}

export interface CreateSmartAdGroup_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface CreateSmartAdGroup {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addSmartAdGroups: CreateSmartAdGroup_addSmartAdGroups;
  getClientMutationId: CreateSmartAdGroup_getClientMutationId;
}

export interface CreateSmartAdGroupVariables {
  smartInput: GdAddSmartAdGroupItemInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateInternalAdGroups
// ====================================================

export interface updateInternalAdGroups_updateInternalAdGroups_updatedAdGroupItems {
  __typename: "GdUpdateAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface updateInternalAdGroups_updateInternalAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface updateInternalAdGroups_updateInternalAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface updateInternalAdGroups_updateInternalAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: updateInternalAdGroups_updateInternalAdGroups_validationResult_errors[];
  warnings: updateInternalAdGroups_updateInternalAdGroups_validationResult_warnings[];
}

export interface updateInternalAdGroups_updateInternalAdGroups {
  __typename: "GdUpdateAdGroupPayload";
  updatedAdGroupItems: (updateInternalAdGroups_updateInternalAdGroups_updatedAdGroupItems | null)[];
  validationResult: updateInternalAdGroups_updateInternalAdGroups_validationResult | null;
}

export interface updateInternalAdGroups {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateInternalAdGroups: updateInternalAdGroups_updateInternalAdGroups;
}

export interface updateInternalAdGroupsVariables {
  internalInput: GdUpdateInternalAdGroupsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoderateAdsCallouts
// ====================================================

export interface RemoderateAdsCallouts_remoderateAdsCallouts_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface RemoderateAdsCallouts_remoderateAdsCallouts_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface RemoderateAdsCallouts_remoderateAdsCallouts_validationResult {
  __typename: "GdValidationResult";
  errors: RemoderateAdsCallouts_remoderateAdsCallouts_validationResult_errors[];
  warnings: RemoderateAdsCallouts_remoderateAdsCallouts_validationResult_warnings[];
}

export interface RemoderateAdsCallouts_remoderateAdsCallouts {
  __typename: "GdRemoderateAdsCalloutsPayload";
  processedAdGroupIds: GraphQlLong[];
  skippedAdGroupIds: GraphQlLong[];
  validationResult: RemoderateAdsCallouts_remoderateAdsCallouts_validationResult | null;
}

export interface RemoderateAdsCallouts_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface RemoderateAdsCallouts {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  remoderateAdsCallouts: RemoderateAdsCallouts_remoderateAdsCallouts;
  getClientMutationId: RemoderateAdsCallouts_getClientMutationId;
}

export interface RemoderateAdsCalloutsVariables {
  input: GdRemoderateAdsCalloutsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: addInternalAdGroups
// ====================================================

export interface addInternalAdGroups_addInternalAdGroups_addedAdGroupItems {
  __typename: "GdAddAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface addInternalAdGroups_addInternalAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface addInternalAdGroups_addInternalAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface addInternalAdGroups_addInternalAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: addInternalAdGroups_addInternalAdGroups_validationResult_errors[];
  warnings: addInternalAdGroups_addInternalAdGroups_validationResult_warnings[];
}

export interface addInternalAdGroups_addInternalAdGroups {
  __typename: "GdAddAdGroupPayload";
  addedAdGroupItems: (addInternalAdGroups_addInternalAdGroups_addedAdGroupItems | null)[];
  validationResult: addInternalAdGroups_addInternalAdGroups_validationResult | null;
}

export interface addInternalAdGroups_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface addInternalAdGroups {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addInternalAdGroups: addInternalAdGroups_addInternalAdGroups;
  getClientMutationId: addInternalAdGroups_getClientMutationId;
}

export interface addInternalAdGroupsVariables {
  internalInput: GdAddInternalAdGroupsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CopyAdGroupsMutation
// ====================================================

export interface CopyAdGroupsMutation_copyAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface CopyAdGroupsMutation_copyAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface CopyAdGroupsMutation_copyAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: CopyAdGroupsMutation_copyAdGroups_validationResult_errors[];
  warnings: CopyAdGroupsMutation_copyAdGroups_validationResult_warnings[];
}

export interface CopyAdGroupsMutation_copyAdGroups {
  __typename: "GdCopyAdGroupsPayload";
  copiedAdGroupIds: GraphQlLong[];
  validationResult: CopyAdGroupsMutation_copyAdGroups_validationResult | null;
}

export interface CopyAdGroupsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface CopyAdGroupsMutation {
  copyAdGroups: CopyAdGroupsMutation_copyAdGroups;
  getClientMutationId: CopyAdGroupsMutation_getClientMutationId;
}

export interface CopyAdGroupsMutationVariables {
  input: GdCopyAdGroupsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCpmAdGroup
// ====================================================

export interface UpdateCpmAdGroup_saveCpmAdGroups_updatedAdGroupItems {
  __typename: "GdUpdateAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface UpdateCpmAdGroup_saveCpmAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateCpmAdGroup_saveCpmAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateCpmAdGroup_saveCpmAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateCpmAdGroup_saveCpmAdGroups_validationResult_errors[];
  warnings: UpdateCpmAdGroup_saveCpmAdGroups_validationResult_warnings[];
}

export interface UpdateCpmAdGroup_saveCpmAdGroups {
  __typename: "GdUpdateAdGroupPayload";
  updatedAdGroupItems: (UpdateCpmAdGroup_saveCpmAdGroups_updatedAdGroupItems | null)[];
  validationResult: UpdateCpmAdGroup_saveCpmAdGroups_validationResult | null;
}

export interface UpdateCpmAdGroup_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface UpdateCpmAdGroup {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  saveCpmAdGroups: UpdateCpmAdGroup_saveCpmAdGroups;
  getClientMutationId: UpdateCpmAdGroup_getClientMutationId;
}

export interface UpdateCpmAdGroupVariables {
  cpmInput: GdUpdateCpmAdGroupInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddContentPromotionAdGroupsMutation
// ====================================================

export interface AddContentPromotionAdGroupsMutation_addContentPromotionAdGroups_addedAdGroupItems {
  __typename: "GdAddAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface AddContentPromotionAdGroupsMutation_addContentPromotionAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddContentPromotionAdGroupsMutation_addContentPromotionAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddContentPromotionAdGroupsMutation_addContentPromotionAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: AddContentPromotionAdGroupsMutation_addContentPromotionAdGroups_validationResult_errors[];
  warnings: AddContentPromotionAdGroupsMutation_addContentPromotionAdGroups_validationResult_warnings[];
}

export interface AddContentPromotionAdGroupsMutation_addContentPromotionAdGroups {
  __typename: "GdAddAdGroupPayload";
  addedAdGroupItems: (AddContentPromotionAdGroupsMutation_addContentPromotionAdGroups_addedAdGroupItems | null)[];
  validationResult: AddContentPromotionAdGroupsMutation_addContentPromotionAdGroups_validationResult | null;
}

export interface AddContentPromotionAdGroupsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addContentPromotionAdGroups: AddContentPromotionAdGroupsMutation_addContentPromotionAdGroups;
}

export interface AddContentPromotionAdGroupsMutationVariables {
  contentPromotionInput: GdAddContentPromotionAdGroupInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateContentPromotionAdGroups
// ====================================================

export interface UpdateContentPromotionAdGroups_updateContentPromotionAdGroups_updatedAdGroupItems {
  __typename: "GdUpdateAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface UpdateContentPromotionAdGroups_updateContentPromotionAdGroups_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateContentPromotionAdGroups_updateContentPromotionAdGroups_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateContentPromotionAdGroups_updateContentPromotionAdGroups_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateContentPromotionAdGroups_updateContentPromotionAdGroups_validationResult_errors[];
  warnings: UpdateContentPromotionAdGroups_updateContentPromotionAdGroups_validationResult_warnings[];
}

export interface UpdateContentPromotionAdGroups_updateContentPromotionAdGroups {
  __typename: "GdUpdateAdGroupPayload";
  updatedAdGroupItems: (UpdateContentPromotionAdGroups_updateContentPromotionAdGroups_updatedAdGroupItems | null)[];
  validationResult: UpdateContentPromotionAdGroups_updateContentPromotionAdGroups_validationResult | null;
}

export interface UpdateContentPromotionAdGroups {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateContentPromotionAdGroups: UpdateContentPromotionAdGroups_updateContentPromotionAdGroups;
}

export interface UpdateContentPromotionAdGroupsVariables {
  contentPromotionInput: GdUpdateContentPromotionAdGroupInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAdGroupRegions
// ====================================================

export interface UpdateAdGroupRegions_updateAdGroupRegions_updatedAdGroupItems {
  __typename: "GdUpdateAdGroupPayloadItem";
  adGroupId: GraphQlLong;
}

export interface UpdateAdGroupRegions_updateAdGroupRegions_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateAdGroupRegions_updateAdGroupRegions_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateAdGroupRegions_updateAdGroupRegions_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateAdGroupRegions_updateAdGroupRegions_validationResult_errors[];
  warnings: UpdateAdGroupRegions_updateAdGroupRegions_validationResult_warnings[];
}

export interface UpdateAdGroupRegions_updateAdGroupRegions {
  __typename: "GdUpdateAdGroupRegionsPayload";
  updatedAdGroupItems: (UpdateAdGroupRegions_updateAdGroupRegions_updatedAdGroupItems | null)[];
  skippedAdGroupIds: (GraphQlLong | null)[];
  validationResult: UpdateAdGroupRegions_updateAdGroupRegions_validationResult | null;
}

export interface UpdateAdGroupRegions {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateAdGroupRegions: UpdateAdGroupRegions_updateAdGroupRegions;
}

export interface UpdateAdGroupRegionsVariables {
  input: GdUpdateAdGroupRegionsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: addMinusKeywordsPacks
// ====================================================

export interface addMinusKeywordsPacks_addMinusKeywordsPacks_addedItems {
  __typename: "GdAddMinusKeywordsPacksPayloadItem";
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
}

export interface addMinusKeywordsPacks_addMinusKeywordsPacks_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface addMinusKeywordsPacks_addMinusKeywordsPacks_validationResult {
  __typename: "GdValidationResult";
  errors: addMinusKeywordsPacks_addMinusKeywordsPacks_validationResult_errors[];
}

export interface addMinusKeywordsPacks_addMinusKeywordsPacks {
  __typename: "GdAddMinusKeywordsPacksPayload";
  addedItems: (addMinusKeywordsPacks_addMinusKeywordsPacks_addedItems | null)[];
  validationResult: addMinusKeywordsPacks_addMinusKeywordsPacks_validationResult | null;
}

export interface addMinusKeywordsPacks {
  /**
   * Создание набора минус-фраз
   */
  addMinusKeywordsPacks: addMinusKeywordsPacks_addMinusKeywordsPacks;
}

export interface addMinusKeywordsPacksVariables {
  input: GdAddMinusKeywordsPacksInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateMinusKeywordsPacks
// ====================================================

export interface updateMinusKeywordsPacks_updateMinusKeywordsPacks_updatedItems {
  __typename: "GdUpdateMinusKeywordsPacksPayloadItem";
  id: GraphQlLong;
  name: string;
  minusKeywords: string[];
}

export interface updateMinusKeywordsPacks_updateMinusKeywordsPacks_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface updateMinusKeywordsPacks_updateMinusKeywordsPacks_validationResult {
  __typename: "GdValidationResult";
  errors: updateMinusKeywordsPacks_updateMinusKeywordsPacks_validationResult_errors[];
}

export interface updateMinusKeywordsPacks_updateMinusKeywordsPacks {
  __typename: "GdUpdateMinusKeywordsPacksPayload";
  updatedItems: (updateMinusKeywordsPacks_updateMinusKeywordsPacks_updatedItems | null)[];
  validationResult: updateMinusKeywordsPacks_updateMinusKeywordsPacks_validationResult | null;
}

export interface updateMinusKeywordsPacks {
  /**
   * Изменение набора минус-фраз
   */
  updateMinusKeywordsPacks: updateMinusKeywordsPacks_updateMinusKeywordsPacks;
}

export interface updateMinusKeywordsPacksVariables {
  input: GdUpdateMinusKeywordsPacksInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteMinusKeywordsPacks
// ====================================================

export interface deleteMinusKeywordsPacks_deleteMinusKeywordsPacks_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface deleteMinusKeywordsPacks_deleteMinusKeywordsPacks_validationResult {
  __typename: "GdValidationResult";
  errors: deleteMinusKeywordsPacks_deleteMinusKeywordsPacks_validationResult_errors[];
}

export interface deleteMinusKeywordsPacks_deleteMinusKeywordsPacks {
  __typename: "GdDeleteMinusKeywordsPacksPayload";
  deletedPackIds: GraphQlLong[];
  validationResult: deleteMinusKeywordsPacks_deleteMinusKeywordsPacks_validationResult | null;
}

export interface deleteMinusKeywordsPacks {
  /**
   * Удаление набора минус-фраз
   */
  deleteMinusKeywordsPacks: deleteMinusKeywordsPacks_deleteMinusKeywordsPacks;
}

export interface deleteMinusKeywordsPacksVariables {
  input: GdDeleteMinusKeywordsPacksInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateAdGroupMinusKeywords
// ====================================================

export interface updateAdGroupMinusKeywords_updateAdGroupMinusKeywords {
  __typename: "GdUpdateAdGroupMinusKeywordsPayload";
  updatedAdGroupIds: GraphQlLong[];
}

export interface updateAdGroupMinusKeywords {
  updateAdGroupMinusKeywords: updateAdGroupMinusKeywords_updateAdGroupMinusKeywords;
}

export interface updateAdGroupMinusKeywordsVariables {
  input: GdUpdateAdGroupMinusKeywordsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateOrganizations
// ====================================================

export interface UpdateOrganizations_updateOrganizations_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface UpdateOrganizations_updateOrganizations_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateOrganizations_updateOrganizations_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateOrganizations_updateOrganizations_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateOrganizations_updateOrganizations_validationResult_errors[];
  warnings: UpdateOrganizations_updateOrganizations_validationResult_warnings[];
}

export interface UpdateOrganizations_updateOrganizations {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (UpdateOrganizations_updateOrganizations_updatedAds | null)[];
  validationResult: UpdateOrganizations_updateOrganizations_validationResult | null;
}

export interface UpdateOrganizations {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * Мутация для массового обновления организаций на баннерах
   */
  updateOrganizations: UpdateOrganizations_updateOrganizations;
}

export interface UpdateOrganizationsVariables {
  input: GdUpdateOrganizationInput[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FindAndReplaceKeywordsMutation
// ====================================================

export interface FindAndReplaceKeywordsMutation_findAndReplaceKeywords_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface FindAndReplaceKeywordsMutation_findAndReplaceKeywords_validationResult {
  __typename: "GdValidationResult";
  errors: FindAndReplaceKeywordsMutation_findAndReplaceKeywords_validationResult_errors[];
}

export interface FindAndReplaceKeywordsMutation_findAndReplaceKeywords {
  __typename: "GdFindAndReplaceKeywordsPayload";
  cacheKey: string;
  updatedTotalCount: number;
  validationResult: FindAndReplaceKeywordsMutation_findAndReplaceKeywords_validationResult | null;
}

export interface FindAndReplaceKeywordsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface FindAndReplaceKeywordsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  findAndReplaceKeywords: FindAndReplaceKeywordsMutation_findAndReplaceKeywords;
  getClientMutationId: FindAndReplaceKeywordsMutation_getClientMutationId;
}

export interface FindAndReplaceKeywordsMutationVariables {
  input: GdFindAndReplaceKeywordsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteKeywordsMutation
// ====================================================

export interface DeleteKeywordsMutation_deleteKeywords_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface DeleteKeywordsMutation_deleteKeywords_validationResult {
  __typename: "GdValidationResult";
  errors: DeleteKeywordsMutation_deleteKeywords_validationResult_errors[];
}

export interface DeleteKeywordsMutation_deleteKeywords {
  __typename: "GdDeleteKeywordsPayload";
  deletedKeywordIds: GraphQlLong[];
  validationResult: DeleteKeywordsMutation_deleteKeywords_validationResult | null;
}

export interface DeleteKeywordsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface DeleteKeywordsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  deleteKeywords: DeleteKeywordsMutation_deleteKeywords;
  getClientMutationId: DeleteKeywordsMutation_getClientMutationId;
}

export interface DeleteKeywordsMutationVariables {
  input: GdDeleteKeywordsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UnsuspendKeywordsMutation
// ====================================================

export interface UnsuspendKeywordsMutation_unsuspendKeywords_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface UnsuspendKeywordsMutation_unsuspendKeywords_validationResult {
  __typename: "GdValidationResult";
  errors: UnsuspendKeywordsMutation_unsuspendKeywords_validationResult_errors[];
}

export interface UnsuspendKeywordsMutation_unsuspendKeywords {
  __typename: "GdUnsuspendKeywordsPayload";
  unsuspendedKeywordIds: GraphQlLong[];
  validationResult: UnsuspendKeywordsMutation_unsuspendKeywords_validationResult | null;
}

export interface UnsuspendKeywordsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface UnsuspendKeywordsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  unsuspendKeywords: UnsuspendKeywordsMutation_unsuspendKeywords;
  getClientMutationId: UnsuspendKeywordsMutation_getClientMutationId;
}

export interface UnsuspendKeywordsMutationVariables {
  input: GdUnsuspendKeywordsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SuspendKeywordsMutation
// ====================================================

export interface SuspendKeywordsMutation_suspendKeywords_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface SuspendKeywordsMutation_suspendKeywords_validationResult {
  __typename: "GdValidationResult";
  errors: SuspendKeywordsMutation_suspendKeywords_validationResult_errors[];
}

export interface SuspendKeywordsMutation_suspendKeywords {
  __typename: "GdSuspendKeywordsPayload";
  suspendedKeywordIds: GraphQlLong[];
  validationResult: SuspendKeywordsMutation_suspendKeywords_validationResult | null;
}

export interface SuspendKeywordsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface SuspendKeywordsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  suspendKeywords: SuspendKeywordsMutation_suspendKeywords;
  getClientMutationId: SuspendKeywordsMutation_getClientMutationId;
}

export interface SuspendKeywordsMutationVariables {
  input: GdSuspendKeywordsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateKeywordsMutation
// ====================================================

export interface UpdateKeywordsMutation_updateKeywords_updatedKeywords {
  __typename: "GdUpdateKeywordsPayloadItem";
  id: GraphQlLong;
}

export interface UpdateKeywordsMutation_updateKeywords_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface UpdateKeywordsMutation_updateKeywords_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateKeywordsMutation_updateKeywords_validationResult_errors[];
}

export interface UpdateKeywordsMutation_updateKeywords {
  __typename: "GdUpdateKeywordsPayload";
  updatedKeywords: UpdateKeywordsMutation_updateKeywords_updatedKeywords[];
  validationResult: UpdateKeywordsMutation_updateKeywords_validationResult | null;
}

export interface UpdateKeywordsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface UpdateKeywordsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateKeywords: UpdateKeywordsMutation_updateKeywords;
  getClientMutationId: UpdateKeywordsMutation_getClientMutationId;
}

export interface UpdateKeywordsMutationVariables {
  input: GdUpdateKeywordsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddKeywordsMutation
// ====================================================

export interface AddKeywordsMutation_addKeywords_addedItems {
  __typename: "GdAddKeywordsPayloadItem";
  keywordId: GraphQlLong;
}

export interface AddKeywordsMutation_addKeywords_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface AddKeywordsMutation_addKeywords_validationResult {
  __typename: "GdValidationResult";
  errors: AddKeywordsMutation_addKeywords_validationResult_errors[];
}

export interface AddKeywordsMutation_addKeywords {
  __typename: "GdAddKeywordsPayload";
  addedItems: AddKeywordsMutation_addKeywords_addedItems[];
  validationResult: AddKeywordsMutation_addKeywords_validationResult | null;
}

export interface AddKeywordsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface AddKeywordsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addKeywords: AddKeywordsMutation_addKeywords;
  getClientMutationId: AddKeywordsMutation_getClientMutationId;
}

export interface AddKeywordsMutationVariables {
  input: GdAddKeywordsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAdGroupMinusKeywordsMutation
// ====================================================

export interface AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords_addedItems {
  __typename: "GdAddAdGroupMinusKeywordsPayloadItem";
  adGroupId: GraphQlLong;
}

export interface AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords_validationResult {
  __typename: "GdValidationResult";
  errors: AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords_validationResult_errors[];
}

export interface AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords {
  __typename: "GdAddAdGroupMinusKeywordsPayload";
  addedItems: AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords_addedItems[];
  validationResult: AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords_validationResult | null;
}

export interface AddAdGroupMinusKeywordsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface AddAdGroupMinusKeywordsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addAdGroupMinusKeywords: AddAdGroupMinusKeywordsMutation_addAdGroupMinusKeywords;
  getClientMutationId: AddAdGroupMinusKeywordsMutation_getClientMutationId;
}

export interface AddAdGroupMinusKeywordsMutationVariables {
  input: GdAddAdGroupMinusKeywordsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePricePackages
// ====================================================

export interface UpdatePricePackages_updatePricePackages_updatedItems {
  __typename: "GdUpdatePricePackagesPayloadItem";
  id: GraphQlLong;
}

export interface UpdatePricePackages_updatePricePackages_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdatePricePackages_updatePricePackages_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdatePricePackages_updatePricePackages_validationResult {
  __typename: "GdValidationResult";
  errors: UpdatePricePackages_updatePricePackages_validationResult_errors[];
  warnings: UpdatePricePackages_updatePricePackages_validationResult_warnings[];
}

export interface UpdatePricePackages_updatePricePackages {
  __typename: "GdUpdatePricePackagesPayload";
  updatedItems: (UpdatePricePackages_updatePricePackages_updatedItems | null)[];
  validationResult: UpdatePricePackages_updatePricePackages_validationResult | null;
}

export interface UpdatePricePackages {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * Обновление прайсовых пакетов
   */
  updatePricePackages: UpdatePricePackages_updatePricePackages | null;
}

export interface UpdatePricePackagesVariables {
  input: GdUpdatePricePackagesInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddPricePackage
// ====================================================

export interface AddPricePackage_addPricePackages_addedItems {
  __typename: "GdAddPricePackagePayloadItem";
  id: GraphQlLong;
}

export interface AddPricePackage_addPricePackages_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddPricePackage_addPricePackages_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddPricePackage_addPricePackages_validationResult {
  __typename: "GdValidationResult";
  errors: AddPricePackage_addPricePackages_validationResult_errors[];
  warnings: AddPricePackage_addPricePackages_validationResult_warnings[];
}

export interface AddPricePackage_addPricePackages {
  __typename: "GdAddPricePackagesPayload";
  addedItems: (AddPricePackage_addPricePackages_addedItems | null)[];
  validationResult: AddPricePackage_addPricePackages_validationResult | null;
}

export interface AddPricePackage {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * Создание прайсовых пакетов
   */
  addPricePackages: AddPricePackage_addPricePackages | null;
}

export interface AddPricePackageVariables {
  input: GdAddPricePackagesInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setBidsMutation
// ====================================================

export interface setBidsMutation_setBids_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface setBidsMutation_setBids_validationResult {
  __typename: "GdValidationResult";
  errors: setBidsMutation_setBids_validationResult_errors[];
}

export interface setBidsMutation_setBids {
  __typename: "GdSetBidsPayload";
  showConditionIds: GraphQlLong[];
  validationResult: setBidsMutation_setBids_validationResult | null;
}

export interface setBidsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface setBidsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  setBids: setBidsMutation_setBids;
  getClientMutationId: setBidsMutation_getClientMutationId;
}

export interface setBidsMutationVariables {
  input: GdSetBidsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setAutoBidsMutation
// ====================================================

export interface setAutoBidsMutation_setAutoBids_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface setAutoBidsMutation_setAutoBids_validationResult {
  __typename: "GdValidationResult";
  errors: setAutoBidsMutation_setAutoBids_validationResult_errors[];
}

export interface setAutoBidsMutation_setAutoBids {
  __typename: "GdSetAutoBidsPayload";
  keywordIds: GraphQlLong[];
  validationResult: setAutoBidsMutation_setAutoBids_validationResult | null;
}

export interface setAutoBidsMutation_setMcBannerAutoBids_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface setAutoBidsMutation_setMcBannerAutoBids_validationResult {
  __typename: "GdValidationResult";
  errors: setAutoBidsMutation_setMcBannerAutoBids_validationResult_errors[];
}

export interface setAutoBidsMutation_setMcBannerAutoBids {
  __typename: "GdSetAutoBidsPayload";
  keywordIds: GraphQlLong[];
  validationResult: setAutoBidsMutation_setMcBannerAutoBids_validationResult | null;
}

export interface setAutoBidsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface setAutoBidsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  setAutoBids: setAutoBidsMutation_setAutoBids;
  setMcBannerAutoBids: setAutoBidsMutation_setMcBannerAutoBids;
  getClientMutationId: setAutoBidsMutation_getClientMutationId;
}

export interface setAutoBidsMutationVariables {
  input: GdSetAutoBidsInput;
  mcBannerInput: GdSetAutoBidsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: executeRecommendationMutation
// ====================================================

export interface executeRecommendationMutation_executeRecommendation_items {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface executeRecommendationMutation_executeRecommendation {
  __typename: "GdExecuteRecommedationsPayload";
  items: executeRecommendationMutation_executeRecommendation_items[];
}

export interface executeRecommendationMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  executeRecommendation: executeRecommendationMutation_executeRecommendation;
}

export interface executeRecommendationMutationVariables {
  input: GdExecuteRecommedationsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateRetargetingConditionsMutation
// ====================================================

export interface UpdateRetargetingConditionsMutation_updateRetargetingConditions_rowset {
  __typename: "GdUpdateRetargetingConditionPayloadItem";
  retargetingConditionId: GraphQlLong;
}

export interface UpdateRetargetingConditionsMutation_updateRetargetingConditions_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  params: GraphQlObjectScalar | null;
  code: string;
}

export interface UpdateRetargetingConditionsMutation_updateRetargetingConditions_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateRetargetingConditionsMutation_updateRetargetingConditions_validationResult_errors[];
}

export interface UpdateRetargetingConditionsMutation_updateRetargetingConditions {
  __typename: "GdResult_GdUpdateRetargetingConditionPayloadItem";
  rowset: (UpdateRetargetingConditionsMutation_updateRetargetingConditions_rowset | null)[];
  validationResult: UpdateRetargetingConditionsMutation_updateRetargetingConditions_validationResult | null;
}

export interface UpdateRetargetingConditionsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  updateRetargetingConditions: UpdateRetargetingConditionsMutation_updateRetargetingConditions;
}

export interface UpdateRetargetingConditionsMutationVariables {
  input: GdUpdateRetargetingConditionsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateRetargetingConditionsMutation
// ====================================================

export interface CreateRetargetingConditionsMutation_createRetargetingConditions_rowset {
  __typename: "GdCreateRetargetingConditionPayloadItem";
  retargetingConditionId: GraphQlLong;
}

export interface CreateRetargetingConditionsMutation_createRetargetingConditions_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  params: GraphQlObjectScalar | null;
  code: string;
}

export interface CreateRetargetingConditionsMutation_createRetargetingConditions_validationResult {
  __typename: "GdValidationResult";
  errors: CreateRetargetingConditionsMutation_createRetargetingConditions_validationResult_errors[];
}

export interface CreateRetargetingConditionsMutation_createRetargetingConditions {
  __typename: "GdResult_GdCreateRetargetingConditionPayloadItem";
  rowset: (CreateRetargetingConditionsMutation_createRetargetingConditions_rowset | null)[];
  validationResult: CreateRetargetingConditionsMutation_createRetargetingConditions_validationResult | null;
}

export interface CreateRetargetingConditionsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  createRetargetingConditions: CreateRetargetingConditionsMutation_createRetargetingConditions;
}

export interface CreateRetargetingConditionsMutationVariables {
  input: GdCreateRetargetingConditionsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RetargetingCommonPriceEditorMutation
// ====================================================

export interface RetargetingCommonPriceEditorMutation_setBidsRetargeting_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface RetargetingCommonPriceEditorMutation_setBidsRetargeting_validationResult {
  __typename: "GdValidationResult";
  errors: RetargetingCommonPriceEditorMutation_setBidsRetargeting_validationResult_errors[];
}

export interface RetargetingCommonPriceEditorMutation_setBidsRetargeting {
  __typename: "GdSetBidsPayload";
  showConditionIds: GraphQlLong[];
  validationResult: RetargetingCommonPriceEditorMutation_setBidsRetargeting_validationResult | null;
}

export interface RetargetingCommonPriceEditorMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface RetargetingCommonPriceEditorMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  setBidsRetargeting: RetargetingCommonPriceEditorMutation_setBidsRetargeting;
  getClientMutationId: RetargetingCommonPriceEditorMutation_getClientMutationId;
}

export interface RetargetingCommonPriceEditorMutationVariables {
  input: GdSetBidsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResumeRetargetingsMutation
// ====================================================

export interface ResumeRetargetingsMutation_resumeRetargetings_rowset {
  __typename: "GdResumeRetargetingsPayloadItem";
  retargetingId: GraphQlLong | null;
}

export interface ResumeRetargetingsMutation_resumeRetargetings_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface ResumeRetargetingsMutation_resumeRetargetings_validationResult_warnings {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface ResumeRetargetingsMutation_resumeRetargetings_validationResult {
  __typename: "GdValidationResult";
  errors: ResumeRetargetingsMutation_resumeRetargetings_validationResult_errors[];
  warnings: ResumeRetargetingsMutation_resumeRetargetings_validationResult_warnings[];
}

export interface ResumeRetargetingsMutation_resumeRetargetings {
  __typename: "GdResult_GdResumeRetargetingsPayloadItem";
  successCount: number;
  totalCount: number;
  rowset: (ResumeRetargetingsMutation_resumeRetargetings_rowset | null)[];
  validationResult: ResumeRetargetingsMutation_resumeRetargetings_validationResult | null;
}

export interface ResumeRetargetingsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface ResumeRetargetingsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  resumeRetargetings: ResumeRetargetingsMutation_resumeRetargetings;
  getClientMutationId: ResumeRetargetingsMutation_getClientMutationId;
}

export interface ResumeRetargetingsMutationVariables {
  input: GdResumeRetargetingsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SuspendRetargetingsMutation
// ====================================================

export interface SuspendRetargetingsMutation_suspendRetargetings_rowset {
  __typename: "GdSuspendRetargetingsPayloadItem";
  retargetingId: GraphQlLong;
}

export interface SuspendRetargetingsMutation_suspendRetargetings_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface SuspendRetargetingsMutation_suspendRetargetings_validationResult_warnings {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface SuspendRetargetingsMutation_suspendRetargetings_validationResult {
  __typename: "GdValidationResult";
  errors: SuspendRetargetingsMutation_suspendRetargetings_validationResult_errors[];
  warnings: SuspendRetargetingsMutation_suspendRetargetings_validationResult_warnings[];
}

export interface SuspendRetargetingsMutation_suspendRetargetings {
  __typename: "GdResult_GdSuspendRetargetingsPayloadItem";
  successCount: number;
  totalCount: number;
  rowset: (SuspendRetargetingsMutation_suspendRetargetings_rowset | null)[];
  validationResult: SuspendRetargetingsMutation_suspendRetargetings_validationResult | null;
}

export interface SuspendRetargetingsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface SuspendRetargetingsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  suspendRetargetings: SuspendRetargetingsMutation_suspendRetargetings;
  getClientMutationId: SuspendRetargetingsMutation_getClientMutationId;
}

export interface SuspendRetargetingsMutationVariables {
  input: GdSuspendRetargetingsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteRetargetingsMutation
// ====================================================

export interface DeleteRetargetingsMutation_deleteRetargetings_rowset {
  __typename: "GdDeleteRetargetingsPayloadItem";
  retargetingId: GraphQlLong;
}

export interface DeleteRetargetingsMutation_deleteRetargetings_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface DeleteRetargetingsMutation_deleteRetargetings_validationResult_warnings {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface DeleteRetargetingsMutation_deleteRetargetings_validationResult {
  __typename: "GdValidationResult";
  errors: DeleteRetargetingsMutation_deleteRetargetings_validationResult_errors[];
  warnings: DeleteRetargetingsMutation_deleteRetargetings_validationResult_warnings[];
}

export interface DeleteRetargetingsMutation_deleteRetargetings {
  __typename: "GdResult_GdDeleteRetargetingsPayloadItem";
  successCount: number;
  totalCount: number;
  rowset: (DeleteRetargetingsMutation_deleteRetargetings_rowset | null)[];
  validationResult: DeleteRetargetingsMutation_deleteRetargetings_validationResult | null;
}

export interface DeleteRetargetingsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface DeleteRetargetingsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  deleteRetargetings: DeleteRetargetingsMutation_deleteRetargetings;
  getClientMutationId: DeleteRetargetingsMutation_getClientMutationId;
}

export interface DeleteRetargetingsMutationVariables {
  input: GdDeleteRetargetingsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteRetargetingConditionsMutation
// ====================================================

export interface DeleteRetargetingConditionsMutation_deleteRetargetingConditions_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface DeleteRetargetingConditionsMutation_deleteRetargetingConditions_validationResult {
  __typename: "GdValidationResult";
  errors: DeleteRetargetingConditionsMutation_deleteRetargetingConditions_validationResult_errors[];
}

export interface DeleteRetargetingConditionsMutation_deleteRetargetingConditions {
  __typename: "GdResult_GdDeleteRetargetingConditionsPayloadItem";
  successCount: number;
  totalCount: number;
  validationResult: DeleteRetargetingConditionsMutation_deleteRetargetingConditions_validationResult | null;
}

export interface DeleteRetargetingConditionsMutation_getClientMutationId {
  __typename: "GdGetClientMutationIdPayload";
  mutationId: string;
}

export interface DeleteRetargetingConditionsMutation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  deleteRetargetingConditions: DeleteRetargetingConditionsMutation_deleteRetargetingConditions;
  getClientMutationId: DeleteRetargetingConditionsMutation_getClientMutationId;
}

export interface DeleteRetargetingConditionsMutationVariables {
  input: GdDeleteRetargetingConditionsInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetAutoOverdraftLimit
// ====================================================

export interface SetAutoOverdraftLimit_setAutoOverdraftLimit_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface SetAutoOverdraftLimit_setAutoOverdraftLimit_validationResult {
  __typename: "GdValidationResult";
  errors: SetAutoOverdraftLimit_setAutoOverdraftLimit_validationResult_errors[];
}

export interface SetAutoOverdraftLimit_setAutoOverdraftLimit {
  __typename: "GdSetAutoOverdraftParamsPayload";
  validationResult: SetAutoOverdraftLimit_setAutoOverdraftLimit_validationResult | null;
}

export interface SetAutoOverdraftLimit {
  setAutoOverdraftLimit: SetAutoOverdraftLimit_setAutoOverdraftLimit;
}

export interface SetAutoOverdraftLimitVariables {
  input: GdSetAutoOverdraftParamsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResetAutoOverdraftLimit
// ====================================================

export interface ResetAutoOverdraftLimit_resetAutoOverdraftLimit_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface ResetAutoOverdraftLimit_resetAutoOverdraftLimit_validationResult {
  __typename: "GdValidationResult";
  errors: ResetAutoOverdraftLimit_resetAutoOverdraftLimit_validationResult_errors[];
}

export interface ResetAutoOverdraftLimit_resetAutoOverdraftLimit {
  __typename: "GdResetAutoOverdraftParamsPayload";
  autoOverdraftLimit: GraphQlBigDecimal;
  validationResult: ResetAutoOverdraftLimit_resetAutoOverdraftLimit_validationResult | null;
}

export interface ResetAutoOverdraftLimit {
  resetAutoOverdraftLimit: ResetAutoOverdraftLimit_resetAutoOverdraftLimit;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UaTraitsQuery
// ====================================================

export interface UaTraitsQuery_constants_stringDicts_entries_GdStringDictEntry {
  __typename: "GdStringDictEntry";
  value: string;
}

export interface UaTraitsQuery_constants_stringDicts_entries_GdStringDictEntryWithLongKey {
  __typename: "GdStringDictEntryWithLongKey";
  key: GraphQlLong;
  value: string;
}

export type UaTraitsQuery_constants_stringDicts_entries = UaTraitsQuery_constants_stringDicts_entries_GdStringDictEntry | UaTraitsQuery_constants_stringDicts_entries_GdStringDictEntryWithLongKey;

export interface UaTraitsQuery_constants_stringDicts {
  __typename: "GdStringDictData";
  dictName: GdStringDictName;
  entries: UaTraitsQuery_constants_stringDicts_entries[];
}

export interface UaTraitsQuery_constants {
  __typename: "GdDirectConstants";
  /**
   * Строковые словари
   */
  stringDicts: (UaTraitsQuery_constants_stringDicts | null)[];
}

export interface UaTraitsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  constants: UaTraitsQuery_constants;
}

export interface UaTraitsQueryVariables {
  dictNames: (GdStringDictNameInput | null)[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: DefaultCampaignsEditQuery
// ====================================================

export interface DefaultCampaignsEditQuery_operator_access_availableFields {
  __typename: "GdAvailableFields";
  campaignFields: GdCampaignsAvailableFields[];
}

export interface DefaultCampaignsEditQuery_operator_access {
  __typename: "GdOperatorAccess";
  availableFields: DefaultCampaignsEditQuery_operator_access_availableFields;
}

export interface DefaultCampaignsEditQuery_operator {
  __typename: "GdOperatorInfo";
  access: DefaultCampaignsEditQuery_operator_access;
}

export interface DefaultCampaignsEditQuery_client_notification {
  __typename: "GdClientNotificationInfo";
  smsPhone: string | null;
}

export interface DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifierTypesByCampaignTypes {
  __typename: "GdAllowedBidModifiersByCampaignType";
  campaignType: GdCampaignType;
  allowedBidModifierTypes: GdBidModifierType[];
}

export interface DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment {
  __typename: "GdAllowedBidModifierValuesABSegment" | "GdAllowedBidModifierValuesDemographics" | "GdAllowedBidModifierValuesDesktop" | "GdAllowedBidModifierValuesExpression" | "GdAllowedBidModifierValuesGeo" | "GdAllowedBidModifierValuesRetargeting" | "GdAllowedBidModifierValuesSmartTgo" | "GdAllowedBidModifierValuesVideo" | "GdAllowedBidModifierValuesWeather";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment_percentRange;
}

export interface DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile {
  __typename: "GdAllowedBidModifierValuesMobile";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile_percentRange;
  osTypes: GdOsType[];
}

export interface DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory {
  __typename: "GdAllowedBidModifierValuesInventory";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory_percentRange;
  inventoryTypes: GdInventoryType[];
}

export interface DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType {
  __typename: "GdAllowedBidModifierValuesAdType";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType_percentRange;
  adTypes: GdAdjustmentAdType[];
}

export type DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues = DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment | DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile | DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory | DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType;

export interface DefaultCampaignsEditQuery_client_clientConstants {
  __typename: "GdClientConstants";
  allowedBidModifierTypesByCampaignTypes: DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifierTypesByCampaignTypes[];
  allowedBidModifiersValues: DefaultCampaignsEditQuery_client_clientConstants_allowedBidModifiersValues[];
}

export interface DefaultCampaignsEditQuery_client_defaultCampaignNotifications_emailSettings {
  __typename: "GdCampaignEmailSettings";
  allowedEvents: GdCampaignEmailEvent[];
  checkPositionInterval: GdCampaignCheckPositionInterval | null;
  email: string;
  sendAccountNews: boolean | null;
  stopByReachDailyBudget: boolean | null;
  warningBalance: number | null;
  xlsReady: boolean | null;
}

export interface DefaultCampaignsEditQuery_client_defaultCampaignNotifications_smsSettings_smsTime_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface DefaultCampaignsEditQuery_client_defaultCampaignNotifications_smsSettings_smsTime_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface DefaultCampaignsEditQuery_client_defaultCampaignNotifications_smsSettings_smsTime {
  __typename: "GdTimeInterval";
  endTime: DefaultCampaignsEditQuery_client_defaultCampaignNotifications_smsSettings_smsTime_endTime;
  startTime: DefaultCampaignsEditQuery_client_defaultCampaignNotifications_smsSettings_smsTime_startTime;
}

export interface DefaultCampaignsEditQuery_client_defaultCampaignNotifications_smsSettings_events {
  __typename: "GdCampaignSmsEventInfo";
  checked: boolean;
  event: GdCampaignSmsEvent;
}

export interface DefaultCampaignsEditQuery_client_defaultCampaignNotifications_smsSettings {
  __typename: "GdCampaignSmsSettings";
  smsTime: DefaultCampaignsEditQuery_client_defaultCampaignNotifications_smsSettings_smsTime;
  events: DefaultCampaignsEditQuery_client_defaultCampaignNotifications_smsSettings_events[];
}

export interface DefaultCampaignsEditQuery_client_defaultCampaignNotifications {
  __typename: "GdDefaultCampaignNotification";
  campaignType: GdCampaignType;
  emailSettings: DefaultCampaignsEditQuery_client_defaultCampaignNotifications_emailSettings;
  smsSettings: DefaultCampaignsEditQuery_client_defaultCampaignNotifications_smsSettings;
}

export interface DefaultCampaignsEditQuery_client_features {
  __typename: "GdClientFeatures";
  hasAbSegments: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isCampaignDefaultOrganizationsEnabled: boolean;
}

export interface DefaultCampaignsEditQuery_client {
  __typename: "GdClient";
  notification: DefaultCampaignsEditQuery_client_notification;
  clientConstants: DefaultCampaignsEditQuery_client_clientConstants;
  campaignsCount: number;
  defaultCampaignNotifications: (DefaultCampaignsEditQuery_client_defaultCampaignNotifications | null)[];
  features: DefaultCampaignsEditQuery_client_features;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierDesktopAdjustment {
  __typename: "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment";
  id: GraphQlLong;
  percent: number;
  sectionId: GraphQlLong;
  segmentId: GraphQlLong;
}

export type DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments = DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierDesktopAdjustment | DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierMobileAdjustment | DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierExpressAdjustment | DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment;

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers_adjustments[];
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_broadMatch {
  __typename: "GdBroadMatch";
  broadMatchFlag: boolean;
  broadMatchGoalId: GraphQlLong | null;
  broadMatchLimit: number;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard_workTimes_startTime;
  endTime: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard_workTimes_endTime;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard_address_pointOnMap | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard {
  __typename: "GdVcard";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard_instantMessenger | null;
  workTimes: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard_workTimes[];
  phone: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard_phone;
  address: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard_address;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_defaultSmsTimeInterval_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_defaultSmsTimeInterval_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_defaultSmsTimeInterval {
  __typename: "GdTimeInterval";
  endTime: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_defaultSmsTimeInterval_endTime;
  startTime: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_defaultSmsTimeInterval_startTime;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_defaultTimeTarget_holidaysSettings {
  __typename: "GdHolidaysSettings";
  endHour: number | null;
  isShow: boolean;
  rateCorrections: number | null;
  startHour: number | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_defaultTimeTarget {
  __typename: "GdTimeTarget";
  enabledHolidaysMode: boolean;
  holidaysSettings: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_defaultTimeTarget_holidaysSettings | null;
  timeBoard: number[][];
  useWorkingWeekends: boolean;
  idTimeZone: GraphQlLong;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_menaningfulGoals {
  __typename: "GdMeaningfulGoal";
  conversionValue: GraphQlBigDecimal | null;
  goalId: GraphQlLong;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdStrategyOptimizeClicks_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdStrategyOptimizeClicks {
  __typename: "GdStrategyOptimizeClicks";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdStrategyOptimizeClicks_budget | null;
  avgBid: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
  clicksLimit: GraphQlLong | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdStrategyOptimizeConversions_budget | null;
  goalId: GraphQlLong | null;
  avgCpa: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
  payForConversion: boolean | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdCampaignStrategyRoi_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdCampaignStrategyRoi {
  __typename: "GdCampaignStrategyRoi";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdCampaignStrategyRoi_budget | null;
  goalId: GraphQlLong | null;
  profitability: GraphQlBigDecimal | null;
  reserveReturn: GraphQlLong | null;
  roiCoef: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
}

export type DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy = DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdCampaignStrategyAvgClick | DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdCampaignStrategyManual | DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdStrategyOptimizeClicks | DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdStrategyOptimizeConversions | DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy_GdCampaignStrategyRoi;

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaigns {
  __typename: "GdCampaignDefaultValues";
  allowedPageIds: GraphQlLong[] | null;
  attributionModel: GdCampaignAttributionModel;
  bidModifiers: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_bidModifiers[];
  broadMatch: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_broadMatch;
  campaignName: string;
  clientDialogId: GraphQlLong | null;
  commonVcard: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_commonVcard | null;
  contentLanguage: GdContentLanguage | null;
  defaultAddMetrikaTagToUrl: boolean;
  defaultAddOpenstatTagToUrl: boolean;
  defaultBroadMatchAllGoalsId: number;
  defaultBroadMatchLimit: number;
  defaultCheckPositionInterval: GdCampaignCheckPositionInterval;
  defaultContextLimit: number;
  defaultDayBudget: GraphQlBigDecimal;
  defaultDayBudgetShowMode: GdDayBudgetShowMode;
  defaultEnableCompanyInfo: boolean;
  defaultExcludePausedCompetingAds: boolean;
  defaultHasEnableCpcHold: boolean;
  defaultMeaningfulGoalId: GraphQlLong;
  defaultSmsTimeInterval: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_defaultSmsTimeInterval;
  defaultTimeTarget: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_defaultTimeTarget;
  defaultWarningBalance: number;
  disabledIps: string[];
  disabledPlaces: string[];
  hasExtendedGeoTargeting: boolean;
  hasSiteMonitoring: boolean;
  hasTitleSubstitute: boolean;
  markMetrikaCunters: boolean;
  menaningfulGoals: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_menaningfulGoals[];
  metrikaCounters: number[];
  openStat: boolean;
  startDate: GraphQlLocalDate;
  strategy: DefaultCampaignsEditQuery_constants_defaultValues_campaigns_strategy;
  defaultIsAloneTrafaretAllowed: boolean;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues_campaign {
  __typename: "GdCampaignDefaultValues";
  defaultMeaningfulGoalId: GraphQlLong;
  defaultBroadMatchAllGoalsId: number;
  defaultContextLimit: number;
  defaultDayBudget: GraphQlBigDecimal;
  defaultHasEnableCpcHold: boolean;
  defaultIsAloneTrafaretAllowed: boolean;
}

export interface DefaultCampaignsEditQuery_constants_defaultValues {
  __typename: "GdDefaultValues";
  campaigns: (DefaultCampaignsEditQuery_constants_defaultValues_campaigns | null)[];
  campaign: DefaultCampaignsEditQuery_constants_defaultValues_campaign;
}

export interface DefaultCampaignsEditQuery_constants_validation_campaignConstants {
  __typename: "GdDirectConstantsCampaignValidationData";
  maxDisabledPlacesCount: number;
  maxMetrikaCountersNumberForTextCampaign: number;
  maxDisabledIpsCount: number;
  minBroadMatchLimit: number;
  maxBroadMatchLimit: number;
  roiCoefMin: GraphQlBigDecimal;
  maxNameLength: number;
}

export interface DefaultCampaignsEditQuery_constants_validation_minusKeywordsConstants {
  __typename: "GdDirectConstantsMinusWordsValidationData";
  normalizedMinusKeywordsMaxLength: number;
}

export interface DefaultCampaignsEditQuery_constants_validation {
  __typename: "GdDirectConstantsValidationData";
  campaignConstants: DefaultCampaignsEditQuery_constants_validation_campaignConstants;
  minusKeywordsConstants: DefaultCampaignsEditQuery_constants_validation_minusKeywordsConstants;
}

export interface DefaultCampaignsEditQuery_constants_strategyConstants {
  __typename: "GdStrategyConstants";
  byAllGoalsGoalId: GraphQlLong;
  meaningfulGoalsOptimizationGoalId: GraphQlLong;
  payForConversionSumToAvgCpaMinRatio: number;
}

export interface DefaultCampaignsEditQuery_constants_metroStations_rowset {
  __typename: "GdMetroStation";
  geoRegionId: number;
  metroStationId: number;
  metroStationName: string;
}

export interface DefaultCampaignsEditQuery_constants_metroStations {
  __typename: "GdMetroStationsData";
  rowset: DefaultCampaignsEditQuery_constants_metroStations_rowset[];
}

export interface DefaultCampaignsEditQuery_constants {
  __typename: "GdDirectConstants";
  defaultValues: DefaultCampaignsEditQuery_constants_defaultValues;
  validation: DefaultCampaignsEditQuery_constants_validation;
  strategyConstants: DefaultCampaignsEditQuery_constants_strategyConstants;
  /**
   * Станции метрополитена (только для Москвы, Санкт-Петербурга и Киева)
   */
  metroStations: DefaultCampaignsEditQuery_constants_metroStations;
}

export interface DefaultCampaignsEditQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  operator: DefaultCampaignsEditQuery_operator;
  client: DefaultCampaignsEditQuery_client;
  constants: DefaultCampaignsEditQuery_constants;
}

export interface DefaultCampaignsEditQueryVariables {
  login: string;
  campaignTypes?: GdCampaignTypeInput[] | null;
  city?: GdMetroCityInput[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BroadmatchGoalsQuery
// ====================================================

export interface BroadmatchGoalsQuery_client_broadMatchGoals_campaignGoals_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  simpleName: string;
  parentId: GraphQlLong | null;
}

export interface BroadmatchGoalsQuery_client_broadMatchGoals_campaignGoals {
  __typename: "GdCampaignGoals";
  campaignId: GraphQlLong;
  goals: BroadmatchGoalsQuery_client_broadMatchGoals_campaignGoals_goals[];
}

export interface BroadmatchGoalsQuery_client_broadMatchGoals {
  __typename: "GdBroadMatchGoals";
  campaignGoals: BroadmatchGoalsQuery_client_broadMatchGoals_campaignGoals[] | null;
  isMetrikaAvailable: boolean;
}

export interface BroadmatchGoalsQuery_client {
  __typename: "GdClient";
  broadMatchGoals: BroadmatchGoalsQuery_client_broadMatchGoals;
}

export interface BroadmatchGoalsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: BroadmatchGoalsQuery_client;
}

export interface BroadmatchGoalsQueryVariables {
  login: string;
  broadMatchGoalsInput: GdBroadMatchesContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignsEditDataQuery
// ====================================================

export interface CampaignsEditDataQuery_operator_access_availableFields {
  __typename: "GdAvailableFields";
  campaignFields: GdCampaignsAvailableFields[];
}

export interface CampaignsEditDataQuery_operator_access {
  __typename: "GdOperatorAccess";
  availableFields: CampaignsEditDataQuery_operator_access_availableFields;
}

export interface CampaignsEditDataQuery_operator {
  __typename: "GdOperatorInfo";
  access: CampaignsEditDataQuery_operator_access;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdStrategyOptimizeClicks_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdStrategyOptimizeClicks {
  __typename: "GdStrategyOptimizeClicks";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdStrategyOptimizeClicks_budget | null;
  avgBid: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
  clicksLimit: GraphQlLong | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  goalId: GraphQlLong | null;
  avgCpa: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
  payForConversion: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyRoi_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyRoi {
  __typename: "GdCampaignStrategyRoi";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyRoi_budget | null;
  goalId: GraphQlLong | null;
  profitability: GraphQlBigDecimal | null;
  reserveReturn: GraphQlLong | null;
  roiCoef: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
}

export type CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy = CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyAvgClick | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyManual | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdStrategyOptimizeClicks | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdStrategyOptimizeConversions | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyRoi;

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierDesktopAdjustment {
  __typename: "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment";
  id: GraphQlLong;
  percent: number;
  sectionId: GraphQlLong;
  segmentId: GraphQlLong;
}

export type CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments = CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierDesktopAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierMobileAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment;

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers_adjustments[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_emailSettings {
  __typename: "GdCampaignEmailSettings";
  allowedEvents: GdCampaignEmailEvent[];
  checkPositionInterval: GdCampaignCheckPositionInterval | null;
  email: string;
  sendAccountNews: boolean | null;
  stopByReachDailyBudget: boolean | null;
  warningBalance: number | null;
  xlsReady: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_smsTime_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_smsTime_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_smsTime {
  __typename: "GdTimeInterval";
  endTime: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_smsTime_endTime;
  startTime: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_smsTime_startTime;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_events {
  __typename: "GdCampaignSmsEventInfo";
  checked: boolean;
  event: GdCampaignSmsEvent;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings {
  __typename: "GdCampaignSmsSettings";
  smsTime: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_smsTime;
  events: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings_events[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification {
  __typename: "GdCampaignNotification";
  emailSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_emailSettings;
  smsSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification_smsSettings;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  allowDomainMonitoring: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  hasRunningUnmoderatedAds: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_timeTarget_holidaysSettings {
  __typename: "GdHolidaysSettings";
  endHour: number | null;
  startHour: number | null;
  isShow: boolean;
  rateCorrections: number | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_timeTarget {
  __typename: "GdTimeTarget";
  enabledHolidaysMode: boolean;
  holidaysSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_timeTarget_holidaysSettings | null;
  idTimeZone: GraphQlLong;
  timeBoard: number[][];
  useWorkingWeekends: boolean;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  exportId: GraphQlLong;
  name: string;
  type: GdCampaignType;
  access: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_access;
  strategy: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy;
  contextLimit: number;
  hasEnableCpcHold: boolean;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  bidModifiers: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_bidModifiers[] | null;
  disabledIps: string[] | null;
  notification: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification;
  status: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_status;
  timeTarget: CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_timeTarget;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdStrategyOptimizeClicks_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdStrategyOptimizeClicks {
  __typename: "GdStrategyOptimizeClicks";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdStrategyOptimizeClicks_budget | null;
  avgBid: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
  clicksLimit: GraphQlLong | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  goalId: GraphQlLong | null;
  avgCpa: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
  payForConversion: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdCampaignStrategyRoi_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdCampaignStrategyRoi {
  __typename: "GdCampaignStrategyRoi";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdCampaignStrategyRoi_budget | null;
  goalId: GraphQlLong | null;
  profitability: GraphQlBigDecimal | null;
  reserveReturn: GraphQlLong | null;
  roiCoef: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
}

export type CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy = CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdCampaignStrategyManual | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdStrategyOptimizeClicks | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdStrategyOptimizeConversions | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdCampaignStrategyRoi;

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierDesktopAdjustment {
  __typename: "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment";
  id: GraphQlLong;
  percent: number;
  sectionId: GraphQlLong;
  segmentId: GraphQlLong;
}

export type CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments = CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierDesktopAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierMobileAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment;

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers_adjustments[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_emailSettings {
  __typename: "GdCampaignEmailSettings";
  allowedEvents: GdCampaignEmailEvent[];
  checkPositionInterval: GdCampaignCheckPositionInterval | null;
  email: string;
  sendAccountNews: boolean | null;
  stopByReachDailyBudget: boolean | null;
  warningBalance: number | null;
  xlsReady: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_smsTime_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_smsTime_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_smsTime {
  __typename: "GdTimeInterval";
  endTime: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_smsTime_endTime;
  startTime: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_smsTime_startTime;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_events {
  __typename: "GdCampaignSmsEventInfo";
  checked: boolean;
  event: GdCampaignSmsEvent;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings {
  __typename: "GdCampaignSmsSettings";
  smsTime: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_smsTime;
  events: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings_events[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification {
  __typename: "GdCampaignNotification";
  emailSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_emailSettings;
  smsSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification_smsSettings;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  allowDomainMonitoring: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  hasRunningUnmoderatedAds: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_timeTarget_holidaysSettings {
  __typename: "GdHolidaysSettings";
  endHour: number | null;
  startHour: number | null;
  isShow: boolean;
  rateCorrections: number | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_timeTarget {
  __typename: "GdTimeTarget";
  enabledHolidaysMode: boolean;
  holidaysSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_timeTarget_holidaysSettings | null;
  idTimeZone: GraphQlLong;
  timeBoard: number[][];
  useWorkingWeekends: boolean;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_meaningfulGoals {
  __typename: "GdMeaningfulGoal";
  goalId: GraphQlLong;
  conversionValue: GraphQlBigDecimal | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentRetargetingCondition_retargetingCondition_conditionRules_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentRetargetingCondition_retargetingCondition_conditionRules {
  __typename: "GdRetargetingConditionRuleItem";
  sectionId: GraphQlLong | null;
  goals: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentRetargetingCondition_retargetingCondition_conditionRules_goals[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentRetargetingCondition_retargetingCondition {
  __typename: "GdRetargetingCondition";
  retargetingConditionId: GraphQlLong;
  conditionRules: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentRetargetingCondition_retargetingCondition_conditionRules[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentRetargetingCondition {
  __typename: "GdRetargetingConditionWithMetrikaFlag";
  isMetrikaAvailable: boolean;
  retargetingCondition: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentRetargetingCondition_retargetingCondition | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentStatisticRetargetingCondition_retargetingCondition_conditionRules_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentStatisticRetargetingCondition_retargetingCondition_conditionRules {
  __typename: "GdRetargetingConditionRuleItem";
  sectionId: GraphQlLong | null;
  goals: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentStatisticRetargetingCondition_retargetingCondition_conditionRules_goals[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentStatisticRetargetingCondition_retargetingCondition {
  __typename: "GdRetargetingCondition";
  retargetingConditionId: GraphQlLong;
  conditionRules: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentStatisticRetargetingCondition_retargetingCondition_conditionRules[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentStatisticRetargetingCondition {
  __typename: "GdRetargetingConditionWithMetrikaFlag";
  isMetrikaAvailable: boolean;
  retargetingCondition: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentStatisticRetargetingCondition_retargetingCondition | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_broadMatch {
  __typename: "GdBroadMatch";
  broadMatchFlag: boolean;
  broadMatchGoalId: GraphQlLong | null;
  broadMatchLimit: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes[];
  phone: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_phone;
  address: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_address;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  exportId: GraphQlLong;
  name: string;
  type: GdCampaignType;
  access: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_access;
  strategy: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_strategy;
  contextLimit: number;
  hasEnableCpcHold: boolean;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  bidModifiers: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_bidModifiers[] | null;
  disabledIps: string[] | null;
  notification: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification;
  status: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_status;
  timeTarget: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_timeTarget;
  contentLanguage: GdContentLanguage | null;
  disabledPlaces: string[] | null;
  meaningfulGoals: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_meaningfulGoals[] | null;
  metrikaCounters: number[] | null;
  hasTitleSubstitution: boolean;
  clientDialogId: GraphQlLong | null;
  hasExtendedGeoTargeting: boolean;
  abSegmentRetargetingCondition: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentRetargetingCondition | null;
  abSegmentStatisticRetargetingCondition: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_abSegmentStatisticRetargetingCondition | null;
  allowedPageIds: GraphQlLong[] | null;
  attributionModel: GdCampaignAttributionModel;
  hasAddMetrikaTagToUrl: boolean;
  hasAddOpenstatTagToUrl: boolean;
  excludePausedCompetingAds: boolean;
  enableCompanyInfo: boolean;
  minusKeywords: string[] | null;
  broadMatch: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_broadMatch;
  commonVcard: CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_commonVcard | null;
  isAloneTrafaretAllowed: boolean;
  defaultPermalinkId: GraphQlLong | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdStrategyOptimizeClicks_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdStrategyOptimizeClicks {
  __typename: "GdStrategyOptimizeClicks";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdStrategyOptimizeClicks_budget | null;
  avgBid: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
  clicksLimit: GraphQlLong | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  goalId: GraphQlLong | null;
  avgCpa: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
  payForConversion: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyRoi_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyRoi {
  __typename: "GdCampaignStrategyRoi";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyRoi_budget | null;
  goalId: GraphQlLong | null;
  profitability: GraphQlBigDecimal | null;
  reserveReturn: GraphQlLong | null;
  roiCoef: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
}

export type CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy = CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdStrategyOptimizeClicks | CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions | CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyRoi;

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierDesktopAdjustment {
  __typename: "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment";
  id: GraphQlLong;
  percent: number;
  sectionId: GraphQlLong;
  segmentId: GraphQlLong;
}

export type CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments = CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierDesktopAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierMobileAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment;

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers_adjustments[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_notification_emailSettings {
  __typename: "GdCampaignEmailSettings";
  allowedEvents: GdCampaignEmailEvent[];
  checkPositionInterval: GdCampaignCheckPositionInterval | null;
  email: string;
  sendAccountNews: boolean | null;
  stopByReachDailyBudget: boolean | null;
  warningBalance: number | null;
  xlsReady: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_notification_smsSettings_smsTime_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_notification_smsSettings_smsTime_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_notification_smsSettings_smsTime {
  __typename: "GdTimeInterval";
  endTime: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_notification_smsSettings_smsTime_endTime;
  startTime: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_notification_smsSettings_smsTime_startTime;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_notification_smsSettings_events {
  __typename: "GdCampaignSmsEventInfo";
  checked: boolean;
  event: GdCampaignSmsEvent;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_notification_smsSettings {
  __typename: "GdCampaignSmsSettings";
  smsTime: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_notification_smsSettings_smsTime;
  events: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_notification_smsSettings_events[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_notification {
  __typename: "GdCampaignNotification";
  emailSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_notification_emailSettings;
  smsSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_notification_smsSettings;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  allowDomainMonitoring: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  hasRunningUnmoderatedAds: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_timeTarget_holidaysSettings {
  __typename: "GdHolidaysSettings";
  endHour: number | null;
  startHour: number | null;
  isShow: boolean;
  rateCorrections: number | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_timeTarget {
  __typename: "GdTimeTarget";
  enabledHolidaysMode: boolean;
  holidaysSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_timeTarget_holidaysSettings | null;
  idTimeZone: GraphQlLong;
  timeBoard: number[][];
  useWorkingWeekends: boolean;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign";
  id: GraphQlLong;
  exportId: GraphQlLong;
  name: string;
  type: GdCampaignType;
  access: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_access;
  strategy: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy;
  contextLimit: number;
  hasEnableCpcHold: boolean;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  bidModifiers: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_bidModifiers[] | null;
  disabledIps: string[] | null;
  notification: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_notification;
  status: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_status;
  timeTarget: CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign_timeTarget;
  contentLanguage: GdContentLanguage | null;
  metrikaCounters: number[] | null;
  hasExtendedGeoTargeting: boolean;
  attributionModel: GdCampaignAttributionModel;
  minusKeywords: string[] | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdStrategyOptimizeClicks_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdStrategyOptimizeClicks {
  __typename: "GdStrategyOptimizeClicks";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdStrategyOptimizeClicks_budget | null;
  avgBid: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
  clicksLimit: GraphQlLong | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  goalId: GraphQlLong | null;
  avgCpa: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
  payForConversion: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdCampaignStrategyRoi_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdCampaignStrategyRoi {
  __typename: "GdCampaignStrategyRoi";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdCampaignStrategyRoi_budget | null;
  goalId: GraphQlLong | null;
  profitability: GraphQlBigDecimal | null;
  reserveReturn: GraphQlLong | null;
  roiCoef: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
}

export type CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy = CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdCampaignStrategyAvgClick | CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdCampaignStrategyManual | CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdStrategyOptimizeClicks | CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdStrategyOptimizeConversions | CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy_GdCampaignStrategyRoi;

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierDesktopAdjustment {
  __typename: "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment";
  id: GraphQlLong;
  percent: number;
  sectionId: GraphQlLong;
  segmentId: GraphQlLong;
}

export type CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments = CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierDesktopAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierMobileAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierExpressAdjustment | CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment;

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers_adjustments[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_notification_emailSettings {
  __typename: "GdCampaignEmailSettings";
  allowedEvents: GdCampaignEmailEvent[];
  checkPositionInterval: GdCampaignCheckPositionInterval | null;
  email: string;
  sendAccountNews: boolean | null;
  stopByReachDailyBudget: boolean | null;
  warningBalance: number | null;
  xlsReady: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_notification_smsSettings_smsTime_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_notification_smsSettings_smsTime_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_notification_smsSettings_smsTime {
  __typename: "GdTimeInterval";
  endTime: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_notification_smsSettings_smsTime_endTime;
  startTime: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_notification_smsSettings_smsTime_startTime;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_notification_smsSettings_events {
  __typename: "GdCampaignSmsEventInfo";
  checked: boolean;
  event: GdCampaignSmsEvent;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_notification_smsSettings {
  __typename: "GdCampaignSmsSettings";
  smsTime: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_notification_smsSettings_smsTime;
  events: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_notification_smsSettings_events[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_notification {
  __typename: "GdCampaignNotification";
  emailSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_notification_emailSettings;
  smsSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_notification_smsSettings;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_status {
  __typename: "GdCampaignStatus";
  allowDomainMonitoring: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  hasRunningUnmoderatedAds: boolean | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_timeTarget_holidaysSettings {
  __typename: "GdHolidaysSettings";
  endHour: number | null;
  startHour: number | null;
  isShow: boolean;
  rateCorrections: number | null;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_timeTarget {
  __typename: "GdTimeTarget";
  enabledHolidaysMode: boolean;
  holidaysSettings: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_timeTarget_holidaysSettings | null;
  idTimeZone: GraphQlLong;
  timeBoard: number[][];
  useWorkingWeekends: boolean;
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  geoExpanded: GraphQlLong[] | null;
  geoType: number | null;
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
}

export interface CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  exportId: GraphQlLong;
  name: string;
  type: GdCampaignType;
  access: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_access;
  strategy: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_strategy;
  contextLimit: number;
  hasEnableCpcHold: boolean;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  bidModifiers: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_bidModifiers[] | null;
  disabledIps: string[] | null;
  notification: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_notification;
  status: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_status;
  timeTarget: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_timeTarget;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign_flightTargetingsSnapshot | null;
  flightOrderVolume: GraphQlLong | null;
  flightStatusApprove: GdPriceFlightStatusApprove | null;
  flightStatusCorrect: GdPriceFlightStatusCorrect | null;
}

export type CampaignsEditDataQuery_client_campaigns_rowset = CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign | CampaignsEditDataQuery_client_campaigns_rowset_GdContentPromotionCampaign | CampaignsEditDataQuery_client_campaigns_rowset_GdPriceCampaign;

export interface CampaignsEditDataQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: CampaignsEditDataQuery_client_campaigns_rowset[];
}

export interface CampaignsEditDataQuery_client_notification {
  __typename: "GdClientNotificationInfo";
  smsPhone: string | null;
}

export interface CampaignsEditDataQuery_client_clientConstants_allowedBidModifierTypesByCampaignTypes {
  __typename: "GdAllowedBidModifiersByCampaignType";
  campaignType: GdCampaignType;
  allowedBidModifierTypes: GdBidModifierType[];
}

export interface CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment {
  __typename: "GdAllowedBidModifierValuesABSegment" | "GdAllowedBidModifierValuesDemographics" | "GdAllowedBidModifierValuesDesktop" | "GdAllowedBidModifierValuesExpression" | "GdAllowedBidModifierValuesGeo" | "GdAllowedBidModifierValuesRetargeting" | "GdAllowedBidModifierValuesSmartTgo" | "GdAllowedBidModifierValuesVideo" | "GdAllowedBidModifierValuesWeather";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment_percentRange;
}

export interface CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile {
  __typename: "GdAllowedBidModifierValuesMobile";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile_percentRange;
  osTypes: GdOsType[];
}

export interface CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory {
  __typename: "GdAllowedBidModifierValuesInventory";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory_percentRange;
  inventoryTypes: GdInventoryType[];
}

export interface CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType {
  __typename: "GdAllowedBidModifierValuesAdType";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType_percentRange;
  adTypes: GdAdjustmentAdType[];
}

export type CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues = CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment | CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile | CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory | CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType;

export interface CampaignsEditDataQuery_client_clientConstants {
  __typename: "GdClientConstants";
  allowedBidModifierTypesByCampaignTypes: CampaignsEditDataQuery_client_clientConstants_allowedBidModifierTypesByCampaignTypes[];
  allowedBidModifiersValues: CampaignsEditDataQuery_client_clientConstants_allowedBidModifiersValues[];
}

export interface CampaignsEditDataQuery_client_features {
  __typename: "GdClientFeatures";
  isTycoonOrganizationsEnabled: boolean;
  isCampaignDefaultOrganizationsEnabled: boolean;
}

export interface CampaignsEditDataQuery_client {
  __typename: "GdClient";
  campaigns: CampaignsEditDataQuery_client_campaigns;
  notification: CampaignsEditDataQuery_client_notification;
  clientConstants: CampaignsEditDataQuery_client_clientConstants;
  features: CampaignsEditDataQuery_client_features;
}

export interface CampaignsEditDataQuery_constants_validation_campaignConstants {
  __typename: "GdDirectConstantsCampaignValidationData";
  maxDisabledPlacesCount: number;
  maxMetrikaCountersNumberForTextCampaign: number;
  maxDisabledIpsCount: number;
  minBroadMatchLimit: number;
  maxBroadMatchLimit: number;
  roiCoefMin: GraphQlBigDecimal;
  maxNameLength: number;
}

export interface CampaignsEditDataQuery_constants_validation_minusKeywordsConstants {
  __typename: "GdDirectConstantsMinusWordsValidationData";
  normalizedMinusKeywordsMaxLength: number;
}

export interface CampaignsEditDataQuery_constants_validation {
  __typename: "GdDirectConstantsValidationData";
  campaignConstants: CampaignsEditDataQuery_constants_validation_campaignConstants;
  minusKeywordsConstants: CampaignsEditDataQuery_constants_validation_minusKeywordsConstants;
}

export interface CampaignsEditDataQuery_constants_defaultValues_campaign {
  __typename: "GdCampaignDefaultValues";
  defaultMeaningfulGoalId: GraphQlLong;
  defaultBroadMatchAllGoalsId: number;
  defaultContextLimit: number;
  defaultDayBudget: GraphQlBigDecimal;
  defaultHasEnableCpcHold: boolean;
  defaultIsAloneTrafaretAllowed: boolean;
}

export interface CampaignsEditDataQuery_constants_defaultValues {
  __typename: "GdDefaultValues";
  campaign: CampaignsEditDataQuery_constants_defaultValues_campaign;
}

export interface CampaignsEditDataQuery_constants_strategyConstants {
  __typename: "GdStrategyConstants";
  byAllGoalsGoalId: GraphQlLong;
  meaningfulGoalsOptimizationGoalId: GraphQlLong;
  payForConversionSumToAvgCpaMinRatio: number;
}

export interface CampaignsEditDataQuery_constants {
  __typename: "GdDirectConstants";
  validation: CampaignsEditDataQuery_constants_validation;
  defaultValues: CampaignsEditDataQuery_constants_defaultValues;
  strategyConstants: CampaignsEditDataQuery_constants_strategyConstants;
}

export interface CampaignsEditDataQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  operator: CampaignsEditDataQuery_operator;
  client: CampaignsEditDataQuery_client;
  constants: CampaignsEditDataQuery_constants;
}

export interface CampaignsEditDataQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignsAvailableForKeyGoalsQuery
// ====================================================

export interface CampaignsAvailableForKeyGoalsQuery_client_meaningfulGoals_campaignGoals_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  domain: string | null;
  parentId: GraphQlLong | null;
  simpleName: string;
}

export interface CampaignsAvailableForKeyGoalsQuery_client_meaningfulGoals_campaignGoals {
  __typename: "GdCampaignGoals";
  campaignId: GraphQlLong;
  goals: CampaignsAvailableForKeyGoalsQuery_client_meaningfulGoals_campaignGoals_goals[];
}

export interface CampaignsAvailableForKeyGoalsQuery_client_meaningfulGoals {
  __typename: "GdCampaignsGoals";
  isMetrikaAvailable: boolean;
  campaignGoals: CampaignsAvailableForKeyGoalsQuery_client_meaningfulGoals_campaignGoals[] | null;
}

export interface CampaignsAvailableForKeyGoalsQuery_client {
  __typename: "GdClient";
  meaningfulGoals: CampaignsAvailableForKeyGoalsQuery_client_meaningfulGoals;
}

export interface CampaignsAvailableForKeyGoalsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignsAvailableForKeyGoalsQuery_client;
}

export interface CampaignsAvailableForKeyGoalsQueryVariables {
  login: string;
  availableForKeyGoalsInput: GdMeaningfulGoalsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignsAvailableForKeyGoalsForNewCampaignQuery
// ====================================================

export interface CampaignsAvailableForKeyGoalsForNewCampaignQuery_client_goalsByCounterIds_counterWithGoals_goals {
  __typename: "GdGoal";
  domain: string | null;
  id: GraphQlLong;
  parentId: GraphQlLong | null;
  simpleName: string;
}

export interface CampaignsAvailableForKeyGoalsForNewCampaignQuery_client_goalsByCounterIds_counterWithGoals {
  __typename: "GdCounterWithGoals";
  counterId: GraphQlLong;
  goals: CampaignsAvailableForKeyGoalsForNewCampaignQuery_client_goalsByCounterIds_counterWithGoals_goals[];
}

export interface CampaignsAvailableForKeyGoalsForNewCampaignQuery_client_goalsByCounterIds {
  __typename: "GdCountersWithGoals";
  isMetrikaAvailable: boolean;
  counterWithGoals: CampaignsAvailableForKeyGoalsForNewCampaignQuery_client_goalsByCounterIds_counterWithGoals[] | null;
}

export interface CampaignsAvailableForKeyGoalsForNewCampaignQuery_client {
  __typename: "GdClient";
  goalsByCounterIds: CampaignsAvailableForKeyGoalsForNewCampaignQuery_client_goalsByCounterIds;
}

export interface CampaignsAvailableForKeyGoalsForNewCampaignQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignsAvailableForKeyGoalsForNewCampaignQuery_client;
}

export interface CampaignsAvailableForKeyGoalsForNewCampaignQueryVariables {
  login: string;
  availableForKeyGoalsInput: GraphQlLong[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignsABSegmentsQuery
// ====================================================

export interface CampaignsABSegmentsQuery_client_abSegments_campaignGoals_goals {
  __typename: "GdGoal";
  sectionName: string | null;
  sectionId: GraphQlLong | null;
  id: GraphQlLong;
  name: string;
  percent: number | null;
}

export interface CampaignsABSegmentsQuery_client_abSegments_campaignGoals {
  __typename: "GdCampaignGoals";
  campaignId: GraphQlLong;
  goals: CampaignsABSegmentsQuery_client_abSegments_campaignGoals_goals[];
}

export interface CampaignsABSegmentsQuery_client_abSegments {
  __typename: "GdCampaignsGoals";
  isMetrikaAvailable: boolean;
  campaignGoals: CampaignsABSegmentsQuery_client_abSegments_campaignGoals[] | null;
}

export interface CampaignsABSegmentsQuery_client {
  __typename: "GdClient";
  abSegments: CampaignsABSegmentsQuery_client_abSegments | null;
}

export interface CampaignsABSegmentsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignsABSegmentsQuery_client;
}

export interface CampaignsABSegmentsQueryVariables {
  login: string;
  abSegmentsInput: GdMeaningfulGoalsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignsABSegmentsQueryForNewCampaign
// ====================================================

export interface CampaignsABSegmentsQueryForNewCampaign_client_abSegmentsByCounterIds_counterWithGoals_goals {
  __typename: "GdGoal";
  sectionName: string | null;
  sectionId: GraphQlLong | null;
  id: GraphQlLong;
  name: string;
  percent: number | null;
}

export interface CampaignsABSegmentsQueryForNewCampaign_client_abSegmentsByCounterIds_counterWithGoals {
  __typename: "GdCounterWithGoals";
  goals: CampaignsABSegmentsQueryForNewCampaign_client_abSegmentsByCounterIds_counterWithGoals_goals[];
}

export interface CampaignsABSegmentsQueryForNewCampaign_client_abSegmentsByCounterIds {
  __typename: "GdCountersWithGoals";
  isMetrikaAvailable: boolean;
  counterWithGoals: CampaignsABSegmentsQueryForNewCampaign_client_abSegmentsByCounterIds_counterWithGoals[] | null;
}

export interface CampaignsABSegmentsQueryForNewCampaign_client {
  __typename: "GdClient";
  abSegmentsByCounterIds: CampaignsABSegmentsQueryForNewCampaign_client_abSegmentsByCounterIds;
}

export interface CampaignsABSegmentsQueryForNewCampaign {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignsABSegmentsQueryForNewCampaign_client;
}

export interface CampaignsABSegmentsQueryForNewCampaignVariables {
  login: string;
  abSegmentsInput: GraphQlLong[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ClientDevQuery
// ====================================================

export interface ClientDevQuery_clientDev {
  __typename: "GdClientDevInfo";
  clientId: GraphQlLong;
  environment: string;
  operatorLogin: string;
  role: RbacRole;
  shard: number;
  uid: GraphQlLong;
  operatorFeatures: string[];
  clientFeatures: string[];
}

export interface ClientDevQuery {
  clientDev: ClientDevQuery_clientDev;
  /**
   * Получить reqId запроса
   */
  reqId: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CommonQuery
// ====================================================

export interface CommonQuery_client_wallets_status {
  __typename: "GdWalletStatus";
  enabled: boolean;
}

export interface CommonQuery_client_wallets_budget {
  __typename: "GdWalletBudget";
  sum: GraphQlBigDecimal | null;
  showMode: GdWalletBudgetShowMode | null;
  type: GdWalletBudgetType;
}

export interface CommonQuery_client_wallets {
  __typename: "GdWallet";
  id: GraphQlLong;
  status: CommonQuery_client_wallets_status;
  budget: CommonQuery_client_wallets_budget;
  sum: GraphQlBigDecimal;
  currency: CurrencyCode;
  actions: GdWalletAction[];
}

export interface CommonQuery_client_access {
  __typename: "GdClientAccess";
  canCreateCampaignTypes: GdCampaignType[];
  canCreateCampaign: boolean;
  canViewInternalAds: boolean;
  canEditInternalAds: boolean;
  canManageLibMinusWords: boolean;
  canExportToExcel: boolean;
  canMassEditAdGroupRegions: boolean;
  canUseVideoConstructor: boolean;
  canPayByCash: boolean;
  canManageFavoriteCampaigns: boolean;
  canCopyCampaign: boolean;
  canManageUsingCommander: boolean;
  canMonitorPhrasesPositions: boolean;
  canTransferMoney: boolean;
  operatorIsClient: boolean;
  canUploadDocuments: boolean;
  canManageUsingXLS: boolean;
  canManageRetargertingConditions: boolean;
  canManageTurboLandings: boolean;
  canSeeClientRepresentatives: boolean;
  canManageVCards: boolean;
  canViewOfflineReports: boolean;
  canManageUsingApi: boolean;
  operatorIsClientChief: boolean;
  canManageCreatives: boolean;
  canManageFeeds: boolean;
  canCheckCampaignsStats: boolean;
  canViewUserLogs: boolean;
  canViewMobileApps: boolean;
  canSeeDealsLinkEverywhere: boolean;
  canSeeAgencyClients: boolean;
}

export interface CommonQuery_client_features {
  __typename: "GdClientFeatures";
  hasAbSegments: boolean;
  isAloneTrafaretOptionEnabled: boolean;
  isBidCorrectionSearchEnabled: boolean;
  isCampaignDefaultOrganizationsEnabled: boolean;
  isContentPromotionCampaignInDnaSupported: boolean;
  isContentPromotionVideoInGridSupported: boolean;
  isContentPromotionCollectionInGridSupported: boolean;
  isCpcDeviceModifiersAllowed: boolean;
  isCpmBannerCampaignAddAllowed: boolean;
  isCpmBannerCampaignUpdateAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isCpmIndoorSegmentsEnabled: boolean;
  isCpmVideoSeveralPixelsEnabled: boolean;
  isDefaultAutobudgetAvgCpaEnabled: boolean;
  isEmptyRetCondInCpmGroupEnabled: boolean;
  isHonestAddTextAdGroupAllowed: boolean;
  isGoalsStatEnabled: boolean;
  isGridEnabled: boolean;
  isInAppEventsInRmpEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isMassEditRegionsEnabled: boolean;
  isNewKeywordsEditorForDnaEnabled: boolean;
  isOverlayCreativesEnabled: boolean;
  isTargetTagsAllowed: boolean;
  isTextBannerInterestsRetCondEnabled: boolean;
  isTextCampaign8SitelinksEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isRoiMeaningfulGoalsOptimizationEnabled: boolean;
  isVideoConstructorEnabled: boolean;
  isZeroSpeedPageForGeoproductEnabled: boolean;
  relevanceMatchForNewGroupsEnabled: boolean;
  isAdmetricaMeasurerCpmBannerAllowed: boolean;
  isAdmetricaMeasurerCpmDealsAllowed: boolean;
  isAdmetricaMeasurerCpmAudioAllowed: boolean;
  isAdmetricaMeasurerCpmGeoproductAllowed: boolean;
  isAdmetricaMeasurerCpmVideoAllowed: boolean;
  isAdmetricaMeasurerCpmYndxFrontpageAllowed: boolean;
  isAdlooxMeasurerCpmBannerAllowed: boolean;
  isAdlooxMeasurerCpmAudioAllowed: boolean;
  isAdlooxMeasurerCpmDealsAllowed: boolean;
  isAdlooxMeasurerCpmGeoproductAllowed: boolean;
  isAdlooxMeasurerCpmVideoAllowed: boolean;
  isAdlooxMeasurerCpmYndxFrontpageAllowed: boolean;
  isAdriverMeasurerCpmBannerAllowed: boolean;
  isAdriverMeasurerCpmAudioAllowed: boolean;
  isAdriverMeasurerCpmDealsAllowed: boolean;
  isAdriverMeasurerCpmGeoproductAllowed: boolean;
  isAdriverMeasurerCpmVideoAllowed: boolean;
  isAdriverMeasurerCpmYndxFrontpageAllowed: boolean;
  isCpaPayForConversionsStrategyAllowed: boolean;
  isDvMeasurerCpmBannerAllowed: boolean;
  isDvMeasurerCpmAudioAllowed: boolean;
  isDvMeasurerCpmDealsAllowed: boolean;
  isDvMeasurerCpmGeoproductAllowed: boolean;
  isDvMeasurerCpmVideoAllowed: boolean;
  isDvMeasurerCpmYndxFrontpageAllowed: boolean;
  isIntegralAdScienceMeasurerCpmBannerAllowed: boolean;
  isIntegralAdScienceMeasurerCpmAudioAllowed: boolean;
  isIntegralAdScienceMeasurerCpmDealsAllowed: boolean;
  isIntegralAdScienceMeasurerCpmGeoproductAllowed: boolean;
  isIntegralAdScienceMeasurerCpmVideoAllowed: boolean;
  isIntegralAdScienceMeasurerCpmYndxFrontpageAllowed: boolean;
  isLandingsWizardAllowed: boolean;
  isMediascopeMeasurerCpmBannerAllowed: boolean;
  isMediascopeMeasurerCpmAudioAllowed: boolean;
  isMediascopeMeasurerCpmDealsAllowed: boolean;
  isMediascopeMeasurerCpmGeoproductAllowed: boolean;
  isMediascopeMeasurerCpmVideoAllowed: boolean;
  isMediascopeMeasurerCpmYndxFrontpageAllowed: boolean;
  isMoatMeasurerCpmBannerAllowed: boolean;
  isMoatMeasurerCpmAudioAllowed: boolean;
  isMoatMeasurerCpmDealsAllowed: boolean;
  isMoatMeasurerCpmGeoproductAllowed: boolean;
  isMoatMeasurerCpmVideoAllowed: boolean;
  isMoatMeasurerCpmYndxFrontpageAllowed: boolean;
  isMediascopeMeasurerEnabled: boolean;
  isSizmekMeasurerCpmBannerAllowed: boolean;
  isSizmekMeasurerCpmAudioAllowed: boolean;
  isSizmekMeasurerCpmDealsAllowed: boolean;
  isSizmekMeasurerCpmGeoproductAllowed: boolean;
  isSizmekMeasurerCpmVideoAllowed: boolean;
  isSizmekMeasurerCpmYndxFrontpageAllowed: boolean;
  isWeboramaMeasurerCpmBannerAllowed: boolean;
  isWeboramaMeasurerCpmAudioAllowed: boolean;
  isWeboramaMeasurerCpmDealsAllowed: boolean;
  isWeboramaMeasurerCpmGeoproductAllowed: boolean;
  isWeboramaMeasurerCpmVideoAllowed: boolean;
  isWeboramaMeasurerCpmYndxFrontpageAllowed: boolean;
  isTnsEnabled: boolean;
}

export interface CommonQuery_client_info_managersInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface CommonQuery_client_info_agencyInfo {
  __typename: "GdAgencyInfo";
  clientId: GraphQlLong | null;
  userId: GraphQlLong | null;
  name: string | null;
  login: string | null;
  email: string | null;
  phone: string | null;
  representativeName: string | null;
}

export interface CommonQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
  translocalGeotreeType: GdGeotreeType;
  autoVideo: boolean;
  internalAdProductName: string | null;
  managersInfo: CommonQuery_client_info_managersInfo[];
  agencyInfo: CommonQuery_client_info_agencyInfo | null;
}

export interface CommonQuery_client {
  __typename: "GdClient";
  measurerAccounts: (GdClientMeasurerSystem | null)[];
  wallets: CommonQuery_client_wallets[];
  access: CommonQuery_client_access;
  features: CommonQuery_client_features;
  info: CommonQuery_client_info;
}

export interface CommonQuery_constants_strategyConstants {
  __typename: "GdStrategyConstants";
  maxDailyBudgetChangesPerDay: number;
}

export interface CommonQuery_constants_currencyConstants {
  __typename: "GdCurrencyDescription";
  code: CurrencyCode;
  minDailyBudget: GraphQlBigDecimal;
  maxDailyBudget: GraphQlBigDecimal;
  bigRate: GraphQlBigDecimal;
  minPrice: GraphQlBigDecimal;
  maxPrice: GraphQlBigDecimal;
  defaultPrice: GraphQlBigDecimal;
  minCpmPrice: GraphQlBigDecimal;
  maxCpmPrice: GraphQlBigDecimal;
  autobudgetAvgCpaWarning: GraphQlBigDecimal;
  autobudgetAvgPriceWarning: GraphQlBigDecimal;
  autobudgetClicksBundleWarning: number;
  autobudgetMaxPriceWarning: GraphQlBigDecimal;
  autobudgetSumWarning: GraphQlBigDecimal;
  maxAutobudget: GraphQlBigDecimal;
  maxAutobudgetBid: GraphQlBigDecimal;
  maxAutobudgetClicksBundle: GraphQlLong;
  minAutobudget: GraphQlBigDecimal;
  minAutobudgetBid: GraphQlBigDecimal;
  minAutobudgetClicksBundle: number;
  minAutobudgetAvgCpa: GraphQlBigDecimal;
  minAutobudgetAvgPrice: GraphQlBigDecimal;
  brandSurveyBudgetThreshold: GraphQlBigDecimal;
  autobudgetPayForConversionAvgCpaWarning: GraphQlBigDecimal;
}

export interface CommonQuery_constants_alertData {
  __typename: "GdAlertData";
  enabled: boolean;
  textRu: string | null;
  textEn: string | null;
}

export interface CommonQuery_constants_validation_libMinusKeywordsConstants {
  __typename: "GdDirectConstantsMinusWordsLibValidationData";
  libMinusKeywordsTextMaxLength: number;
  maxLibraryPacksCount: number;
  maxLinkedPacksToOneAdGroup: number;
  maxNameLength: number;
  maxWordsInMinusPhrase: number;
  nameAllowLetters: string;
  textAllowLetters: string;
}

export interface CommonQuery_constants_validation_adGroupConstants {
  __typename: "GdDirectConstantsAdGroupValidationData";
  maxAdGroupsCountPerUpdate: number;
}

export interface CommonQuery_constants_validation_campaignConstants {
  __typename: "GdDirectConstantsCampaignValidationData";
  minWarningBalanceInPercent: number;
  maxWarningBalanceInPercent: number;
}

export interface CommonQuery_constants_validation_vcardConstants {
  __typename: "GdDirectConstantsVcardValidationData";
  companyNameMaxLength: number;
  contactPersonMaxLength: number;
  contactEmailMaxLength: number;
  extraMessageMaxLength: number;
  countryMaxLength: number;
  cityMaxLength: number;
  streetMaxLength: number;
  houseWithBuildingMaxLength: number;
  apartmentMaxLength: number;
  instantMessengerLoginMaxLength: number;
  pointOnMapLongitudeMin: GraphQlBigDecimal;
  pointOnMapLongitudeMax: GraphQlBigDecimal;
  pointOnMapLatitudeMin: GraphQlBigDecimal;
  pointOnMapLatitudeMax: GraphQlBigDecimal;
  countryCodeMaxLength: number;
  cityCodeMaxLength: number;
  phoneNumberMinLength: number;
  phoneNumberMaxLength: number;
  extensionMaxLength: number;
  entirePhoneMinLength: number;
  entirePhoneMaxLength: number;
  entirePhoneWithExtensionMaxLength: number;
}

export interface CommonQuery_constants_validation {
  __typename: "GdDirectConstantsValidationData";
  libMinusKeywordsConstants: CommonQuery_constants_validation_libMinusKeywordsConstants;
  adGroupConstants: CommonQuery_constants_validation_adGroupConstants;
  campaignConstants: CommonQuery_constants_validation_campaignConstants;
  vcardConstants: CommonQuery_constants_validation_vcardConstants;
}

export interface CommonQuery_constants_defaultValues_campaign_defaultSmsTimeInterval_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CommonQuery_constants_defaultValues_campaign_defaultSmsTimeInterval_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CommonQuery_constants_defaultValues_campaign_defaultSmsTimeInterval {
  __typename: "GdTimeInterval";
  endTime: CommonQuery_constants_defaultValues_campaign_defaultSmsTimeInterval_endTime;
  startTime: CommonQuery_constants_defaultValues_campaign_defaultSmsTimeInterval_startTime;
}

export interface CommonQuery_constants_defaultValues_campaign {
  __typename: "GdCampaignDefaultValues";
  defaultWarningBalance: number;
  defaultCheckPositionInterval: GdCampaignCheckPositionInterval;
  defaultSmsTimeInterval: CommonQuery_constants_defaultValues_campaign_defaultSmsTimeInterval;
}

export interface CommonQuery_constants_defaultValues {
  __typename: "GdDefaultValues";
  campaign: CommonQuery_constants_defaultValues_campaign;
}

export interface CommonQuery_constants_configuration {
  __typename: "GdConfigurationConstants";
  balanceDomain: string;
  canvasUiDomain: string;
  spravIFrameUrl: string;
  surveysUiUrl: string;
}

export interface CommonQuery_constants {
  __typename: "GdDirectConstants";
  /**
   * Максимально допустимая конечная дата для заказа агентсткого оффлайн-отчета
   */
  agencyOfflineReportMaximumDate: GraphQlLocalDate;
  strategyConstants: CommonQuery_constants_strategyConstants;
  currencyConstants: CommonQuery_constants_currencyConstants[];
  alertData: CommonQuery_constants_alertData;
  validation: CommonQuery_constants_validation;
  defaultValues: CommonQuery_constants_defaultValues;
  configuration: CommonQuery_constants_configuration;
}

export interface CommonQuery_operator_info {
  __typename: "GdUserInfo";
  login: string;
}

export interface CommonQuery_operator_access {
  __typename: "GdOperatorAccess";
  canEditInternationalization: boolean;
  canSearchPhrasesDuplicates: boolean;
  canEditAdDomain: boolean;
  canViewListOfInternalAdManagers: boolean;
  canViewListOfInternalAdProducts: boolean;
  canEditInternalAdManagers: boolean;
  canEditInternalAdProducts: boolean;
  actions: GdOperatorAction[];
}

export interface CommonQuery_operator_officeInfo_cityContact {
  __typename: "GdOfficeContactData";
  description: string;
  cityName: string | null;
  phone: string;
  phoneExtension: string | null;
}

export interface CommonQuery_operator_officeInfo_regionContact {
  __typename: "GdOfficeContactData";
  description: string;
  cityName: string | null;
  phone: string;
  phoneExtension: string | null;
}

export interface CommonQuery_operator_officeInfo_regionContact2 {
  __typename: "GdOfficeContactData";
  description: string;
  cityName: string | null;
  phone: string;
  phoneExtension: string | null;
}

export interface CommonQuery_operator_officeInfo {
  __typename: "GdOfficeInfo";
  cityContact: CommonQuery_operator_officeInfo_cityContact | null;
  regionContact: CommonQuery_operator_officeInfo_regionContact | null;
  regionContact2: CommonQuery_operator_officeInfo_regionContact2 | null;
}

export interface CommonQuery_operator_managerInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface CommonQuery_operator_chiefInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface CommonQuery_operator_agencyInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface CommonQuery_operator_features {
  __typename: "GdOperatorFeatures";
  isAdGroupUpdateAllowed: boolean;
  isBannerUpdateAllowed: boolean;
  isCpmBannerUpdateAllowed: boolean;
  isBannerAimingAllowed: boolean;
  isBannerAimingCpmAllowed: boolean;
  isPerformanceAdEditAllowed: boolean;
  isOutdoorGroupsEditAllowed: boolean;
  isIndoorGroupsEditAllowed: boolean;
  isRetargetingGridEnabled: boolean;
  isAdsMassEditAllowed: boolean;
  isCampaignAddAllowed: boolean;
  isCampaignUpdateAllowed: boolean;
  isCpmAdGroupUpdateAllowed: boolean;
  isVideoGroupsEditAllowed: boolean;
  isGeoproductGroupsEditAllowed: boolean;
  isAudioGroupsEditAllowed: boolean;
  isAggregatedStatusAllowed: boolean;
  isMcBannerDnaEnabled: boolean;
  isTargetTagsAllowed: boolean;
  isOldPhraseSelectorWizardDisabled: boolean;
}

export interface CommonQuery_operator {
  __typename: "GdOperatorInfo";
  tuneSecretKey: string | null;
  workCurrency: CurrencyCode;
  isSelfAgency: boolean;
  isAgency: boolean;
  info: CommonQuery_operator_info | null;
  access: CommonQuery_operator_access;
  officeInfo: CommonQuery_operator_officeInfo;
  managerInfo: CommonQuery_operator_managerInfo | null;
  chiefInfo: CommonQuery_operator_chiefInfo | null;
  agencyInfo: CommonQuery_operator_agencyInfo | null;
  features: CommonQuery_operator_features | null;
}

export interface CommonQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CommonQuery_client;
  constants: CommonQuery_constants;
  operator: CommonQuery_operator;
}

export interface CommonQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FindAndReplaceKeywordsPreview
// ====================================================

export interface FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview_rowset {
  __typename: "GdFindAndReplaceKeywordsPreviewPayloadItem";
  minusKeywords: string[];
  changedMinusKeywords: string[] | null;
  keyword: string;
  changedKeyword: string | null;
}

export interface FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview_validationResult_errors {
  __typename: "GdDefect";
  path: string;
  code: string;
  params: GraphQlObjectScalar | null;
}

export interface FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview_validationResult {
  __typename: "GdValidationResult";
  errors: FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview_validationResult_errors[];
}

export interface FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview {
  __typename: "GdFindAndReplaceKeywordsPreviewPayload";
  cacheKey: string;
  totalCount: number;
  rowset: FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview_rowset[];
  validationResult: FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview_validationResult | null;
}

export interface FindAndReplaceKeywordsPreview {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  getFindAndReplaceKeywordsPreview: FindAndReplaceKeywordsPreview_getFindAndReplaceKeywordsPreview;
}

export interface FindAndReplaceKeywordsPreviewVariables {
  input: GdFindAndReplaceKeywordsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CommonWalletQuery
// ====================================================

export interface CommonWalletQuery_client_wallets_status {
  __typename: "GdWalletStatus";
  enabled: boolean;
}

export interface CommonWalletQuery_client_wallets {
  __typename: "GdWallet";
  sum: GraphQlBigDecimal;
  currency: CurrencyCode;
  status: CommonWalletQuery_client_wallets_status;
}

export interface CommonWalletQuery_client {
  __typename: "GdClient";
  wallets: CommonWalletQuery_client_wallets[];
}

export interface CommonWalletQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CommonWalletQuery_client;
}

export interface CommonWalletQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BalanceCartDataQuery
// ====================================================

export interface BalanceCartDataQuery_client_wallets {
  __typename: "GdWallet";
  id: GraphQlLong;
}

export interface BalanceCartDataQuery_client_features {
  __typename: "GdClientFeatures";
  isB2bBalanceCartEnabled: boolean;
}

export interface BalanceCartDataQuery_client {
  __typename: "GdClient";
  wallets: BalanceCartDataQuery_client_wallets[];
  features: BalanceCartDataQuery_client_features;
}

export interface BalanceCartDataQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: BalanceCartDataQuery_client;
}

export interface BalanceCartDataQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: DealsCount
// ====================================================

export interface DealsCount_client_deals {
  __typename: "GdDealsContext";
  totalCount: number;
}

export interface DealsCount_client {
  __typename: "GdClient";
  deals: DealsCount_client_deals;
}

export interface DealsCount {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: DealsCount_client;
}

export interface DealsCountVariables {
  login: string;
  dealsFilter?: GdiDealFilterInput | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: HeaderClientInfoQuery
// ====================================================

export interface HeaderClientInfoQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  chiefUserId: GraphQlLong;
  agencyClientId: GraphQlLong | null;
}

export interface HeaderClientInfoQuery_client_wallets_status {
  __typename: "GdWalletStatus";
  enabled: boolean;
}

export interface HeaderClientInfoQuery_client_wallets_budget {
  __typename: "GdWalletBudget";
  sum: GraphQlBigDecimal | null;
  showMode: GdWalletBudgetShowMode | null;
  type: GdWalletBudgetType;
}

export interface HeaderClientInfoQuery_client_wallets {
  __typename: "GdWallet";
  id: GraphQlLong;
  status: HeaderClientInfoQuery_client_wallets_status;
  budget: HeaderClientInfoQuery_client_wallets_budget;
  sum: GraphQlBigDecimal;
  currency: CurrencyCode;
  actions: GdWalletAction[];
}

export interface HeaderClientInfoQuery_client {
  __typename: "GdClient";
  info: HeaderClientInfoQuery_client_info;
  wallets: HeaderClientInfoQuery_client_wallets[];
}

export interface HeaderClientInfoQuery {
  client: HeaderClientInfoQuery_client;
}

export interface HeaderClientInfoQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: MenuHeaderQuery
// ====================================================

export interface MenuHeaderQuery_menuHeader {
  __typename: "GdMenuHeaderInfo";
  allowedMenuItems: GdMenuItem[];
}

export interface MenuHeaderQuery {
  menuHeader: MenuHeaderQuery_menuHeader;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: HeaderInfoQuery
// ====================================================

export interface HeaderInfoQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  chiefUserId: GraphQlLong;
  agencyClientId: GraphQlLong | null;
}

export interface HeaderInfoQuery_client_deals {
  __typename: "GdDealsContext";
  totalCount: number;
}

export interface HeaderInfoQuery_client_features {
  __typename: "GdClientFeatures";
  isB2bBalanceCartEnabled: boolean;
}

export interface HeaderInfoQuery_client_access {
  __typename: "GdClientAccess";
  canSeeDealsLinkEverywhere: boolean;
}

export interface HeaderInfoQuery_client_wallets_status {
  __typename: "GdWalletStatus";
  enabled: boolean;
}

export interface HeaderInfoQuery_client_wallets_budget {
  __typename: "GdWalletBudget";
  sum: GraphQlBigDecimal | null;
  showMode: GdWalletBudgetShowMode | null;
  type: GdWalletBudgetType;
}

export interface HeaderInfoQuery_client_wallets {
  __typename: "GdWallet";
  id: GraphQlLong;
  status: HeaderInfoQuery_client_wallets_status;
  budget: HeaderInfoQuery_client_wallets_budget;
  sum: GraphQlBigDecimal;
  currency: CurrencyCode;
  actions: GdWalletAction[];
}

export interface HeaderInfoQuery_client {
  __typename: "GdClient";
  info: HeaderInfoQuery_client_info;
  deals: HeaderInfoQuery_client_deals;
  features: HeaderInfoQuery_client_features;
  access: HeaderInfoQuery_client_access;
  wallets: HeaderInfoQuery_client_wallets[];
}

export interface HeaderInfoQuery_operator_info {
  __typename: "GdUserInfo";
  userId: GraphQlLong;
}

export interface HeaderInfoQuery_operator {
  __typename: "GdOperatorInfo";
  info: HeaderInfoQuery_operator_info | null;
  isAgency: boolean;
}

export interface HeaderInfoQuery {
  /**
   * Получить reqId запроса
   */
  getReqId: string;
  client: HeaderInfoQuery_client;
  operator: HeaderInfoQuery_operator;
}

export interface HeaderInfoQueryVariables {
  login: string;
  dealsFilter?: GdiDealFilterInput | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: WalletInfoQuery
// ====================================================

export interface WalletInfoQuery_client_wallets_status {
  __typename: "GdWalletStatus";
  enabled: boolean;
}

export interface WalletInfoQuery_client_wallets_budget {
  __typename: "GdWalletBudget";
  sum: GraphQlBigDecimal | null;
  showMode: GdWalletBudgetShowMode | null;
  type: GdWalletBudgetType;
}

export interface WalletInfoQuery_client_wallets {
  __typename: "GdWallet";
  id: GraphQlLong;
  status: WalletInfoQuery_client_wallets_status;
  budget: WalletInfoQuery_client_wallets_budget;
  sum: GraphQlBigDecimal;
  currency: CurrencyCode;
  actions: GdWalletAction[];
}

export interface WalletInfoQuery_client {
  __typename: "GdClient";
  wallets: WalletInfoQuery_client_wallets[];
}

export interface WalletInfoQuery {
  /**
   * Получить reqId запроса
   */
  getReqId: string;
  client: WalletInfoQuery_client;
}

export interface WalletInfoQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CheckClientMutationStateQuery
// ====================================================

export interface CheckClientMutationStateQuery_checkClientMutationState {
  __typename: "GdCheckClientMutationStatePayload";
  state: GdClientMutationState;
}

export interface CheckClientMutationStateQuery {
  checkClientMutationState: CheckClientMutationStateQuery_checkClientMutationState;
}

export interface CheckClientMutationStateQueryVariables {
  input: GdCheckClientMutationStateInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AuthorizationQuery
// ====================================================

export interface AuthorizationQuery_operator_chiefInfo {
  __typename: "GdUserInfo";
  login: string;
  clientId: GraphQlLong;
  userId: GraphQlLong;
}

export interface AuthorizationQuery_operator {
  __typename: "GdOperatorInfo";
  chiefInfo: AuthorizationQuery_operator_chiefInfo | null;
  isFreelancer: boolean;
}

export interface AuthorizationQuery {
  operator: AuthorizationQuery_operator;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ClientMetrikaCountersQuery
// ====================================================

export interface ClientMetrikaCountersQuery_client_metrikaCounters {
  __typename: "GdClientMetrikaCounters";
  counters: number[] | null;
  isMetrikaAvailable: boolean;
}

export interface ClientMetrikaCountersQuery_client {
  __typename: "GdClient";
  metrikaCounters: ClientMetrikaCountersQuery_client_metrikaCounters;
}

export interface ClientMetrikaCountersQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: ClientMetrikaCountersQuery_client;
}

export interface ClientMetrikaCountersQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: TimeZoneGroupsQuery
// ====================================================

export interface TimeZoneGroupsQuery_constants_timezoneGroups_timezones {
  __typename: "GdTimezone";
  id: GraphQlLong;
  name: string;
}

export interface TimeZoneGroupsQuery_constants_timezoneGroups {
  __typename: "GdTimezoneGroup";
  groupNick: string;
  timezones: TimeZoneGroupsQuery_constants_timezoneGroups_timezones[];
}

export interface TimeZoneGroupsQuery_constants {
  __typename: "GdDirectConstants";
  /**
   * Доступные группы таймзон
   */
  timezoneGroups: TimeZoneGroupsQuery_constants_timezoneGroups[];
}

export interface TimeZoneGroupsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  constants: TimeZoneGroupsQuery_constants;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPhoneCodeByRegionIdQuery
// ====================================================

export interface GetPhoneCodeByRegionIdQuery_getPhoneCodeByRegionId {
  __typename: "GdPhoneCodes";
  codes: number[];
}

export interface GetPhoneCodeByRegionIdQuery {
  getPhoneCodeByRegionId: GetPhoneCodeByRegionIdQuery_getPhoneCodeByRegionId;
}

export interface GetPhoneCodeByRegionIdQueryVariables {
  input: GdRegionInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CryptaSegments
// ====================================================

export interface CryptaSegments_cryptaSegments_rowset {
  __typename: "GdCryptaSegment";
  id: GraphQlLong;
  type: WebGoalType;
  name: string;
  parentId: GraphQlLong | null;
  description: string;
  interestType: CryptaInterestTypeWeb | null;
  canSelectAll: boolean | null;
  mutuallyExclusiveIds: GraphQlLong[] | null;
}

export interface CryptaSegments_cryptaSegments {
  __typename: "GdCryptaSegmentsContext";
  totalCount: number;
  rowset: CryptaSegments_cryptaSegments_rowset[];
}

export interface CryptaSegments {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  cryptaSegments: CryptaSegments_cryptaSegments;
}

export interface CryptaSegmentsVariables {
  input: GdCryptaSegmentsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: DealsQuery
// ====================================================

export interface DealsQuery_client_deals_rowset_placements {
  __typename: "GdiDealPlacement";
  domain: string | null;
  formats: (string | null)[] | null;
}

export interface DealsQuery_client_deals_rowset {
  __typename: "GdiDeal";
  id: GraphQlLong;
  name: string | null;
  status: StatusDirect;
  completeReason: CompleteReason | null;
  dateStart: GraphQlLocalDateTime | null;
  dateEnd: GraphQlLocalDateTime | null;
  description: string | null;
  expectedMoneyPerWeek: GraphQlLong | null;
  expectedImpressionsPerWeek: GraphQlLong | null;
  dealType: DealType;
  contacts: string | null;
  minPrice: GraphQlBigDecimal | null;
  targetingsText: string | null;
  agencyFeePercent: GraphQlBigDecimal | null;
  currencyCode: string | null;
  publisherName: string | null;
  numberOfLinkedCampaigns: number | null;
  clicks: GraphQlLong | null;
  cpc: GraphQlBigDecimal | null;
  cpm: GraphQlBigDecimal | null;
  ctr: GraphQlBigDecimal | null;
  placements: DealsQuery_client_deals_rowset_placements[] | null;
  shows: GraphQlLong | null;
  spent: GraphQlBigDecimal | null;
}

export interface DealsQuery_client_deals {
  __typename: "GdDealsContext";
  rowset: DealsQuery_client_deals_rowset[];
  totalCount: number;
  cacheKey: string;
  dealIds: GraphQlLong[];
}

export interface DealsQuery_client {
  __typename: "GdClient";
  deals: DealsQuery_client_deals;
}

export interface DealsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: DealsQuery_client;
}

export interface DealsQueryVariables {
  login: string;
  limit?: number | null;
  offset?: number | null;
  selectedDealIds?: GraphQlLong[] | null;
  needStats: boolean;
  orderBy?: GdDealOrderByInput[] | null;
  filter?: GdiDealFilterInput | null;
  cacheKey?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: DialogsQuery
// ====================================================

export interface DialogsQuery_client_dialogs {
  __typename: "GdDialog";
  id: GraphQlLong | null;
  name: string;
  isActive: boolean;
  skillId: string;
}

export interface DialogsQuery_client {
  __typename: "GdClient";
  dialogs: (DialogsQuery_client_dialogs | null)[];
  chiefLogin: string;
}

export interface DialogsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: DialogsQuery_client;
}

export interface DialogsQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignsQuery
// ====================================================

export interface CampaignsQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
  isTextBannerInterestsRetCondEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isCampaignDefaultOrganizationsEnabled: boolean;
  isShowAutoAssignedOrganizationsEnabled: boolean;
  isInAppEventsInRmpEnabled: boolean;
  isTargetTagsAllowed: boolean;
}

export interface CampaignsQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi = CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_keys[];
  kpi: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi;
}

export type CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations = CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithoutKpi | CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi;

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy = CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_aggregatedStatusInfo_counters {
  __typename: "GdCampaignAggregatedStatusCountersInfo";
  adgroups: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_aggregatedStatusInfo {
  __typename: "GdCampaignAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
  counters: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_aggregatedStatusInfo_counters;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  agencyId: GraphQlLong | null;
  name: string;
  index: number;
  currency: CurrencyCode | null;
  type: GdCampaignType;
  sum: GraphQlBigDecimal | null;
  hasAds: boolean;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  recommendations: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_recommendations[] | null;
  strategy: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_aggregatedStatusInfo | null;
  status: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_status;
  access: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_access;
  stats: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_stats;
  goalStats: CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign_goalStats[] | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi = CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_keys[];
  kpi: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi;
}

export type CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations = CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi;

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy = CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyAvgClick | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdCampaignStrategyManual | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy_GdStrategyOptimizeConversions;

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_aggregatedStatusInfo_counters {
  __typename: "GdCampaignAggregatedStatusCountersInfo";
  adgroups: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_aggregatedStatusInfo {
  __typename: "GdCampaignAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
  counters: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_aggregatedStatusInfo_counters;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_brandSurveyStatus {
  __typename: "GdBrandSurveyStatus";
  surveyStatus: GdSurveyStatus;
  reasonIds: GraphQlLong[];
  brandSurveyStopReasons: GdBrandSurveyStopReason[];
}

export interface CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign";
  id: GraphQlLong;
  agencyId: GraphQlLong | null;
  name: string;
  index: number;
  currency: CurrencyCode | null;
  type: GdCampaignType;
  sum: GraphQlBigDecimal | null;
  hasAds: boolean;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  recommendations: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_recommendations[] | null;
  strategy: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_strategy;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_aggregatedStatusInfo | null;
  status: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_status;
  access: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_access;
  stats: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_stats;
  goalStats: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_goalStats[] | null;
  brandSurveyId: string | null;
  brandSurveyStatus: CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign_brandSurveyStatus | null;
}

export type CampaignsQuery_client_campaigns_rowset = CampaignsQuery_client_campaigns_rowset_GdContentPromotionCampaign | CampaignsQuery_client_campaigns_rowset_GdCpmBannerCampaign;

export interface CampaignsQuery_client_campaigns_totalStats {
  __typename: "GdEntityStats";
  cost: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  clicks: GraphQlLong | null;
  ctr: GraphQlBigDecimal | null;
}

export interface CampaignsQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: CampaignsQuery_client_campaigns_rowset[];
  totalCount: number;
  campaignIds: GraphQlLong[];
  cacheKey: string;
  totalStats: CampaignsQuery_client_campaigns_totalStats;
}

export interface CampaignsQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: CampaignsQuery_client_features;
  info: CampaignsQuery_client_info;
  campaigns: CampaignsQuery_client_campaigns;
}

export interface CampaignsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignsQuery_client;
}

export interface CampaignsQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignPayActionInfoQuery
// ====================================================

export interface CampaignPayActionInfoQuery_client_campaigns_features {
  __typename: "GdCampaignsFeatures";
  campaignTypes: GdCampaignType[];
}

export interface CampaignPayActionInfoQuery_client_campaigns_rowset_access {
  __typename: "GdCampaignAccess";
  actions: GdCampaignAction[];
}

export interface CampaignPayActionInfoQuery_client_campaigns_rowset_status {
  __typename: "GdCampaignStatus";
  moderationStatus: GdCampaignStatusModerate;
}

export interface CampaignPayActionInfoQuery_client_campaigns_rowset {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  access: CampaignPayActionInfoQuery_client_campaigns_rowset_access;
  status: CampaignPayActionInfoQuery_client_campaigns_rowset_status;
}

export interface CampaignPayActionInfoQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  features: CampaignPayActionInfoQuery_client_campaigns_features;
  rowset: CampaignPayActionInfoQuery_client_campaigns_rowset[];
}

export interface CampaignPayActionInfoQuery_client {
  __typename: "GdClient";
  campaigns: CampaignPayActionInfoQuery_client_campaigns;
}

export interface CampaignPayActionInfoQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignPayActionInfoQuery_client;
}

export interface CampaignPayActionInfoQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupsQuery
// ====================================================

export interface GroupsQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
  isTextBannerInterestsRetCondEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isCampaignDefaultOrganizationsEnabled: boolean;
  isShowAutoAssignedOrganizationsEnabled: boolean;
  isInAppEventsInRmpEnabled: boolean;
  isTargetTagsAllowed: boolean;
}

export interface GroupsQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_aggregatedStatusInfo_counters {
  __typename: "GdAdgroupAggregatedStatusCountersInfo";
  ads: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
  keywords: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_aggregatedStatusInfo {
  __typename: "GdAdgroupAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
  counters: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_aggregatedStatusInfo_counters;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign = GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdTextCampaign | GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi = GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations = GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithoutKpi | GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi;

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
  canEditRegions: boolean;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdMcBannerAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_aggregatedStatusInfo | null;
  index: number;
  adsCount: number;
  campaign: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_campaign;
  recommendations: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_regionsInfo;
  access: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_access;
  stats: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_stats;
  status: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_status;
  goalStats: GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_aggregatedStatusInfo_counters {
  __typename: "GdAdgroupAggregatedStatusCountersInfo";
  ads: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
  keywords: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_aggregatedStatusInfo {
  __typename: "GdAdgroupAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
  counters: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_aggregatedStatusInfo_counters;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign = GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdTextCampaign | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi = GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations = GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi;

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
  canEditRegions: boolean;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_aggregatedStatusInfo | null;
  index: number;
  adsCount: number;
  campaign: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_campaign;
  recommendations: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_regionsInfo;
  access: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_access;
  stats: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_stats;
  status: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_status;
  goalStats: GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
  mainDomain: string | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_aggregatedStatusInfo_counters {
  __typename: "GdAdgroupAggregatedStatusCountersInfo";
  ads: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
  keywords: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_aggregatedStatusInfo {
  __typename: "GdAdgroupAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
  counters: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_aggregatedStatusInfo_counters;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign = GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdTextCampaign | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi = GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations = GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi;

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
  canEditRegions: boolean;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_aggregatedStatusInfo | null;
  index: number;
  adsCount: number;
  campaign: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_campaign;
  recommendations: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_regionsInfo;
  access: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_access;
  stats: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_stats;
  status: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_status;
  goalStats: GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
  storeHref: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_aggregatedStatusInfo_counters {
  __typename: "GdAdgroupAggregatedStatusCountersInfo";
  ads: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
  keywords: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_aggregatedStatusInfo {
  __typename: "GdAdgroupAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
  counters: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_aggregatedStatusInfo_counters;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy = GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_strategy = GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_access;
  strategy: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy = GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_status;
  access: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign = GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdTextCampaign | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign_GdDynamicCampaign;

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi = GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations = GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations_GdRecommendationWithKpi;

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
  canEditRegions: boolean;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingInternalNetwork {
  __typename: "GdAdditionalTargetingInternalNetwork";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsBrowser {
  __typename: "GdAdditionalTargetingIsBrowser";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsTablet {
  __typename: "GdAdditionalTargetingIsTablet";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsMobile {
  __typename: "GdAdditionalTargetingIsMobile";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsTouch {
  __typename: "GdAdditionalTargetingIsTouch";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingUserAgents {
  __typename: "GdAdditionalTargetingUserAgents";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames {
  __typename: "GdAdditionalTargetingOsNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames_value[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
  minVersion: string | null;
  maxVersion: string | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies {
  __typename: "GdAdditionalTargetingOsFamilies";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies_value[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
  minVersion: string | null;
  maxVersion: string | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames {
  __typename: "GdAdditionalTargetingBrowserNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames_value[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
  minVersion: string | null;
  maxVersion: string | null;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines {
  __typename: "GdAdditionalTargetingBrowserEngines";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines_value[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors {
  __typename: "GdAdditionalTargetingDeviceVendors";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors_value[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceNames {
  __typename: "GdAdditionalTargetingDeviceNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingInterfaceLangs {
  __typename: "GdAdditionalTargetingInterfaceLangs";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: InterfaceLang[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingQueryReferers {
  __typename: "GdAdditionalTargetingQueryReferers";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingYandexUids {
  __typename: "GdAdditionalTargetingYandexUids";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingShowDates {
  __typename: "GdAdditionalTargetingShowDates";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLocalDate[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingClidTypes {
  __typename: "GdAdditionalTargetingClidTypes";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingClids {
  __typename: "GdAdditionalTargetingClids";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingDesktopInstalledApps {
  __typename: "GdAdditionalTargetingDesktopInstalledApps";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingMobileInstalledApps {
  __typename: "GdAdditionalTargetingMobileInstalledApps";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingQueryOptions {
  __typename: "GdAdditionalTargetingQueryOptions";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingTestIds {
  __typename: "GdAdditionalTargetingTestIds";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingYsCookies {
  __typename: "GdAdditionalTargetingYsCookies";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsYandexPlus {
  __typename: "GdAdditionalTargetingIsYandexPlus";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsVirused {
  __typename: "GdAdditionalTargetingIsVirused";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQuery_client_adGroups_rowset_GdInternalAdGroup {
  __typename: "GdInternalAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_aggregatedStatusInfo | null;
  index: number;
  adsCount: number;
  campaign: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_campaign;
  recommendations: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_regionsInfo;
  access: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_access;
  stats: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_stats;
  status: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_status;
  goalStats: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
  level: GraphQlLong | null;
  targetingInternalNetwork: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingInternalNetwork | null;
  targetingIsBrowser: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsBrowser | null;
  targetingIsTablet: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsTablet | null;
  targetingIsMobile: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsMobile | null;
  targetingIsTouch: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsTouch | null;
  targetingUserAgents: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingUserAgents | null;
  targetingOsNames: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames | null;
  targetingOsFamilies: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies | null;
  targetingBrowserNames: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames | null;
  targetingBrowserEngines: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines | null;
  targetingDeviceVendors: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors | null;
  targetingDeviceNames: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceNames | null;
  targetingInterfaceLangs: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingInterfaceLangs | null;
  targetingQueryReferers: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingQueryReferers | null;
  targetingYandexUids: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingYandexUids | null;
  targetingShowDates: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingShowDates | null;
  targetingClidTypes: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingClidTypes | null;
  targetingClids: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingClids | null;
  targetingDesktopInstalledApps: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingDesktopInstalledApps | null;
  targetingMobileInstalledApps: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingMobileInstalledApps | null;
  targetingQueryOptions: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingQueryOptions | null;
  targetingTestIds: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingTestIds | null;
  targetingYsCookies: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingYsCookies | null;
  targetingIsYandexPlus: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsYandexPlus | null;
  targetingIsVirused: GroupsQuery_client_adGroups_rowset_GdInternalAdGroup_targetingIsVirused | null;
  startTime: GraphQlLocalDateTime | null;
  finishTime: GraphQlLocalDateTime | null;
}

export type GroupsQuery_client_adGroups_rowset = GroupsQuery_client_adGroups_rowset_GdContentPromotionAdGroup | GroupsQuery_client_adGroups_rowset_GdDynamicAdGroup | GroupsQuery_client_adGroups_rowset_GdMobileContentAdGroup | GroupsQuery_client_adGroups_rowset_GdInternalAdGroup;

export interface GroupsQuery_client_adGroups_features {
  __typename: "GdAdGroupFeatures";
  hasAdGroupsOverLimit: boolean;
}

export interface GroupsQuery_client_adGroups_totalStats {
  __typename: "GdEntityStats";
  shows: GraphQlLong | null;
  clicks: GraphQlLong | null;
  ctr: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
}

export interface GroupsQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: GroupsQuery_client_adGroups_rowset[];
  features: GroupsQuery_client_adGroups_features;
  totalCount: number;
  adGroupIds: GraphQlLong[];
  cacheKey: string;
  totalStats: GroupsQuery_client_adGroups_totalStats;
}

export interface GroupsQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: GroupsQuery_client_features;
  info: GroupsQuery_client_info;
  adGroups: GroupsQuery_client_adGroups;
}

export interface GroupsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupsQuery_client;
}

export interface GroupsQueryVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupsMassActionsCount
// ====================================================

export interface GroupsMassActionsCount_client_adGroups_features {
  __typename: "GdAdGroupFeatures";
  canRemoderateAdsCalloutsCount: number;
  canAcceptAdsCalloutsModerationCount: number;
  canBeDeletedAdGroupsCount: number;
  canBeSentToModerationAdGroupsCount: number;
  canBeSentToBSAdGroupsCount: number;
  canBeSentToRemoderationAdGroupsCount: number;
  canAcceptModerationAdGroupsCount: number;
  canBeSentToModerationByClientAdGroupsCount: number;
  canBeCopied: number;
  canBeEditedRegionsCount: number;
}

export interface GroupsMassActionsCount_client_adGroups {
  __typename: "GdAdGroupsContext";
  features: GroupsMassActionsCount_client_adGroups_features;
}

export interface GroupsMassActionsCount_client {
  __typename: "GdClient";
  adGroups: GroupsMassActionsCount_client_adGroups;
}

export interface GroupsMassActionsCount {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupsMassActionsCount_client;
}

export interface GroupsMassActionsCountVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PhrasesQuery
// ====================================================

export interface PhrasesQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
  isTextBannerInterestsRetCondEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isCampaignDefaultOrganizationsEnabled: boolean;
  isShowAutoAssignedOrganizationsEnabled: boolean;
  isInAppEventsInRmpEnabled: boolean;
  isTargetTagsAllowed: boolean;
}

export interface PhrasesQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_aggregatedStatusInfo {
  __typename: "GdKeywordAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_status {
  __typename: "GdShowConditionStatus";
  suspended: boolean;
  primaryStatus: GdShowConditionPrimaryStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup = PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd = PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdCPCVideoAd | PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd_GdContentPromotionAd;

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_pokazometerData_allCostsAndClicks {
  __typename: "GdPokazometerCostsAndClicksItem";
  clicks: number;
  price: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_pokazometerData_priceForCoverage {
  __typename: "GdPokazometerPriceForCoverageItem";
  coverage: number;
  price: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_pokazometerData {
  __typename: "GdPokazometerData";
  allCostsAndClicks: PhrasesQuery_client_showConditions_rowset_GdKeyword_pokazometerData_allCostsAndClicks[];
  priceForCoverage: PhrasesQuery_client_showConditions_rowset_GdKeyword_pokazometerData_priceForCoverage[];
  maxShows: number | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_auctionData_auctionDataItems {
  __typename: "GdAuctionDataItem";
  bid: GraphQlBigDecimal;
  amnestyPrice: GraphQlBigDecimal;
  trafficVolume: GraphQlLong;
  showInTable: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword_auctionData {
  __typename: "GdAuctionData";
  auctionDataItems: PhrasesQuery_client_showConditions_rowset_GdKeyword_auctionData_auctionDataItems[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdKeyword {
  __typename: "GdKeyword";
  id: GraphQlLong;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: PhrasesQuery_client_showConditions_rowset_GdKeyword_aggregatedStatusInfo | null;
  status: PhrasesQuery_client_showConditions_rowset_GdKeyword_status;
  adGroup: PhrasesQuery_client_showConditions_rowset_GdKeyword_adGroup;
  access: PhrasesQuery_client_showConditions_rowset_GdKeyword_access;
  adsInAdGroupCount: number;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdKeyword_mainAd | null;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  index: number;
  type: GdShowConditionType;
  stats: PhrasesQuery_client_showConditions_rowset_GdKeyword_stats;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdKeyword_goalStats[] | null;
  priceContext: GraphQlBigDecimal | null;
  weightedCtr: GraphQlBigDecimal;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  showsForecast: GraphQlLong | null;
  price: GraphQlBigDecimal | null;
  usePhraseTrafaretAuction: boolean;
  minusKeywords: string[];
  pokazometerData: PhrasesQuery_client_showConditions_rowset_GdKeyword_pokazometerData | null;
  keyword: string;
  auctionData: PhrasesQuery_client_showConditions_rowset_GdKeyword_auctionData | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_aggregatedStatusInfo {
  __typename: "GdKeywordAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_status {
  __typename: "GdShowConditionStatus";
  suspended: boolean;
  primaryStatus: GdShowConditionPrimaryStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_access;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_typedCreative = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_image | null;
  bannerImage: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_typedCreative | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_status;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd = PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdCPCVideoAd | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd_GdContentPromotionAd;

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
  id: GraphQlLong;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_aggregatedStatusInfo | null;
  status: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_status;
  adGroup: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup;
  access: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_access;
  adsInAdGroupCount: number;
  mainAd: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_mainAd | null;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  index: number;
  type: GdShowConditionType;
  stats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_stats;
  goalStats: PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch_goalStats[] | null;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  price: GraphQlBigDecimal | null;
  priceContext: GraphQlBigDecimal | null;
}

export type PhrasesQuery_client_showConditions_rowset = PhrasesQuery_client_showConditions_rowset_GdKeyword | PhrasesQuery_client_showConditions_rowset_GdRelevanceMatch;

export interface PhrasesQuery_client_showConditions_features {
  __typename: "GdShowConditionFeatures";
  commonPlatform: GdCampaignPlatform[];
  commonCampaignTypes: GdCampaignType[];
}

export interface PhrasesQuery_client_showConditions_totalStats {
  __typename: "GdEntityStats";
  shows: GraphQlLong | null;
  clicks: GraphQlLong | null;
  ctr: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
}

export interface PhrasesQuery_client_showConditions {
  __typename: "GdShowConditionsContext";
  rowset: PhrasesQuery_client_showConditions_rowset[];
  totalCount: number;
  showConditionIds: GraphQlLong[];
  features: PhrasesQuery_client_showConditions_features;
  totalStats: PhrasesQuery_client_showConditions_totalStats;
  hasObjectsOverLimit: boolean;
  cacheKey: string;
}

export interface PhrasesQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: PhrasesQuery_client_features;
  info: PhrasesQuery_client_info;
  showConditions: PhrasesQuery_client_showConditions;
}

export interface PhrasesQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: PhrasesQuery_client;
}

export interface PhrasesQueryVariables {
  showConditionsInput: GdShowConditionsContainerInput;
  login?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: TargetingQuery
// ====================================================

export interface TargetingQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
  isTextBannerInterestsRetCondEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isCampaignDefaultOrganizationsEnabled: boolean;
  isShowAutoAssignedOrganizationsEnabled: boolean;
  isInAppEventsInRmpEnabled: boolean;
  isTargetTagsAllowed: boolean;
}

export interface TargetingQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup = TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdContentPromotionAdGroup | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdDynamicAdGroup | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdMobileContentAdGroup | TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup_GdSmartAdGroup;

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_status {
  __typename: "GdShowConditionStatus";
  primaryStatus: GdShowConditionPrimaryStatus;
  deleted: boolean;
  suspended: boolean;
  statusModerate: GdShowConditionStatusModerate;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdKeyword {
  __typename: "GdKeyword";
  id: GraphQlLong;
  adGroupId: GraphQlLong;
  adGroup: TargetingQuery_client_showConditions_rowset_GdKeyword_adGroup;
  status: TargetingQuery_client_showConditions_rowset_GdKeyword_status;
  access: TargetingQuery_client_showConditions_rowset_GdKeyword_access;
  stats: TargetingQuery_client_showConditions_rowset_GdKeyword_stats;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_access;
  mainAd: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup = TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdDynamicAdGroup | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdMobileContentAdGroup | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup_GdSmartAdGroup;

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_status {
  __typename: "GdShowConditionStatus";
  primaryStatus: GdShowConditionPrimaryStatus;
  deleted: boolean;
  suspended: boolean;
  statusModerate: GdShowConditionStatusModerate;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface TargetingQuery_client_showConditions_rowset_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
  id: GraphQlLong;
  adGroupId: GraphQlLong;
  adGroup: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_adGroup;
  status: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_status;
  access: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_access;
  stats: TargetingQuery_client_showConditions_rowset_GdRelevanceMatch_stats;
  price: GraphQlBigDecimal | null;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
}

export type TargetingQuery_client_showConditions_rowset = TargetingQuery_client_showConditions_rowset_GdKeyword | TargetingQuery_client_showConditions_rowset_GdRelevanceMatch;

export interface TargetingQuery_client_showConditions {
  __typename: "GdShowConditionsContext";
  rowset: TargetingQuery_client_showConditions_rowset[];
  cacheKey: string;
  totalCount: number;
  showConditionIds: GraphQlLong[];
  hasObjectsOverLimit: boolean;
}

export interface TargetingQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: TargetingQuery_client_features;
  info: TargetingQuery_client_info;
  showConditions: TargetingQuery_client_showConditions;
}

export interface TargetingQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: TargetingQuery_client;
}

export interface TargetingQueryVariables {
  login: string;
  showConditionsInput: GdShowConditionsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingsQuery
// ====================================================

export interface RetargetingsQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
  isTextBannerInterestsRetCondEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isCampaignDefaultOrganizationsEnabled: boolean;
  isShowAutoAssignedOrganizationsEnabled: boolean;
  isInAppEventsInRmpEnabled: boolean;
  isTargetTagsAllowed: boolean;
}

export interface RetargetingsQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
}

export interface RetargetingsQuery_client_retargetings_rowset_access {
  __typename: "GdRetargetingAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_retargetingCondition_conditionRules_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  type: GdGoalType;
  time: number | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_retargetingCondition_conditionRules {
  __typename: "GdRetargetingConditionRuleItem";
  type: GdRetargetingConditionRuleType;
  interestType: CryptaInterestType | null;
  goals: RetargetingsQuery_client_retargetings_rowset_retargetingCondition_conditionRules_goals[];
}

export interface RetargetingsQuery_client_retargetings_rowset_retargetingCondition {
  __typename: "GdRetargetingCondition";
  name: string;
  description: string | null;
  conditionRules: RetargetingsQuery_client_retargetings_rowset_retargetingCondition_conditionRules[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign = RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd = RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_access;
  mainAd: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd = RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_access;
  mainAd: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_regionsInfo;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd = RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_access;
  mainAd: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd = RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign;
  access: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_access;
  mainAd: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_regionsInfo;
  status: RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type RetargetingsQuery_client_retargetings_rowset_adGroup = RetargetingsQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup | RetargetingsQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup | RetargetingsQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup | RetargetingsQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup;

export interface RetargetingsQuery_client_retargetings_rowset_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface RetargetingsQuery_client_retargetings_rowset {
  __typename: "GdRetargeting";
  access: RetargetingsQuery_client_retargetings_rowset_access;
  retargetingId: GraphQlLong;
  isSuspended: boolean;
  priceContext: GraphQlBigDecimal;
  retargetingCondition: RetargetingsQuery_client_retargetings_rowset_retargetingCondition | null;
  adGroup: RetargetingsQuery_client_retargetings_rowset_adGroup;
  stats: RetargetingsQuery_client_retargetings_rowset_stats;
}

export interface RetargetingsQuery_client_retargetings_totalStats {
  __typename: "GdEntityStats";
  shows: GraphQlLong | null;
  clicks: GraphQlLong | null;
  ctr: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
}

export interface RetargetingsQuery_client_retargetings {
  __typename: "GdRetargetingContext";
  rowset: RetargetingsQuery_client_retargetings_rowset[];
  totalCount: number;
  totalStats: RetargetingsQuery_client_retargetings_totalStats;
  hasObjectsOverLimit: boolean;
  retargetingIds: GraphQlLong[];
  cacheKey: string;
}

export interface RetargetingsQuery_client_goals_rowset {
  __typename: "GdGoal";
  id: GraphQlLong;
  domain: string | null;
  name: string;
  counterId: number | null;
  time: number | null;
}

export interface RetargetingsQuery_client_goals {
  __typename: "GdGoalsContext";
  rowset: RetargetingsQuery_client_goals_rowset[];
}

export interface RetargetingsQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: RetargetingsQuery_client_features;
  info: RetargetingsQuery_client_info;
  retargetings: RetargetingsQuery_client_retargetings;
  goals: RetargetingsQuery_client_goals;
}

export interface RetargetingsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RetargetingsQuery_client;
}

export interface RetargetingsQueryVariables {
  login: string;
  retargetingsInput: GdRetargetingsContainerInput;
  goalsInput: GdGoalsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UsersProfileQuery
// ====================================================

export interface UsersProfileQuery_cryptaSegments_rowset {
  __typename: "GdCryptaSegment";
  id: GraphQlLong;
  type: WebGoalType;
  name: string;
  parentId: GraphQlLong | null;
  description: string;
  interestType: CryptaInterestTypeWeb | null;
  canSelectAll: boolean | null;
  mutuallyExclusiveIds: GraphQlLong[] | null;
}

export interface UsersProfileQuery_cryptaSegments {
  __typename: "GdCryptaSegmentsContext";
  totalCount: number;
  rowset: UsersProfileQuery_cryptaSegments_rowset[];
}

export interface UsersProfileQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
  isTextBannerInterestsRetCondEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isCampaignDefaultOrganizationsEnabled: boolean;
  isShowAutoAssignedOrganizationsEnabled: boolean;
  isInAppEventsInRmpEnabled: boolean;
  isTargetTagsAllowed: boolean;
}

export interface UsersProfileQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
}

export interface UsersProfileQuery_client_retargetings_rowset_access {
  __typename: "GdRetargetingAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_retargetingCondition_conditionRules_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  type: GdGoalType;
  time: number | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_retargetingCondition_conditionRules {
  __typename: "GdRetargetingConditionRuleItem";
  type: GdRetargetingConditionRuleType;
  interestType: CryptaInterestType | null;
  goals: UsersProfileQuery_client_retargetings_rowset_retargetingCondition_conditionRules_goals[];
}

export interface UsersProfileQuery_client_retargetings_rowset_retargetingCondition {
  __typename: "GdRetargetingCondition";
  name: string;
  description: string | null;
  conditionRules: UsersProfileQuery_client_retargetings_rowset_retargetingCondition_conditionRules[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign = UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd = UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_campaign;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_access;
  mainAd: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd = UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_campaign;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_access;
  mainAd: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_regionsInfo;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd = UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_campaign;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_access;
  mainAd: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd = UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_campaign;
  access: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_access;
  mainAd: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_regionsInfo;
  status: UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type UsersProfileQuery_client_retargetings_rowset_adGroup = UsersProfileQuery_client_retargetings_rowset_adGroup_GdContentPromotionAdGroup | UsersProfileQuery_client_retargetings_rowset_adGroup_GdDynamicAdGroup | UsersProfileQuery_client_retargetings_rowset_adGroup_GdMobileContentAdGroup | UsersProfileQuery_client_retargetings_rowset_adGroup_GdSmartAdGroup;

export interface UsersProfileQuery_client_retargetings_rowset_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface UsersProfileQuery_client_retargetings_rowset {
  __typename: "GdRetargeting";
  access: UsersProfileQuery_client_retargetings_rowset_access;
  retargetingId: GraphQlLong;
  isSuspended: boolean;
  priceContext: GraphQlBigDecimal;
  retargetingCondition: UsersProfileQuery_client_retargetings_rowset_retargetingCondition | null;
  adGroup: UsersProfileQuery_client_retargetings_rowset_adGroup;
  stats: UsersProfileQuery_client_retargetings_rowset_stats;
}

export interface UsersProfileQuery_client_retargetings_totalStats {
  __typename: "GdEntityStats";
  shows: GraphQlLong | null;
  clicks: GraphQlLong | null;
  ctr: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
}

export interface UsersProfileQuery_client_retargetings {
  __typename: "GdRetargetingContext";
  rowset: UsersProfileQuery_client_retargetings_rowset[];
  totalStats: UsersProfileQuery_client_retargetings_totalStats;
  totalCount: number;
  hasObjectsOverLimit: boolean;
  retargetingIds: GraphQlLong[];
  cacheKey: string;
}

export interface UsersProfileQuery_client_goals_rowset {
  __typename: "GdGoal";
  id: GraphQlLong;
  domain: string | null;
  type: GdGoalType;
  name: string;
  counterId: number | null;
  time: number | null;
}

export interface UsersProfileQuery_client_goals {
  __typename: "GdGoalsContext";
  rowset: UsersProfileQuery_client_goals_rowset[];
}

export interface UsersProfileQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: UsersProfileQuery_client_features;
  info: UsersProfileQuery_client_info;
  retargetings: UsersProfileQuery_client_retargetings;
  goals: UsersProfileQuery_client_goals;
}

export interface UsersProfileQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  cryptaSegments: UsersProfileQuery_cryptaSegments;
  client: UsersProfileQuery_client;
}

export interface UsersProfileQueryVariables {
  login: string;
  retargetingsInput: GdRetargetingsContainerInput;
  goalsInput: GdGoalsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BannersTouchQuery
// ====================================================

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative_layout | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpcVideoCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmVideoCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmAudioCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_aggregatedStatusInfo {
  __typename: "GdAdAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  hasCallouts: boolean;
  hasSitelink: boolean;
  hasTurboGallery: boolean;
  hasTurbolanding: boolean;
  hasVideo: boolean;
  adGroup: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_adGroup;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  turbolanding: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_turbolanding | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_typedCreative | null;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_aggregatedStatusInfo | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_status;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_stats;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup = BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup | BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdTextAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdTextAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdTextAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative_layout | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmGeoproductCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpcVideoCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdVideoAdditionCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmVideoCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmAudioCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmIndoorCreative | BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_aggregatedStatusInfo {
  __typename: "GdAdAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations = BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd_bannerPrice {
  __typename: "GdAdPrice";
  currency: GdAdPriceCurrency | null;
  prefix: GdAdPricePrefix | null;
  price: string | null;
  priceOld: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdTextAd {
  __typename: "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  hasCallouts: boolean;
  hasSitelink: boolean;
  hasTurboGallery: boolean;
  hasTurbolanding: boolean;
  hasVideo: boolean;
  adGroup: BannersTouchQuery_client_ads_rowset_GdTextAd_adGroup;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdTextAd_access;
  domain: string | null;
  href: string | null;
  turbolanding: BannersTouchQuery_client_ads_rowset_GdTextAd_turbolanding | null;
  image: BannersTouchQuery_client_ads_rowset_GdTextAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdTextAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdTextAd_typedCreative | null;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: BannersTouchQuery_client_ads_rowset_GdTextAd_aggregatedStatusInfo | null;
  status: BannersTouchQuery_client_ads_rowset_GdTextAd_status;
  recommendations: BannersTouchQuery_client_ads_rowset_GdTextAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdTextAd_stats;
  goalStats: BannersTouchQuery_client_ads_rowset_GdTextAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdTextAd_sitelinks[] | null;
  flags: string[] | null;
  turboGalleryHref: string | null;
  bannerPrice: BannersTouchQuery_client_ads_rowset_GdTextAd_bannerPrice | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup = BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup | BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdInternalAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdInternalAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdInternalAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdSmartCreative_layout | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmGeoproductCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpcVideoCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdVideoAdditionCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmVideoCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmAudioCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmOutdoorCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmIndoorCreative | BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_aggregatedStatusInfo {
  __typename: "GdAdAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations = BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdInternalAd {
  __typename: "GdInternalAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  hasCallouts: boolean;
  hasSitelink: boolean;
  hasTurboGallery: boolean;
  hasTurbolanding: boolean;
  hasVideo: boolean;
  adGroup: BannersTouchQuery_client_ads_rowset_GdInternalAd_adGroup;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdInternalAd_access;
  domain: string | null;
  href: string | null;
  turbolanding: BannersTouchQuery_client_ads_rowset_GdInternalAd_turbolanding | null;
  image: BannersTouchQuery_client_ads_rowset_GdInternalAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdInternalAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdInternalAd_typedCreative | null;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: BannersTouchQuery_client_ads_rowset_GdInternalAd_aggregatedStatusInfo | null;
  status: BannersTouchQuery_client_ads_rowset_GdInternalAd_status;
  recommendations: BannersTouchQuery_client_ads_rowset_GdInternalAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdInternalAd_stats;
  goalStats: BannersTouchQuery_client_ads_rowset_GdInternalAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdInternalAd_sitelinks[] | null;
  flags: string[] | null;
  description: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_aggregatedStatusInfo {
  __typename: "GdAdAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations = BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_placementPages {
  __typename: "GdPlacementPageModerationResult";
  bannerId: GraphQlLong;
  comment: string | null;
  createTime: GraphQlLocalDateTime;
  id: GraphQlLong;
  pageId: GraphQlLong;
  statusModerate: StatusModerateBannerPage;
  statusModerateOperator: StatusModerateOperator;
  version: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd {
  __typename: "GdCPMOutdoorBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  hasCallouts: boolean;
  hasSitelink: boolean;
  hasTurboGallery: boolean;
  hasTurbolanding: boolean;
  hasVideo: boolean;
  adGroup: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_access;
  domain: string | null;
  href: string | null;
  turbolanding: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_turbolanding | null;
  image: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative | null;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_aggregatedStatusInfo | null;
  status: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_status;
  recommendations: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_stats;
  goalStats: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_sitelinks[] | null;
  flags: string[] | null;
  placementPages: BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd_placementPages[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdSmartCreative_layout | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmGeoproductCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpcVideoCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdVideoAdditionCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmVideoCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmAudioCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmIndoorCreative | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_aggregatedStatusInfo {
  __typename: "GdAdAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations = BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersTouchQuery_client_ads_rowset_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  hasCallouts: boolean;
  hasSitelink: boolean;
  hasTurboGallery: boolean;
  hasTurbolanding: boolean;
  hasVideo: boolean;
  adGroup: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_adGroup;
  body: string | null;
  access: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  turbolanding: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_turbolanding | null;
  image: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_image | null;
  bannerImage: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_typedCreative | null;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_aggregatedStatusInfo | null;
  status: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_status;
  recommendations: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_recommendations[] | null;
  stats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_stats;
  goalStats: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersTouchQuery_client_ads_rowset_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionId: GraphQlLong;
  contentPromotionUrl: string;
  contentPromotionType: GdContentPromotionType;
  contentPromotionVisitUrl: string | null;
  contentPromotionPreviewUrl: string | null;
}

export type BannersTouchQuery_client_ads_rowset = BannersTouchQuery_client_ads_rowset_GdCPCVideoAd | BannersTouchQuery_client_ads_rowset_GdTextAd | BannersTouchQuery_client_ads_rowset_GdInternalAd | BannersTouchQuery_client_ads_rowset_GdCPMOutdoorBannerAd | BannersTouchQuery_client_ads_rowset_GdContentPromotionAd;

export interface BannersTouchQuery_client_ads_totalStats {
  __typename: "GdEntityStats";
  shows: GraphQlLong | null;
  clicks: GraphQlLong | null;
  ctr: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
}

export interface BannersTouchQuery_client_ads {
  __typename: "GdAdsContext";
  rowset: BannersTouchQuery_client_ads_rowset[];
  totalCount: number;
  adIds: GraphQlLong[];
  cacheKey: string;
  totalStats: BannersTouchQuery_client_ads_totalStats;
  hasObjectsOverLimit: boolean;
}

export interface BannersTouchQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  ads: BannersTouchQuery_client_ads;
}

export interface BannersTouchQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: BannersTouchQuery_client;
}

export interface BannersTouchQueryVariables {
  login: string;
  adsInput: GdAdsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BannersQuery
// ====================================================

export interface BannersQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
  isTextBannerInterestsRetCondEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isCampaignDefaultOrganizationsEnabled: boolean;
  isShowAutoAssignedOrganizationsEnabled: boolean;
  isInAppEventsInRmpEnabled: boolean;
  isTargetTagsAllowed: boolean;
}

export interface BannersQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup = BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup | BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative_layout | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpcVideoCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmVideoCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmAudioCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative | BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_aggregatedStatusInfo {
  __typename: "GdAdAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  hasCallouts: boolean;
  hasSitelink: boolean;
  hasTurboGallery: boolean;
  hasTurbolanding: boolean;
  hasVideo: boolean;
  adGroup: BannersQuery_client_ads_rowset_GdCPCVideoAd_adGroup;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  turbolanding: BannersQuery_client_ads_rowset_GdCPCVideoAd_turbolanding | null;
  image: BannersQuery_client_ads_rowset_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPCVideoAd_typedCreative | null;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: BannersQuery_client_ads_rowset_GdCPCVideoAd_aggregatedStatusInfo | null;
  status: BannersQuery_client_ads_rowset_GdCPCVideoAd_status;
  recommendations: BannersQuery_client_ads_rowset_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPCVideoAd_stats;
  goalStats: BannersQuery_client_ads_rowset_GdCPCVideoAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQuery_client_ads_rowset_GdTextAd_adGroup = BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup | BannersQuery_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup;

export interface BannersQuery_client_ads_rowset_GdTextAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdTextAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdTextAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdTextAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative_layout | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_typedCreative = BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmGeoproductCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpcVideoCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdVideoAdditionCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmVideoCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmAudioCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCpmIndoorCreative | BannersQuery_client_ads_rowset_GdTextAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdTextAd_aggregatedStatusInfo {
  __typename: "GdAdAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdTextAd_recommendations = BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdTextAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdTextAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd_bannerPrice {
  __typename: "GdAdPrice";
  currency: GdAdPriceCurrency | null;
  prefix: GdAdPricePrefix | null;
  price: string | null;
  priceOld: string | null;
}

export interface BannersQuery_client_ads_rowset_GdTextAd {
  __typename: "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  hasCallouts: boolean;
  hasSitelink: boolean;
  hasTurboGallery: boolean;
  hasTurbolanding: boolean;
  hasVideo: boolean;
  adGroup: BannersQuery_client_ads_rowset_GdTextAd_adGroup;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdTextAd_access;
  domain: string | null;
  href: string | null;
  turbolanding: BannersQuery_client_ads_rowset_GdTextAd_turbolanding | null;
  image: BannersQuery_client_ads_rowset_GdTextAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdTextAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdTextAd_typedCreative | null;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: BannersQuery_client_ads_rowset_GdTextAd_aggregatedStatusInfo | null;
  status: BannersQuery_client_ads_rowset_GdTextAd_status;
  recommendations: BannersQuery_client_ads_rowset_GdTextAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdTextAd_stats;
  goalStats: BannersQuery_client_ads_rowset_GdTextAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdTextAd_sitelinks[] | null;
  flags: string[] | null;
  turboGalleryHref: string | null;
  bannerPrice: BannersQuery_client_ads_rowset_GdTextAd_bannerPrice | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_adGroup = BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdContentPromotionAdGroup | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdDynamicAdGroup | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdMobileContentAdGroup | BannersQuery_client_ads_rowset_GdInternalAd_adGroup_GdSmartAdGroup;

export interface BannersQuery_client_ads_rowset_GdInternalAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdInternalAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdSmartCreative_layout | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_typedCreative = BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmGeoproductCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpcVideoCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdVideoAdditionCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmVideoCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmAudioCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmOutdoorCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCpmIndoorCreative | BannersQuery_client_ads_rowset_GdInternalAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdInternalAd_aggregatedStatusInfo {
  __typename: "GdAdAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdInternalAd_recommendations = BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdInternalAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdInternalAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdInternalAd {
  __typename: "GdInternalAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  hasCallouts: boolean;
  hasSitelink: boolean;
  hasTurboGallery: boolean;
  hasTurbolanding: boolean;
  hasVideo: boolean;
  adGroup: BannersQuery_client_ads_rowset_GdInternalAd_adGroup;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdInternalAd_access;
  domain: string | null;
  href: string | null;
  turbolanding: BannersQuery_client_ads_rowset_GdInternalAd_turbolanding | null;
  image: BannersQuery_client_ads_rowset_GdInternalAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdInternalAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdInternalAd_typedCreative | null;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: BannersQuery_client_ads_rowset_GdInternalAd_aggregatedStatusInfo | null;
  status: BannersQuery_client_ads_rowset_GdInternalAd_status;
  recommendations: BannersQuery_client_ads_rowset_GdInternalAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdInternalAd_stats;
  goalStats: BannersQuery_client_ads_rowset_GdInternalAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdInternalAd_sitelinks[] | null;
  flags: string[] | null;
  description: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_aggregatedStatusInfo {
  __typename: "GdAdAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations = BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_placementPages {
  __typename: "GdPlacementPageModerationResult";
  bannerId: GraphQlLong;
  comment: string | null;
  createTime: GraphQlLocalDateTime;
  id: GraphQlLong;
  pageId: GraphQlLong;
  statusModerate: StatusModerateBannerPage;
  statusModerateOperator: StatusModerateOperator;
  version: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd {
  __typename: "GdCPMOutdoorBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  hasCallouts: boolean;
  hasSitelink: boolean;
  hasTurboGallery: boolean;
  hasTurbolanding: boolean;
  hasVideo: boolean;
  adGroup: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_access;
  domain: string | null;
  href: string | null;
  turbolanding: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_turbolanding | null;
  image: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative | null;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_aggregatedStatusInfo | null;
  status: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_status;
  recommendations: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_stats;
  goalStats: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_sitelinks[] | null;
  flags: string[] | null;
  placementPages: BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd_placementPages[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup = BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup | BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdSmartCreative_layout | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative = BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmGeoproductCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpcVideoCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdVideoAdditionCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmVideoCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmAudioCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmIndoorCreative | BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_aggregatedStatusInfo {
  __typename: "GdAdAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations = BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQuery_client_ads_rowset_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  hasCallouts: boolean;
  hasSitelink: boolean;
  hasTurboGallery: boolean;
  hasTurbolanding: boolean;
  hasVideo: boolean;
  adGroup: BannersQuery_client_ads_rowset_GdContentPromotionAd_adGroup;
  body: string | null;
  access: BannersQuery_client_ads_rowset_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  turbolanding: BannersQuery_client_ads_rowset_GdContentPromotionAd_turbolanding | null;
  image: BannersQuery_client_ads_rowset_GdContentPromotionAd_image | null;
  bannerImage: BannersQuery_client_ads_rowset_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQuery_client_ads_rowset_GdContentPromotionAd_typedCreative | null;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: BannersQuery_client_ads_rowset_GdContentPromotionAd_aggregatedStatusInfo | null;
  status: BannersQuery_client_ads_rowset_GdContentPromotionAd_status;
  recommendations: BannersQuery_client_ads_rowset_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQuery_client_ads_rowset_GdContentPromotionAd_stats;
  goalStats: BannersQuery_client_ads_rowset_GdContentPromotionAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQuery_client_ads_rowset_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionId: GraphQlLong;
  contentPromotionUrl: string;
  contentPromotionType: GdContentPromotionType;
  contentPromotionVisitUrl: string | null;
  contentPromotionPreviewUrl: string | null;
}

export type BannersQuery_client_ads_rowset = BannersQuery_client_ads_rowset_GdCPCVideoAd | BannersQuery_client_ads_rowset_GdTextAd | BannersQuery_client_ads_rowset_GdInternalAd | BannersQuery_client_ads_rowset_GdCPMOutdoorBannerAd | BannersQuery_client_ads_rowset_GdContentPromotionAd;

export interface BannersQuery_client_ads_totalStats {
  __typename: "GdEntityStats";
  shows: GraphQlLong | null;
  clicks: GraphQlLong | null;
  ctr: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
}

export interface BannersQuery_client_ads {
  __typename: "GdAdsContext";
  rowset: BannersQuery_client_ads_rowset[];
  totalCount: number;
  adIds: GraphQlLong[];
  cacheKey: string;
  totalStats: BannersQuery_client_ads_totalStats;
  hasObjectsOverLimit: boolean;
}

export interface BannersQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: BannersQuery_client_features;
  info: BannersQuery_client_info;
  ads: BannersQuery_client_ads;
}

export interface BannersQuery_operator_features {
  __typename: "GdOperatorFeatures";
  isBannerUpdateAllowed: boolean;
  isCpmBannerUpdateAllowed: boolean;
}

export interface BannersQuery_operator {
  __typename: "GdOperatorInfo";
  features: BannersQuery_operator_features | null;
}

export interface BannersQuery_constants_configuration {
  __typename: "GdConfigurationConstants";
  canvasUiDomain: string;
}

export interface BannersQuery_constants {
  __typename: "GdDirectConstants";
  configuration: BannersQuery_constants_configuration;
}

export interface BannersQuery_placements_placements {
  __typename: "GdPlacement";
  operatorName: string | null;
  id: GraphQlLong;
}

export interface BannersQuery_placements {
  __typename: "GdPlacementContext";
  placements: BannersQuery_placements_placements[];
}

export interface BannersQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: BannersQuery_client;
  operator: BannersQuery_operator;
  constants: BannersQuery_constants;
  placements: BannersQuery_placements;
}

export interface BannersQueryVariables {
  login: string;
  adsInput: GdAdsContainerInput;
  placementsInput: GdPlacementFilterInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BannersPreviewQuery
// ====================================================

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  domain: string | null;
  dynamicDisclaimer: string | null;
  linkTail: string | null;
  type: GdAdType;
  href: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_access;
  status: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_status;
  adGroup: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_adGroup;
  image: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_typedCreative | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_typedCreative = BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  domain: string | null;
  dynamicDisclaimer: string | null;
  linkTail: string | null;
  type: GdAdType;
  href: string | null;
  access: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_access;
  status: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_status;
  adGroup: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_adGroup;
  image: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_image | null;
  bannerImage: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_typedCreative | null;
  sitelinks: BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionUrl: string;
  contentPromotionType: GdContentPromotionType;
  contentPromotionVisitUrl: string | null;
  contentPromotionPreviewUrl: string | null;
}

export type BannersPreviewQuery_client_ads_rowset = BannersPreviewQuery_client_ads_rowset_GdCPCVideoAd | BannersPreviewQuery_client_ads_rowset_GdContentPromotionAd;

export interface BannersPreviewQuery_client_ads {
  __typename: "GdAdsContext";
  rowset: BannersPreviewQuery_client_ads_rowset[];
  totalCount: number;
}

export interface BannersPreviewQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  ads: BannersPreviewQuery_client_ads;
}

export interface BannersPreviewQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: BannersPreviewQuery_client;
}

export interface BannersPreviewQueryVariables {
  login: string;
  adsInput: GdAdsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupAdQuery
// ====================================================

export interface GroupAdQuery_client_ads_rowset {
  __typename: "GdContentPromotionAd" | "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
}

export interface GroupAdQuery_client_ads {
  __typename: "GdAdsContext";
  rowset: GroupAdQuery_client_ads_rowset[];
}

export interface GroupAdQuery_client {
  __typename: "GdClient";
  ads: GroupAdQuery_client_ads;
}

export interface GroupAdQuery_callouts {
  __typename: "GdCallout";
  id: GraphQlLong;
}

export interface GroupAdQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupAdQuery_client;
  callouts: (GroupAdQuery_callouts | null)[];
}

export interface GroupAdQueryVariables {
  login: string;
  adsInput: GdAdsContainerInput;
  calloutsFilter: GdCalloutFilterInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupBannersQuery
// ====================================================

export interface GroupBannersQuery_client_ads_rowset_creative {
  __typename: "GdCreative";
  height: GraphQlLong | null;
  width: GraphQlLong | null;
}

export interface GroupBannersQuery_client_ads_rowset_typedCreative_GdSmartCreative_moderationInfo_aspects {
  __typename: "GdModerationInfoAspect";
  height: GraphQlLong;
  width: GraphQlLong;
}

export interface GroupBannersQuery_client_ads_rowset_typedCreative_GdSmartCreative_moderationInfo {
  __typename: "GdModerationInfo";
  aspects: GroupBannersQuery_client_ads_rowset_typedCreative_GdSmartCreative_moderationInfo_aspects[] | null;
}

export interface GroupBannersQuery_client_ads_rowset_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  creativeType: GdCreativeType;
  moderationInfo: GroupBannersQuery_client_ads_rowset_typedCreative_GdSmartCreative_moderationInfo | null;
}

export interface GroupBannersQuery_client_ads_rowset_typedCreative_GdCanvasCreative_moderationInfo_aspects {
  __typename: "GdModerationInfoAspect";
  height: GraphQlLong;
  width: GraphQlLong;
}

export interface GroupBannersQuery_client_ads_rowset_typedCreative_GdCanvasCreative_moderationInfo {
  __typename: "GdModerationInfo";
  aspects: GroupBannersQuery_client_ads_rowset_typedCreative_GdCanvasCreative_moderationInfo_aspects[] | null;
}

export interface GroupBannersQuery_client_ads_rowset_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeType: GdCreativeType;
  moderationInfo: GroupBannersQuery_client_ads_rowset_typedCreative_GdCanvasCreative_moderationInfo | null;
  isAdaptive: boolean | null;
}

export type GroupBannersQuery_client_ads_rowset_typedCreative = GroupBannersQuery_client_ads_rowset_typedCreative_GdSmartCreative | GroupBannersQuery_client_ads_rowset_typedCreative_GdCanvasCreative;

export interface GroupBannersQuery_client_ads_rowset {
  __typename: "GdContentPromotionAd" | "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  creative: GroupBannersQuery_client_ads_rowset_creative | null;
  typedCreative: GroupBannersQuery_client_ads_rowset_typedCreative | null;
}

export interface GroupBannersQuery_client_ads {
  __typename: "GdAdsContext";
  rowset: GroupBannersQuery_client_ads_rowset[];
}

export interface GroupBannersQuery_client {
  __typename: "GdClient";
  ads: GroupBannersQuery_client_ads;
}

export interface GroupBannersQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupBannersQuery_client;
}

export interface GroupBannersQueryVariables {
  login: string;
  adsInput: GdAdsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CalloutsIdsQuery
// ====================================================

export interface CalloutsIdsQuery_callouts {
  __typename: "GdCallout";
  id: GraphQlLong;
}

export interface CalloutsIdsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  callouts: (CalloutsIdsQuery_callouts | null)[];
}

export interface CalloutsIdsQueryVariables {
  login: string;
  calloutsFilter: GdCalloutFilterInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: TurbolandingQuery
// ====================================================

export interface TurbolandingQuery_turbolandings {
  __typename: "GdTurbolanding";
  id: GraphQlLong;
  clientId: GraphQlLong;
  name: string;
  href: string;
}

export interface TurbolandingQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  turbolandings: (TurbolandingQuery_turbolandings | null)[];
}

export interface TurbolandingQueryVariables {
  login: string;
  filter: GdTurbolandingFilterInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ImagesQueryForEdit
// ====================================================

export interface ImagesQueryForEdit_images_rowset_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface ImagesQueryForEdit_images_rowset_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface ImagesQueryForEdit_images_rowset_formats {
  __typename: "GdImageFormat";
  imageSize: ImagesQueryForEdit_images_rowset_formats_imageSize;
  path: string;
  smartCenters: ImagesQueryForEdit_images_rowset_formats_smartCenters[] | null;
}

export interface ImagesQueryForEdit_images_rowset_imageSize {
  __typename: "GdImageSize";
  width: number;
  height: number;
}

export interface ImagesQueryForEdit_images_rowset {
  __typename: "GdImage";
  avatarsHost: GdAdImageAvatarsHost;
  createTime: GraphQlLocalDateTime;
  imageHash: string;
  mdsGroupId: GraphQlLong | null;
  name: string | null;
  namespace: GdAdImageNamespace;
  type: GdAdImageType;
  formats: ImagesQueryForEdit_images_rowset_formats[] | null;
  imageSize: ImagesQueryForEdit_images_rowset_imageSize;
}

export interface ImagesQueryForEdit_images {
  __typename: "GdImagesContext";
  cacheKey: string;
  imageHashes: string[];
  rowset: ImagesQueryForEdit_images_rowset[];
  totalCount: number;
}

export interface ImagesQueryForEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  images: ImagesQueryForEdit_images;
}

export interface ImagesQueryForEditVariables {
  login: string;
  cacheKey: string;
  filter: GdImageFilterInput;
  limitOffset: GdLimitOffsetInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BannersQueryForEdit
// ====================================================

export interface BannersQueryForEdit_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface BannersQueryForEdit_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
  isTextBannerInterestsRetCondEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isCampaignDefaultOrganizationsEnabled: boolean;
  isShowAutoAssignedOrganizationsEnabled: boolean;
  isInAppEventsInRmpEnabled: boolean;
  isTargetTagsAllowed: boolean;
}

export interface BannersQueryForEdit_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdDynamicAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdMobileContentAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup_GdSmartAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmAudioCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdHtml5Creative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpcVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCpmVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_sitelinks_turbolanding | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_adGroup;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_bannerImage | null;
  callouts: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_callouts[] | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_sitelinks[] | null;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd_turbolanding | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup = BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdContentPromotionAdGroup | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdDynamicAdGroup | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdMobileContentAdGroup | BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup_GdSmartAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmGeoproductCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdVideoAdditionCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmAudioCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdHtml5Creative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmOutdoorCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmIndoorCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpcVideoCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCpmVideoCreative | BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdTextAd_sitelinks_turbolanding | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerPrice {
  __typename: "GdAdPrice";
  currency: GdAdPriceCurrency | null;
  prefix: GdAdPricePrefix | null;
  price: string | null;
  priceOld: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdTextAd {
  __typename: "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: BannersQueryForEdit_client_ads_rowset_GdTextAd_adGroup;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdTextAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: BannersQueryForEdit_client_ads_rowset_GdTextAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerImage | null;
  callouts: BannersQueryForEdit_client_ads_rowset_GdTextAd_callouts[] | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdTextAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdTextAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdTextAd_sitelinks[] | null;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdTextAd_turbolanding | null;
  turboGalleryHref: string | null;
  bannerPrice: BannersQueryForEdit_client_ads_rowset_GdTextAd_bannerPrice | null;
  permalinkId: GraphQlLong | null;
  permalinkAssignType: GdAdPermalinkAssignType | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdDynamicAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdMobileContentAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup_GdSmartAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmGeoproductCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdVideoAdditionCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmAudioCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdHtml5Creative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmIndoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpcVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCpmVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_sitelinks_turbolanding | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_pixels {
  __typename: "GdPixel";
  kind: GdPixelKind;
  url: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_measurers {
  __typename: "GdBannerMeasurer";
  measurerSystem: GdBannerMeasurerSystem;
  params: string;
  hasIntegration: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd {
  __typename: "GdCPMBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_adGroup;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_bannerImage | null;
  callouts: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_callouts[] | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_sitelinks[] | null;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_turbolanding | null;
  pixels: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_pixels[];
  measurers: BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd_measurers[] | null;
  tnsId: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdDynamicAdGroup | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdMobileContentAdGroup | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup_GdSmartAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmGeoproductCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdVideoAdditionCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmAudioCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdHtml5Creative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmIndoorCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpcVideoCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCpmVideoCreative | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_sitelinks_turbolanding | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_adGroup;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_bannerImage | null;
  callouts: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_callouts[] | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_sitelinks[] | null;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd_turbolanding | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
  contentPromotionId: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdHtml5Creative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_sitelinks_turbolanding | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_pixels {
  __typename: "GdPixel";
  kind: GdPixelKind;
  url: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_placementPages {
  __typename: "GdPlacementPageModerationResult";
  bannerId: GraphQlLong;
  comment: string | null;
  createTime: GraphQlLocalDateTime;
  id: GraphQlLong;
  pageId: GraphQlLong;
  statusModerate: StatusModerateBannerPage;
  statusModerateOperator: StatusModerateOperator;
  version: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd {
  __typename: "GdCPMOutdoorBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_adGroup;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_bannerImage | null;
  callouts: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_callouts[] | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_sitelinks[] | null;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_turbolanding | null;
  pixels: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_pixels[];
  placementPages: BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd_placementPages[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage_formats[] | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative = BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmGeoproductCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdVideoAdditionCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmAudioCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdHtml5Creative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmIndoorCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdSmartCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpcVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCpmVideoCreative | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative_GdCanvasCreative;

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_sitelinks_turbolanding | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_pixels {
  __typename: "GdPixel";
  kind: GdPixelKind;
  url: string;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_measurers {
  __typename: "GdBannerMeasurer";
  measurerSystem: GdBannerMeasurerSystem;
  params: string;
  hasIntegration: boolean | null;
}

export interface BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd {
  __typename: "GdCPMAudioBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_adGroup;
  body: string | null;
  access: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_image | null;
  bannerImage: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_bannerImage | null;
  callouts: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_callouts[] | null;
  typedCreative: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_typedCreative | null;
  status: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_sitelinks[] | null;
  turbolanding: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_turbolanding | null;
  pixels: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_pixels[];
  measurers: BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd_measurers[] | null;
}

export type BannersQueryForEdit_client_ads_rowset = BannersQueryForEdit_client_ads_rowset_GdCPCVideoAd | BannersQueryForEdit_client_ads_rowset_GdTextAd | BannersQueryForEdit_client_ads_rowset_GdCPMBannerAd | BannersQueryForEdit_client_ads_rowset_GdContentPromotionAd | BannersQueryForEdit_client_ads_rowset_GdCPMOutdoorBannerAd | BannersQueryForEdit_client_ads_rowset_GdCPMAudioBannerAd;

export interface BannersQueryForEdit_client_ads {
  __typename: "GdAdsContext";
  rowset: BannersQueryForEdit_client_ads_rowset[];
  totalCount: number;
  adIds: GraphQlLong[];
  hasObjectsOverLimit: boolean;
}

export interface BannersQueryForEdit_client_campaigns_rowset_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  promocodeRestrictedDomain: string[] | null;
}

export interface BannersQueryForEdit_client_campaigns_rowset_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  promocodeRestrictedDomain: string[] | null;
  defaultPermalinkId: GraphQlLong | null;
}

export type BannersQueryForEdit_client_campaigns_rowset = BannersQueryForEdit_client_campaigns_rowset_GdContentPromotionCampaign | BannersQueryForEdit_client_campaigns_rowset_GdTextCampaign;

export interface BannersQueryForEdit_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: BannersQueryForEdit_client_campaigns_rowset[];
}

export interface BannersQueryForEdit_client {
  __typename: "GdClient";
  measurerAccounts: (GdClientMeasurerSystem | null)[];
  chiefLogin: string;
  features: BannersQueryForEdit_client_features;
  info: BannersQueryForEdit_client_info;
  ads: BannersQueryForEdit_client_ads;
  campaigns: BannersQueryForEdit_client_campaigns;
}

export interface BannersQueryForEdit_operator_features {
  __typename: "GdOperatorFeatures";
  isBannerUpdateAllowed: boolean;
  isCpmBannerUpdateAllowed: boolean;
}

export interface BannersQueryForEdit_operator_access {
  __typename: "GdOperatorAccess";
  canEditAdDomain: boolean;
}

export interface BannersQueryForEdit_operator {
  __typename: "GdOperatorInfo";
  features: BannersQueryForEdit_operator_features | null;
  access: BannersQueryForEdit_operator_access;
}

export interface BannersQueryForEdit_constants_validation_adConstants {
  __typename: "GdDirectConstantsAdValidationData";
  maxLengthTitle: number;
  maxLengthTitleWord: number;
  maxLengthTitleExtension: number;
  maxLengthBody: number;
  maxLengthBodyWord: number;
  narrowSymbols: string;
  maxNumberOfNarrowCharacters: number;
  allowAdLetters: string;
  maxLengthHref: number;
  maxLengthTurboGalleryHref: number;
  maxLengthDisplayHref: number;
  allowAdDisplayHrefLetters: string;
  aggregationDomains: string[];
}

export interface BannersQueryForEdit_constants_validation_vcardConstants {
  __typename: "GdDirectConstantsVcardValidationData";
  companyNameMaxLength: number;
  contactPersonMaxLength: number;
  contactEmailMaxLength: number;
  extraMessageMaxLength: number;
  countryMaxLength: number;
  cityMaxLength: number;
  streetMaxLength: number;
  houseWithBuildingMaxLength: number;
  apartmentMaxLength: number;
  instantMessengerLoginMaxLength: number;
  pointOnMapLongitudeMin: GraphQlBigDecimal;
  pointOnMapLongitudeMax: GraphQlBigDecimal;
  pointOnMapLatitudeMin: GraphQlBigDecimal;
  pointOnMapLatitudeMax: GraphQlBigDecimal;
  countryCodeMaxLength: number;
  cityCodeMaxLength: number;
  phoneNumberMinLength: number;
  phoneNumberMaxLength: number;
  extensionMaxLength: number;
  entirePhoneMinLength: number;
  entirePhoneMaxLength: number;
  entirePhoneWithExtensionMaxLength: number;
}

export interface BannersQueryForEdit_constants_validation_calloutConstants {
  __typename: "GdDirectConstantsCalloutValidationData";
  calloutLettersAllowed: string;
  calloutTextMaxLength: number;
  calloutsOnClientMaxCount: number;
  calloutsOnClientMaxCountWithDeleted: number;
}

export interface BannersQueryForEdit_constants_validation_sitelinkConstants {
  __typename: "GdDirectConstantsSitelinkValidationData";
  allowLetters: string;
  maxDescriptionLength: number;
  maxHrefLength: number;
  maxTitleLength: number;
  sitelinkMaxCount: number;
}

export interface BannersQueryForEdit_constants_validation {
  __typename: "GdDirectConstantsValidationData";
  adConstants: BannersQueryForEdit_constants_validation_adConstants;
  vcardConstants: BannersQueryForEdit_constants_validation_vcardConstants;
  calloutConstants: BannersQueryForEdit_constants_validation_calloutConstants;
  sitelinkConstants: BannersQueryForEdit_constants_validation_sitelinkConstants;
}

export interface BannersQueryForEdit_constants_configuration {
  __typename: "GdConfigurationConstants";
  turbolandingUnifiedApiUrl: string;
  canvasUiDomain: string;
}

export interface BannersQueryForEdit_constants {
  __typename: "GdDirectConstants";
  validation: BannersQueryForEdit_constants_validation;
  configuration: BannersQueryForEdit_constants_configuration;
}

export interface BannersQueryForEdit_placements_placements {
  __typename: "GdPlacement";
  operatorName: string | null;
  id: GraphQlLong;
}

export interface BannersQueryForEdit_placements {
  __typename: "GdPlacementContext";
  placements: BannersQueryForEdit_placements_placements[];
}

export interface BannersQueryForEdit {
  callouts: (BannersQueryForEdit_callouts | null)[];
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: BannersQueryForEdit_client;
  operator: BannersQueryForEdit_operator;
  constants: BannersQueryForEdit_constants;
  placements: BannersQueryForEdit_placements;
}

export interface BannersQueryForEditVariables {
  login: string;
  adsInput: GdAdsContainerInput;
  campaignsInput: GdCampaignsContainerInput;
  placementsInput: GdPlacementFilterInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BaseInfoForBannerCreationQuery
// ====================================================

export interface BaseInfoForBannerCreationQuery_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface BaseInfoForBannerCreationQuery_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
  isTextBannerInterestsRetCondEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isCampaignDefaultOrganizationsEnabled: boolean;
  isShowAutoAssignedOrganizationsEnabled: boolean;
  isInAppEventsInRmpEnabled: boolean;
  isTargetTagsAllowed: boolean;
}

export interface BaseInfoForBannerCreationQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  platform: GdCampaignPlatform;
  payForConversion: boolean | null;
}

export type BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy = BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  primaryStatus: GdCampaignPrimaryStatus;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  strategy: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy;
  name: string;
  id: GraphQlLong;
  type: GdCampaignType;
  access: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdContentPromotionCampaign_access;
  hasAds: boolean;
  status: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdContentPromotionCampaign_status;
  promocodeRestrictedDomain: string[] | null;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  platform: GdCampaignPlatform;
  payForConversion: boolean | null;
}

export type BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_strategy = BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  primaryStatus: GdCampaignPrimaryStatus;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_workTimes[];
  phone: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_phone;
  address: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard_address;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign {
  __typename: "GdTextCampaign";
  strategy: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_strategy;
  name: string;
  id: GraphQlLong;
  type: GdCampaignType;
  access: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_access;
  hasAds: boolean;
  status: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_status;
  promocodeRestrictedDomain: string[] | null;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign_commonVcard | null;
  defaultPermalinkId: GraphQlLong | null;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  platform: GdCampaignPlatform;
  payForConversion: boolean | null;
}

export type BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_strategy = BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  primaryStatus: GdCampaignPrimaryStatus;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard_workTimes[];
  phone: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard_phone;
  address: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard_address;
}

export interface BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  strategy: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_strategy;
  name: string;
  id: GraphQlLong;
  type: GdCampaignType;
  access: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_access;
  hasAds: boolean;
  status: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_status;
  promocodeRestrictedDomain: string[] | null;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign_commonVcard | null;
}

export type BaseInfoForBannerCreationQuery_client_campaigns_rowset = BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdContentPromotionCampaign | BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdTextCampaign | BaseInfoForBannerCreationQuery_client_campaigns_rowset_GdDynamicCampaign;

export interface BaseInfoForBannerCreationQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: BaseInfoForBannerCreationQuery_client_campaigns_rowset[];
}

export interface BaseInfoForBannerCreationQuery_client_adGroups_rowset_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface BaseInfoForBannerCreationQuery_client_adGroups_rowset_status {
  __typename: "GdAdGroupStatus";
  primaryStatus: GdAdGroupPrimaryStatus;
}

export interface BaseInfoForBannerCreationQuery_client_adGroups_rowset {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  id: GraphQlLong;
  adsCount: number;
  name: string;
  type: GdAdGroupType;
  access: BaseInfoForBannerCreationQuery_client_adGroups_rowset_access;
  status: BaseInfoForBannerCreationQuery_client_adGroups_rowset_status;
}

export interface BaseInfoForBannerCreationQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: BaseInfoForBannerCreationQuery_client_adGroups_rowset[];
}

export interface BaseInfoForBannerCreationQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  features: BaseInfoForBannerCreationQuery_client_features;
  info: BaseInfoForBannerCreationQuery_client_info;
  campaigns: BaseInfoForBannerCreationQuery_client_campaigns;
  adGroups: BaseInfoForBannerCreationQuery_client_adGroups;
}

export interface BaseInfoForBannerCreationQuery_operator_features {
  __typename: "GdOperatorFeatures";
  isBannerUpdateAllowed: boolean;
  isCpmBannerUpdateAllowed: boolean;
}

export interface BaseInfoForBannerCreationQuery_operator_access {
  __typename: "GdOperatorAccess";
  canEditAdDomain: boolean;
}

export interface BaseInfoForBannerCreationQuery_operator {
  __typename: "GdOperatorInfo";
  features: BaseInfoForBannerCreationQuery_operator_features | null;
  access: BaseInfoForBannerCreationQuery_operator_access;
}

export interface BaseInfoForBannerCreationQuery_constants_validation_adConstants {
  __typename: "GdDirectConstantsAdValidationData";
  maxLengthTitle: number;
  maxLengthTitleWord: number;
  maxLengthTitleExtension: number;
  maxLengthBody: number;
  maxLengthBodyWord: number;
  narrowSymbols: string;
  maxNumberOfNarrowCharacters: number;
  allowAdLetters: string;
  maxLengthHref: number;
  maxLengthTurboGalleryHref: number;
  maxLengthDisplayHref: number;
  allowAdDisplayHrefLetters: string;
  aggregationDomains: string[];
}

export interface BaseInfoForBannerCreationQuery_constants_validation_vcardConstants {
  __typename: "GdDirectConstantsVcardValidationData";
  companyNameMaxLength: number;
  contactPersonMaxLength: number;
  contactEmailMaxLength: number;
  extraMessageMaxLength: number;
  countryMaxLength: number;
  cityMaxLength: number;
  streetMaxLength: number;
  houseWithBuildingMaxLength: number;
  apartmentMaxLength: number;
  instantMessengerLoginMaxLength: number;
  pointOnMapLongitudeMin: GraphQlBigDecimal;
  pointOnMapLongitudeMax: GraphQlBigDecimal;
  pointOnMapLatitudeMin: GraphQlBigDecimal;
  pointOnMapLatitudeMax: GraphQlBigDecimal;
  countryCodeMaxLength: number;
  cityCodeMaxLength: number;
  phoneNumberMinLength: number;
  phoneNumberMaxLength: number;
  extensionMaxLength: number;
  entirePhoneMinLength: number;
  entirePhoneMaxLength: number;
  entirePhoneWithExtensionMaxLength: number;
}

export interface BaseInfoForBannerCreationQuery_constants_validation_calloutConstants {
  __typename: "GdDirectConstantsCalloutValidationData";
  calloutLettersAllowed: string;
  calloutTextMaxLength: number;
  calloutsOnClientMaxCount: number;
  calloutsOnClientMaxCountWithDeleted: number;
}

export interface BaseInfoForBannerCreationQuery_constants_validation_sitelinkConstants {
  __typename: "GdDirectConstantsSitelinkValidationData";
  allowLetters: string;
  maxDescriptionLength: number;
  maxHrefLength: number;
  maxTitleLength: number;
  sitelinkMaxCount: number;
}

export interface BaseInfoForBannerCreationQuery_constants_validation {
  __typename: "GdDirectConstantsValidationData";
  adConstants: BaseInfoForBannerCreationQuery_constants_validation_adConstants;
  vcardConstants: BaseInfoForBannerCreationQuery_constants_validation_vcardConstants;
  calloutConstants: BaseInfoForBannerCreationQuery_constants_validation_calloutConstants;
  sitelinkConstants: BaseInfoForBannerCreationQuery_constants_validation_sitelinkConstants;
}

export interface BaseInfoForBannerCreationQuery_constants_configuration {
  __typename: "GdConfigurationConstants";
  turbolandingUnifiedApiUrl: string;
  canvasUiDomain: string;
}

export interface BaseInfoForBannerCreationQuery_constants {
  __typename: "GdDirectConstants";
  validation: BaseInfoForBannerCreationQuery_constants_validation;
  configuration: BaseInfoForBannerCreationQuery_constants_configuration;
}

export interface BaseInfoForBannerCreationQuery {
  callouts: (BaseInfoForBannerCreationQuery_callouts | null)[];
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: BaseInfoForBannerCreationQuery_client;
  operator: BaseInfoForBannerCreationQuery_operator;
  constants: BaseInfoForBannerCreationQuery_constants;
}

export interface BaseInfoForBannerCreationQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: InternalBannersQueryForEdit
// ====================================================

export interface InternalBannersQueryForEdit_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdContentPromotionAd {
  __typename: "GdContentPromotionAd" | "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_templateVars {
  __typename: "GdTemplateVariable";
  templateResourceId: GraphQlLong;
  value: string | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_status_timeTargetStatus;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_strategy = InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick | InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual | InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions;

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign {
  __typename: "GdInternalFreeCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  status: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_status;
  adsCount: number;
  access: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_access;
  strategy: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign_strategy;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_status_timeTargetStatus;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_strategy = InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick | InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual | InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions;

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign {
  __typename: "GdInternalDistribCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  adsCount: number;
  status: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_status;
  access: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_access;
  strategy: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign_strategy;
}

export type InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign = InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdContentPromotionCampaign | InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalFreeCampaign | InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign_GdInternalDistribCampaign;

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  campaign: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_campaign;
  access: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_access;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_regionsInfo;
  status: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_images_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_images_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_images_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_images_image_formats {
  __typename: "GdImageFormat";
  imageSize: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_images_image_formats_imageSize;
  path: string;
  smartCenters: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_images_image_formats_smartCenters[] | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_images_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_images_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_images_image_formats[] | null;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_images {
  __typename: "GdInternalAdImageResource";
  image: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_images_image;
  templateResourceId: string;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd {
  __typename: "GdInternalAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  description: string | null;
  templateId: GraphQlLong;
  templateVars: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_templateVars[];
  access: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_access;
  adGroup: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_adGroup;
  images: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_images[];
  status: InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd_status;
}

export type InternalBannersQueryForEdit_client_ads_rowset = InternalBannersQueryForEdit_client_ads_rowset_GdContentPromotionAd | InternalBannersQueryForEdit_client_ads_rowset_GdInternalAd;

export interface InternalBannersQueryForEdit_client_ads {
  __typename: "GdAdsContext";
  rowset: InternalBannersQueryForEdit_client_ads_rowset[];
  totalCount: number;
  adIds: GraphQlLong[];
  hasObjectsOverLimit: boolean;
}

export interface InternalBannersQueryForEdit_client {
  __typename: "GdClient";
  chiefLogin: string;
  info: InternalBannersQueryForEdit_client_info;
  ads: InternalBannersQueryForEdit_client_ads;
}

export interface InternalBannersQueryForEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: InternalBannersQueryForEdit_client;
}

export interface InternalBannersQueryForEditVariables {
  login: string;
  adsInput: GdAdsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: InternalBannersQueryForCreation
// ====================================================

export interface InternalBannersQueryForCreation_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_status_timeTargetStatus;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_strategy = InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick | InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual | InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions;

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign {
  __typename: "GdInternalFreeCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  status: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_status;
  adsCount: number;
  access: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_access;
  strategy: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign_strategy;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_status_timeTargetStatus;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_strategy = InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick | InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual | InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions;

export interface InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign {
  __typename: "GdInternalDistribCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  adsCount: number;
  status: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_status;
  access: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_access;
  strategy: InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign_strategy;
}

export type InternalBannersQueryForCreation_client_adGroups_rowset_campaign = InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdContentPromotionCampaign | InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalFreeCampaign | InternalBannersQueryForCreation_client_adGroups_rowset_campaign_GdInternalDistribCampaign;

export interface InternalBannersQueryForCreation_client_adGroups_rowset_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface InternalBannersQueryForCreation_client_adGroups_rowset {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  campaign: InternalBannersQueryForCreation_client_adGroups_rowset_campaign;
  access: InternalBannersQueryForCreation_client_adGroups_rowset_access;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: InternalBannersQueryForCreation_client_adGroups_rowset_regionsInfo;
  status: InternalBannersQueryForCreation_client_adGroups_rowset_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface InternalBannersQueryForCreation_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: InternalBannersQueryForCreation_client_adGroups_rowset[];
}

export interface InternalBannersQueryForCreation_client {
  __typename: "GdClient";
  chiefLogin: string;
  info: InternalBannersQueryForCreation_client_info;
  adGroups: InternalBannersQueryForCreation_client_adGroups;
}

export interface InternalBannersQueryForCreation {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: InternalBannersQueryForCreation_client;
}

export interface InternalBannersQueryForCreationVariables {
  login: string;
  adGroupsInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: InternalTemplateResourcesQuery
// ====================================================

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_choices {
  __typename: "GdResourceValueChoice";
  display: string;
  value: string;
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdBasicValueRestriction {
  __typename: "GdBasicValueRestriction";
  type: GdResourceValueRestrictionType;
  strict: boolean;
  defectCode: string;
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdUrlCorrectRestriction {
  __typename: "GdUrlCorrectRestriction";
  type: GdResourceValueRestrictionType;
  strict: boolean;
  defectCode: string;
  isHttpsOnly: boolean;
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdLengthValueRestriction {
  __typename: "GdLengthValueRestriction";
  type: GdResourceValueRestrictionType;
  strict: boolean;
  defectCode: string;
  length: number;
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdImageFormatValueRestriction {
  __typename: "GdImageFormatValueRestriction";
  type: GdResourceValueRestrictionType;
  strict: boolean;
  defectCode: string;
  format: GdRestrictionImageFormat[];
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdImageSizeKbMaxValueRestriction {
  __typename: "GdImageSizeKbMaxValueRestriction";
  type: GdResourceValueRestrictionType;
  strict: boolean;
  defectCode: string;
  size: number;
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdImageDimensionsValueRestriction {
  __typename: "GdImageDimensionsValueRestriction";
  type: GdResourceValueRestrictionType;
  strict: boolean;
  defectCode: string;
  width: number | null;
  height: number | null;
}

export type InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions = InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdBasicValueRestriction | InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdUrlCorrectRestriction | InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdLengthValueRestriction | InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdImageFormatValueRestriction | InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdImageSizeKbMaxValueRestriction | InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions_GdImageDimensionsValueRestriction;

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources {
  __typename: "GdResourceInfo";
  id: string;
  label: string;
  type: GdResourceType;
  choices: InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_choices[] | null;
  valueRestrictions: InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources_valueRestrictions[];
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resourceRestrictions {
  __typename: "GdResourceRestriction";
  required: string[];
  absent: string[];
}

export interface InternalTemplateResourcesQuery_client_internalAdTemplateInfo {
  __typename: "GdInternalTemplateInfo";
  campaignId: string;
  templateId: string;
  resources: InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resources[];
  resourceRestrictions: InternalTemplateResourcesQuery_client_internalAdTemplateInfo_resourceRestrictions[];
}

export interface InternalTemplateResourcesQuery_client {
  __typename: "GdClient";
  internalAdTemplateInfo: (InternalTemplateResourcesQuery_client_internalAdTemplateInfo | null)[];
}

export interface InternalTemplateResourcesQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: InternalTemplateResourcesQuery_client;
}

export interface InternalTemplateResourcesQueryVariables {
  login: string;
  entries: GdInternalTemplateInfoRequestEntryInput[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: InternalTemplatePlacesQuery
// ====================================================

export interface InternalTemplatePlacesQuery_constants_internalTemplatePlaces_rowset {
  __typename: "GdInternalTemplatePlace";
  placeId: GraphQlLong;
  templateId: GraphQlLong;
}

export interface InternalTemplatePlacesQuery_constants_internalTemplatePlaces {
  __typename: "GdInternalTemplatePlacesData";
  rowset: InternalTemplatePlacesQuery_constants_internalTemplatePlaces_rowset[];
}

export interface InternalTemplatePlacesQuery_constants {
  __typename: "GdDirectConstants";
  /**
   * Набор связей места с шаблонами для внутренней рекламы
   */
  internalTemplatePlaces: InternalTemplatePlacesQuery_constants_internalTemplatePlaces;
}

export interface InternalTemplatePlacesQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  constants: InternalTemplatePlacesQuery_constants;
}

export interface InternalTemplatePlacesQueryVariables {
  placesIds?: GraphQlLong[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: VCardsForBannersEdit
// ====================================================

export interface VCardsForBannersEdit_vcards_rowset_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface VCardsForBannersEdit_vcards_rowset_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface VCardsForBannersEdit_vcards_rowset_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface VCardsForBannersEdit_vcards_rowset_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: VCardsForBannersEdit_vcards_rowset_workTimes_startTime;
  endTime: VCardsForBannersEdit_vcards_rowset_workTimes_endTime;
}

export interface VCardsForBannersEdit_vcards_rowset_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface VCardsForBannersEdit_vcards_rowset_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface VCardsForBannersEdit_vcards_rowset_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: VCardsForBannersEdit_vcards_rowset_address_pointOnMap | null;
}

export interface VCardsForBannersEdit_vcards_rowset {
  __typename: "GdVcard";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: VCardsForBannersEdit_vcards_rowset_instantMessenger | null;
  workTimes: VCardsForBannersEdit_vcards_rowset_workTimes[];
  phone: VCardsForBannersEdit_vcards_rowset_phone;
  address: VCardsForBannersEdit_vcards_rowset_address;
}

export interface VCardsForBannersEdit_vcards {
  __typename: "GdVcardsContext";
  rowset: VCardsForBannersEdit_vcards_rowset[];
}

export interface VCardsForBannersEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  vcards: VCardsForBannersEdit_vcards;
}

export interface VCardsForBannersEditVariables {
  login: string;
  vcardIdIn?: GraphQlLong[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: MetroStationsQuery
// ====================================================

export interface MetroStationsQuery_constants_metroStations_rowset {
  __typename: "GdMetroStation";
  geoRegionId: number;
  metroStationId: number;
  metroStationName: string;
}

export interface MetroStationsQuery_constants_metroStations {
  __typename: "GdMetroStationsData";
  rowset: MetroStationsQuery_constants_metroStations_rowset[];
}

export interface MetroStationsQuery_constants {
  __typename: "GdDirectConstants";
  /**
   * Станции метрополитена (только для Москвы, Санкт-Петербурга и Киева)
   */
  metroStations: MetroStationsQuery_constants_metroStations;
}

export interface MetroStationsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  constants: MetroStationsQuery_constants;
}

export interface MetroStationsQueryVariables {
  city?: GdMetroCityInput[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMetroByCoordinates
// ====================================================

export interface GetMetroByCoordinates_getMetroByCoordinates {
  __typename: "GdGeoToolsResponse";
  geoId: GraphQlLong;
}

export interface GetMetroByCoordinates {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  getMetroByCoordinates: GetMetroByCoordinates_getMetroByCoordinates | null;
}

export interface GetMetroByCoordinatesVariables {
  coordinates: GdCoordinatesInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetGeoByAddress
// ====================================================

export interface GetGeoByAddress_getGeoByAddress {
  __typename: "GdGeoToolsResponse";
  geoId: GraphQlLong;
}

export interface GetGeoByAddress {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  getGeoByAddress: GetGeoByAddress_getGeoByAddress | null;
}

export interface GetGeoByAddressVariables {
  address: GdGeoToolsAddressInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLastChangedAds
// ====================================================

export interface GetLastChangedAds_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdDynamicAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdMobileContentAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup_GdSmartAdGroup;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpmAudioCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdHtml5Creative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpcVideoCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCpmVideoCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_sitelinks_turbolanding | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_adGroup;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_bannerImage | null;
  callouts: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_callouts[] | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_sitelinks[] | null;
  turbolanding: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd_turbolanding | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdContentPromotionAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdDynamicAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdMobileContentAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup_GdSmartAdGroup;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpmGeoproductCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdVideoAdditionCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpmAudioCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdHtml5Creative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpmOutdoorCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpmIndoorCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpcVideoCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCpmVideoCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_sitelinks_turbolanding | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_bannerPrice {
  __typename: "GdAdPrice";
  currency: GdAdPriceCurrency | null;
  prefix: GdAdPricePrefix | null;
  price: string | null;
  priceOld: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd {
  __typename: "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_adGroup;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_bannerImage | null;
  callouts: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_callouts[] | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_sitelinks[] | null;
  turbolanding: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_turbolanding | null;
  turboGalleryHref: string | null;
  bannerPrice: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd_bannerPrice | null;
  permalinkId: GraphQlLong | null;
  permalinkAssignType: GdAdPermalinkAssignType | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdDynamicAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdMobileContentAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup_GdSmartAdGroup;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpmGeoproductCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdVideoAdditionCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpmAudioCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdHtml5Creative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpmIndoorCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpcVideoCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCpmVideoCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_sitelinks_turbolanding | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_pixels {
  __typename: "GdPixel";
  kind: GdPixelKind;
  url: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_measurers {
  __typename: "GdBannerMeasurer";
  measurerSystem: GdBannerMeasurerSystem;
  params: string;
  hasIntegration: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd {
  __typename: "GdCPMBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_adGroup;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_bannerImage | null;
  callouts: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_callouts[] | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_sitelinks[] | null;
  turbolanding: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_turbolanding | null;
  pixels: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_pixels[];
  measurers: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd_measurers[] | null;
  tnsId: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdDynamicAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdMobileContentAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup_GdSmartAdGroup;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpmGeoproductCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdVideoAdditionCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpmAudioCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdHtml5Creative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpmIndoorCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpcVideoCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCpmVideoCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_sitelinks_turbolanding | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_adGroup;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_bannerImage | null;
  callouts: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_callouts[] | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_sitelinks[] | null;
  turbolanding: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd_turbolanding | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
  contentPromotionId: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdHtml5Creative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_sitelinks_turbolanding | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_pixels {
  __typename: "GdPixel";
  kind: GdPixelKind;
  url: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_placementPages {
  __typename: "GdPlacementPageModerationResult";
  bannerId: GraphQlLong;
  comment: string | null;
  createTime: GraphQlLocalDateTime;
  id: GraphQlLong;
  pageId: GraphQlLong;
  statusModerate: StatusModerateBannerPage;
  statusModerateOperator: StatusModerateOperator;
  version: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd {
  __typename: "GdCPMOutdoorBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_adGroup;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_bannerImage | null;
  callouts: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_callouts[] | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_sitelinks[] | null;
  turbolanding: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_turbolanding | null;
  pixels: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_pixels[];
  placementPages: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd_placementPages[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_image_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_image_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_bannerImage_formats[] | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpmGeoproductCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdVideoAdditionCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpmAudioCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdHtml5Creative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpmIndoorCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdSmartCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpcVideoCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCpmVideoCreative | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative_GdCanvasCreative;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_sitelinks_turbolanding | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_pixels {
  __typename: "GdPixel";
  kind: GdPixelKind;
  url: string;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_measurers {
  __typename: "GdBannerMeasurer";
  measurerSystem: GdBannerMeasurerSystem;
  params: string;
  hasIntegration: boolean | null;
}

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd {
  __typename: "GdCPMAudioBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_adGroup;
  body: string | null;
  access: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_image | null;
  bannerImage: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_bannerImage | null;
  callouts: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_callouts[] | null;
  typedCreative: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_typedCreative | null;
  status: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_sitelinks[] | null;
  turbolanding: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_turbolanding | null;
  pixels: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_pixels[];
  measurers: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd_measurers[] | null;
}

export type GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad = GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPCVideoAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdTextAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMBannerAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdContentPromotionAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMOutdoorBannerAd | GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad_GdCPMAudioBannerAd;

export interface GetLastChangedAds_client_lastChangedAds_lastChangedAds {
  __typename: "GdLastChangedAd";
  ad: GetLastChangedAds_client_lastChangedAds_lastChangedAds_ad;
}

export interface GetLastChangedAds_client_lastChangedAds {
  __typename: "GdLastChangedAds";
  lastChangedAds: GetLastChangedAds_client_lastChangedAds_lastChangedAds[];
}

export interface GetLastChangedAds_client_features {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
  isTextBannerInterestsRetCondEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isCampaignDefaultOrganizationsEnabled: boolean;
  isShowAutoAssignedOrganizationsEnabled: boolean;
  isInAppEventsInRmpEnabled: boolean;
  isTargetTagsAllowed: boolean;
}

export interface GetLastChangedAds_client {
  __typename: "GdClient";
  info: GetLastChangedAds_client_info;
  lastChangedAds: GetLastChangedAds_client_lastChangedAds;
  features: GetLastChangedAds_client_features;
}

export interface GetLastChangedAds_operator_features {
  __typename: "GdOperatorFeatures";
  isBannerUpdateAllowed: boolean;
  isCpmBannerUpdateAllowed: boolean;
}

export interface GetLastChangedAds_operator {
  __typename: "GdOperatorInfo";
  features: GetLastChangedAds_operator_features | null;
}

export interface GetLastChangedAds_placements_placements {
  __typename: "GdPlacement";
  operatorName: string | null;
  id: GraphQlLong;
}

export interface GetLastChangedAds_placements {
  __typename: "GdPlacementContext";
  placements: GetLastChangedAds_placements_placements[];
}

export interface GetLastChangedAds {
  client: GetLastChangedAds_client;
  operator: GetLastChangedAds_operator;
  placements: GetLastChangedAds_placements;
  /**
   * Получить reqId запроса
   */
  reqId: string;
}

export interface GetLastChangedAdsVariables {
  login: string;
  lastChangedAdsInput: GdLastChangedAdContainerInput;
  placementsInput: GdPlacementFilterInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetGeoByCoordinates
// ====================================================

export interface GetGeoByCoordinates_getGeoByCoordinates {
  __typename: "GdGeoToolsResponse";
  geoId: GraphQlLong;
}

export interface GetGeoByCoordinates {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  getGeoByCoordinates: GetGeoByCoordinates_getGeoByCoordinates | null;
}

export interface GetGeoByCoordinatesVariables {
  coordinates: GdCoordinatesInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: validateAdPrice
// ====================================================

export interface validateAdPrice_validateAdPrice_errors {
  __typename: "GdDefect";
  code: string;
  path: string;
  params: GraphQlObjectScalar | null;
}

export interface validateAdPrice_validateAdPrice {
  __typename: "GdValidationResult";
  errors: validateAdPrice_validateAdPrice_errors[];
}

export interface validateAdPrice {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  validateAdPrice: validateAdPrice_validateAdPrice | null;
}

export interface validateAdPriceVariables {
  bannerPrice: (GdAdPriceInput | null)[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupsQueryForEdit
// ====================================================

export interface GroupsQueryForEdit_client_clientConstants_allowedBidModifierTypesByAdGroupTypes {
  __typename: "GdAllowedBidModifiersByAdGroupType";
  adGroupType: GdAdGroupType;
  allowedBidModifierTypes: GdBidModifierType[];
}

export interface GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment {
  __typename: "GdAllowedBidModifierValuesABSegment" | "GdAllowedBidModifierValuesDemographics" | "GdAllowedBidModifierValuesDesktop" | "GdAllowedBidModifierValuesExpression" | "GdAllowedBidModifierValuesGeo" | "GdAllowedBidModifierValuesRetargeting" | "GdAllowedBidModifierValuesSmartTgo" | "GdAllowedBidModifierValuesVideo" | "GdAllowedBidModifierValuesWeather";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment_percentRange;
}

export interface GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile {
  __typename: "GdAllowedBidModifierValuesMobile";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile_percentRange;
  osTypes: GdOsType[];
}

export interface GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory {
  __typename: "GdAllowedBidModifierValuesInventory";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory_percentRange;
  inventoryTypes: GdInventoryType[];
}

export interface GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType {
  __typename: "GdAllowedBidModifierValuesAdType";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType_percentRange;
  adTypes: GdAdjustmentAdType[];
}

export type GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues = GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment | GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile | GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory | GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType;

export interface GroupsQueryForEdit_client_clientConstants_clientLimits {
  __typename: "GdClientLimits";
  keywordsCountLimit: GraphQlLong;
}

export interface GroupsQueryForEdit_client_clientConstants {
  __typename: "GdClientConstants";
  allowedBidModifierTypesByAdGroupTypes: GroupsQueryForEdit_client_clientConstants_allowedBidModifierTypesByAdGroupTypes[];
  allowedBidModifiersValues: GroupsQueryForEdit_client_clientConstants_allowedBidModifiersValues[];
  clientLimits: GroupsQueryForEdit_client_clientConstants_clientLimits;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd = GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign = GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign_GdPriceCampaign;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments = GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers_adjustments[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdTextAdGroup";
  access: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_access;
  regionsInfo: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_regionsInfo;
  mainAd: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_mainAd | null;
  campaign: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup_bidModifiers[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd = GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdCPCVideoAd | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign = GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdContentPromotionCampaign | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign_GdPriceCampaign;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments = GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers_adjustments[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  access: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_access;
  regionsInfo: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_regionsInfo;
  mainAd: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_mainAd | null;
  campaign: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup_bidModifiers[] | null;
  feedId: GraphQlLong;
  fieldToUseAsBody: string | null;
  fieldToUseAsName: string | null;
  trackingParams: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd = GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdCPCVideoAd | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd_GdContentPromotionAd;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign = GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdContentPromotionCampaign | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign_GdPriceCampaign;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments = GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers_adjustments[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingInternalNetwork {
  __typename: "GdAdditionalTargetingInternalNetwork";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsBrowser {
  __typename: "GdAdditionalTargetingIsBrowser";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsTablet {
  __typename: "GdAdditionalTargetingIsTablet";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsMobile {
  __typename: "GdAdditionalTargetingIsMobile";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsTouch {
  __typename: "GdAdditionalTargetingIsTouch";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingUserAgents {
  __typename: "GdAdditionalTargetingUserAgents";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames {
  __typename: "GdAdditionalTargetingOsNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames_value[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
  minVersion: string | null;
  maxVersion: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies {
  __typename: "GdAdditionalTargetingOsFamilies";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies_value[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
  minVersion: string | null;
  maxVersion: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames {
  __typename: "GdAdditionalTargetingBrowserNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames_value[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
  minVersion: string | null;
  maxVersion: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines {
  __typename: "GdAdditionalTargetingBrowserEngines";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines_value[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors {
  __typename: "GdAdditionalTargetingDeviceVendors";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors_value[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceNames {
  __typename: "GdAdditionalTargetingDeviceNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingInterfaceLangs {
  __typename: "GdAdditionalTargetingInterfaceLangs";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: InterfaceLang[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingQueryReferers {
  __typename: "GdAdditionalTargetingQueryReferers";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingYandexUids {
  __typename: "GdAdditionalTargetingYandexUids";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingShowDates {
  __typename: "GdAdditionalTargetingShowDates";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLocalDate[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingClidTypes {
  __typename: "GdAdditionalTargetingClidTypes";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingClids {
  __typename: "GdAdditionalTargetingClids";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingDesktopInstalledApps {
  __typename: "GdAdditionalTargetingDesktopInstalledApps";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingMobileInstalledApps {
  __typename: "GdAdditionalTargetingMobileInstalledApps";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingQueryOptions {
  __typename: "GdAdditionalTargetingQueryOptions";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingTestIds {
  __typename: "GdAdditionalTargetingTestIds";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingYsCookies {
  __typename: "GdAdditionalTargetingYsCookies";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsYandexPlus {
  __typename: "GdAdditionalTargetingIsYandexPlus";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsVirused {
  __typename: "GdAdditionalTargetingIsVirused";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup {
  __typename: "GdInternalAdGroup";
  access: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_access;
  regionsInfo: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_regionsInfo;
  mainAd: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_mainAd | null;
  campaign: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_bidModifiers[] | null;
  level: GraphQlLong | null;
  targetingInternalNetwork: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingInternalNetwork | null;
  targetingIsBrowser: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsBrowser | null;
  targetingIsTablet: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsTablet | null;
  targetingIsMobile: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsMobile | null;
  targetingIsTouch: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsTouch | null;
  targetingUserAgents: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingUserAgents | null;
  targetingOsNames: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsNames | null;
  targetingOsFamilies: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingOsFamilies | null;
  targetingBrowserNames: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserNames | null;
  targetingBrowserEngines: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingBrowserEngines | null;
  targetingDeviceVendors: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceVendors | null;
  targetingDeviceNames: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingDeviceNames | null;
  targetingInterfaceLangs: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingInterfaceLangs | null;
  targetingQueryReferers: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingQueryReferers | null;
  targetingYandexUids: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingYandexUids | null;
  targetingShowDates: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingShowDates | null;
  targetingClidTypes: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingClidTypes | null;
  targetingClids: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingClids | null;
  targetingDesktopInstalledApps: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingDesktopInstalledApps | null;
  targetingMobileInstalledApps: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingMobileInstalledApps | null;
  targetingQueryOptions: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingQueryOptions | null;
  targetingTestIds: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingTestIds | null;
  targetingYsCookies: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingYsCookies | null;
  targetingIsYandexPlus: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsYandexPlus | null;
  targetingIsVirused: GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup_targetingIsVirused | null;
  startTime: GraphQlLocalDateTime | null;
  finishTime: GraphQlLocalDateTime | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd = GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign = GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdContentPromotionCampaign | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign_GdPriceCampaign;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments = GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers_adjustments[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup {
  __typename: "GdCpmVideoAdGroup";
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_access;
  regionsInfo: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_regionsInfo;
  mainAd: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_mainAd | null;
  campaign: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd = GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign = GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdContentPromotionCampaign | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign_GdPriceCampaign;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments = GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers_adjustments[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup";
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_access;
  regionsInfo: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_regionsInfo;
  mainAd: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_mainAd | null;
  campaign: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd = GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign = GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdContentPromotionCampaign | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments = GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers_adjustments[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_pageBlocks {
  __typename: "GdAdGroupPageBlock";
  impId: GraphQlLong;
  pageId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup {
  __typename: "GdCpmOutdoorAdGroup";
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_access;
  regionsInfo: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_regionsInfo;
  mainAd: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_mainAd | null;
  campaign: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
  pageBlocks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup_pageBlocks[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd = GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign = GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdContentPromotionCampaign | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign_GdPriceCampaign;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments = GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers_adjustments[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_pageBlocks {
  __typename: "GdAdGroupPageBlock";
  impId: GraphQlLong;
  pageId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup {
  __typename: "GdCpmIndoorAdGroup";
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_access;
  regionsInfo: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_regionsInfo;
  mainAd: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_mainAd | null;
  campaign: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
  pageBlocks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup_pageBlocks[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_typedCreative = GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd = GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd | GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign = GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdContentPromotionCampaign | GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign_GdPriceCampaign;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments = GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers_adjustments[];
}

export interface GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup {
  __typename: "GdCpmPriceAdGroup";
  access: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_access;
  regionsInfo: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_regionsInfo;
  mainAd: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_mainAd | null;
  campaign: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup_bidModifiers[] | null;
  priority: GraphQlLong;
}

export type GroupsQueryForEdit_client_adGroups_rowset = GroupsQueryForEdit_client_adGroups_rowset_GdContentPromotionAdGroup | GroupsQueryForEdit_client_adGroups_rowset_GdSmartAdGroup | GroupsQueryForEdit_client_adGroups_rowset_GdInternalAdGroup | GroupsQueryForEdit_client_adGroups_rowset_GdCpmVideoAdGroup | GroupsQueryForEdit_client_adGroups_rowset_GdCpmAudioAdGroup | GroupsQueryForEdit_client_adGroups_rowset_GdCpmOutdoorAdGroup | GroupsQueryForEdit_client_adGroups_rowset_GdCpmIndoorAdGroup | GroupsQueryForEdit_client_adGroups_rowset_GdCpmPriceAdGroup;

export interface GroupsQueryForEdit_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: GroupsQueryForEdit_client_adGroups_rowset[];
  totalCount: number;
  adGroupIds: GraphQlLong[];
}

export interface GroupsQueryForEdit_client_retargetings_rowset {
  __typename: "GdRetargeting";
  adGroupId: GraphQlLong;
  retargetingConditionId: GraphQlLong;
  retargetingId: GraphQlLong;
  priceContext: GraphQlBigDecimal;
}

export interface GroupsQueryForEdit_client_retargetings {
  __typename: "GdRetargetingContext";
  rowset: GroupsQueryForEdit_client_retargetings_rowset[];
}

export interface GroupsQueryForEdit_client_interests_rowset {
  __typename: "GdRetargeting";
  adGroupId: GraphQlLong;
  retargetingConditionId: GraphQlLong;
  retargetingId: GraphQlLong;
  priceContext: GraphQlBigDecimal;
}

export interface GroupsQueryForEdit_client_interests {
  __typename: "GdRetargetingContext";
  rowset: GroupsQueryForEdit_client_interests_rowset[];
}

export interface GroupsQueryForEdit_client_showConditions_rowset_GdKeyword {
  __typename: "GdKeyword";
  id: GraphQlLong;
  keyword: string;
  minusKeywords: string[];
  adGroupId: GraphQlLong;
}

export interface GroupsQueryForEdit_client_showConditions_rowset_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
  id: GraphQlLong;
  adGroupId: GraphQlLong;
}

export type GroupsQueryForEdit_client_showConditions_rowset = GroupsQueryForEdit_client_showConditions_rowset_GdKeyword | GroupsQueryForEdit_client_showConditions_rowset_GdRelevanceMatch;

export interface GroupsQueryForEdit_client_showConditions {
  __typename: "GdShowConditionsContext";
  rowset: GroupsQueryForEdit_client_showConditions_rowset[];
}

export interface GroupsQueryForEdit_client_smartFilters_rowset_conditions {
  __typename: "GdSmartFilterCondition";
  field: string;
  operator: GdSmartFilterConditionOperator;
  stringValue: string;
}

export interface GroupsQueryForEdit_client_smartFilters_rowset {
  __typename: "GdSmartFilter";
  id: GraphQlLong;
  adGroupId: GraphQlLong;
  name: string;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  priceCpa: GraphQlBigDecimal | null;
  priceCpc: GraphQlBigDecimal | null;
  targetFunnel: GdSmartFilterTargetFunnel;
  tab: GdSmartFilterTab;
  conditions: GroupsQueryForEdit_client_smartFilters_rowset_conditions[];
}

export interface GroupsQueryForEdit_client_smartFilters {
  __typename: "GdSmartFiltersContext";
  rowset: GroupsQueryForEdit_client_smartFilters_rowset[];
}

export interface GroupsQueryForEdit_client_feeds_rowset_categories {
  __typename: "GdFeedCategory";
  categoryId: GraphQlBigInteger;
  offerCount: GraphQlLong | null;
  parentCategoryId: GraphQlBigInteger;
  name: string;
  isDeleted: boolean;
}

export interface GroupsQueryForEdit_client_feeds_rowset {
  __typename: "GdFeed";
  id: GraphQlLong;
  name: string;
  updateStatus: GdUpdateStatus;
  businessType: GdBusinessType;
  categories: GroupsQueryForEdit_client_feeds_rowset_categories[];
  feedType: GdFeedType | null;
}

export interface GroupsQueryForEdit_client_feeds {
  __typename: "GdFeedsContext";
  rowset: GroupsQueryForEdit_client_feeds_rowset[];
}

export interface GroupsQueryForEdit_client {
  __typename: "GdClient";
  chiefLogin: string;
  clientConstants: GroupsQueryForEdit_client_clientConstants;
  adGroups: GroupsQueryForEdit_client_adGroups;
  retargetings: GroupsQueryForEdit_client_retargetings;
  interests: GroupsQueryForEdit_client_interests;
  showConditions: GroupsQueryForEdit_client_showConditions;
  smartFilters: GroupsQueryForEdit_client_smartFilters;
  feeds: GroupsQueryForEdit_client_feeds;
}

export interface GroupsQueryForEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupsQueryForEdit_client;
}

export interface GroupsQueryForEditVariables {
  login: string;
  adGroupsInput: GdAdGroupsContainerInput;
  showConditionsInput: GdShowConditionsContainerInput;
  smartFiltersInput: GdSmartFiltersContainerInput;
  retargetingsInput: GdRetargetingsContainerInput;
  interestsInput: GdRetargetingsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupsQueryPageBlocks
// ====================================================

export interface GroupsQueryPageBlocks_client_adGroups_rowset_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
}

export interface GroupsQueryPageBlocks_client_adGroups_rowset_GdCpmIndoorAdGroup_pageBlocks {
  __typename: "GdAdGroupPageBlock";
  pageId: GraphQlLong;
  blockId: GraphQlLong;
}

export interface GroupsQueryPageBlocks_client_adGroups_rowset_GdCpmIndoorAdGroup {
  __typename: "GdCpmIndoorAdGroup";
  pageBlocks: GroupsQueryPageBlocks_client_adGroups_rowset_GdCpmIndoorAdGroup_pageBlocks[];
}

export interface GroupsQueryPageBlocks_client_adGroups_rowset_GdCpmOutdoorAdGroup_pageBlocks {
  __typename: "GdAdGroupPageBlock";
  pageId: GraphQlLong;
  blockId: GraphQlLong;
}

export interface GroupsQueryPageBlocks_client_adGroups_rowset_GdCpmOutdoorAdGroup {
  __typename: "GdCpmOutdoorAdGroup";
  pageBlocks: GroupsQueryPageBlocks_client_adGroups_rowset_GdCpmOutdoorAdGroup_pageBlocks[];
}

export type GroupsQueryPageBlocks_client_adGroups_rowset = GroupsQueryPageBlocks_client_adGroups_rowset_GdContentPromotionAdGroup | GroupsQueryPageBlocks_client_adGroups_rowset_GdCpmIndoorAdGroup | GroupsQueryPageBlocks_client_adGroups_rowset_GdCpmOutdoorAdGroup;

export interface GroupsQueryPageBlocks_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: GroupsQueryPageBlocks_client_adGroups_rowset[];
}

export interface GroupsQueryPageBlocks_client {
  __typename: "GdClient";
  adGroups: GroupsQueryPageBlocks_client_adGroups;
}

export interface GroupsQueryPageBlocks {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupsQueryPageBlocks_client;
}

export interface GroupsQueryPageBlocksVariables {
  adGroupsInput: GdAdGroupsContainerInput;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupsQueryKeywordsAndRetargeting
// ====================================================

export interface GroupsQueryKeywordsAndRetargeting_cryptaSegments_rowset {
  __typename: "GdCryptaSegment";
  id: GraphQlLong;
  type: WebGoalType;
  name: string;
  parentId: GraphQlLong | null;
  description: string;
  interestType: CryptaInterestTypeWeb | null;
  canSelectAll: boolean | null;
  mutuallyExclusiveIds: GraphQlLong[] | null;
}

export interface GroupsQueryKeywordsAndRetargeting_cryptaSegments {
  __typename: "GdCryptaSegmentsContext";
  totalCount: number;
  rowset: GroupsQueryKeywordsAndRetargeting_cryptaSegments_rowset[];
}

export interface GroupsQueryKeywordsAndRetargeting_client_retargetings_rowset_retargetingCondition {
  __typename: "GdRetargetingCondition";
  name: string;
}

export interface GroupsQueryKeywordsAndRetargeting_client_retargetings_rowset {
  __typename: "GdRetargeting";
  retargetingCondition: GroupsQueryKeywordsAndRetargeting_client_retargetings_rowset_retargetingCondition | null;
}

export interface GroupsQueryKeywordsAndRetargeting_client_retargetings {
  __typename: "GdRetargetingContext";
  rowset: GroupsQueryKeywordsAndRetargeting_client_retargetings_rowset[];
}

export interface GroupsQueryKeywordsAndRetargeting_client_interests_rowset_retargetingCondition_conditionRules_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  type: GdGoalType;
  time: number | null;
}

export interface GroupsQueryKeywordsAndRetargeting_client_interests_rowset_retargetingCondition_conditionRules {
  __typename: "GdRetargetingConditionRuleItem";
  type: GdRetargetingConditionRuleType;
  interestType: CryptaInterestType | null;
  goals: GroupsQueryKeywordsAndRetargeting_client_interests_rowset_retargetingCondition_conditionRules_goals[];
}

export interface GroupsQueryKeywordsAndRetargeting_client_interests_rowset_retargetingCondition {
  __typename: "GdRetargetingCondition";
  name: string;
  description: string | null;
  conditionRules: GroupsQueryKeywordsAndRetargeting_client_interests_rowset_retargetingCondition_conditionRules[];
}

export interface GroupsQueryKeywordsAndRetargeting_client_interests_rowset {
  __typename: "GdRetargeting";
  retargetingId: GraphQlLong;
  retargetingCondition: GroupsQueryKeywordsAndRetargeting_client_interests_rowset_retargetingCondition | null;
}

export interface GroupsQueryKeywordsAndRetargeting_client_interests {
  __typename: "GdRetargetingContext";
  rowset: GroupsQueryKeywordsAndRetargeting_client_interests_rowset[];
}

export interface GroupsQueryKeywordsAndRetargeting_client_showConditions_rowset_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
  id: GraphQlLong;
}

export interface GroupsQueryKeywordsAndRetargeting_client_showConditions_rowset_GdKeyword {
  __typename: "GdKeyword";
  id: GraphQlLong;
  keyword: string;
}

export type GroupsQueryKeywordsAndRetargeting_client_showConditions_rowset = GroupsQueryKeywordsAndRetargeting_client_showConditions_rowset_GdRelevanceMatch | GroupsQueryKeywordsAndRetargeting_client_showConditions_rowset_GdKeyword;

export interface GroupsQueryKeywordsAndRetargeting_client_showConditions {
  __typename: "GdShowConditionsContext";
  rowset: GroupsQueryKeywordsAndRetargeting_client_showConditions_rowset[];
}

export interface GroupsQueryKeywordsAndRetargeting_client {
  __typename: "GdClient";
  retargetings: GroupsQueryKeywordsAndRetargeting_client_retargetings;
  interests: GroupsQueryKeywordsAndRetargeting_client_interests;
  showConditions: GroupsQueryKeywordsAndRetargeting_client_showConditions;
}

export interface GroupsQueryKeywordsAndRetargeting {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  cryptaSegments: GroupsQueryKeywordsAndRetargeting_cryptaSegments;
  client: GroupsQueryKeywordsAndRetargeting_client;
}

export interface GroupsQueryKeywordsAndRetargetingVariables {
  login: string;
  showConditionsInput: GdShowConditionsContainerInput;
  retargetingsInput: GdRetargetingsContainerInput;
  interestsInput: GdRetargetingsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ProductsListQuery
// ====================================================

export interface ProductsListQuery_products_rowset_restrictions_conditions {
  __typename: "GdProductRestrictionCondition";
  name: string;
  values: GraphQlMap_String_ObjectScalar[];
}

export interface ProductsListQuery_products_rowset_restrictions {
  __typename: "GdProductRestriction";
  id: GraphQlLong;
  groupType: GdAdGroupType;
  active: boolean | null;
  conditions: ProductsListQuery_products_rowset_restrictions_conditions[];
}

export interface ProductsListQuery_products_rowset {
  __typename: "GdProduct";
  id: GraphQlLong;
  type: GdProductType;
  restrictions: ProductsListQuery_products_rowset_restrictions[];
}

export interface ProductsListQuery_products {
  __typename: "GdProductContext";
  totalCount: number;
  rowset: ProductsListQuery_products_rowset[];
}

export interface ProductsListQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  products: ProductsListQuery_products;
}

export interface ProductsListQueryVariables {
  productFilterInput: GdProductContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SmartFiltersQuery
// ====================================================

export interface SmartFiltersQuery_client_smartFilters_rowset_conditions {
  __typename: "GdSmartFilterCondition";
  field: string;
  operator: GdSmartFilterConditionOperator;
  stringValue: string;
}

export interface SmartFiltersQuery_client_smartFilters_rowset {
  __typename: "GdSmartFilter";
  id: GraphQlLong;
  adGroupId: GraphQlLong;
  name: string;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  priceCpa: GraphQlBigDecimal | null;
  priceCpc: GraphQlBigDecimal | null;
  targetFunnel: GdSmartFilterTargetFunnel;
  tab: GdSmartFilterTab;
  conditions: SmartFiltersQuery_client_smartFilters_rowset_conditions[];
}

export interface SmartFiltersQuery_client_smartFilters {
  __typename: "GdSmartFiltersContext";
  rowset: SmartFiltersQuery_client_smartFilters_rowset[];
}

export interface SmartFiltersQuery_client {
  __typename: "GdClient";
  smartFilters: SmartFiltersQuery_client_smartFilters;
}

export interface SmartFiltersQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: SmartFiltersQuery_client;
}

export interface SmartFiltersQueryVariables {
  login: string;
  smartFiltersInput: GdSmartFiltersContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignBasicDataForGroupEdit
// ====================================================

export interface CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  type: GdCampaignType;
  name: string;
  defaultRegionIds: (GraphQlLong | null)[];
  strategy: CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdContentPromotionCampaign_strategy;
  availableAdGroupTypes: GdAdGroupType[];
}

export interface CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  type: GdCampaignType;
  name: string;
  defaultRegionIds: (GraphQlLong | null)[];
  strategy: CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdPriceCampaign_strategy;
  availableAdGroupTypes: GdAdGroupType[];
  pricePackageId: GraphQlLong | null;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  hasDefaultAdGroup: boolean;
  flightTargetingsSnapshot: CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdPriceCampaign_pricePackage;
}

export type CampaignBasicDataForGroupEdit_client_campaigns_rowset = CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdContentPromotionCampaign | CampaignBasicDataForGroupEdit_client_campaigns_rowset_GdPriceCampaign;

export interface CampaignBasicDataForGroupEdit_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: CampaignBasicDataForGroupEdit_client_campaigns_rowset[];
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifierTypesByAdGroupTypes {
  __typename: "GdAllowedBidModifiersByAdGroupType";
  adGroupType: GdAdGroupType;
  allowedBidModifierTypes: GdBidModifierType[];
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment {
  __typename: "GdAllowedBidModifierValuesABSegment" | "GdAllowedBidModifierValuesDemographics" | "GdAllowedBidModifierValuesDesktop" | "GdAllowedBidModifierValuesExpression" | "GdAllowedBidModifierValuesGeo" | "GdAllowedBidModifierValuesRetargeting" | "GdAllowedBidModifierValuesSmartTgo" | "GdAllowedBidModifierValuesVideo" | "GdAllowedBidModifierValuesWeather";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment_percentRange;
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile {
  __typename: "GdAllowedBidModifierValuesMobile";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile_percentRange;
  osTypes: GdOsType[];
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory {
  __typename: "GdAllowedBidModifierValuesInventory";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory_percentRange;
  inventoryTypes: GdInventoryType[];
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType {
  __typename: "GdAllowedBidModifierValuesAdType";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType_percentRange;
  adTypes: GdAdjustmentAdType[];
}

export type CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues = CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesABSegment | CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesMobile | CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesInventory | CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues_GdAllowedBidModifierValuesAdType;

export interface CampaignBasicDataForGroupEdit_client_clientConstants_clientLimits {
  __typename: "GdClientLimits";
  keywordsCountLimit: GraphQlLong;
}

export interface CampaignBasicDataForGroupEdit_client_clientConstants {
  __typename: "GdClientConstants";
  allowedBidModifierTypesByAdGroupTypes: CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifierTypesByAdGroupTypes[];
  allowedBidModifiersValues: CampaignBasicDataForGroupEdit_client_clientConstants_allowedBidModifiersValues[];
  clientLimits: CampaignBasicDataForGroupEdit_client_clientConstants_clientLimits;
}

export interface CampaignBasicDataForGroupEdit_client {
  __typename: "GdClient";
  campaigns: CampaignBasicDataForGroupEdit_client_campaigns;
  clientConstants: CampaignBasicDataForGroupEdit_client_clientConstants;
}

export interface CampaignBasicDataForGroupEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignBasicDataForGroupEdit_client;
}

export interface CampaignBasicDataForGroupEditVariables {
  login: string;
  campInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RegionTreeForGroupEdit
// ====================================================

export interface RegionTreeForGroupEdit_client_campaigns_rowset_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  type: GdCampaignType;
}

export interface RegionTreeForGroupEdit_client_campaigns_rowset_GdPriceCampaign_customGeoExpanded_geoExpandedTrees_inner_inner_inner_inner {
  __typename: "GdCpmPriceCampaignGeoNode";
  id: GraphQlLong;
  name: string;
}

export interface RegionTreeForGroupEdit_client_campaigns_rowset_GdPriceCampaign_customGeoExpanded_geoExpandedTrees_inner_inner_inner {
  __typename: "GdCpmPriceCampaignGeoNode";
  id: GraphQlLong;
  name: string;
  inner: RegionTreeForGroupEdit_client_campaigns_rowset_GdPriceCampaign_customGeoExpanded_geoExpandedTrees_inner_inner_inner_inner[] | null;
}

export interface RegionTreeForGroupEdit_client_campaigns_rowset_GdPriceCampaign_customGeoExpanded_geoExpandedTrees_inner_inner {
  __typename: "GdCpmPriceCampaignGeoNode";
  id: GraphQlLong;
  name: string;
  inner: RegionTreeForGroupEdit_client_campaigns_rowset_GdPriceCampaign_customGeoExpanded_geoExpandedTrees_inner_inner_inner[] | null;
}

export interface RegionTreeForGroupEdit_client_campaigns_rowset_GdPriceCampaign_customGeoExpanded_geoExpandedTrees_inner {
  __typename: "GdCpmPriceCampaignGeoNode";
  id: GraphQlLong;
  name: string;
  inner: RegionTreeForGroupEdit_client_campaigns_rowset_GdPriceCampaign_customGeoExpanded_geoExpandedTrees_inner_inner[] | null;
}

export interface RegionTreeForGroupEdit_client_campaigns_rowset_GdPriceCampaign_customGeoExpanded_geoExpandedTrees {
  __typename: "GdCpmPriceCampaignGeoNode";
  id: GraphQlLong;
  name: string;
  inner: RegionTreeForGroupEdit_client_campaigns_rowset_GdPriceCampaign_customGeoExpanded_geoExpandedTrees_inner[] | null;
}

export interface RegionTreeForGroupEdit_client_campaigns_rowset_GdPriceCampaign_customGeoExpanded {
  __typename: "GdCpmPriceCampaignGeo";
  geoExpandedTrees: RegionTreeForGroupEdit_client_campaigns_rowset_GdPriceCampaign_customGeoExpanded_geoExpandedTrees[];
}

export interface RegionTreeForGroupEdit_client_campaigns_rowset_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  type: GdCampaignType;
  customGeoExpanded: RegionTreeForGroupEdit_client_campaigns_rowset_GdPriceCampaign_customGeoExpanded;
}

export type RegionTreeForGroupEdit_client_campaigns_rowset = RegionTreeForGroupEdit_client_campaigns_rowset_GdContentPromotionCampaign | RegionTreeForGroupEdit_client_campaigns_rowset_GdPriceCampaign;

export interface RegionTreeForGroupEdit_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: RegionTreeForGroupEdit_client_campaigns_rowset[];
}

export interface RegionTreeForGroupEdit_client {
  __typename: "GdClient";
  campaigns: RegionTreeForGroupEdit_client_campaigns;
}

export interface RegionTreeForGroupEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RegionTreeForGroupEdit_client;
}

export interface RegionTreeForGroupEditVariables {
  login: string;
  campInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CreativesQuery
// ====================================================

export interface CreativesQuery_creatives_rowset_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  previewUrl: string;
  width: GraphQlLong | null;
}

export interface CreativesQuery_creatives_rowset_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  previewUrl: string;
  width: GraphQlLong | null;
  isAdaptive: boolean | null;
}

export interface CreativesQuery_creatives_rowset_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  previewUrl: string;
  width: GraphQlLong | null;
  isImage: boolean;
}

export type CreativesQuery_creatives_rowset = CreativesQuery_creatives_rowset_GdSmartCreative | CreativesQuery_creatives_rowset_GdCanvasCreative | CreativesQuery_creatives_rowset_GdHtml5Creative;

export interface CreativesQuery_creatives {
  __typename: "GdCreativesContext";
  cacheKey: string;
  creativeIds: GraphQlLong[];
  rowset: CreativesQuery_creatives_rowset[];
  totalCount: number;
}

export interface CreativesQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  creatives: CreativesQuery_creatives;
}

export interface CreativesQueryVariables {
  input: GdCreativesContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SmartFeedSchemaQuery
// ====================================================

export interface SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterNumberField_operators {
  __typename: "GdSmartFilterOperator";
  maxItems: number;
  type: GdSmartFilterConditionOperator;
}

export interface SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterNumberField {
  __typename: "GdSmartFilterNumberField";
  name: string;
  operators: SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterNumberField_operators[];
  max: number;
  min: number;
  precision: number;
}

export interface SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterStringField_operators {
  __typename: "GdSmartFilterOperator";
  maxItems: number;
  type: GdSmartFilterConditionOperator;
}

export interface SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterStringField {
  __typename: "GdSmartFilterStringField";
  name: string;
  operators: SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterStringField_operators[];
  maxLength: number;
  minLength: number;
  pattern: string | null;
}

export interface SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterEnumField_operators {
  __typename: "GdSmartFilterOperator";
  maxItems: number;
  type: GdSmartFilterConditionOperator;
}

export interface SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterEnumField {
  __typename: "GdSmartFilterEnumField";
  name: string;
  operators: SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterEnumField_operators[];
  values: string[];
}

export type SmartFeedSchemaQuery_constants_smartFilterSchemas_fields = SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterNumberField | SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterStringField | SmartFeedSchemaQuery_constants_smartFilterSchemas_fields_GdSmartFilterEnumField;

export interface SmartFeedSchemaQuery_constants_smartFilterSchemas {
  __typename: "GdSmartFilterSchema";
  fields: SmartFeedSchemaQuery_constants_smartFilterSchemas_fields[];
}

export interface SmartFeedSchemaQuery_constants {
  __typename: "GdDirectConstants";
  smartFilterSchemas: (SmartFeedSchemaQuery_constants_smartFilterSchemas | null)[] | null;
}

export interface SmartFeedSchemaQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  constants: SmartFeedSchemaQuery_constants;
}

export interface SmartFeedSchemaQueryVariables {
  input?: GdSmartFilterSchemaQueryInput | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PerformanceCreativesQuery
// ====================================================

export interface PerformanceCreativesQuery_client_ads_rowset_GdContentPromotionAd {
  __typename: "GdContentPromotionAd" | "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdTextAd";
}

export interface PerformanceCreativesQuery_client_ads_rowset_GdSmartAd_creative {
  __typename: "GdCreative";
  creativeId: GraphQlLong;
}

export interface PerformanceCreativesQuery_client_ads_rowset_GdSmartAd {
  __typename: "GdSmartAd";
  creative: PerformanceCreativesQuery_client_ads_rowset_GdSmartAd_creative | null;
}

export type PerformanceCreativesQuery_client_ads_rowset = PerformanceCreativesQuery_client_ads_rowset_GdContentPromotionAd | PerformanceCreativesQuery_client_ads_rowset_GdSmartAd;

export interface PerformanceCreativesQuery_client_ads {
  __typename: "GdAdsContext";
  rowset: PerformanceCreativesQuery_client_ads_rowset[];
}

export interface PerformanceCreativesQuery_client_adGroups_rowset_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdTextAdGroup";
}

export interface PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset_layout {
  __typename: "GdCreativeLayout";
  id: GraphQlLong;
  imgSrc: string | null;
  name: string | null;
}

export interface PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset_theme {
  __typename: "GdCreativeTheme";
  id: GraphQlLong;
  name: string | null;
}

export interface PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset_usedInCampaigns {
  __typename: "GdCampaignForLink";
  id: GraphQlLong;
  name: string;
}

export interface PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset {
  __typename: "GdSmartCreative";
  groupId: GraphQlLong | null;
  groupName: string | null;
  creativeId: GraphQlLong;
  businessType: GdCreativeBusinessType;
  statusModerate: GdCreativeStatusModerate;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset_layout | null;
  theme: PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset_theme | null;
  usedInCampaigns: PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset_usedInCampaigns[];
  regionIds: GraphQlLong[];
}

export interface PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives {
  __typename: "GdAvailableCreativesContext";
  rowset: PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives_rowset[];
}

export interface PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  availableCreatives: PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup_availableCreatives | null;
}

export type PerformanceCreativesQuery_client_adGroups_rowset = PerformanceCreativesQuery_client_adGroups_rowset_GdContentPromotionAdGroup | PerformanceCreativesQuery_client_adGroups_rowset_GdSmartAdGroup;

export interface PerformanceCreativesQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: PerformanceCreativesQuery_client_adGroups_rowset[];
}

export interface PerformanceCreativesQuery_client {
  __typename: "GdClient";
  ads: PerformanceCreativesQuery_client_ads;
  adGroups: PerformanceCreativesQuery_client_adGroups;
}

export interface PerformanceCreativesQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: PerformanceCreativesQuery_client;
}

export interface PerformanceCreativesQueryVariables {
  login: string;
  adsInput: GdAdsContainerInput;
  adGroupInput: GdAdGroupsContainerInput;
  limit: number;
  offset: number;
  order: OrderInput;
  idOrName: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FeedsQuery
// ====================================================

export interface FeedsQuery_client_feeds_rowset_categories {
  __typename: "GdFeedCategory";
  categoryId: GraphQlBigInteger;
  offerCount: GraphQlLong | null;
  parentCategoryId: GraphQlBigInteger;
  name: string;
  isDeleted: boolean;
}

export interface FeedsQuery_client_feeds_rowset {
  __typename: "GdFeed";
  id: GraphQlLong;
  name: string;
  updateStatus: GdUpdateStatus;
  businessType: GdBusinessType;
  categories: FeedsQuery_client_feeds_rowset_categories[];
  feedType: GdFeedType | null;
}

export interface FeedsQuery_client_feeds {
  __typename: "GdFeedsContext";
  rowset: FeedsQuery_client_feeds_rowset[];
}

export interface FeedsQuery_client {
  __typename: "GdClient";
  feeds: FeedsQuery_client_feeds;
}

export interface FeedsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: FeedsQuery_client;
}

export interface FeedsQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SmartFiltersGridQuery
// ====================================================

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_campaign;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_access;
  mainAd: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_campaign;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_access;
  mainAd: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_regionsInfo;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_campaign;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_access;
  mainAd: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_campaign;
  access: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_access;
  mainAd: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_regionsInfo;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type SmartFiltersGridQuery_client_smartFilters_rowset_adGroup = SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdContentPromotionAdGroup | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdDynamicAdGroup | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdMobileContentAdGroup | SmartFiltersGridQuery_client_smartFilters_rowset_adGroup_GdSmartAdGroup;

export interface SmartFiltersGridQuery_client_smartFilters_rowset_conditions {
  __typename: "GdSmartFilterCondition";
  field: string;
  operator: GdSmartFilterConditionOperator;
  stringValue: string;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_stats {
  __typename: "GdEntityStats";
  avgClickCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
  cost: GraphQlBigDecimal | null;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset_status {
  __typename: "GdSmartFilterStatus";
  primaryStatus: GdSmartFilterPrimaryStatus;
}

export interface SmartFiltersGridQuery_client_smartFilters_rowset {
  __typename: "GdSmartFilter";
  id: GraphQlLong;
  adGroup: SmartFiltersGridQuery_client_smartFilters_rowset_adGroup;
  name: string;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  priceCpa: GraphQlBigDecimal | null;
  priceCpc: GraphQlBigDecimal | null;
  targetFunnel: GdSmartFilterTargetFunnel;
  tab: GdSmartFilterTab;
  conditions: SmartFiltersGridQuery_client_smartFilters_rowset_conditions[];
  stats: SmartFiltersGridQuery_client_smartFilters_rowset_stats;
  status: SmartFiltersGridQuery_client_smartFilters_rowset_status;
}

export interface SmartFiltersGridQuery_client_smartFilters_totalStats {
  __typename: "GdEntityStats";
  shows: GraphQlLong | null;
  ctr: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
}

export interface SmartFiltersGridQuery_client_smartFilters {
  __typename: "GdSmartFiltersContext";
  rowset: SmartFiltersGridQuery_client_smartFilters_rowset[];
  cacheKey: string;
  smartFilterIds: GraphQlLong[];
  totalCount: number;
  totalStats: SmartFiltersGridQuery_client_smartFilters_totalStats | null;
}

export interface SmartFiltersGridQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  smartFilters: SmartFiltersGridQuery_client_smartFilters;
}

export interface SmartFiltersGridQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: SmartFiltersGridQuery_client;
}

export interface SmartFiltersGridQueryVariables {
  login: string;
  smartFiltersInput: GdSmartFiltersContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CopyAdGroupsInfoQuery
// ====================================================

export interface CopyAdGroupsInfoQuery_client_adGroups_rowset_campaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  type: GdCampaignType;
  name: string;
  id: GraphQlLong;
}

export interface CopyAdGroupsInfoQuery_client_adGroups_rowset {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  name: string;
  id: GraphQlLong;
  campaign: CopyAdGroupsInfoQuery_client_adGroups_rowset_campaign;
}

export interface CopyAdGroupsInfoQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: CopyAdGroupsInfoQuery_client_adGroups_rowset[];
}

export interface CopyAdGroupsInfoQuery_client {
  __typename: "GdClient";
  adGroups: CopyAdGroupsInfoQuery_client_adGroups;
}

export interface CopyAdGroupsInfoQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CopyAdGroupsInfoQuery_client;
}

export interface CopyAdGroupsInfoQueryVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GoalsQuery
// ====================================================

export interface GoalsQuery_client_campaignGoals_rowset {
  __typename: "GdGoal";
  id: GraphQlLong;
  name: string;
}

export interface GoalsQuery_client_campaignGoals {
  __typename: "GdGoalsContext";
  rowset: GoalsQuery_client_campaignGoals_rowset[];
}

export interface GoalsQuery_client {
  __typename: "GdClient";
  campaignGoals: GoalsQuery_client_campaignGoals;
}

export interface GoalsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GoalsQuery_client;
}

export interface GoalsQueryVariables {
  login: string;
  goalsInput: GdCampaignGoalsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupKeywordsQuery
// ====================================================

export interface GroupKeywordsQuery_client_showConditions_rowset_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
  id: GraphQlLong;
}

export interface GroupKeywordsQuery_client_showConditions_rowset_GdKeyword {
  __typename: "GdKeyword";
  id: GraphQlLong;
  keyword: string;
}

export type GroupKeywordsQuery_client_showConditions_rowset = GroupKeywordsQuery_client_showConditions_rowset_GdRelevanceMatch | GroupKeywordsQuery_client_showConditions_rowset_GdKeyword;

export interface GroupKeywordsQuery_client_showConditions {
  __typename: "GdShowConditionsContext";
  rowset: GroupKeywordsQuery_client_showConditions_rowset[];
}

export interface GroupKeywordsQuery_client {
  __typename: "GdClient";
  showConditions: GroupKeywordsQuery_client_showConditions;
}

export interface GroupKeywordsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupKeywordsQuery_client;
}

export interface GroupKeywordsQueryVariables {
  login: string;
  input: GdShowConditionsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ReachQuery
// ====================================================

export interface ReachQuery_reach_basic {
  __typename: "GdReachInfo";
  reach: GraphQlLong | null;
  reachLessThan: GraphQlLong | null;
}

export interface ReachQuery_reach_detailed {
  __typename: "GdReachInfo";
  reach: GraphQlLong | null;
  reachLessThan: GraphQlLong | null;
}

export interface ReachQuery_reach {
  __typename: "GdReachResult";
  basic: ReachQuery_reach_basic | null;
  detailed: ReachQuery_reach_detailed | null;
  requestId: string;
}

export interface ReachQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  reach: ReachQuery_reach;
}

export interface ReachQueryVariables {
  input: GdReachRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ReachRecommendationQuery
// ====================================================

export interface ReachRecommendationQuery_reachRecommendation_bannerFormats {
  __typename: "GdBannerFormatIncreasePercent";
  format: string;
  increasePercent: GraphQlBigDecimal | null;
}

export interface ReachRecommendationQuery_reachRecommendation {
  __typename: "GdReachRecommendationResult";
  bannerFormats: ReachRecommendationQuery_reachRecommendation_bannerFormats[] | null;
  requestId: string;
}

export interface ReachRecommendationQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  reachRecommendation: ReachRecommendationQuery_reachRecommendation;
}

export interface ReachRecommendationQueryVariables {
  input: GdReachRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RecommendationsAdsGroupEditQuery
// ====================================================

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi = RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi;
}

export type RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations = RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi | RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi;

export interface RecommendationsAdsGroupEditQuery_client_adGroups_rowset {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  id: GraphQlLong;
  type: GdAdGroupType;
  name: string;
  recommendations: RecommendationsAdsGroupEditQuery_client_adGroups_rowset_recommendations[] | null;
}

export interface RecommendationsAdsGroupEditQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: RecommendationsAdsGroupEditQuery_client_adGroups_rowset[];
}

export interface RecommendationsAdsGroupEditQuery_client {
  __typename: "GdClient";
  adGroups: RecommendationsAdsGroupEditQuery_client_adGroups;
}

export interface RecommendationsAdsGroupEditQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RecommendationsAdsGroupEditQuery_client;
}

export interface RecommendationsAdsGroupEditQueryVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RecommendationsGroupEditQuery
// ====================================================

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi = RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi;
}

export type RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations = RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi | RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi;

export interface RecommendationsGroupEditQuery_client_adGroups_rowset {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  id: GraphQlLong;
  type: GdAdGroupType;
  name: string;
  recommendations: RecommendationsGroupEditQuery_client_adGroups_rowset_recommendations[] | null;
}

export interface RecommendationsGroupEditQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: RecommendationsGroupEditQuery_client_adGroups_rowset[];
}

export interface RecommendationsGroupEditQuery_client {
  __typename: "GdClient";
  adGroups: RecommendationsGroupEditQuery_client_adGroups;
}

export interface RecommendationsGroupEditQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RecommendationsGroupEditQuery_client;
}

export interface RecommendationsGroupEditQueryVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ReachOutdoorQuery
// ====================================================

export interface ReachOutdoorQuery_reachOutdoor {
  __typename: "GdReachOutdoorResult";
  otsCapacity: GraphQlLong | null;
  reach: GraphQlLong | null;
  reachLessThan: GraphQlLong | null;
  requestId: string;
}

export interface ReachOutdoorQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  reachOutdoor: ReachOutdoorQuery_reachOutdoor | null;
}

export interface ReachOutdoorQueryVariables {
  input: GdOutdoorReachRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ReachIndoorQuery
// ====================================================

export interface ReachIndoorQuery_reachIndoor {
  __typename: "GdReachIndoorResult";
  otsCapacity: GraphQlLong | null;
  reach: GraphQlLong | null;
  reachLessThan: GraphQlLong | null;
  requestId: string;
}

export interface ReachIndoorQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  reachIndoor: ReachIndoorQuery_reachIndoor | null;
}

export interface ReachIndoorQueryVariables {
  input: GdIndoorReachRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: TopRegionQuery
// ====================================================

export interface TopRegionQuery_adGroupTopRegions_regions {
  __typename: "GdClientTopRegionInfo";
  count: number;
  regionIds: number[];
}

export interface TopRegionQuery_adGroupTopRegions {
  __typename: "GdClientTopRegionsPayload";
  regions: TopRegionQuery_adGroupTopRegions_regions[];
}

export interface TopRegionQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  adGroupTopRegions: TopRegionQuery_adGroupTopRegions;
}

export interface TopRegionQueryVariables {
  input: GdClientTopRegionsInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContentPromotionMetadata
// ====================================================

export interface GetContentPromotionMetadata_getContentPromotionMeta_contentPromotionMeta {
  __typename: "GdContentPromotionMeta";
  contentId: GraphQlLong | null;
  title: string | null;
  description: string | null;
  url: string | null;
  previewUrl: string | null;
}

export interface GetContentPromotionMetadata_getContentPromotionMeta_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface GetContentPromotionMetadata_getContentPromotionMeta_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface GetContentPromotionMetadata_getContentPromotionMeta_validationResult {
  __typename: "GdValidationResult";
  errors: GetContentPromotionMetadata_getContentPromotionMeta_validationResult_errors[];
  warnings: GetContentPromotionMetadata_getContentPromotionMeta_validationResult_warnings[];
}

export interface GetContentPromotionMetadata_getContentPromotionMeta {
  __typename: "GdGetContentPromotionMetaPayload";
  contentPromotionMeta: GetContentPromotionMetadata_getContentPromotionMeta_contentPromotionMeta | null;
  validationResult: GetContentPromotionMetadata_getContentPromotionMeta_validationResult | null;
}

export interface GetContentPromotionMetadata {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  getContentPromotionMeta: GetContentPromotionMetadata_getContentPromotionMeta;
}

export interface GetContentPromotionMetadataVariables {
  input: GdGetContentPromotionMetaInputInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FreelancersListUpdateQuery
// ====================================================

export interface FreelancersListUpdateQuery_freelancersList_privateData_newestCard_contacts {
  __typename: "GdFreelancerContacts";
  siteUrl: string | null;
  whatsApp: string | null;
  phone: string;
  icq: string | null;
  telegram: string | null;
  email: string;
  viber: string | null;
  skype: string | null;
}

export interface FreelancersListUpdateQuery_freelancersList_privateData_newestCard {
  __typename: "GdFreelancerCard";
  statusModerate: GdFreelancersCardStatusModerate;
  briefInfo: string;
  avatarUrl: string;
  contacts: FreelancersListUpdateQuery_freelancersList_privateData_newestCard_contacts;
}

export interface FreelancersListUpdateQuery_freelancersList_privateData_advQuality {
  __typename: "GdFreelancerAdvQuality";
  advQualityRank: GraphQlLong | null;
  advQualityRating: GraphQlBigDecimal | null;
}

export interface FreelancersListUpdateQuery_freelancersList_privateData {
  __typename: "GdFreelancerPrivateData";
  freelancerId: GraphQlLong;
  /**
   * Последняя версия карточки вне зависимости от статуса
   */
  newestCard: FreelancersListUpdateQuery_freelancersList_privateData_newestCard | null;
  /**
   * ОКР-рейтинг специалиста.
   */
  advQuality: FreelancersListUpdateQuery_freelancersList_privateData_advQuality | null;
}

export interface FreelancersListUpdateQuery_freelancersList {
  __typename: "GdFreelancerBase";
  /**
   * Приватные данные фрилансера. null, если у оператора нет прав на просмотр
   */
  privateData: FreelancersListUpdateQuery_freelancersList_privateData | null;
}

export interface FreelancersListUpdateQuery_client_freelancerProjects {
  __typename: "GdClientProject";
  freelancerId: GraphQlLong;
}

export interface FreelancersListUpdateQuery_client {
  __typename: "GdClient";
  freelancerProjects: FreelancersListUpdateQuery_client_freelancerProjects[];
}

export interface FreelancersListUpdateQuery {
  freelancersList: (FreelancersListUpdateQuery_freelancersList | null)[];
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: FreelancersListUpdateQuery_client;
}

export interface FreelancersListUpdateQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FreelancerRegisteredQuery
// ====================================================

export interface FreelancerRegisteredQuery_freelancersList_privateData_newestCard_contacts {
  __typename: "GdFreelancerContacts";
  siteUrl: string | null;
  whatsApp: string | null;
  phone: string;
  icq: string | null;
  telegram: string | null;
  email: string;
  viber: string | null;
  skype: string | null;
}

export interface FreelancerRegisteredQuery_freelancersList_privateData_newestCard {
  __typename: "GdFreelancerCard";
  statusModerate: GdFreelancersCardStatusModerate;
  briefInfo: string;
  avatarUrl: string;
  contacts: FreelancerRegisteredQuery_freelancersList_privateData_newestCard_contacts;
}

export interface FreelancerRegisteredQuery_freelancersList_privateData_advQuality {
  __typename: "GdFreelancerAdvQuality";
  advQualityRank: GraphQlLong | null;
  advQualityRating: GraphQlBigDecimal | null;
}

export interface FreelancerRegisteredQuery_freelancersList_privateData {
  __typename: "GdFreelancerPrivateData";
  freelancerId: GraphQlLong;
  /**
   * Последняя версия карточки вне зависимости от статуса
   */
  newestCard: FreelancerRegisteredQuery_freelancersList_privateData_newestCard | null;
  /**
   * ОКР-рейтинг специалиста.
   */
  advQuality: FreelancerRegisteredQuery_freelancersList_privateData_advQuality | null;
}

export interface FreelancerRegisteredQuery_freelancersList_card {
  __typename: "GdFreelancerCard";
  avatarUrl: string;
}

export interface FreelancerRegisteredQuery_freelancersList_feedbacks_authorInfo {
  __typename: "GdUserPublicInfo";
  avatarUrl: string;
  login: string;
  name: string;
  userId: GraphQlLong;
}

export interface FreelancerRegisteredQuery_freelancersList_feedbacks {
  __typename: "GdFreelancerFeedback";
  authorInfo: FreelancerRegisteredQuery_freelancersList_feedbacks_authorInfo | null;
  authorUid: GraphQlLong;
  createdTime: GraphQlLocalDateTime;
  feedbackId: string;
  feedbackText: string;
  freelancerId: GraphQlLong;
  overallMark: GraphQlLong;
  willRecommend: boolean | null;
  moderationStatus: GdFreelancerUgcModerationStatus;
}

export interface FreelancerRegisteredQuery_freelancersList {
  __typename: "GdFreelancerBase";
  /**
   * Приватные данные фрилансера. null, если у оператора нет прав на просмотр
   */
  privateData: FreelancerRegisteredQuery_freelancersList_privateData | null;
  fio: string;
  login: string;
  card: FreelancerRegisteredQuery_freelancersList_card | null;
  feedbacks: FreelancerRegisteredQuery_freelancersList_feedbacks[] | null;
}

export interface FreelancerRegisteredQuery_constants {
  __typename: "GdDirectConstants";
  /**
   * Количество частных специалистов по настройке Директа
   */
  freelancersCount: number | null;
}

export interface FreelancerRegisteredQuery_client_info_chiefUser {
  __typename: "GdUserInfo";
  name: string;
  avatarUrl: string;
  phone: string | null;
}

export interface FreelancerRegisteredQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  chiefUser: FreelancerRegisteredQuery_client_info_chiefUser;
}

export interface FreelancerRegisteredQuery_client_freelancerProjects_freelancer {
  __typename: "GdFreelancerBase" | "GdFreelancerFull";
  login: string;
}

export interface FreelancerRegisteredQuery_client_freelancerProjects {
  __typename: "GdClientProject";
  id: GraphQlLong;
  freelancerId: GraphQlLong;
  createdTime: GraphQlLocalDateTime;
  startedTime: GraphQlLocalDateTime | null;
  status: GdFreelancerProjectStatus;
  freelancer: FreelancerRegisteredQuery_client_freelancerProjects_freelancer | null;
}

export interface FreelancerRegisteredQuery_client_hasCooperation {
  __typename: "GdClientProject";
  id: GraphQlLong;
}

export interface FreelancerRegisteredQuery_client_access {
  __typename: "GdClientAccess";
  canRequestFlService: boolean;
}

export interface FreelancerRegisteredQuery_client {
  __typename: "GdClient";
  info: FreelancerRegisteredQuery_client_info;
  freelancerProjects: FreelancerRegisteredQuery_client_freelancerProjects[];
  hasCooperation: FreelancerRegisteredQuery_client_hasCooperation[];
  access: FreelancerRegisteredQuery_client_access;
}

export interface FreelancerRegisteredQuery {
  freelancersList: (FreelancerRegisteredQuery_freelancersList | null)[];
  /**
   * Получить reqId запроса
   */
  reqId: string;
  constants: FreelancerRegisteredQuery_constants;
  client: FreelancerRegisteredQuery_client;
}

export interface FreelancerRegisteredQueryVariables {
  freelancerLogin: string;
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FreelancerCustomersQuery
// ====================================================

export interface FreelancerCustomersQuery_freelancersList_privateData_projects_client {
  __typename: "GdFreelancerClient";
  fio: string;
  clientId: GraphQlLong;
  chiefLogin: string;
  phoneNumber: string | null;
}

export interface FreelancerCustomersQuery_freelancersList_privateData_projects {
  __typename: "GdFreelancerProject";
  id: GraphQlLong;
  status: GdFreelancerProjectStatus;
  createdTime: GraphQlLocalDateTime;
  updatedTime: GraphQlLocalDateTime;
  startedTime: GraphQlLocalDateTime | null;
  client: FreelancerCustomersQuery_freelancersList_privateData_projects_client;
}

export interface FreelancerCustomersQuery_freelancersList_privateData {
  __typename: "GdFreelancerPrivateData";
  freelancerId: GraphQlLong;
  projects: FreelancerCustomersQuery_freelancersList_privateData_projects[];
}

export interface FreelancerCustomersQuery_freelancersList {
  __typename: "GdFreelancerBase";
  /**
   * Приватные данные фрилансера. null, если у оператора нет прав на просмотр
   */
  privateData: FreelancerCustomersQuery_freelancersList_privateData | null;
}

export interface FreelancerCustomersQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  freelancersList: (FreelancerCustomersQuery_freelancersList | null)[];
}

export interface FreelancerCustomersQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ClientFreelancerQuery
// ====================================================

export interface ClientFreelancerQuery_client_freelancerProjects_freelancer_card_contacts {
  __typename: "GdFreelancerContacts";
  phone: string;
}

export interface ClientFreelancerQuery_client_freelancerProjects_freelancer_card {
  __typename: "GdFreelancerCard";
  contacts: ClientFreelancerQuery_client_freelancerProjects_freelancer_card_contacts;
  avatarUrl: string;
}

export interface ClientFreelancerQuery_client_freelancerProjects_freelancer {
  __typename: "GdFreelancerBase" | "GdFreelancerFull";
  login: string;
  fio: string;
  card: ClientFreelancerQuery_client_freelancerProjects_freelancer_card | null;
}

export interface ClientFreelancerQuery_client_freelancerProjects {
  __typename: "GdClientProject";
  freelancer: ClientFreelancerQuery_client_freelancerProjects_freelancer | null;
  status: GdFreelancerProjectStatus;
}

export interface ClientFreelancerQuery_client_info_chiefUser {
  __typename: "GdUserInfo";
  phone: string | null;
  avatarUrl: string;
  name: string;
}

export interface ClientFreelancerQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  chiefUser: ClientFreelancerQuery_client_info_chiefUser;
}

export interface ClientFreelancerQuery_client {
  __typename: "GdClient";
  chiefLogin: string;
  freelancerProjects: ClientFreelancerQuery_client_freelancerProjects[];
  info: ClientFreelancerQuery_client_info;
}

export interface ClientFreelancerQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: ClientFreelancerQuery_client;
}

export interface ClientFreelancerQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FreelancerEditorQuery
// ====================================================

export interface FreelancerEditorQuery_constants_freelancerSkillTypes {
  __typename: "GdFreelancerSkillType";
  name: string;
  skillCode: string;
  skillId: GraphQlLong;
}

export interface FreelancerEditorQuery_constants {
  __typename: "GdDirectConstants";
  freelancerSkillTypes: FreelancerEditorQuery_constants_freelancerSkillTypes[];
}

export interface FreelancerEditorQuery_freelancersList_certificates {
  __typename: "GdFreelancerCertificate";
  certId: GraphQlLong;
  type: GdFreelancerCertificateType;
  link: string;
}

export interface FreelancerEditorQuery_freelancersList_skills {
  __typename: "GdFreelancerSkill";
  name: string;
  skillId: GraphQlLong;
  days: string;
  price: GraphQlBigDecimal;
  duration: GdFreelancerSkillOfferDuration;
}

export interface FreelancerEditorQuery_freelancersList_privateData_newestCard_contacts {
  __typename: "GdFreelancerContacts";
  siteUrl: string | null;
  whatsApp: string | null;
  phone: string;
  icq: string | null;
  telegram: string | null;
  email: string;
  viber: string | null;
  skype: string | null;
}

export interface FreelancerEditorQuery_freelancersList_privateData_newestCard {
  __typename: "GdFreelancerCard";
  briefInfo: string;
  avatarUrl: string;
  contacts: FreelancerEditorQuery_freelancersList_privateData_newestCard_contacts;
}

export interface FreelancerEditorQuery_freelancersList_privateData {
  __typename: "GdFreelancerPrivateData";
  freelancerId: GraphQlLong;
  /**
   * Последняя версия карточки вне зависимости от статуса
   */
  newestCard: FreelancerEditorQuery_freelancersList_privateData_newestCard | null;
}

export interface FreelancerEditorQuery_freelancersList_card_contacts {
  __typename: "GdFreelancerContacts";
  siteUrl: string | null;
  whatsApp: string | null;
  phone: string;
  icq: string | null;
  telegram: string | null;
  email: string;
  viber: string | null;
  skype: string | null;
}

export interface FreelancerEditorQuery_freelancersList_card {
  __typename: "GdFreelancerCard";
  briefInfo: string;
  avatarUrl: string;
  contacts: FreelancerEditorQuery_freelancersList_card_contacts;
}

export interface FreelancerEditorQuery_freelancersList_region_translation {
  __typename: "GdFreelancerRegionTranslation";
  region: string;
  country: string;
}

export interface FreelancerEditorQuery_freelancersList_region {
  __typename: "GdFreelancerRegion";
  regionId: GraphQlLong;
  translation: FreelancerEditorQuery_freelancersList_region_translation;
}

export interface FreelancerEditorQuery_freelancersList {
  __typename: "GdFreelancerBase";
  fio: string;
  login: string;
  createTime: GraphQlLocalDateTime;
  certificates: FreelancerEditorQuery_freelancersList_certificates[];
  skills: FreelancerEditorQuery_freelancersList_skills[];
  /**
   * Приватные данные фрилансера. null, если у оператора нет прав на просмотр
   */
  privateData: FreelancerEditorQuery_freelancersList_privateData | null;
  card: FreelancerEditorQuery_freelancersList_card | null;
  /**
   * Данные о стране и названии региона фрилансера.
   */
  region: FreelancerEditorQuery_freelancersList_region | null;
}

export interface FreelancerEditorQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  constants: FreelancerEditorQuery_constants;
  freelancersList: (FreelancerEditorQuery_freelancersList | null)[];
}

export interface FreelancerEditorQueryVariables {
  freelancerLogin: string;
  lang: GdLanguageInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: minusPhraseLibraryQuery
// ====================================================

export interface minusPhraseLibraryQuery_getLibraryMinusKeywordsPacks_rowset {
  __typename: "GdGetMinusKeywordsPacksItem";
  id: GraphQlLong;
  linkedAdGroupsCount: GraphQlLong;
  minusKeywords: string[];
  name: string;
}

export interface minusPhraseLibraryQuery_getLibraryMinusKeywordsPacks {
  __typename: "GdGetMinusKeywordsPacksPayload";
  cacheKey: string;
  rowset: minusPhraseLibraryQuery_getLibraryMinusKeywordsPacks_rowset[];
  totalCount: number;
}

export interface minusPhraseLibraryQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * Получение библиотечных наборов минус-фраз
   */
  getLibraryMinusKeywordsPacks: minusPhraseLibraryQuery_getLibraryMinusKeywordsPacks;
}

export interface minusPhraseLibraryQueryVariables {
  input: GdGetMinusKeywordsPacksInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: minusPhraseLibraryGridQuery
// ====================================================

export interface minusPhraseLibraryGridQuery_getLibraryMinusKeywordsPacks_rowset {
  __typename: "GdGetMinusKeywordsPacksItem";
  id: GraphQlLong;
  linkedAdGroupsCount: GraphQlLong;
  minusKeywords: string[];
  name: string;
}

export interface minusPhraseLibraryGridQuery_getLibraryMinusKeywordsPacks {
  __typename: "GdGetMinusKeywordsPacksPayload";
  cacheKey: string;
  rowset: minusPhraseLibraryGridQuery_getLibraryMinusKeywordsPacks_rowset[];
  totalCount: number;
}

export interface minusPhraseLibraryGridQuery_client_campaigns_rowset {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
}

export interface minusPhraseLibraryGridQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: minusPhraseLibraryGridQuery_client_campaigns_rowset[];
}

export interface minusPhraseLibraryGridQuery_client {
  __typename: "GdClient";
  campaigns: minusPhraseLibraryGridQuery_client_campaigns;
}

export interface minusPhraseLibraryGridQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * Получение библиотечных наборов минус-фраз
   */
  getLibraryMinusKeywordsPacks: minusPhraseLibraryGridQuery_getLibraryMinusKeywordsPacks;
  client: minusPhraseLibraryGridQuery_client;
}

export interface minusPhraseLibraryGridQueryVariables {
  minusPhraseInput: GdGetMinusKeywordsPacksInput;
  login: string;
  campaignInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ClientMobileAppsQuery
// ====================================================

export interface ClientMobileAppsQuery_client_access {
  __typename: "GdClientAccess";
  canViewMobileApps: boolean;
  canEditMobileApps: boolean;
  canEditMobileAppDomain: boolean;
  canViewMobileAppDomain: boolean;
}

export interface ClientMobileAppsQuery_client {
  __typename: "GdClient";
  access: ClientMobileAppsQuery_client_access;
}

export interface ClientMobileAppsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: ClientMobileAppsQuery_client;
}

export interface ClientMobileAppsQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: OrganizationsQuery
// ====================================================

export interface OrganizationsQuery_organizations_address {
  __typename: "GdAddress";
  geoId: number;
  apartment: string | null;
  city: string;
  country: string;
  street: string | null;
  metroStationName: string | null;
  metroStationId: number | null;
  houseWithBuilding: string | null;
}

export interface OrganizationsQuery_organizations_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface OrganizationsQuery_organizations_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface OrganizationsQuery_organizations_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface OrganizationsQuery_organizations_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  endTime: OrganizationsQuery_organizations_workTimes_endTime;
  startTime: OrganizationsQuery_organizations_workTimes_startTime;
}

export interface OrganizationsQuery_organizations {
  __typename: "GdOrganization";
  permalinkId: GraphQlLong;
  address: OrganizationsQuery_organizations_address | null;
  cabinetUrl: string;
  profileUrl: string;
  chainId: GraphQlLong | null;
  companyName: string;
  email: string | null;
  phone: OrganizationsQuery_organizations_phone | null;
  rubric: string | null;
  statusPublish: GdOrganizationStatusPublish;
  urls: string[];
  workTimes: OrganizationsQuery_organizations_workTimes[];
}

export interface OrganizationsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  organizations: (OrganizationsQuery_organizations | null)[];
}

export interface OrganizationsQueryVariables {
  input: GdOrganizationsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RefinePhraseQuery
// ====================================================

export interface RefinePhraseQuery_refineKeyword_words {
  __typename: "RefinedWord";
  phrases: (string | null)[] | null;
  count: GraphQlLong;
  word: string | null;
}

export interface RefinePhraseQuery_refineKeyword {
  __typename: "GdRefineKeywordPayload";
  hasMore: boolean;
  words: (RefinePhraseQuery_refineKeyword_words | null)[] | null;
}

export interface RefinePhraseQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  refineKeyword: RefinePhraseQuery_refineKeyword;
}

export interface RefinePhraseQueryVariables {
  input: GdRefineKeywordInput;
  withExamples: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PlacementsQuery
// ====================================================

export interface PlacementsQuery_placements_regionDictionary {
  __typename: "GdRegionDesc";
  id: GraphQlLong;
  nameEn: string | null;
  nameRu: string | null;
  nameTr: string | null;
  nameUa: string | null;
}

export interface PlacementsQuery_placements_facilityDictionary {
  __typename: "GdStringDictEntryWithLongKey";
  key: GraphQlLong;
  value: string;
}

export interface PlacementsQuery_placements_zoneDictionary {
  __typename: "GdStringDictEntryWithLongKey";
  key: GraphQlLong;
  value: string;
}

export interface PlacementsQuery_placements_placements {
  __typename: "GdPlacement";
  operatorName: string | null;
  caption: string;
  domain: string;
  id: GraphQlLong;
  isDeleted: boolean;
  isTesting: boolean;
  isYandexPage: boolean;
  login: string;
  type: PlacementType;
}

export interface PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_sizes {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_photos_formats {
  __typename: "GdPlacementFormat";
  height: number;
  path: string;
  width: number;
}

export interface PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_photos {
  __typename: "GdPlacementPhoto";
  formats: PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_photos_formats[];
}

export interface PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_resolution {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock {
  __typename: "GdOutdoorPlacementBlock";
  blockCaption: string | null;
  blockId: GraphQlLong;
  isDeleted: boolean;
  lastChange: GraphQlLocalDateTime;
  pageId: GraphQlLong;
  sizes: PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_sizes[];
  address: string;
  coordinates: string;
  duration: number;
  direction: number;
  facilityType: number;
  geoId: GraphQlLong | null;
  height: number;
  hidden: boolean | null;
  photos: PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_photos[] | null;
  resolution: PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock_resolution;
  width: number;
}

export interface PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_sizes {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_photos_formats {
  __typename: "GdPlacementFormat";
  height: number;
  path: string;
  width: number;
}

export interface PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_photos {
  __typename: "GdPlacementPhoto";
  formats: PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_photos_formats[];
}

export interface PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_resolution {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock {
  __typename: "GdIndoorPlacementBlock";
  blockCaption: string | null;
  blockId: GraphQlLong;
  isDeleted: boolean;
  lastChange: GraphQlLocalDateTime;
  pageId: GraphQlLong;
  sizes: PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_sizes[];
  geoId: GraphQlLong | null;
  address: string;
  coordinates: string;
  facilityType: number;
  zoneCategory: number;
  aspectRatio: number[];
  hidden: boolean | null;
  photos: PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_photos[] | null;
  resolution: PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock_resolution;
}

export type PlacementsQuery_placements_placementBlocks = PlacementsQuery_placements_placementBlocks_GdOutdoorPlacementBlock | PlacementsQuery_placements_placementBlocks_GdIndoorPlacementBlock;

export interface PlacementsQuery_placements {
  __typename: "GdPlacementContext";
  regionDictionary: PlacementsQuery_placements_regionDictionary[];
  facilityDictionary: PlacementsQuery_placements_facilityDictionary[];
  zoneDictionary: PlacementsQuery_placements_zoneDictionary[];
  placements: PlacementsQuery_placements_placements[];
  placementBlocks: PlacementsQuery_placements_placementBlocks[];
}

export interface PlacementsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  placements: PlacementsQuery_placements;
}

export interface PlacementsQueryVariables {
  input: GdPlacementFilterInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PricePackagesQuery
// ====================================================

export interface PricePackagesQuery_getPricePackages_rowset_targetingsFixed {
  __typename: "GdTargetingsFixed";
  viewTypes: GdViewType[];
  geo: GraphQlLong[] | null;
  geoType: number | null;
}

export interface PricePackagesQuery_getPricePackages_rowset_targetingsCustom {
  __typename: "GdTargetingsCustom";
  behaviors: GraphQlLong[];
  geo: GraphQlLong[] | null;
  geoType: number | null;
}

export interface PricePackagesQuery_getPricePackages_rowset {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  price: GraphQlBigDecimal;
  currency: CurrencyCode;
  orderVolumeMin: GraphQlLong;
  orderVolumeMax: GraphQlLong;
  targetingsFixed: PricePackagesQuery_getPricePackages_rowset_targetingsFixed | null;
  targetingsCustom: PricePackagesQuery_getPricePackages_rowset_targetingsCustom | null;
  statusApprove: GdStatusApprove;
  dateStart: GraphQlLocalDate;
  dateEnd: GraphQlLocalDate;
  clientIds: (GraphQlLong | null)[];
  lastUpdateTime: GraphQlLocalDateTime;
}

export interface PricePackagesQuery_getPricePackages {
  __typename: "GdGetPricePackagesPayload";
  totalCount: number;
  rowset: PricePackagesQuery_getPricePackages_rowset[];
}

export interface PricePackagesQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * Получение прайсовых пакетов
   */
  getPricePackages: PricePackagesQuery_getPricePackages | null;
}

export interface PricePackagesQueryVariables {
  input: GdGetPricePackagesInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PricePackagesSuggestQuery
// ====================================================

export interface PricePackagesSuggestQuery_getPricePackages_rowset {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
}

export interface PricePackagesSuggestQuery_getPricePackages {
  __typename: "GdGetPricePackagesPayload";
  rowset: PricePackagesSuggestQuery_getPricePackages_rowset[];
}

export interface PricePackagesSuggestQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * Получение прайсовых пакетов
   */
  getPricePackages: PricePackagesSuggestQuery_getPricePackages | null;
}

export interface PricePackagesSuggestQueryVariables {
  input: GdGetPricePackagesInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PricePackagesQueryForEdit
// ====================================================

export interface PricePackagesQueryForEdit_getPricePackages_rowset_targetingsFixed {
  __typename: "GdTargetingsFixed";
  viewTypes: GdViewType[];
  geo: GraphQlLong[] | null;
  geoType: number | null;
}

export interface PricePackagesQueryForEdit_getPricePackages_rowset_targetingsCustom {
  __typename: "GdTargetingsCustom";
  behaviors: GraphQlLong[];
  geo: GraphQlLong[] | null;
  geoType: number | null;
}

export interface PricePackagesQueryForEdit_getPricePackages_rowset {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  price: GraphQlBigDecimal;
  currency: CurrencyCode;
  trackerUrl: string;
  orderVolumeMin: GraphQlLong;
  orderVolumeMax: GraphQlLong;
  targetingsFixed: PricePackagesQueryForEdit_getPricePackages_rowset_targetingsFixed | null;
  targetingsCustom: PricePackagesQueryForEdit_getPricePackages_rowset_targetingsCustom | null;
  statusApprove: GdStatusApprove;
  lastUpdateTime: GraphQlLocalDateTime;
  dateStart: GraphQlLocalDate;
  dateEnd: GraphQlLocalDate;
  clientIds: (GraphQlLong | null)[];
}

export interface PricePackagesQueryForEdit_getPricePackages {
  __typename: "GdGetPricePackagesPayload";
  totalCount: number;
  rowset: PricePackagesQueryForEdit_getPricePackages_rowset[];
}

export interface PricePackagesQueryForEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * Получение прайсовых пакетов
   */
  getPricePackages: PricePackagesQueryForEdit_getPricePackages | null;
}

export interface PricePackagesQueryForEditVariables {
  input: GdGetPricePackagesInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PricePackagesAvailableForClient
// ====================================================

export interface PricePackagesAvailableForClient_getPricePackagesAvailableForClient_rowset_targetingsFixed {
  __typename: "GdTargetingsFixed";
  viewTypes: GdViewType[];
}

export interface PricePackagesAvailableForClient_getPricePackagesAvailableForClient_rowset_targetingsCustom {
  __typename: "GdTargetingsCustom";
  behaviors: GraphQlLong[];
}

export interface PricePackagesAvailableForClient_getPricePackagesAvailableForClient_rowset {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  price: GraphQlBigDecimal;
  currency: CurrencyCode;
  orderVolumeMin: GraphQlLong;
  orderVolumeMax: GraphQlLong;
  targetingsFixed: PricePackagesAvailableForClient_getPricePackagesAvailableForClient_rowset_targetingsFixed | null;
  targetingsCustom: PricePackagesAvailableForClient_getPricePackagesAvailableForClient_rowset_targetingsCustom | null;
  dateStart: GraphQlLocalDate;
  dateEnd: GraphQlLocalDate;
}

export interface PricePackagesAvailableForClient_getPricePackagesAvailableForClient {
  __typename: "GdGetPricePackagesAvailableForClientPayload";
  rowset: PricePackagesAvailableForClient_getPricePackagesAvailableForClient_rowset[];
}

export interface PricePackagesAvailableForClient {
  /**
   * Получение прайсовых пакетов доступных текущему клиенту для создания кампании
   */
  getPricePackagesAvailableForClient: PricePackagesAvailableForClient_getPricePackagesAvailableForClient | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PricePackagesForGroupQuery
// ====================================================

export interface PricePackagesForGroupQuery_getPricePackages_rowset_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface PricePackagesForGroupQuery_getPricePackages_rowset_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface PricePackagesForGroupQuery_getPricePackages_rowset {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: PricePackagesForGroupQuery_getPricePackages_rowset_targetingsFixed | null;
  targetingsCustom: PricePackagesForGroupQuery_getPricePackages_rowset_targetingsCustom | null;
  lastUpdateTime: GraphQlLocalDateTime;
}

export interface PricePackagesForGroupQuery_getPricePackages {
  __typename: "GdGetPricePackagesPayload";
  rowset: PricePackagesForGroupQuery_getPricePackages_rowset[];
}

export interface PricePackagesForGroupQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * Получение прайсовых пакетов
   */
  getPricePackages: PricePackagesForGroupQuery_getPricePackages | null;
}

export interface PricePackagesForGroupQueryVariables {
  input: GdGetPricePackagesInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RecommendationsPageQuery
// ====================================================

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi {
  __typename: "GdRecommendationSummaryWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  campaignIds: GraphQlLong[];
  keys: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi_keys[];
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export type RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi = RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget;

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_items_rowset {
  __typename: "GdRecommendationItem";
  clicks: GraphQlLong;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  name: string;
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_items {
  __typename: "GdRecommendationItems";
  rowset: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_items_rowset[];
}

export interface RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi {
  __typename: "GdRecommendationSummaryWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  campaignIds: GraphQlLong[];
  keys: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_keys[];
  kpi: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi;
  items: RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_items;
}

export type RecommendationsPageQuery_client_recommendationsSummary_rowset = RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi | RecommendationsPageQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi;

export interface RecommendationsPageQuery_client_recommendationsSummary {
  __typename: "GdRecommendationSummaryContext";
  rowset: RecommendationsPageQuery_client_recommendationsSummary_rowset[];
}

export interface RecommendationsPageQuery_client {
  __typename: "GdClient";
  recommendationsSummary: RecommendationsPageQuery_client_recommendationsSummary;
}

export interface RecommendationsPageQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RecommendationsPageQuery_client;
}

export interface RecommendationsPageQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: DailyBudgetRecommendationsGridQuery
// ====================================================

export interface DailyBudgetRecommendationsGridQuery_client_features {
  __typename: "GdClientFeatures";
  enabledRecommendationTypes: GdiRecommendationType[];
}

export interface DailyBudgetRecommendationsGridQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_stats {
  __typename: "GdEntityStats";
  clicks: GraphQlLong | null;
  cost: GraphQlBigDecimal | null;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives" | "GdRecommendationKpiWeeklyBudget";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  recommendedDailyBudget: GraphQlBigDecimal;
  currentDailyBudget: GraphQlBigDecimal;
}

export type DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi = DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget;

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  kpi: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi;
  keys: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_keys[];
}

export type DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations = DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi | DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi;

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_strategy_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  budget: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_strategy_budget | null;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns_rowset {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  stats: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_stats;
  recommendations: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_recommendations[] | null;
  strategy: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset_strategy;
  type: GdCampaignType;
  name: string;
  id: GraphQlLong;
  currency: CurrencyCode | null;
}

export interface DailyBudgetRecommendationsGridQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: DailyBudgetRecommendationsGridQuery_client_campaigns_rowset[];
  totalCount: number;
  campaignIds: GraphQlLong[];
}

export interface DailyBudgetRecommendationsGridQuery_client {
  __typename: "GdClient";
  features: DailyBudgetRecommendationsGridQuery_client_features;
  info: DailyBudgetRecommendationsGridQuery_client_info;
  campaigns: DailyBudgetRecommendationsGridQuery_client_campaigns;
}

export interface DailyBudgetRecommendationsGridQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: DailyBudgetRecommendationsGridQuery_client;
}

export interface DailyBudgetRecommendationsGridQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RemovePagesFromBlackListRecommendationGridQuery
// ====================================================

export interface RemovePagesFromBlackListRecommendationGridQuery_client_features {
  __typename: "GdClientFeatures";
  enabledRecommendationTypes: GdiRecommendationType[];
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiDailyBudget" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives" | "GdRecommendationKpiWeeklyBudget";
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackList {
  __typename: "GdRecommendationKpiRemovePagesFromBlackList";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  pageName: string;
}

export type RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_kpi = RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackList;

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi_kpi;
}

export type RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations = RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithoutKpi | RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations_GdRecommendationWithKpi;

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset {
  __typename: "GdPage";
  name: string;
  recommendations: RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset_recommendations[];
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages {
  __typename: "GdPageContext";
  totalCount: number;
  rowset: RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages_rowset[];
}

export interface RemovePagesFromBlackListRecommendationGridQuery_client {
  __typename: "GdClient";
  features: RemovePagesFromBlackListRecommendationGridQuery_client_features;
  info: RemovePagesFromBlackListRecommendationGridQuery_client_info;
  forbiddenPages: RemovePagesFromBlackListRecommendationGridQuery_client_forbiddenPages;
}

export interface RemovePagesFromBlackListRecommendationGridQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RemovePagesFromBlackListRecommendationGridQuery_client;
}

export interface RemovePagesFromBlackListRecommendationGridQueryVariables {
  login: string;
  offset?: number | null;
  orderBy?: GdPageOrderByInput[] | null;
  count?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SwitchOnAutotargetingRecommendationsGridQuery
// ====================================================

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_features {
  __typename: "GdClientFeatures";
  enabledRecommendationTypes: GdiRecommendationType[];
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_stats {
  __typename: "GdEntityStats";
  clicks: GraphQlLong | null;
  cost: GraphQlBigDecimal | null;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiDailyBudget" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives" | "GdRecommendationKpiWeeklyBudget";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  kpi: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_kpi;
  keys: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi_keys[];
}

export type SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations = SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithoutKpi | SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations_GdRecommendationWithKpi;

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_campaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  stats: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_stats;
  recommendations: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_recommendations[] | null;
  name: string;
  id: GraphQlLong;
  campaign: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset_campaign;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups_rowset[];
  totalCount: number;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery_client {
  __typename: "GdClient";
  features: SwitchOnAutotargetingRecommendationsGridQuery_client_features;
  info: SwitchOnAutotargetingRecommendationsGridQuery_client_info;
  adGroups: SwitchOnAutotargetingRecommendationsGridQuery_client_adGroups;
}

export interface SwitchOnAutotargetingRecommendationsGridQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: SwitchOnAutotargetingRecommendationsGridQuery_client;
}

export interface SwitchOnAutotargetingRecommendationsGridQueryVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RecommendationsGridSummaryQuery
// ====================================================

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi {
  __typename: "GdRecommendationSummaryWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  keys: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi_keys[];
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export type RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi = RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget;

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi {
  __typename: "GdRecommendationSummaryWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  keys: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_keys[];
  kpi: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi_kpi;
}

export type RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset = RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithoutKpi | RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset_GdRecommendationSummaryWithKpi;

export interface RecommendationsGridSummaryQuery_client_recommendationsSummary {
  __typename: "GdRecommendationSummaryContext";
  rowset: RecommendationsGridSummaryQuery_client_recommendationsSummary_rowset[];
}

export interface RecommendationsGridSummaryQuery_client {
  __typename: "GdClient";
  recommendationsSummary: RecommendationsGridSummaryQuery_client_recommendationsSummary;
}

export interface RecommendationsGridSummaryQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RecommendationsGridSummaryQuery_client;
}

export interface RecommendationsGridSummaryQueryVariables {
  login: string;
  types?: (GdiRecommendationTypeInput | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RecommendationsStatusesQuery
// ====================================================

export interface RecommendationsStatusesQuery_client_recommendationsStatuses {
  __typename: "GdiRecommendation";
  status: RecommendationStatus | null;
  cid: GraphQlLong | null;
}

export interface RecommendationsStatusesQuery_client {
  __typename: "GdClient";
  recommendationsStatuses: RecommendationsStatusesQuery_client_recommendationsStatuses[];
}

export interface RecommendationsStatusesQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RecommendationsStatusesQuery_client;
}

export interface RecommendationsStatusesQueryVariables {
  login: string;
  keys?: GdRecommendationKeyInput[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignsIdsQuery
// ====================================================

export interface CampaignsIdsQuery_client_campaigns_rowset {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
}

export interface CampaignsIdsQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: CampaignsIdsQuery_client_campaigns_rowset[];
}

export interface CampaignsIdsQuery_client {
  __typename: "GdClient";
  campaigns: CampaignsIdsQuery_client_campaigns;
}

export interface CampaignsIdsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignsIdsQuery_client;
}

export interface CampaignsIdsQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignRecommendationsQuery
// ====================================================

export interface CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives" | "GdRecommendationKpiWeeklyBudget";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
}

export interface CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  recommendedDailyBudget: GraphQlBigDecimal;
  currentDailyBudget: GraphQlBigDecimal;
}

export type CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi = CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget;

export interface CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  kpi: CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_kpi;
  keys: CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi_keys[];
}

export type CampaignRecommendationsQuery_client_campaigns_rowset_recommendations = CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithoutKpi | CampaignRecommendationsQuery_client_campaigns_rowset_recommendations_GdRecommendationWithKpi;

export interface CampaignRecommendationsQuery_client_campaigns_rowset {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  recommendations: CampaignRecommendationsQuery_client_campaigns_rowset_recommendations[] | null;
}

export interface CampaignRecommendationsQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: CampaignRecommendationsQuery_client_campaigns_rowset[];
}

export interface CampaignRecommendationsQuery_client {
  __typename: "GdClient";
  campaigns: CampaignRecommendationsQuery_client_campaigns;
}

export interface CampaignRecommendationsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignRecommendationsQuery_client;
}

export interface CampaignRecommendationsQueryVariables {
  login: string;
  campaignId: GraphQlLong;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: offlineReportList
// ====================================================

export interface offlineReportList_offlineReportList_list {
  __typename: "GdOfflineReport";
  reportId: GraphQlLong;
  uid: GraphQlLong;
  args: string;
  scheduledAt: GraphQlLocalDateTime;
  reportState: OfflineReportState;
  reportType: OfflineReportType;
  reportUrl: string | null;
}

export interface offlineReportList_offlineReportList {
  __typename: "GdOfflineReportResult";
  list: offlineReportList_offlineReportList_list[];
}

export interface offlineReportList {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * список оффлайн отчётов
   */
  offlineReportList: offlineReportList_offlineReportList;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: offlineReportCreate
// ====================================================

export interface offlineReportCreate_offlineReportCreate {
  __typename: "GdOfflineReport";
  reportId: GraphQlLong;
  uid: GraphQlLong;
  args: string;
  scheduledAt: GraphQlLocalDateTime;
  reportState: OfflineReportState;
  reportType: OfflineReportType;
}

export interface offlineReportCreate {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  /**
   * запросить создание нового оффлайн отчёта
   */
  offlineReportCreate: offlineReportCreate_offlineReportCreate;
}

export interface offlineReportCreateVariables {
  input: GdOfflineReportResultRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingConditionsQuery
// ====================================================

export interface RetargetingConditionsQuery_client_retargetingConditions_rowset {
  __typename: "GdRetargetingCondition";
  name: string;
  description: string | null;
  retargetingConditionId: GraphQlLong;
}

export interface RetargetingConditionsQuery_client_retargetingConditions {
  __typename: "GdRetargetingConditionContext";
  rowset: RetargetingConditionsQuery_client_retargetingConditions_rowset[];
}

export interface RetargetingConditionsQuery_client {
  __typename: "GdClient";
  retargetingConditions: RetargetingConditionsQuery_client_retargetingConditions;
}

export interface RetargetingConditionsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RetargetingConditionsQuery_client;
}

export interface RetargetingConditionsQueryVariables {
  login: string;
  input: GdRetargetingConditionsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingGoalsQuery
// ====================================================

export interface RetargetingGoalsQuery_client_goals_rowset {
  __typename: "GdGoal";
  id: GraphQlLong;
  domain: string | null;
  type: GdGoalType;
  name: string;
  counterId: number | null;
  subtype: GoalSubtype | null;
  uploadingSourceId: string | null;
}

export interface RetargetingGoalsQuery_client_goals {
  __typename: "GdGoalsContext";
  rowset: RetargetingGoalsQuery_client_goals_rowset[];
}

export interface RetargetingGoalsQuery_client {
  __typename: "GdClient";
  goals: RetargetingGoalsQuery_client_goals;
}

export interface RetargetingGoalsQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RetargetingGoalsQuery_client;
}

export interface RetargetingGoalsQueryVariables {
  login: string;
  input: GdGoalsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingConditionEstimationQuery
// ====================================================

export interface RetargetingConditionEstimationQuery_estimateRetargetingCondition_validationResult_errors {
  __typename: "GdDefect";
  code: string;
}

export interface RetargetingConditionEstimationQuery_estimateRetargetingCondition_validationResult {
  __typename: "GdValidationResult";
  errors: RetargetingConditionEstimationQuery_estimateRetargetingCondition_validationResult_errors[];
}

export interface RetargetingConditionEstimationQuery_estimateRetargetingCondition {
  __typename: "GdEstimateRetargetingCondition";
  estimation: GraphQlLong | null;
  validationResult: RetargetingConditionEstimationQuery_estimateRetargetingCondition_validationResult | null;
}

export interface RetargetingConditionEstimationQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  estimateRetargetingCondition: RetargetingConditionEstimationQuery_estimateRetargetingCondition;
}

export interface RetargetingConditionEstimationQueryVariables {
  input: GdEstimateRetargetingConditionContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingConditionsQueryForGroupEdit
// ====================================================

export interface RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_goalsInfo {
  __typename: "GdRetargetingConditionGoalsInfo";
  goalDomains: string[];
  hasGeoSegments: boolean;
  hasUnavailableGoals: boolean;
}

export interface RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_campaigns {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
}

export interface RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_conditionRules_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  time: number | null;
  type: GdGoalType;
}

export interface RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_conditionRules {
  __typename: "GdRetargetingConditionRuleItem";
  goals: RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_conditionRules_goals[];
  type: GdRetargetingConditionRuleType;
}

export interface RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset {
  __typename: "GdRetargetingCondition";
  name: string;
  description: string | null;
  retargetingConditionId: GraphQlLong;
  availableForRetargeting: boolean;
  goalsInfo: RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_goalsInfo;
  campaigns: RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_campaigns[];
  conditionRules: RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset_conditionRules[];
}

export interface RetargetingConditionsQueryForGroupEdit_client_retargetingConditions {
  __typename: "GdRetargetingConditionContext";
  rowset: RetargetingConditionsQueryForGroupEdit_client_retargetingConditions_rowset[];
}

export interface RetargetingConditionsQueryForGroupEdit_client {
  __typename: "GdClient";
  chiefLogin: string;
  retargetingConditions: RetargetingConditionsQueryForGroupEdit_client_retargetingConditions;
}

export interface RetargetingConditionsQueryForGroupEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RetargetingConditionsQueryForGroupEdit_client;
}

export interface RetargetingConditionsQueryForGroupEditVariables {
  login: string;
  retargetingConditionsInput: GdRetargetingConditionsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingConditionsQueryForCampaignsEdit
// ====================================================

export interface RetargetingConditionsQueryForCampaignsEdit_client_retargetingConditions_rowset {
  __typename: "GdRetargetingCondition";
  name: string;
  retargetingConditionId: GraphQlLong;
}

export interface RetargetingConditionsQueryForCampaignsEdit_client_retargetingConditions {
  __typename: "GdRetargetingConditionContext";
  rowset: RetargetingConditionsQueryForCampaignsEdit_client_retargetingConditions_rowset[];
}

export interface RetargetingConditionsQueryForCampaignsEdit_client {
  __typename: "GdClient";
  retargetingConditions: RetargetingConditionsQueryForCampaignsEdit_client_retargetingConditions;
}

export interface RetargetingConditionsQueryForCampaignsEdit {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RetargetingConditionsQueryForCampaignsEdit_client;
}

export interface RetargetingConditionsQueryForCampaignsEditVariables {
  login: string;
  retargetingConditionsInput: GdRetargetingConditionsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingConditionsQueryForUserProfile
// ====================================================

export interface RetargetingConditionsQueryForUserProfile_client_retargetingConditions_rowset_conditionRules_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  time: number | null;
  type: GdGoalType;
}

export interface RetargetingConditionsQueryForUserProfile_client_retargetingConditions_rowset_conditionRules {
  __typename: "GdRetargetingConditionRuleItem";
  interestType: CryptaInterestType | null;
  goals: RetargetingConditionsQueryForUserProfile_client_retargetingConditions_rowset_conditionRules_goals[];
  type: GdRetargetingConditionRuleType;
}

export interface RetargetingConditionsQueryForUserProfile_client_retargetingConditions_rowset {
  __typename: "GdRetargetingCondition";
  name: string;
  retargetingConditionId: GraphQlLong;
  adGroupIds: GraphQlLong[];
  conditionRules: RetargetingConditionsQueryForUserProfile_client_retargetingConditions_rowset_conditionRules[];
}

export interface RetargetingConditionsQueryForUserProfile_client_retargetingConditions {
  __typename: "GdRetargetingConditionContext";
  rowset: RetargetingConditionsQueryForUserProfile_client_retargetingConditions_rowset[];
}

export interface RetargetingConditionsQueryForUserProfile_client {
  __typename: "GdClient";
  chiefLogin: string;
  retargetingConditions: RetargetingConditionsQueryForUserProfile_client_retargetingConditions;
}

export interface RetargetingConditionsQueryForUserProfile {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RetargetingConditionsQueryForUserProfile_client;
}

export interface RetargetingConditionsQueryForUserProfileVariables {
  login: string;
  retargetingConditionsInput: GdRetargetingConditionsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignsSuggestQuery
// ====================================================

export interface CampaignsSuggestQuery_client_campaigns_rowset {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  name: string;
}

export interface CampaignsSuggestQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: CampaignsSuggestQuery_client_campaigns_rowset[];
}

export interface CampaignsSuggestQuery_client {
  __typename: "GdClient";
  campaigns: CampaignsSuggestQuery_client_campaigns;
}

export interface CampaignsSuggestQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignsSuggestQuery_client;
}

export interface CampaignsSuggestQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CampaignsSuggestListQuery
// ====================================================

export interface CampaignsSuggestListQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  isAutoBudget: boolean;
}

export interface CampaignsSuggestListQuery_client_campaigns_rowset_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  name: string;
  id: GraphQlLong;
  type: GdCampaignType;
  strategy: CampaignsSuggestListQuery_client_campaigns_rowset_GdContentPromotionCampaign_strategy;
}

export interface CampaignsSuggestListQuery_client_campaigns_rowset_GdInternalFreeCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  isAutoBudget: boolean;
}

export interface CampaignsSuggestListQuery_client_campaigns_rowset_GdInternalFreeCampaign {
  __typename: "GdInternalFreeCampaign";
  name: string;
  id: GraphQlLong;
  type: GdCampaignType;
  strategy: CampaignsSuggestListQuery_client_campaigns_rowset_GdInternalFreeCampaign_strategy;
  adsCount: number;
}

export interface CampaignsSuggestListQuery_client_campaigns_rowset_GdInternalDistribCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  isAutoBudget: boolean;
}

export interface CampaignsSuggestListQuery_client_campaigns_rowset_GdInternalDistribCampaign {
  __typename: "GdInternalDistribCampaign";
  name: string;
  id: GraphQlLong;
  type: GdCampaignType;
  strategy: CampaignsSuggestListQuery_client_campaigns_rowset_GdInternalDistribCampaign_strategy;
  adsCount: number;
}

export type CampaignsSuggestListQuery_client_campaigns_rowset = CampaignsSuggestListQuery_client_campaigns_rowset_GdContentPromotionCampaign | CampaignsSuggestListQuery_client_campaigns_rowset_GdInternalFreeCampaign | CampaignsSuggestListQuery_client_campaigns_rowset_GdInternalDistribCampaign;

export interface CampaignsSuggestListQuery_client_campaigns {
  __typename: "GdCampaignsContext";
  rowset: CampaignsSuggestListQuery_client_campaigns_rowset[];
}

export interface CampaignsSuggestListQuery_client {
  __typename: "GdClient";
  campaigns: CampaignsSuggestListQuery_client_campaigns;
}

export interface CampaignsSuggestListQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: CampaignsSuggestListQuery_client;
}

export interface CampaignsSuggestListQueryVariables {
  login: string;
  campaignInput: GdCampaignsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupsSuggestQuery
// ====================================================

export interface GroupsSuggestQuery_client_adGroups_rowset {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  name: string;
}

export interface GroupsSuggestQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: GroupsSuggestQuery_client_adGroups_rowset[];
}

export interface GroupsSuggestQuery_client {
  __typename: "GdClient";
  adGroups: GroupsSuggestQuery_client_adGroups;
}

export interface GroupsSuggestQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupsSuggestQuery_client;
}

export interface GroupsSuggestQueryVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupsSuggestListQuery
// ====================================================

export interface GroupsSuggestListQuery_client_adGroups_rowset_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface GroupsSuggestListQuery_client_adGroups_rowset_status {
  __typename: "GdAdGroupStatus";
  primaryStatus: GdAdGroupPrimaryStatus;
}

export interface GroupsSuggestListQuery_client_adGroups_rowset_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface GroupsSuggestListQuery_client_adGroups_rowset_campaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  type: GdCampaignType;
}

export interface GroupsSuggestListQuery_client_adGroups_rowset {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  id: GraphQlLong;
  adsCount: number;
  name: string;
  access: GroupsSuggestListQuery_client_adGroups_rowset_access;
  status: GroupsSuggestListQuery_client_adGroups_rowset_status;
  minusKeywords: string[];
  regionsInfo: GroupsSuggestListQuery_client_adGroups_rowset_regionsInfo;
  campaign: GroupsSuggestListQuery_client_adGroups_rowset_campaign;
  type: GdAdGroupType;
}

export interface GroupsSuggestListQuery_client_adGroups {
  __typename: "GdAdGroupsContext";
  rowset: GroupsSuggestListQuery_client_adGroups_rowset[];
}

export interface GroupsSuggestListQuery_client {
  __typename: "GdClient";
  adGroups: GroupsSuggestListQuery_client_adGroups;
}

export interface GroupsSuggestListQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: GroupsSuggestListQuery_client;
}

export interface GroupsSuggestListQueryVariables {
  login: string;
  adGroupInput: GdAdGroupsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BannersSuggestQuery
// ====================================================

export interface BannersSuggestQuery_client_ads_rowset {
  __typename: "GdContentPromotionAd" | "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  title: string | null;
}

export interface BannersSuggestQuery_client_ads {
  __typename: "GdAdsContext";
  rowset: BannersSuggestQuery_client_ads_rowset[];
  cacheKey: string;
}

export interface BannersSuggestQuery_client {
  __typename: "GdClient";
  ads: BannersSuggestQuery_client_ads;
}

export interface BannersSuggestQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: BannersSuggestQuery_client;
}

export interface BannersSuggestQueryVariables {
  login: string;
  adsInput: GdAdsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PhrasesSuggestQuery
// ====================================================

export interface PhrasesSuggestQuery_client_showConditions_rowset_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
}

export interface PhrasesSuggestQuery_client_showConditions_rowset_GdKeyword {
  __typename: "GdKeyword";
  keyword: string;
}

export type PhrasesSuggestQuery_client_showConditions_rowset = PhrasesSuggestQuery_client_showConditions_rowset_GdRelevanceMatch | PhrasesSuggestQuery_client_showConditions_rowset_GdKeyword;

export interface PhrasesSuggestQuery_client_showConditions {
  __typename: "GdShowConditionsContext";
  rowset: PhrasesSuggestQuery_client_showConditions_rowset[];
  cacheKey: string;
}

export interface PhrasesSuggestQuery_client {
  __typename: "GdClient";
  showConditions: PhrasesSuggestQuery_client_showConditions;
}

export interface PhrasesSuggestQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: PhrasesSuggestQuery_client;
}

export interface PhrasesSuggestQueryVariables {
  login: string;
  showConditionsInput: GdShowConditionsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RetargetingsSuggestQuery
// ====================================================

export interface RetargetingsSuggestQuery_client_retargetings_rowset_retargetingCondition {
  __typename: "GdRetargetingCondition";
  name: string;
}

export interface RetargetingsSuggestQuery_client_retargetings_rowset {
  __typename: "GdRetargeting";
  retargetingId: GraphQlLong;
  retargetingCondition: RetargetingsSuggestQuery_client_retargetings_rowset_retargetingCondition | null;
}

export interface RetargetingsSuggestQuery_client_retargetings {
  __typename: "GdRetargetingContext";
  rowset: RetargetingsSuggestQuery_client_retargetings_rowset[];
}

export interface RetargetingsSuggestQuery_client {
  __typename: "GdClient";
  retargetings: RetargetingsSuggestQuery_client_retargetings;
}

export interface RetargetingsSuggestQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: RetargetingsSuggestQuery_client;
}

export interface RetargetingsSuggestQueryVariables {
  login: string;
  retargetingsInput: GdRetargetingsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FeedFiltersSuggestQuery
// ====================================================

export interface FeedFiltersSuggestQuery_client_smartFilters_rowset {
  __typename: "GdSmartFilter";
  id: GraphQlLong;
  name: string;
}

export interface FeedFiltersSuggestQuery_client_smartFilters {
  __typename: "GdSmartFiltersContext";
  rowset: FeedFiltersSuggestQuery_client_smartFilters_rowset[];
}

export interface FeedFiltersSuggestQuery_client {
  __typename: "GdClient";
  smartFilters: FeedFiltersSuggestQuery_client_smartFilters;
}

export interface FeedFiltersSuggestQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: FeedFiltersSuggestQuery_client;
}

export interface FeedFiltersSuggestQueryVariables {
  login: string;
  smartFiltersInput: GdSmartFiltersContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: TurboRecomendationQuery
// ====================================================

export interface TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  bid: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  keys: TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  bid: GraphQlLong;
  type: GdiRecommendationType;
}

export interface TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiDailyBudget" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives" | "GdRecommendationKpiWeeklyBudget";
}

export interface TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite";
  pageLoadedTimingAvg: GraphQlBigDecimal;
}

export type TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_kpi = TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite;

export interface TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  keys: TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_keys[];
  kpi: TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi_kpi;
}

export type TurboRecomendationQuery_client_ads_rowset_recommendations = TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithoutKpi | TurboRecomendationQuery_client_ads_rowset_recommendations_GdRecommendationWithKpi;

export interface TurboRecomendationQuery_client_ads_rowset {
  __typename: "GdContentPromotionAd" | "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  recommendations: TurboRecomendationQuery_client_ads_rowset_recommendations[] | null;
}

export interface TurboRecomendationQuery_client_ads {
  __typename: "GdAdsContext";
  rowset: TurboRecomendationQuery_client_ads_rowset[];
}

export interface TurboRecomendationQuery_client {
  __typename: "GdClient";
  ads: TurboRecomendationQuery_client_ads;
}

export interface TurboRecomendationQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: TurboRecomendationQuery_client;
}

export interface TurboRecomendationQueryVariables {
  login: string;
  adsInput: GdAdsContainerInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UserSettingsDataQuery
// ====================================================

export interface UserSettingsDataQuery_client {
  __typename: "GdClient";
  measurerAccounts: (GdClientMeasurerSystem | null)[];
}

export interface UserSettingsDataQuery {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: UserSettingsDataQuery_client;
}

export interface UserSettingsDataQueryVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: addMeasurerAccount
// ====================================================

export interface addMeasurerAccount_addMeasurerAccount_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface addMeasurerAccount_addMeasurerAccount_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface addMeasurerAccount_addMeasurerAccount_validationResult {
  __typename: "GdValidationResult";
  errors: addMeasurerAccount_addMeasurerAccount_validationResult_errors[];
  warnings: addMeasurerAccount_addMeasurerAccount_validationResult_warnings[];
}

export interface addMeasurerAccount_addMeasurerAccount {
  __typename: "GdClientMeasurerAccountPayload";
  validationResult: addMeasurerAccount_addMeasurerAccount_validationResult | null;
}

export interface addMeasurerAccount {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  addMeasurerAccount: addMeasurerAccount_addMeasurerAccount;
}

export interface addMeasurerAccountVariables {
  input: GdAddClientMeasurerAccountInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteMeasurerAccount
// ====================================================

export interface deleteMeasurerAccount_deleteMeasurerAccount_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface deleteMeasurerAccount_deleteMeasurerAccount_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface deleteMeasurerAccount_deleteMeasurerAccount_validationResult {
  __typename: "GdValidationResult";
  errors: deleteMeasurerAccount_deleteMeasurerAccount_validationResult_errors[];
  warnings: deleteMeasurerAccount_deleteMeasurerAccount_validationResult_warnings[];
}

export interface deleteMeasurerAccount_deleteMeasurerAccount {
  __typename: "GdClientMeasurerAccountPayload";
  validationResult: deleteMeasurerAccount_deleteMeasurerAccount_validationResult | null;
}

export interface deleteMeasurerAccount {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  deleteMeasurerAccount: deleteMeasurerAccount_deleteMeasurerAccount;
}

export interface deleteMeasurerAccountVariables {
  measurerSystem: GdClientMeasurerSystemInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SwitchOffLimitPaymentData
// ====================================================

export interface SwitchOffLimitPaymentData_client_autoOverdraftPaymentOptions_paymentMethods {
  __typename: "GdPaymentMethodInfo";
  code: string;
  name: string;
  selected: boolean;
  limit: GraphQlBigDecimal | null;
}

export interface SwitchOffLimitPaymentData_client_autoOverdraftPaymentOptions_personInfo {
  __typename: "GdPersonInfo";
  id: GraphQlLong;
  name: string;
  selected: boolean;
}

export interface SwitchOffLimitPaymentData_client_autoOverdraftPaymentOptions {
  __typename: "GdPersonPaymentMethodInfo";
  paymentMethods: SwitchOffLimitPaymentData_client_autoOverdraftPaymentOptions_paymentMethods[];
  personInfo: SwitchOffLimitPaymentData_client_autoOverdraftPaymentOptions_personInfo;
}

export interface SwitchOffLimitPaymentData_client {
  __typename: "GdClient";
  autoOverdraftPaymentOptions: SwitchOffLimitPaymentData_client_autoOverdraftPaymentOptions[];
}

export interface SwitchOffLimitPaymentData {
  /**
   * Получить reqId запроса
   */
  reqId: string;
  client: SwitchOffLimitPaymentData_client;
}

export interface SwitchOffLimitPaymentDataVariables {
  login: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ValidationError
// ====================================================

export interface ValidationError {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ValidationWarning
// ====================================================

export interface ValidationWarning {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AddAds
// ====================================================

export interface AddAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface AddAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddAds_validationResult {
  __typename: "GdValidationResult";
  errors: AddAds_validationResult_errors[];
  warnings: AddAds_validationResult_warnings[];
}

export interface AddAds {
  __typename: "GdAddAdsPayload";
  addedAds: (AddAds_addedAds | null)[];
  validationResult: AddAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AddCpmAds
// ====================================================

export interface AddCpmAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface AddCpmAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddCpmAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddCpmAds_validationResult {
  __typename: "GdValidationResult";
  errors: AddCpmAds_validationResult_errors[];
  warnings: AddCpmAds_validationResult_warnings[];
}

export interface AddCpmAds {
  __typename: "GdAddAdsPayload";
  addedAds: (AddCpmAds_addedAds | null)[];
  validationResult: AddCpmAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UpdateCpmAds
// ====================================================

export interface UpdateCpmAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface UpdateCpmAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateCpmAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateCpmAds_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateCpmAds_validationResult_errors[];
  warnings: UpdateCpmAds_validationResult_warnings[];
}

export interface UpdateCpmAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (UpdateCpmAds_updatedAds | null)[];
  validationResult: UpdateCpmAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AddMcBannerAds
// ====================================================

export interface AddMcBannerAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface AddMcBannerAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddMcBannerAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddMcBannerAds_validationResult {
  __typename: "GdValidationResult";
  errors: AddMcBannerAds_validationResult_errors[];
  warnings: AddMcBannerAds_validationResult_warnings[];
}

export interface AddMcBannerAds {
  __typename: "GdAddAdsPayload";
  addedAds: (AddMcBannerAds_addedAds | null)[];
  validationResult: AddMcBannerAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UpdateMcBannerAds
// ====================================================

export interface UpdateMcBannerAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface UpdateMcBannerAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateMcBannerAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateMcBannerAds_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateMcBannerAds_validationResult_errors[];
  warnings: UpdateMcBannerAds_validationResult_warnings[];
}

export interface UpdateMcBannerAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (UpdateMcBannerAds_updatedAds | null)[];
  validationResult: UpdateMcBannerAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AddContentPromotionAds
// ====================================================

export interface AddContentPromotionAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface AddContentPromotionAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddContentPromotionAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddContentPromotionAds_validationResult {
  __typename: "GdValidationResult";
  errors: AddContentPromotionAds_validationResult_errors[];
  warnings: AddContentPromotionAds_validationResult_warnings[];
}

export interface AddContentPromotionAds {
  __typename: "GdAddAdsPayload";
  addedAds: (AddContentPromotionAds_addedAds | null)[];
  validationResult: AddContentPromotionAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UpdateContentPromotionAds
// ====================================================

export interface UpdateContentPromotionAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface UpdateContentPromotionAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateContentPromotionAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateContentPromotionAds_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateContentPromotionAds_validationResult_errors[];
  warnings: UpdateContentPromotionAds_validationResult_warnings[];
}

export interface UpdateContentPromotionAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (UpdateContentPromotionAds_updatedAds | null)[];
  validationResult: UpdateContentPromotionAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AddSmartAds
// ====================================================

export interface AddSmartAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface AddSmartAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddSmartAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddSmartAds_validationResult {
  __typename: "GdValidationResult";
  errors: AddSmartAds_validationResult_errors[];
  warnings: AddSmartAds_validationResult_warnings[];
}

export interface AddSmartAds {
  __typename: "GdAddAdsPayload";
  addedAds: (AddSmartAds_addedAds | null)[];
  validationResult: AddSmartAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UpdateSmartAds
// ====================================================

export interface UpdateSmartAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface UpdateSmartAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateSmartAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateSmartAds_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateSmartAds_validationResult_errors[];
  warnings: UpdateSmartAds_validationResult_warnings[];
}

export interface UpdateSmartAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (UpdateSmartAds_updatedAds | null)[];
  validationResult: UpdateSmartAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DeleteAdsWithValidation
// ====================================================

export interface DeleteAdsWithValidation_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface DeleteAdsWithValidation_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface DeleteAdsWithValidation_validationResult {
  __typename: "GdValidationResult";
  errors: DeleteAdsWithValidation_validationResult_errors[];
  warnings: DeleteAdsWithValidation_validationResult_warnings[];
}

export interface DeleteAdsWithValidation {
  __typename: "GdAdsMassActionPayload";
  validationResult: DeleteAdsWithValidation_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UpdateAds
// ====================================================

export interface UpdateAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface UpdateAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateAds_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateAds_validationResult_errors[];
  warnings: UpdateAds_validationResult_warnings[];
}

export interface UpdateAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (UpdateAds_updatedAds | null)[];
  validationResult: UpdateAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AddInternalAds
// ====================================================

export interface AddInternalAds_addedAds {
  __typename: "GdAddAdPayloadItem";
  id: GraphQlLong;
}

export interface AddInternalAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddInternalAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface AddInternalAds_validationResult {
  __typename: "GdValidationResult";
  errors: AddInternalAds_validationResult_errors[];
  warnings: AddInternalAds_validationResult_warnings[];
}

export interface AddInternalAds {
  __typename: "GdAddAdsPayload";
  addedAds: (AddInternalAds_addedAds | null)[];
  validationResult: AddInternalAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UpdateInternalAds
// ====================================================

export interface UpdateInternalAds_updatedAds {
  __typename: "GdUpdateAdPayloadItem";
  id: GraphQlLong;
}

export interface UpdateInternalAds_validationResult_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateInternalAds_validationResult_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface UpdateInternalAds_validationResult {
  __typename: "GdValidationResult";
  errors: UpdateInternalAds_validationResult_errors[];
  warnings: UpdateInternalAds_validationResult_warnings[];
}

export interface UpdateInternalAds {
  __typename: "GdUpdateAdsPayload";
  updatedAds: (UpdateInternalAds_updatedAds | null)[];
  validationResult: UpdateInternalAds_validationResult | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ValidationErrorFragment
// ====================================================

export interface ValidationErrorFragment {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ValidationWarningFragment
// ====================================================

export interface ValidationWarningFragment {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ValidationResultFragment
// ====================================================

export interface ValidationResultFragment_errors {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface ValidationResultFragment_warnings {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

export interface ValidationResultFragment {
  __typename: "GdValidationResult";
  errors: ValidationResultFragment_errors[];
  warnings: ValidationResultFragment_warnings[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: commonBidModifiersAdjustmentFragment
// ====================================================

export interface commonBidModifiersAdjustmentFragment_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface commonBidModifiersAdjustmentFragment_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface commonBidModifiersAdjustmentFragment_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface commonBidModifiersAdjustmentFragment_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface commonBidModifiersAdjustmentFragment_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface commonBidModifiersAdjustmentFragment_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface commonBidModifiersAdjustmentFragment_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface commonBidModifiersAdjustmentFragment_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: commonBidModifiersAdjustmentFragment_GdBidModifierWeatherAdjustment_expression[][];
}

export interface commonBidModifiersAdjustmentFragment_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface commonBidModifiersAdjustmentFragment_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: commonBidModifiersAdjustmentFragment_GdBidModifierExpressAdjustment_condition[][];
}

export type commonBidModifiersAdjustmentFragment = commonBidModifiersAdjustmentFragment_GdBidModifierABSegmentAdjustment | commonBidModifiersAdjustmentFragment_GdBidModifierRetargetingAdjustment | commonBidModifiersAdjustmentFragment_GdBidModifierDemographicsAdjustment | commonBidModifiersAdjustmentFragment_GdBidModifierMobileAdjustment | commonBidModifiersAdjustmentFragment_GdBidModifierInventoryAdjustment | commonBidModifiersAdjustmentFragment_GdBidModifierAdTypeAdjustment | commonBidModifiersAdjustmentFragment_GdBidModifierWeatherAdjustment | commonBidModifiersAdjustmentFragment_GdBidModifierExpressAdjustment;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignBidModifiersAdjustmentFragment
// ====================================================

export interface campaignBidModifiersAdjustmentFragment_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment" | "GdBidModifierDemographicsAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierExpressAdjustment" | "GdBidModifierInventoryAdjustment" | "GdBidModifierMobileAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierRetargetingAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment" | "GdBidModifierWeatherAdjustment";
}

export interface campaignBidModifiersAdjustmentFragment_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment";
  sectionId: GraphQlLong;
  segmentId: GraphQlLong;
}

export type campaignBidModifiersAdjustmentFragment = campaignBidModifiersAdjustmentFragment_GdBidModifierAdTypeAdjustment | campaignBidModifiersAdjustmentFragment_GdBidModifierABSegmentAdjustment;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: emailSettingsFragment
// ====================================================

export interface emailSettingsFragment {
  __typename: "GdCampaignEmailSettings";
  allowedEvents: GdCampaignEmailEvent[];
  checkPositionInterval: GdCampaignCheckPositionInterval | null;
  email: string;
  sendAccountNews: boolean | null;
  stopByReachDailyBudget: boolean | null;
  warningBalance: number | null;
  xlsReady: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: smsSettingsFragment
// ====================================================

export interface smsSettingsFragment_smsTime_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface smsSettingsFragment_smsTime_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface smsSettingsFragment_smsTime {
  __typename: "GdTimeInterval";
  endTime: smsSettingsFragment_smsTime_endTime;
  startTime: smsSettingsFragment_smsTime_startTime;
}

export interface smsSettingsFragment_events {
  __typename: "GdCampaignSmsEventInfo";
  checked: boolean;
  event: GdCampaignSmsEvent;
}

export interface smsSettingsFragment {
  __typename: "GdCampaignSmsSettings";
  smsTime: smsSettingsFragment_smsTime;
  events: smsSettingsFragment_events[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignsNotificationFragment
// ====================================================

export interface campaignsNotificationFragment_emailSettings {
  __typename: "GdCampaignEmailSettings";
  allowedEvents: GdCampaignEmailEvent[];
  checkPositionInterval: GdCampaignCheckPositionInterval | null;
  email: string;
  sendAccountNews: boolean | null;
  stopByReachDailyBudget: boolean | null;
  warningBalance: number | null;
  xlsReady: boolean | null;
}

export interface campaignsNotificationFragment_smsSettings_smsTime_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface campaignsNotificationFragment_smsSettings_smsTime_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface campaignsNotificationFragment_smsSettings_smsTime {
  __typename: "GdTimeInterval";
  endTime: campaignsNotificationFragment_smsSettings_smsTime_endTime;
  startTime: campaignsNotificationFragment_smsSettings_smsTime_startTime;
}

export interface campaignsNotificationFragment_smsSettings_events {
  __typename: "GdCampaignSmsEventInfo";
  checked: boolean;
  event: GdCampaignSmsEvent;
}

export interface campaignsNotificationFragment_smsSettings {
  __typename: "GdCampaignSmsSettings";
  smsTime: campaignsNotificationFragment_smsSettings_smsTime;
  events: campaignsNotificationFragment_smsSettings_events[];
}

export interface campaignsNotificationFragment {
  __typename: "GdCampaignNotification";
  emailSettings: campaignsNotificationFragment_emailSettings;
  smsSettings: campaignsNotificationFragment_smsSettings;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignsNotificationFragments
// ====================================================

export interface campaignsNotificationFragments_emailSettings {
  __typename: "GdCampaignEmailSettings";
  allowedEvents: GdCampaignEmailEvent[];
  checkPositionInterval: GdCampaignCheckPositionInterval | null;
  email: string;
  sendAccountNews: boolean | null;
  stopByReachDailyBudget: boolean | null;
  warningBalance: number | null;
  xlsReady: boolean | null;
}

export interface campaignsNotificationFragments_smsSettings_smsTime_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface campaignsNotificationFragments_smsSettings_smsTime_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface campaignsNotificationFragments_smsSettings_smsTime {
  __typename: "GdTimeInterval";
  endTime: campaignsNotificationFragments_smsSettings_smsTime_endTime;
  startTime: campaignsNotificationFragments_smsSettings_smsTime_startTime;
}

export interface campaignsNotificationFragments_smsSettings_events {
  __typename: "GdCampaignSmsEventInfo";
  checked: boolean;
  event: GdCampaignSmsEvent;
}

export interface campaignsNotificationFragments_smsSettings {
  __typename: "GdCampaignSmsSettings";
  smsTime: campaignsNotificationFragments_smsSettings_smsTime;
  events: campaignsNotificationFragments_smsSettings_events[];
}

export interface campaignsNotificationFragments {
  __typename: "GdDefaultCampaignNotification";
  campaignType: GdCampaignType;
  emailSettings: campaignsNotificationFragments_emailSettings;
  smsSettings: campaignsNotificationFragments_smsSettings;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignVerboseStrategyFragment
// ====================================================

export interface campaignVerboseStrategyFragment_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignVerboseStrategyFragment_GdCampaignStrategyAvgClick_budget | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignVerboseStrategyFragment_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface campaignVerboseStrategyFragment_GdStrategyOptimizeClicks_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignVerboseStrategyFragment_GdStrategyOptimizeClicks {
  __typename: "GdStrategyOptimizeClicks";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignVerboseStrategyFragment_GdStrategyOptimizeClicks_budget | null;
  avgBid: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
  clicksLimit: GraphQlLong | null;
}

export interface campaignVerboseStrategyFragment_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignVerboseStrategyFragment_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignVerboseStrategyFragment_GdStrategyOptimizeConversions_budget | null;
  goalId: GraphQlLong | null;
  avgCpa: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
  payForConversion: boolean | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyRoi_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignVerboseStrategyFragment_GdCampaignStrategyRoi {
  __typename: "GdCampaignStrategyRoi";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignVerboseStrategyFragment_GdCampaignStrategyRoi_budget | null;
  goalId: GraphQlLong | null;
  profitability: GraphQlBigDecimal | null;
  reserveReturn: GraphQlLong | null;
  roiCoef: GraphQlBigDecimal | null;
  bid: GraphQlBigDecimal | null;
}

export type campaignVerboseStrategyFragment = campaignVerboseStrategyFragment_GdCampaignStrategyAvgClick | campaignVerboseStrategyFragment_GdCampaignStrategyManual | campaignVerboseStrategyFragment_GdStrategyOptimizeClicks | campaignVerboseStrategyFragment_GdStrategyOptimizeConversions | campaignVerboseStrategyFragment_GdCampaignStrategyRoi;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignsStatusFragment
// ====================================================

export interface campaignsStatusFragment {
  __typename: "GdCampaignStatus";
  allowDomainMonitoring: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  hasRunningUnmoderatedAds: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TextCampaignFragment
// ====================================================

export interface TextCampaignFragment_meaningfulGoals {
  __typename: "GdMeaningfulGoal";
  goalId: GraphQlLong;
  conversionValue: GraphQlBigDecimal | null;
}

export interface TextCampaignFragment_abSegmentRetargetingCondition_retargetingCondition_conditionRules_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
}

export interface TextCampaignFragment_abSegmentRetargetingCondition_retargetingCondition_conditionRules {
  __typename: "GdRetargetingConditionRuleItem";
  sectionId: GraphQlLong | null;
  goals: TextCampaignFragment_abSegmentRetargetingCondition_retargetingCondition_conditionRules_goals[];
}

export interface TextCampaignFragment_abSegmentRetargetingCondition_retargetingCondition {
  __typename: "GdRetargetingCondition";
  retargetingConditionId: GraphQlLong;
  conditionRules: TextCampaignFragment_abSegmentRetargetingCondition_retargetingCondition_conditionRules[];
}

export interface TextCampaignFragment_abSegmentRetargetingCondition {
  __typename: "GdRetargetingConditionWithMetrikaFlag";
  isMetrikaAvailable: boolean;
  retargetingCondition: TextCampaignFragment_abSegmentRetargetingCondition_retargetingCondition | null;
}

export interface TextCampaignFragment_abSegmentStatisticRetargetingCondition_retargetingCondition_conditionRules_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
}

export interface TextCampaignFragment_abSegmentStatisticRetargetingCondition_retargetingCondition_conditionRules {
  __typename: "GdRetargetingConditionRuleItem";
  sectionId: GraphQlLong | null;
  goals: TextCampaignFragment_abSegmentStatisticRetargetingCondition_retargetingCondition_conditionRules_goals[];
}

export interface TextCampaignFragment_abSegmentStatisticRetargetingCondition_retargetingCondition {
  __typename: "GdRetargetingCondition";
  retargetingConditionId: GraphQlLong;
  conditionRules: TextCampaignFragment_abSegmentStatisticRetargetingCondition_retargetingCondition_conditionRules[];
}

export interface TextCampaignFragment_abSegmentStatisticRetargetingCondition {
  __typename: "GdRetargetingConditionWithMetrikaFlag";
  isMetrikaAvailable: boolean;
  retargetingCondition: TextCampaignFragment_abSegmentStatisticRetargetingCondition_retargetingCondition | null;
}

export interface TextCampaignFragment_broadMatch {
  __typename: "GdBroadMatch";
  broadMatchFlag: boolean;
  broadMatchGoalId: GraphQlLong | null;
  broadMatchLimit: number;
}

export interface TextCampaignFragment_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface TextCampaignFragment_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TextCampaignFragment_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface TextCampaignFragment_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: TextCampaignFragment_commonVcard_workTimes_startTime;
  endTime: TextCampaignFragment_commonVcard_workTimes_endTime;
}

export interface TextCampaignFragment_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface TextCampaignFragment_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface TextCampaignFragment_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: TextCampaignFragment_commonVcard_address_pointOnMap | null;
}

export interface TextCampaignFragment_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: TextCampaignFragment_commonVcard_instantMessenger | null;
  workTimes: TextCampaignFragment_commonVcard_workTimes[];
  phone: TextCampaignFragment_commonVcard_phone;
  address: TextCampaignFragment_commonVcard_address;
}

export interface TextCampaignFragment {
  __typename: "GdTextCampaign";
  contentLanguage: GdContentLanguage | null;
  disabledPlaces: string[] | null;
  meaningfulGoals: TextCampaignFragment_meaningfulGoals[] | null;
  metrikaCounters: number[] | null;
  hasTitleSubstitution: boolean;
  clientDialogId: GraphQlLong | null;
  hasExtendedGeoTargeting: boolean;
  abSegmentRetargetingCondition: TextCampaignFragment_abSegmentRetargetingCondition | null;
  abSegmentStatisticRetargetingCondition: TextCampaignFragment_abSegmentStatisticRetargetingCondition | null;
  allowedPageIds: GraphQlLong[] | null;
  attributionModel: GdCampaignAttributionModel;
  hasAddMetrikaTagToUrl: boolean;
  hasAddOpenstatTagToUrl: boolean;
  excludePausedCompetingAds: boolean;
  enableCompanyInfo: boolean;
  minusKeywords: string[] | null;
  broadMatch: TextCampaignFragment_broadMatch;
  commonVcard: TextCampaignFragment_commonVcard | null;
  isAloneTrafaretAllowed: boolean;
  defaultPermalinkId: GraphQlLong | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PriceCampaignFragment
// ====================================================

export interface PriceCampaignFragment_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  geoExpanded: GraphQlLong[] | null;
  geoType: number | null;
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
}

export interface PriceCampaignFragment {
  __typename: "GdPriceCampaign";
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: PriceCampaignFragment_flightTargetingsSnapshot | null;
  flightOrderVolume: GraphQlLong | null;
  flightStatusApprove: GdPriceFlightStatusApprove | null;
  flightStatusCorrect: GdPriceFlightStatusCorrect | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContentPromotionCampaignFragment
// ====================================================

export interface ContentPromotionCampaignFragment {
  __typename: "GdContentPromotionCampaign";
  contentLanguage: GdContentLanguage | null;
  metrikaCounters: number[] | null;
  hasExtendedGeoTargeting: boolean;
  attributionModel: GdCampaignAttributionModel;
  minusKeywords: string[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignConstantsFragment
// ====================================================

export interface campaignConstantsFragment_validation_campaignConstants {
  __typename: "GdDirectConstantsCampaignValidationData";
  maxDisabledPlacesCount: number;
  maxMetrikaCountersNumberForTextCampaign: number;
  maxDisabledIpsCount: number;
  minBroadMatchLimit: number;
  maxBroadMatchLimit: number;
  roiCoefMin: GraphQlBigDecimal;
  maxNameLength: number;
}

export interface campaignConstantsFragment_validation_minusKeywordsConstants {
  __typename: "GdDirectConstantsMinusWordsValidationData";
  normalizedMinusKeywordsMaxLength: number;
}

export interface campaignConstantsFragment_validation {
  __typename: "GdDirectConstantsValidationData";
  campaignConstants: campaignConstantsFragment_validation_campaignConstants;
  minusKeywordsConstants: campaignConstantsFragment_validation_minusKeywordsConstants;
}

export interface campaignConstantsFragment_defaultValues_campaign {
  __typename: "GdCampaignDefaultValues";
  defaultMeaningfulGoalId: GraphQlLong;
  defaultBroadMatchAllGoalsId: number;
  defaultContextLimit: number;
  defaultDayBudget: GraphQlBigDecimal;
  defaultHasEnableCpcHold: boolean;
  defaultIsAloneTrafaretAllowed: boolean;
}

export interface campaignConstantsFragment_defaultValues {
  __typename: "GdDefaultValues";
  campaign: campaignConstantsFragment_defaultValues_campaign;
}

export interface campaignConstantsFragment_strategyConstants {
  __typename: "GdStrategyConstants";
  byAllGoalsGoalId: GraphQlLong;
  meaningfulGoalsOptimizationGoalId: GraphQlLong;
  payForConversionSumToAvgCpaMinRatio: number;
}

export interface campaignConstantsFragment {
  __typename: "GdDirectConstants";
  validation: campaignConstantsFragment_validation;
  defaultValues: campaignConstantsFragment_defaultValues;
  strategyConstants: campaignConstantsFragment_strategyConstants;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: vcardConstantsFragment
// ====================================================

export interface vcardConstantsFragment {
  __typename: "GdDirectConstantsVcardValidationData";
  companyNameMaxLength: number;
  contactPersonMaxLength: number;
  contactEmailMaxLength: number;
  extraMessageMaxLength: number;
  countryMaxLength: number;
  cityMaxLength: number;
  streetMaxLength: number;
  houseWithBuildingMaxLength: number;
  apartmentMaxLength: number;
  instantMessengerLoginMaxLength: number;
  pointOnMapLongitudeMin: GraphQlBigDecimal;
  pointOnMapLongitudeMax: GraphQlBigDecimal;
  pointOnMapLatitudeMin: GraphQlBigDecimal;
  pointOnMapLatitudeMax: GraphQlBigDecimal;
  countryCodeMaxLength: number;
  cityCodeMaxLength: number;
  phoneNumberMinLength: number;
  phoneNumberMaxLength: number;
  extensionMaxLength: number;
  entirePhoneMinLength: number;
  entirePhoneMaxLength: number;
  entirePhoneWithExtensionMaxLength: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: VCardCampaignDataFragment
// ====================================================

export interface VCardCampaignDataFragment_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface VCardCampaignDataFragment_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface VCardCampaignDataFragment_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface VCardCampaignDataFragment_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: VCardCampaignDataFragment_workTimes_startTime;
  endTime: VCardCampaignDataFragment_workTimes_endTime;
}

export interface VCardCampaignDataFragment_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface VCardCampaignDataFragment_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface VCardCampaignDataFragment_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: VCardCampaignDataFragment_address_pointOnMap | null;
}

export interface VCardCampaignDataFragment {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: VCardCampaignDataFragment_instantMessenger | null;
  workTimes: VCardCampaignDataFragment_workTimes[];
  phone: VCardCampaignDataFragment_phone;
  address: VCardCampaignDataFragment_address;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ConstantsCurrencyQueryFragment
// ====================================================

export interface ConstantsCurrencyQueryFragment {
  __typename: "GdCurrencyDescription";
  code: CurrencyCode;
  minDailyBudget: GraphQlBigDecimal;
  maxDailyBudget: GraphQlBigDecimal;
  bigRate: GraphQlBigDecimal;
  minPrice: GraphQlBigDecimal;
  maxPrice: GraphQlBigDecimal;
  defaultPrice: GraphQlBigDecimal;
  minCpmPrice: GraphQlBigDecimal;
  maxCpmPrice: GraphQlBigDecimal;
  autobudgetAvgCpaWarning: GraphQlBigDecimal;
  autobudgetAvgPriceWarning: GraphQlBigDecimal;
  autobudgetClicksBundleWarning: number;
  autobudgetMaxPriceWarning: GraphQlBigDecimal;
  autobudgetSumWarning: GraphQlBigDecimal;
  maxAutobudget: GraphQlBigDecimal;
  maxAutobudgetBid: GraphQlBigDecimal;
  maxAutobudgetClicksBundle: GraphQlLong;
  minAutobudget: GraphQlBigDecimal;
  minAutobudgetBid: GraphQlBigDecimal;
  minAutobudgetClicksBundle: number;
  minAutobudgetAvgCpa: GraphQlBigDecimal;
  minAutobudgetAvgPrice: GraphQlBigDecimal;
  brandSurveyBudgetThreshold: GraphQlBigDecimal;
  autobudgetPayForConversionAvgCpaWarning: GraphQlBigDecimal;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ConstantsQueryFragment
// ====================================================

export interface ConstantsQueryFragment_strategyConstants {
  __typename: "GdStrategyConstants";
  maxDailyBudgetChangesPerDay: number;
}

export interface ConstantsQueryFragment_currencyConstants {
  __typename: "GdCurrencyDescription";
  code: CurrencyCode;
  minDailyBudget: GraphQlBigDecimal;
  maxDailyBudget: GraphQlBigDecimal;
  bigRate: GraphQlBigDecimal;
  minPrice: GraphQlBigDecimal;
  maxPrice: GraphQlBigDecimal;
  defaultPrice: GraphQlBigDecimal;
  minCpmPrice: GraphQlBigDecimal;
  maxCpmPrice: GraphQlBigDecimal;
  autobudgetAvgCpaWarning: GraphQlBigDecimal;
  autobudgetAvgPriceWarning: GraphQlBigDecimal;
  autobudgetClicksBundleWarning: number;
  autobudgetMaxPriceWarning: GraphQlBigDecimal;
  autobudgetSumWarning: GraphQlBigDecimal;
  maxAutobudget: GraphQlBigDecimal;
  maxAutobudgetBid: GraphQlBigDecimal;
  maxAutobudgetClicksBundle: GraphQlLong;
  minAutobudget: GraphQlBigDecimal;
  minAutobudgetBid: GraphQlBigDecimal;
  minAutobudgetClicksBundle: number;
  minAutobudgetAvgCpa: GraphQlBigDecimal;
  minAutobudgetAvgPrice: GraphQlBigDecimal;
  brandSurveyBudgetThreshold: GraphQlBigDecimal;
  autobudgetPayForConversionAvgCpaWarning: GraphQlBigDecimal;
}

export interface ConstantsQueryFragment_alertData {
  __typename: "GdAlertData";
  enabled: boolean;
  textRu: string | null;
  textEn: string | null;
}

export interface ConstantsQueryFragment_validation_libMinusKeywordsConstants {
  __typename: "GdDirectConstantsMinusWordsLibValidationData";
  libMinusKeywordsTextMaxLength: number;
  maxLibraryPacksCount: number;
  maxLinkedPacksToOneAdGroup: number;
  maxNameLength: number;
  maxWordsInMinusPhrase: number;
  nameAllowLetters: string;
  textAllowLetters: string;
}

export interface ConstantsQueryFragment_validation_adGroupConstants {
  __typename: "GdDirectConstantsAdGroupValidationData";
  maxAdGroupsCountPerUpdate: number;
}

export interface ConstantsQueryFragment_validation_campaignConstants {
  __typename: "GdDirectConstantsCampaignValidationData";
  minWarningBalanceInPercent: number;
  maxWarningBalanceInPercent: number;
}

export interface ConstantsQueryFragment_validation_vcardConstants {
  __typename: "GdDirectConstantsVcardValidationData";
  companyNameMaxLength: number;
  contactPersonMaxLength: number;
  contactEmailMaxLength: number;
  extraMessageMaxLength: number;
  countryMaxLength: number;
  cityMaxLength: number;
  streetMaxLength: number;
  houseWithBuildingMaxLength: number;
  apartmentMaxLength: number;
  instantMessengerLoginMaxLength: number;
  pointOnMapLongitudeMin: GraphQlBigDecimal;
  pointOnMapLongitudeMax: GraphQlBigDecimal;
  pointOnMapLatitudeMin: GraphQlBigDecimal;
  pointOnMapLatitudeMax: GraphQlBigDecimal;
  countryCodeMaxLength: number;
  cityCodeMaxLength: number;
  phoneNumberMinLength: number;
  phoneNumberMaxLength: number;
  extensionMaxLength: number;
  entirePhoneMinLength: number;
  entirePhoneMaxLength: number;
  entirePhoneWithExtensionMaxLength: number;
}

export interface ConstantsQueryFragment_validation {
  __typename: "GdDirectConstantsValidationData";
  libMinusKeywordsConstants: ConstantsQueryFragment_validation_libMinusKeywordsConstants;
  adGroupConstants: ConstantsQueryFragment_validation_adGroupConstants;
  campaignConstants: ConstantsQueryFragment_validation_campaignConstants;
  vcardConstants: ConstantsQueryFragment_validation_vcardConstants;
}

export interface ConstantsQueryFragment_defaultValues_campaign_defaultSmsTimeInterval_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface ConstantsQueryFragment_defaultValues_campaign_defaultSmsTimeInterval_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface ConstantsQueryFragment_defaultValues_campaign_defaultSmsTimeInterval {
  __typename: "GdTimeInterval";
  endTime: ConstantsQueryFragment_defaultValues_campaign_defaultSmsTimeInterval_endTime;
  startTime: ConstantsQueryFragment_defaultValues_campaign_defaultSmsTimeInterval_startTime;
}

export interface ConstantsQueryFragment_defaultValues_campaign {
  __typename: "GdCampaignDefaultValues";
  defaultWarningBalance: number;
  defaultCheckPositionInterval: GdCampaignCheckPositionInterval;
  defaultSmsTimeInterval: ConstantsQueryFragment_defaultValues_campaign_defaultSmsTimeInterval;
}

export interface ConstantsQueryFragment_defaultValues {
  __typename: "GdDefaultValues";
  campaign: ConstantsQueryFragment_defaultValues_campaign;
}

export interface ConstantsQueryFragment_configuration {
  __typename: "GdConfigurationConstants";
  balanceDomain: string;
  canvasUiDomain: string;
  spravIFrameUrl: string;
  surveysUiUrl: string;
}

export interface ConstantsQueryFragment {
  __typename: "GdDirectConstants";
  /**
   * Максимально допустимая конечная дата для заказа агентсткого оффлайн-отчета
   */
  agencyOfflineReportMaximumDate: GraphQlLocalDate;
  strategyConstants: ConstantsQueryFragment_strategyConstants;
  currencyConstants: ConstantsQueryFragment_currencyConstants[];
  alertData: ConstantsQueryFragment_alertData;
  validation: ConstantsQueryFragment_validation;
  defaultValues: ConstantsQueryFragment_defaultValues;
  configuration: ConstantsQueryFragment_configuration;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CampaignContextFragment
// ====================================================

export interface CampaignContextFragment {
  __typename: "GdClientAccess";
  canCreateCampaignTypes: GdCampaignType[];
  canCreateCampaign: boolean;
  canViewInternalAds: boolean;
  canEditInternalAds: boolean;
  canManageLibMinusWords: boolean;
  canExportToExcel: boolean;
  canMassEditAdGroupRegions: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FooterQueryUserInfoFragment
// ====================================================

export interface FooterQueryUserInfoFragment {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OperatorFeaturesFragment
// ====================================================

export interface OperatorFeaturesFragment {
  __typename: "GdOperatorFeatures";
  isAdGroupUpdateAllowed: boolean;
  isBannerUpdateAllowed: boolean;
  isCpmBannerUpdateAllowed: boolean;
  isBannerAimingAllowed: boolean;
  isBannerAimingCpmAllowed: boolean;
  isPerformanceAdEditAllowed: boolean;
  isOutdoorGroupsEditAllowed: boolean;
  isIndoorGroupsEditAllowed: boolean;
  isRetargetingGridEnabled: boolean;
  isAdsMassEditAllowed: boolean;
  isCampaignAddAllowed: boolean;
  isCampaignUpdateAllowed: boolean;
  isCpmAdGroupUpdateAllowed: boolean;
  isVideoGroupsEditAllowed: boolean;
  isGeoproductGroupsEditAllowed: boolean;
  isAudioGroupsEditAllowed: boolean;
  isAggregatedStatusAllowed: boolean;
  isMcBannerDnaEnabled: boolean;
  isTargetTagsAllowed: boolean;
  isOldPhraseSelectorWizardDisabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FooterQueryOfficeInfoFragment
// ====================================================

export interface FooterQueryOfficeInfoFragment {
  __typename: "GdOfficeContactData";
  description: string;
  cityName: string | null;
  phone: string;
  phoneExtension: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FooterQueryOperatorFragment
// ====================================================

export interface FooterQueryOperatorFragment_info {
  __typename: "GdUserInfo";
  login: string;
}

export interface FooterQueryOperatorFragment_access {
  __typename: "GdOperatorAccess";
  canEditInternationalization: boolean;
  canSearchPhrasesDuplicates: boolean;
  canEditAdDomain: boolean;
  canViewListOfInternalAdManagers: boolean;
  canViewListOfInternalAdProducts: boolean;
  canEditInternalAdManagers: boolean;
  canEditInternalAdProducts: boolean;
  actions: GdOperatorAction[];
}

export interface FooterQueryOperatorFragment_officeInfo_cityContact {
  __typename: "GdOfficeContactData";
  description: string;
  cityName: string | null;
  phone: string;
  phoneExtension: string | null;
}

export interface FooterQueryOperatorFragment_officeInfo_regionContact {
  __typename: "GdOfficeContactData";
  description: string;
  cityName: string | null;
  phone: string;
  phoneExtension: string | null;
}

export interface FooterQueryOperatorFragment_officeInfo_regionContact2 {
  __typename: "GdOfficeContactData";
  description: string;
  cityName: string | null;
  phone: string;
  phoneExtension: string | null;
}

export interface FooterQueryOperatorFragment_officeInfo {
  __typename: "GdOfficeInfo";
  cityContact: FooterQueryOperatorFragment_officeInfo_cityContact | null;
  regionContact: FooterQueryOperatorFragment_officeInfo_regionContact | null;
  regionContact2: FooterQueryOperatorFragment_officeInfo_regionContact2 | null;
}

export interface FooterQueryOperatorFragment_managerInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface FooterQueryOperatorFragment_chiefInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface FooterQueryOperatorFragment_agencyInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface FooterQueryOperatorFragment {
  __typename: "GdOperatorInfo";
  tuneSecretKey: string | null;
  workCurrency: CurrencyCode;
  isSelfAgency: boolean;
  isAgency: boolean;
  info: FooterQueryOperatorFragment_info | null;
  access: FooterQueryOperatorFragment_access;
  officeInfo: FooterQueryOperatorFragment_officeInfo;
  managerInfo: FooterQueryOperatorFragment_managerInfo | null;
  chiefInfo: FooterQueryOperatorFragment_chiefInfo | null;
  agencyInfo: FooterQueryOperatorFragment_agencyInfo | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FooterQueryAgencyInfoFragment
// ====================================================

export interface FooterQueryAgencyInfoFragment {
  __typename: "GdAgencyInfo";
  clientId: GraphQlLong | null;
  userId: GraphQlLong | null;
  name: string | null;
  login: string | null;
  email: string | null;
  phone: string | null;
  representativeName: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FooterQueryClientFragment
// ====================================================

export interface FooterQueryClientFragment_info_managersInfo {
  __typename: "GdUserInfo";
  name: string;
  login: string;
  email: string;
  phone: string | null;
}

export interface FooterQueryClientFragment_info_agencyInfo {
  __typename: "GdAgencyInfo";
  clientId: GraphQlLong | null;
  userId: GraphQlLong | null;
  name: string | null;
  login: string | null;
  email: string | null;
  phone: string | null;
  representativeName: string | null;
}

export interface FooterQueryClientFragment_info {
  __typename: "GdClientInfo";
  id: GraphQlLong;
  workCurrency: CurrencyCode;
  countryRegionId: GraphQlLong;
  translocalGeotreeType: GdGeotreeType;
  autoVideo: boolean;
  internalAdProductName: string | null;
  managersInfo: FooterQueryClientFragment_info_managersInfo[];
  agencyInfo: FooterQueryClientFragment_info_agencyInfo | null;
}

export interface FooterQueryClientFragment_access {
  __typename: "GdClientAccess";
  canUseVideoConstructor: boolean;
  canPayByCash: boolean;
  canManageFavoriteCampaigns: boolean;
  canCopyCampaign: boolean;
  canManageUsingCommander: boolean;
  canMonitorPhrasesPositions: boolean;
  canTransferMoney: boolean;
  operatorIsClient: boolean;
  canUploadDocuments: boolean;
  canManageUsingXLS: boolean;
  canManageRetargertingConditions: boolean;
  canManageTurboLandings: boolean;
  canSeeClientRepresentatives: boolean;
  canManageVCards: boolean;
  canViewOfflineReports: boolean;
  canManageUsingApi: boolean;
  canCreateCampaign: boolean;
  canCreateCampaignTypes: GdCampaignType[];
  operatorIsClientChief: boolean;
  canManageCreatives: boolean;
  canManageFeeds: boolean;
  canCheckCampaignsStats: boolean;
  canViewUserLogs: boolean;
  canViewMobileApps: boolean;
  canSeeDealsLinkEverywhere: boolean;
  canSeeAgencyClients: boolean;
}

export interface FooterQueryClientFragment {
  __typename: "GdClient";
  info: FooterQueryClientFragment_info;
  access: FooterQueryClientFragment_access;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: WalletsDataFragment
// ====================================================

export interface WalletsDataFragment_status {
  __typename: "GdWalletStatus";
  enabled: boolean;
}

export interface WalletsDataFragment_budget {
  __typename: "GdWalletBudget";
  sum: GraphQlBigDecimal | null;
  showMode: GdWalletBudgetShowMode | null;
  type: GdWalletBudgetType;
}

export interface WalletsDataFragment {
  __typename: "GdWallet";
  id: GraphQlLong;
  status: WalletsDataFragment_status;
  budget: WalletsDataFragment_budget;
  sum: GraphQlBigDecimal;
  currency: CurrencyCode;
  actions: GdWalletAction[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CryptaSegmentFragment
// ====================================================

export interface CryptaSegmentFragment {
  __typename: "GdCryptaSegment";
  id: GraphQlLong;
  type: WebGoalType;
  name: string;
  parentId: GraphQlLong | null;
  description: string;
  interestType: CryptaInterestTypeWeb | null;
  canSelectAll: boolean | null;
  mutuallyExclusiveIds: GraphQlLong[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DealRowFragment
// ====================================================

export interface DealRowFragment_placements {
  __typename: "GdiDealPlacement";
  domain: string | null;
  formats: (string | null)[] | null;
}

export interface DealRowFragment {
  __typename: "GdiDeal";
  id: GraphQlLong;
  name: string | null;
  status: StatusDirect;
  completeReason: CompleteReason | null;
  dateStart: GraphQlLocalDateTime | null;
  dateEnd: GraphQlLocalDateTime | null;
  description: string | null;
  expectedMoneyPerWeek: GraphQlLong | null;
  expectedImpressionsPerWeek: GraphQlLong | null;
  dealType: DealType;
  contacts: string | null;
  minPrice: GraphQlBigDecimal | null;
  targetingsText: string | null;
  agencyFeePercent: GraphQlBigDecimal | null;
  currencyCode: string | null;
  publisherName: string | null;
  numberOfLinkedCampaigns: number | null;
  clicks: GraphQlLong | null;
  cpc: GraphQlBigDecimal | null;
  cpm: GraphQlBigDecimal | null;
  ctr: GraphQlBigDecimal | null;
  placements: DealRowFragment_placements[] | null;
  shows: GraphQlLong | null;
  spent: GraphQlBigDecimal | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PriceCampaignDataForGroupFragment
// ====================================================

export interface PriceCampaignDataForGroupFragment_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface PriceCampaignDataForGroupFragment_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface PriceCampaignDataForGroupFragment_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface PriceCampaignDataForGroupFragment_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: PriceCampaignDataForGroupFragment_pricePackage_targetingsFixed | null;
  targetingsCustom: PriceCampaignDataForGroupFragment_pricePackage_targetingsCustom | null;
}

export interface PriceCampaignDataForGroupFragment {
  __typename: "GdPriceCampaign";
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: PriceCampaignDataForGroupFragment_flightTargetingsSnapshot | null;
  pricePackage: PriceCampaignDataForGroupFragment_pricePackage;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ClientFeaturesFragment
// ====================================================

export interface ClientFeaturesFragment {
  __typename: "GdClientFeatures";
  isWalletEnabled: boolean;
  hasMetrikaCounters: boolean;
  hasEcommerce: boolean;
  hasCampaignsWithCPAStrategy: boolean;
  enabledRecommendationTypes: GdiRecommendationType[];
  isBannerPricesOnGridEnabled: boolean;
  isInternalAdsAllowed: boolean;
  isCpmCampaignsEnabled: boolean;
  isTurboForSerpWizardAllowed: boolean;
  isBrandLiftAllowed: boolean;
  isTextBannerInterestsRetCondEnabled: boolean;
  isTycoonOrganizationsEnabled: boolean;
  isCampaignDefaultOrganizationsEnabled: boolean;
  isShowAutoAssignedOrganizationsEnabled: boolean;
  isInAppEventsInRmpEnabled: boolean;
  isTargetTagsAllowed: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: GoalStatsGridFragment
// ====================================================

export interface GoalStatsGridFragment {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignBrandSurveyFragment
// ====================================================

export interface campaignBrandSurveyFragment {
  __typename: "GdBrandSurveyStatus";
  surveyStatus: GdSurveyStatus;
  reasonIds: GraphQlLong[];
  brandSurveyStopReasons: GdBrandSurveyStopReason[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PokazometerDataFragment
// ====================================================

export interface PokazometerDataFragment_allCostsAndClicks {
  __typename: "GdPokazometerCostsAndClicksItem";
  clicks: number;
  price: GraphQlBigDecimal;
}

export interface PokazometerDataFragment_priceForCoverage {
  __typename: "GdPokazometerPriceForCoverageItem";
  coverage: number;
  price: GraphQlBigDecimal;
}

export interface PokazometerDataFragment {
  __typename: "GdPokazometerData";
  allCostsAndClicks: PokazometerDataFragment_allCostsAndClicks[];
  priceForCoverage: PokazometerDataFragment_priceForCoverage[];
  maxShows: number | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignStrategyBudgetFragment
// ====================================================

export interface campaignStrategyBudgetFragment {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignFlatStrategyFragment
// ====================================================

export interface campaignFlatStrategyFragment_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignFlatStrategyFragment_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignFlatStrategyFragment_GdCampaignStrategyAvgClick_budget | null;
}

export interface campaignFlatStrategyFragment_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignFlatStrategyFragment_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignFlatStrategyFragment_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface campaignFlatStrategyFragment_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignFlatStrategyFragment_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignFlatStrategyFragment_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type campaignFlatStrategyFragment = campaignFlatStrategyFragment_GdCampaignStrategyAvgClick | campaignFlatStrategyFragment_GdCampaignStrategyManual | campaignFlatStrategyFragment_GdStrategyOptimizeConversions;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: recommendationGraphFragment
// ====================================================

export interface recommendationGraphFragment_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationGraphFragment {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationGraphFragment_points[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: recommendationKpiFragment
// ====================================================

export interface recommendationKpiFragment_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationKpiFragment_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationKpiFragment_graph_points[];
}

export interface recommendationKpiFragment {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiDailyBudget" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationKpiFragment_graph;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: recommendationFragment
// ====================================================

export interface recommendationFragment_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface recommendationFragment_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: recommendationFragment_GdRecommendationWithoutKpi_keys[];
}

export interface recommendationFragment_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type recommendationFragment_GdRecommendationWithKpi_kpi = recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | recommendationFragment_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface recommendationFragment_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: recommendationFragment_GdRecommendationWithKpi_keys[];
  kpi: recommendationFragment_GdRecommendationWithKpi_kpi;
}

export type recommendationFragment = recommendationFragment_GdRecommendationWithoutKpi | recommendationFragment_GdRecommendationWithKpi;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: timeTargetStatusInfoFragment
// ====================================================

export interface timeTargetStatusInfoFragment {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignStatusInfoFragment
// ====================================================

export interface campaignStatusInfoFragment_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface campaignStatusInfoFragment {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: campaignStatusInfoFragment_timeTargetStatus;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: statsDataFragment
// ====================================================

export interface statsDataFragment {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignRowCpmFragment
// ====================================================

export interface campaignRowCpmFragment_brandSurveyStatus {
  __typename: "GdBrandSurveyStatus";
  surveyStatus: GdSurveyStatus;
  reasonIds: GraphQlLong[];
  brandSurveyStopReasons: GdBrandSurveyStopReason[];
}

export interface campaignRowCpmFragment {
  __typename: "GdCpmBannerCampaign";
  brandSurveyId: string | null;
  brandSurveyStatus: campaignRowCpmFragment_brandSurveyStatus | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignsRowFragment
// ====================================================

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi = campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_keys[];
  kpi: campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi_kpi;
}

export type campaignsRowFragment_GdContentPromotionCampaign_recommendations = campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithoutKpi | campaignsRowFragment_GdContentPromotionCampaign_recommendations_GdRecommendationWithKpi;

export interface campaignsRowFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignsRowFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignsRowFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignsRowFragment_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type campaignsRowFragment_GdContentPromotionCampaign_strategy = campaignsRowFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | campaignsRowFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | campaignsRowFragment_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface campaignsRowFragment_GdContentPromotionCampaign_aggregatedStatusInfo_counters {
  __typename: "GdCampaignAggregatedStatusCountersInfo";
  adgroups: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_aggregatedStatusInfo {
  __typename: "GdCampaignAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
  counters: campaignsRowFragment_GdContentPromotionCampaign_aggregatedStatusInfo_counters;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: campaignsRowFragment_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface campaignsRowFragment_GdContentPromotionCampaign_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface campaignsRowFragment_GdContentPromotionCampaign_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface campaignsRowFragment_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  agencyId: GraphQlLong | null;
  name: string;
  index: number;
  currency: CurrencyCode | null;
  type: GdCampaignType;
  sum: GraphQlBigDecimal | null;
  hasAds: boolean;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  recommendations: campaignsRowFragment_GdContentPromotionCampaign_recommendations[] | null;
  strategy: campaignsRowFragment_GdContentPromotionCampaign_strategy;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: campaignsRowFragment_GdContentPromotionCampaign_aggregatedStatusInfo | null;
  status: campaignsRowFragment_GdContentPromotionCampaign_status;
  access: campaignsRowFragment_GdContentPromotionCampaign_access;
  stats: campaignsRowFragment_GdContentPromotionCampaign_stats;
  goalStats: campaignsRowFragment_GdContentPromotionCampaign_goalStats[] | null;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_brandSurveyStatus {
  __typename: "GdBrandSurveyStatus";
  surveyStatus: GdSurveyStatus;
  reasonIds: GraphQlLong[];
  brandSurveyStopReasons: GdBrandSurveyStopReason[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi = campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_keys[];
  kpi: campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi_kpi;
}

export type campaignsRowFragment_GdCpmBannerCampaign_recommendations = campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithoutKpi | campaignsRowFragment_GdCpmBannerCampaign_recommendations_GdRecommendationWithKpi;

export interface campaignsRowFragment_GdCpmBannerCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignsRowFragment_GdCpmBannerCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignsRowFragment_GdCpmBannerCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignsRowFragment_GdCpmBannerCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type campaignsRowFragment_GdCpmBannerCampaign_strategy = campaignsRowFragment_GdCpmBannerCampaign_strategy_GdCampaignStrategyAvgClick | campaignsRowFragment_GdCpmBannerCampaign_strategy_GdCampaignStrategyManual | campaignsRowFragment_GdCpmBannerCampaign_strategy_GdStrategyOptimizeConversions;

export interface campaignsRowFragment_GdCpmBannerCampaign_aggregatedStatusInfo_counters {
  __typename: "GdCampaignAggregatedStatusCountersInfo";
  adgroups: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_aggregatedStatusInfo {
  __typename: "GdCampaignAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
  counters: campaignsRowFragment_GdCpmBannerCampaign_aggregatedStatusInfo_counters;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: campaignsRowFragment_GdCpmBannerCampaign_status_timeTargetStatus;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface campaignsRowFragment_GdCpmBannerCampaign_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface campaignsRowFragment_GdCpmBannerCampaign_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface campaignsRowFragment_GdCpmBannerCampaign {
  __typename: "GdCpmBannerCampaign";
  id: GraphQlLong;
  agencyId: GraphQlLong | null;
  name: string;
  index: number;
  currency: CurrencyCode | null;
  brandSurveyId: string | null;
  brandSurveyStatus: campaignsRowFragment_GdCpmBannerCampaign_brandSurveyStatus | null;
  type: GdCampaignType;
  sum: GraphQlBigDecimal | null;
  hasAds: boolean;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  recommendations: campaignsRowFragment_GdCpmBannerCampaign_recommendations[] | null;
  strategy: campaignsRowFragment_GdCpmBannerCampaign_strategy;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: campaignsRowFragment_GdCpmBannerCampaign_aggregatedStatusInfo | null;
  status: campaignsRowFragment_GdCpmBannerCampaign_status;
  access: campaignsRowFragment_GdCpmBannerCampaign_access;
  stats: campaignsRowFragment_GdCpmBannerCampaign_stats;
  goalStats: campaignsRowFragment_GdCpmBannerCampaign_goalStats[] | null;
}

export type campaignsRowFragment = campaignsRowFragment_GdContentPromotionCampaign | campaignsRowFragment_GdCpmBannerCampaign;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignShortRowFragment
// ====================================================

export interface campaignShortRowFragment_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface campaignShortRowFragment_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: campaignShortRowFragment_status_timeTargetStatus;
}

export interface campaignShortRowFragment_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface campaignShortRowFragment_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignShortRowFragment_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignShortRowFragment_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface campaignShortRowFragment_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignShortRowFragment_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignShortRowFragment_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface campaignShortRowFragment_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignShortRowFragment_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignShortRowFragment_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type campaignShortRowFragment_strategy = campaignShortRowFragment_strategy_GdCampaignStrategyAvgClick | campaignShortRowFragment_strategy_GdCampaignStrategyManual | campaignShortRowFragment_strategy_GdStrategyOptimizeConversions;

export interface campaignShortRowFragment {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: campaignShortRowFragment_status;
  access: campaignShortRowFragment_access;
  strategy: campaignShortRowFragment_strategy;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CampaignTruncatedFragment
// ====================================================

export interface CampaignTruncatedFragment_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface CampaignTruncatedFragment_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: CampaignTruncatedFragment_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface CampaignTruncatedFragment_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface CampaignTruncatedFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignTruncatedFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignTruncatedFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface CampaignTruncatedFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignTruncatedFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignTruncatedFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface CampaignTruncatedFragment_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignTruncatedFragment_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignTruncatedFragment_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type CampaignTruncatedFragment_GdContentPromotionCampaign_strategy = CampaignTruncatedFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | CampaignTruncatedFragment_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | CampaignTruncatedFragment_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface CampaignTruncatedFragment_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: CampaignTruncatedFragment_GdContentPromotionCampaign_status;
  access: CampaignTruncatedFragment_GdContentPromotionCampaign_access;
  strategy: CampaignTruncatedFragment_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface CampaignTruncatedFragment_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface CampaignTruncatedFragment_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: CampaignTruncatedFragment_GdTextCampaign_status_timeTargetStatus;
}

export interface CampaignTruncatedFragment_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface CampaignTruncatedFragment_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignTruncatedFragment_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignTruncatedFragment_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface CampaignTruncatedFragment_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignTruncatedFragment_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignTruncatedFragment_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface CampaignTruncatedFragment_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignTruncatedFragment_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignTruncatedFragment_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type CampaignTruncatedFragment_GdTextCampaign_strategy = CampaignTruncatedFragment_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | CampaignTruncatedFragment_GdTextCampaign_strategy_GdCampaignStrategyManual | CampaignTruncatedFragment_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface CampaignTruncatedFragment_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface CampaignTruncatedFragment_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignTruncatedFragment_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignTruncatedFragment_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: CampaignTruncatedFragment_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: CampaignTruncatedFragment_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface CampaignTruncatedFragment_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface CampaignTruncatedFragment_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface CampaignTruncatedFragment_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: CampaignTruncatedFragment_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface CampaignTruncatedFragment_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: CampaignTruncatedFragment_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: CampaignTruncatedFragment_GdTextCampaign_commonVcard_workTimes[];
  phone: CampaignTruncatedFragment_GdTextCampaign_commonVcard_phone;
  address: CampaignTruncatedFragment_GdTextCampaign_commonVcard_address;
}

export interface CampaignTruncatedFragment_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: CampaignTruncatedFragment_GdTextCampaign_status;
  access: CampaignTruncatedFragment_GdTextCampaign_access;
  strategy: CampaignTruncatedFragment_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: CampaignTruncatedFragment_GdTextCampaign_commonVcard | null;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: CampaignTruncatedFragment_GdDynamicCampaign_status_timeTargetStatus;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignTruncatedFragment_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignTruncatedFragment_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: CampaignTruncatedFragment_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type CampaignTruncatedFragment_GdDynamicCampaign_strategy = CampaignTruncatedFragment_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | CampaignTruncatedFragment_GdDynamicCampaign_strategy_GdCampaignStrategyManual | CampaignTruncatedFragment_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface CampaignTruncatedFragment_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: CampaignTruncatedFragment_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: CampaignTruncatedFragment_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: CampaignTruncatedFragment_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: CampaignTruncatedFragment_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: CampaignTruncatedFragment_GdDynamicCampaign_commonVcard_workTimes[];
  phone: CampaignTruncatedFragment_GdDynamicCampaign_commonVcard_phone;
  address: CampaignTruncatedFragment_GdDynamicCampaign_commonVcard_address;
}

export interface CampaignTruncatedFragment_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: CampaignTruncatedFragment_GdDynamicCampaign_status;
  access: CampaignTruncatedFragment_GdDynamicCampaign_access;
  strategy: CampaignTruncatedFragment_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: CampaignTruncatedFragment_GdDynamicCampaign_commonVcard | null;
}

export type CampaignTruncatedFragment = CampaignTruncatedFragment_GdContentPromotionCampaign | CampaignTruncatedFragment_GdTextCampaign | CampaignTruncatedFragment_GdDynamicCampaign;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InternalFreeCampaignTruncatedFragment
// ====================================================

export interface InternalFreeCampaignTruncatedFragment_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface InternalFreeCampaignTruncatedFragment_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: InternalFreeCampaignTruncatedFragment_status_timeTargetStatus;
}

export interface InternalFreeCampaignTruncatedFragment_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface InternalFreeCampaignTruncatedFragment_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalFreeCampaignTruncatedFragment_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalFreeCampaignTruncatedFragment_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface InternalFreeCampaignTruncatedFragment_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalFreeCampaignTruncatedFragment_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalFreeCampaignTruncatedFragment_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface InternalFreeCampaignTruncatedFragment_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalFreeCampaignTruncatedFragment_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalFreeCampaignTruncatedFragment_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type InternalFreeCampaignTruncatedFragment_strategy = InternalFreeCampaignTruncatedFragment_strategy_GdCampaignStrategyAvgClick | InternalFreeCampaignTruncatedFragment_strategy_GdCampaignStrategyManual | InternalFreeCampaignTruncatedFragment_strategy_GdStrategyOptimizeConversions;

export interface InternalFreeCampaignTruncatedFragment {
  __typename: "GdInternalFreeCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  status: InternalFreeCampaignTruncatedFragment_status;
  adsCount: number;
  access: InternalFreeCampaignTruncatedFragment_access;
  strategy: InternalFreeCampaignTruncatedFragment_strategy;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InternalDistribCampaignTruncatedFragment
// ====================================================

export interface InternalDistribCampaignTruncatedFragment_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface InternalDistribCampaignTruncatedFragment_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: InternalDistribCampaignTruncatedFragment_status_timeTargetStatus;
}

export interface InternalDistribCampaignTruncatedFragment_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface InternalDistribCampaignTruncatedFragment_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalDistribCampaignTruncatedFragment_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalDistribCampaignTruncatedFragment_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface InternalDistribCampaignTruncatedFragment_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalDistribCampaignTruncatedFragment_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalDistribCampaignTruncatedFragment_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface InternalDistribCampaignTruncatedFragment_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface InternalDistribCampaignTruncatedFragment_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: InternalDistribCampaignTruncatedFragment_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type InternalDistribCampaignTruncatedFragment_strategy = InternalDistribCampaignTruncatedFragment_strategy_GdCampaignStrategyAvgClick | InternalDistribCampaignTruncatedFragment_strategy_GdCampaignStrategyManual | InternalDistribCampaignTruncatedFragment_strategy_GdStrategyOptimizeConversions;

export interface InternalDistribCampaignTruncatedFragment {
  __typename: "GdInternalDistribCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  adsCount: number;
  status: InternalDistribCampaignTruncatedFragment_status;
  access: InternalDistribCampaignTruncatedFragment_access;
  strategy: InternalDistribCampaignTruncatedFragment_strategy;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdGroupInternalTruncatedFragment
// ====================================================

export interface AdGroupInternalTruncatedFragment_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_status_timeTargetStatus;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_strategy = AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick | AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual | AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions;

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign {
  __typename: "GdInternalFreeCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  status: AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_status;
  adsCount: number;
  access: AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_access;
  strategy: AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign_strategy;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_status_timeTargetStatus;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_strategy = AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick | AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual | AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions;

export interface AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign {
  __typename: "GdInternalDistribCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  adsCount: number;
  status: AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_status;
  access: AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_access;
  strategy: AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign_strategy;
}

export type AdGroupInternalTruncatedFragment_campaign = AdGroupInternalTruncatedFragment_campaign_GdContentPromotionCampaign | AdGroupInternalTruncatedFragment_campaign_GdInternalFreeCampaign | AdGroupInternalTruncatedFragment_campaign_GdInternalDistribCampaign;

export interface AdGroupInternalTruncatedFragment_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface AdGroupInternalTruncatedFragment_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface AdGroupInternalTruncatedFragment_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface AdGroupInternalTruncatedFragment {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  campaign: AdGroupInternalTruncatedFragment_campaign;
  access: AdGroupInternalTruncatedFragment_access;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: AdGroupInternalTruncatedFragment_regionsInfo;
  status: AdGroupInternalTruncatedFragment_status;
  adsCount: number;
  type: GdAdGroupType;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: campaignBaseInfoRowFragment
// ====================================================

export interface campaignBaseInfoRowFragment_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignBaseInfoRowFragment_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignBaseInfoRowFragment_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface campaignBaseInfoRowFragment_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignBaseInfoRowFragment_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignBaseInfoRowFragment_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface campaignBaseInfoRowFragment_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface campaignBaseInfoRowFragment_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: campaignBaseInfoRowFragment_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type campaignBaseInfoRowFragment_strategy = campaignBaseInfoRowFragment_strategy_GdCampaignStrategyAvgClick | campaignBaseInfoRowFragment_strategy_GdCampaignStrategyManual | campaignBaseInfoRowFragment_strategy_GdStrategyOptimizeConversions;

export interface campaignBaseInfoRowFragment_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface campaignBaseInfoRowFragment_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: campaignBaseInfoRowFragment_status_timeTargetStatus;
}

export interface campaignBaseInfoRowFragment_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface campaignBaseInfoRowFragment {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  currency: CurrencyCode | null;
  name: string;
  agencyId: GraphQlLong | null;
  type: GdCampaignType;
  strategy: campaignBaseInfoRowFragment_strategy;
  status: campaignBaseInfoRowFragment_status;
  access: campaignBaseInfoRowFragment_access;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adsGroupRowFragment
// ====================================================

export interface adsGroupRowFragment_GdContentPromotionAdGroup_aggregatedStatusInfo_counters {
  __typename: "GdAdgroupAggregatedStatusCountersInfo";
  ads: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
  keywords: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_aggregatedStatusInfo {
  __typename: "GdAdgroupAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
  counters: adsGroupRowFragment_GdContentPromotionAdGroup_aggregatedStatusInfo_counters;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsGroupRowFragment_GdContentPromotionAdGroup_campaign = adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign | adsGroupRowFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi = adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsGroupRowFragment_GdContentPromotionAdGroup_recommendations = adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithoutKpi | adsGroupRowFragment_GdContentPromotionAdGroup_recommendations_GdRecommendationWithKpi;

export interface adsGroupRowFragment_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
  canEditRegions: boolean;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsGroupRowFragment_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdMcBannerAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: adsGroupRowFragment_GdContentPromotionAdGroup_aggregatedStatusInfo | null;
  index: number;
  adsCount: number;
  campaign: adsGroupRowFragment_GdContentPromotionAdGroup_campaign;
  recommendations: adsGroupRowFragment_GdContentPromotionAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: adsGroupRowFragment_GdContentPromotionAdGroup_regionsInfo;
  access: adsGroupRowFragment_GdContentPromotionAdGroup_access;
  stats: adsGroupRowFragment_GdContentPromotionAdGroup_stats;
  status: adsGroupRowFragment_GdContentPromotionAdGroup_status;
  goalStats: adsGroupRowFragment_GdContentPromotionAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_aggregatedStatusInfo_counters {
  __typename: "GdAdgroupAggregatedStatusCountersInfo";
  ads: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
  keywords: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_aggregatedStatusInfo {
  __typename: "GdAdgroupAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
  counters: adsGroupRowFragment_GdDynamicAdGroup_aggregatedStatusInfo_counters;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsGroupRowFragment_GdDynamicAdGroup_campaign = adsGroupRowFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | adsGroupRowFragment_GdDynamicAdGroup_campaign_GdTextCampaign | adsGroupRowFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi = adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsGroupRowFragment_GdDynamicAdGroup_recommendations = adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithoutKpi | adsGroupRowFragment_GdDynamicAdGroup_recommendations_GdRecommendationWithKpi;

export interface adsGroupRowFragment_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsGroupRowFragment_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
  canEditRegions: boolean;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsGroupRowFragment_GdDynamicAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsGroupRowFragment_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: adsGroupRowFragment_GdDynamicAdGroup_aggregatedStatusInfo | null;
  index: number;
  adsCount: number;
  campaign: adsGroupRowFragment_GdDynamicAdGroup_campaign;
  recommendations: adsGroupRowFragment_GdDynamicAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: adsGroupRowFragment_GdDynamicAdGroup_regionsInfo;
  access: adsGroupRowFragment_GdDynamicAdGroup_access;
  stats: adsGroupRowFragment_GdDynamicAdGroup_stats;
  mainDomain: string | null;
  status: adsGroupRowFragment_GdDynamicAdGroup_status;
  goalStats: adsGroupRowFragment_GdDynamicAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_aggregatedStatusInfo_counters {
  __typename: "GdAdgroupAggregatedStatusCountersInfo";
  ads: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
  keywords: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_aggregatedStatusInfo {
  __typename: "GdAdgroupAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
  counters: adsGroupRowFragment_GdMobileContentAdGroup_aggregatedStatusInfo_counters;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsGroupRowFragment_GdMobileContentAdGroup_campaign = adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdTextCampaign | adsGroupRowFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi = adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsGroupRowFragment_GdMobileContentAdGroup_recommendations = adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithoutKpi | adsGroupRowFragment_GdMobileContentAdGroup_recommendations_GdRecommendationWithKpi;

export interface adsGroupRowFragment_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
  canEditRegions: boolean;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsGroupRowFragment_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: adsGroupRowFragment_GdMobileContentAdGroup_aggregatedStatusInfo | null;
  index: number;
  adsCount: number;
  campaign: adsGroupRowFragment_GdMobileContentAdGroup_campaign;
  recommendations: adsGroupRowFragment_GdMobileContentAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: adsGroupRowFragment_GdMobileContentAdGroup_regionsInfo;
  access: adsGroupRowFragment_GdMobileContentAdGroup_access;
  stats: adsGroupRowFragment_GdMobileContentAdGroup_stats;
  storeHref: string;
  status: adsGroupRowFragment_GdMobileContentAdGroup_status;
  goalStats: adsGroupRowFragment_GdMobileContentAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_aggregatedStatusInfo_counters {
  __typename: "GdAdgroupAggregatedStatusCountersInfo";
  ads: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
  keywords: GraphQlMap_GdSelfStatusEnum_IntegerScalar;
}

export interface adsGroupRowFragment_GdInternalAdGroup_aggregatedStatusInfo {
  __typename: "GdAdgroupAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
  counters: adsGroupRowFragment_GdInternalAdGroup_aggregatedStatusInfo_counters;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy = adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_strategy = adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_status;
  access: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_access;
  strategy: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy = adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_status;
  access: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsGroupRowFragment_GdInternalAdGroup_campaign = adsGroupRowFragment_GdInternalAdGroup_campaign_GdContentPromotionCampaign | adsGroupRowFragment_GdInternalAdGroup_campaign_GdTextCampaign | adsGroupRowFragment_GdInternalAdGroup_campaign_GdDynamicCampaign;

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi = adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsGroupRowFragment_GdInternalAdGroup_recommendations = adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithoutKpi | adsGroupRowFragment_GdInternalAdGroup_recommendations_GdRecommendationWithKpi;

export interface adsGroupRowFragment_GdInternalAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_access {
  __typename: "GdAdGroupAccess";
  canBeDeleted: boolean;
  canEdit: boolean;
  canRemoderateAdsCallouts: boolean;
  canAcceptAdsCalloutsModeration: boolean;
  canBeSentToModeration: boolean;
  canBeSentToModerationByClient: boolean;
  canBeSentToRemoderation: boolean;
  canAcceptModeration: boolean;
  canBeSentToBS: boolean;
  canCopy: boolean;
  canEditRegions: boolean;
}

export interface adsGroupRowFragment_GdInternalAdGroup_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingInternalNetwork {
  __typename: "GdAdditionalTargetingInternalNetwork";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingIsBrowser {
  __typename: "GdAdditionalTargetingIsBrowser";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingIsTablet {
  __typename: "GdAdditionalTargetingIsTablet";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingIsMobile {
  __typename: "GdAdditionalTargetingIsMobile";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingIsTouch {
  __typename: "GdAdditionalTargetingIsTouch";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingUserAgents {
  __typename: "GdAdditionalTargetingUserAgents";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingOsNames_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingOsNames {
  __typename: "GdAdditionalTargetingOsNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adsGroupRowFragment_GdInternalAdGroup_targetingOsNames_value[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingOsFamilies_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
  minVersion: string | null;
  maxVersion: string | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingOsFamilies {
  __typename: "GdAdditionalTargetingOsFamilies";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adsGroupRowFragment_GdInternalAdGroup_targetingOsFamilies_value[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingBrowserNames_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
  minVersion: string | null;
  maxVersion: string | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingBrowserNames {
  __typename: "GdAdditionalTargetingBrowserNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adsGroupRowFragment_GdInternalAdGroup_targetingBrowserNames_value[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingBrowserEngines_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
  minVersion: string | null;
  maxVersion: string | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingBrowserEngines {
  __typename: "GdAdditionalTargetingBrowserEngines";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adsGroupRowFragment_GdInternalAdGroup_targetingBrowserEngines_value[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingDeviceVendors_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingDeviceVendors {
  __typename: "GdAdditionalTargetingDeviceVendors";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adsGroupRowFragment_GdInternalAdGroup_targetingDeviceVendors_value[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingDeviceNames {
  __typename: "GdAdditionalTargetingDeviceNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingInterfaceLangs {
  __typename: "GdAdditionalTargetingInterfaceLangs";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: InterfaceLang[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingQueryReferers {
  __typename: "GdAdditionalTargetingQueryReferers";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingYandexUids {
  __typename: "GdAdditionalTargetingYandexUids";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingShowDates {
  __typename: "GdAdditionalTargetingShowDates";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLocalDate[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingClidTypes {
  __typename: "GdAdditionalTargetingClidTypes";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingClids {
  __typename: "GdAdditionalTargetingClids";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingDesktopInstalledApps {
  __typename: "GdAdditionalTargetingDesktopInstalledApps";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingMobileInstalledApps {
  __typename: "GdAdditionalTargetingMobileInstalledApps";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingQueryOptions {
  __typename: "GdAdditionalTargetingQueryOptions";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingTestIds {
  __typename: "GdAdditionalTargetingTestIds";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingYsCookies {
  __typename: "GdAdditionalTargetingYsCookies";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingIsYandexPlus {
  __typename: "GdAdditionalTargetingIsYandexPlus";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_targetingIsVirused {
  __typename: "GdAdditionalTargetingIsVirused";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adsGroupRowFragment_GdInternalAdGroup_status {
  __typename: "GdAdGroupStatus";
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  bsEverSynced: boolean;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsGroupRowFragment_GdInternalAdGroup_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsGroupRowFragment_GdInternalAdGroup {
  __typename: "GdInternalAdGroup";
  name: string;
  type: GdAdGroupType;
  campaignId: GraphQlLong;
  id: GraphQlLong;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: adsGroupRowFragment_GdInternalAdGroup_aggregatedStatusInfo | null;
  index: number;
  adsCount: number;
  campaign: adsGroupRowFragment_GdInternalAdGroup_campaign;
  recommendations: adsGroupRowFragment_GdInternalAdGroup_recommendations[] | null;
  minusKeywords: string[];
  regionsInfo: adsGroupRowFragment_GdInternalAdGroup_regionsInfo;
  access: adsGroupRowFragment_GdInternalAdGroup_access;
  stats: adsGroupRowFragment_GdInternalAdGroup_stats;
  level: GraphQlLong | null;
  targetingInternalNetwork: adsGroupRowFragment_GdInternalAdGroup_targetingInternalNetwork | null;
  targetingIsBrowser: adsGroupRowFragment_GdInternalAdGroup_targetingIsBrowser | null;
  targetingIsTablet: adsGroupRowFragment_GdInternalAdGroup_targetingIsTablet | null;
  targetingIsMobile: adsGroupRowFragment_GdInternalAdGroup_targetingIsMobile | null;
  targetingIsTouch: adsGroupRowFragment_GdInternalAdGroup_targetingIsTouch | null;
  targetingUserAgents: adsGroupRowFragment_GdInternalAdGroup_targetingUserAgents | null;
  targetingOsNames: adsGroupRowFragment_GdInternalAdGroup_targetingOsNames | null;
  targetingOsFamilies: adsGroupRowFragment_GdInternalAdGroup_targetingOsFamilies | null;
  targetingBrowserNames: adsGroupRowFragment_GdInternalAdGroup_targetingBrowserNames | null;
  targetingBrowserEngines: adsGroupRowFragment_GdInternalAdGroup_targetingBrowserEngines | null;
  targetingDeviceVendors: adsGroupRowFragment_GdInternalAdGroup_targetingDeviceVendors | null;
  targetingDeviceNames: adsGroupRowFragment_GdInternalAdGroup_targetingDeviceNames | null;
  targetingInterfaceLangs: adsGroupRowFragment_GdInternalAdGroup_targetingInterfaceLangs | null;
  targetingQueryReferers: adsGroupRowFragment_GdInternalAdGroup_targetingQueryReferers | null;
  targetingYandexUids: adsGroupRowFragment_GdInternalAdGroup_targetingYandexUids | null;
  targetingShowDates: adsGroupRowFragment_GdInternalAdGroup_targetingShowDates | null;
  targetingClidTypes: adsGroupRowFragment_GdInternalAdGroup_targetingClidTypes | null;
  targetingClids: adsGroupRowFragment_GdInternalAdGroup_targetingClids | null;
  targetingDesktopInstalledApps: adsGroupRowFragment_GdInternalAdGroup_targetingDesktopInstalledApps | null;
  targetingMobileInstalledApps: adsGroupRowFragment_GdInternalAdGroup_targetingMobileInstalledApps | null;
  targetingQueryOptions: adsGroupRowFragment_GdInternalAdGroup_targetingQueryOptions | null;
  targetingTestIds: adsGroupRowFragment_GdInternalAdGroup_targetingTestIds | null;
  targetingYsCookies: adsGroupRowFragment_GdInternalAdGroup_targetingYsCookies | null;
  targetingIsYandexPlus: adsGroupRowFragment_GdInternalAdGroup_targetingIsYandexPlus | null;
  targetingIsVirused: adsGroupRowFragment_GdInternalAdGroup_targetingIsVirused | null;
  startTime: GraphQlLocalDateTime | null;
  finishTime: GraphQlLocalDateTime | null;
  status: adsGroupRowFragment_GdInternalAdGroup_status;
  goalStats: adsGroupRowFragment_GdInternalAdGroup_goalStats[] | null;
  availableShowConditionTypes: GdShowConditionType[];
}

export type adsGroupRowFragment = adsGroupRowFragment_GdContentPromotionAdGroup | adsGroupRowFragment_GdDynamicAdGroup | adsGroupRowFragment_GdMobileContentAdGroup | adsGroupRowFragment_GdInternalAdGroup;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adImageSmartCentersFragment
// ====================================================

export interface adImageSmartCentersFragment {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adImageFormatsFragment
// ====================================================

export interface adImageFormatsFragment_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adImageFormatsFragment_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adImageFormatsFragment {
  __typename: "GdImageFormat";
  imageSize: adImageFormatsFragment_imageSize;
  path: string;
  smartCenters: adImageFormatsFragment_smartCenters[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adImageFragment
// ====================================================

export interface adImageFragment_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adImageFragment_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adImageFragment_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adImageFragment_formats {
  __typename: "GdImageFormat";
  imageSize: adImageFragment_formats_imageSize;
  path: string;
  smartCenters: adImageFragment_formats_smartCenters[] | null;
}

export interface adImageFragment {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adImageFragment_imageSize;
  name: string | null;
  imageHash: string;
  formats: adImageFragment_formats[] | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adsPhraseRowFragment
// ====================================================

export interface adsPhraseRowFragment_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPhraseRowFragment_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPhraseRowFragment_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPhraseRowFragment_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPhraseRowFragment_GdCPCVideoAd_image_formats[] | null;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPhraseRowFragment_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPhraseRowFragment_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPhraseRowFragment_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPhraseRowFragment_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPhraseRowFragment_GdCPCVideoAd_typedCreative = adsPhraseRowFragment_GdCPCVideoAd_typedCreative_GdSmartCreative | adsPhraseRowFragment_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsPhraseRowFragment_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPhraseRowFragment_GdCPCVideoAd_recommendations = adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsPhraseRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsPhraseRowFragment_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPhraseRowFragment_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPhraseRowFragment_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPhraseRowFragment_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsPhraseRowFragment_GdCPCVideoAd_image | null;
  bannerImage: adsPhraseRowFragment_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsPhraseRowFragment_GdCPCVideoAd_typedCreative | null;
  status: adsPhraseRowFragment_GdCPCVideoAd_status;
  goalStats: adsPhraseRowFragment_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsPhraseRowFragment_GdCPCVideoAd_recommendations[] | null;
  stats: adsPhraseRowFragment_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPhraseRowFragment_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPhraseRowFragment_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPhraseRowFragment_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPhraseRowFragment_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPhraseRowFragment_GdContentPromotionAd_image_formats[] | null;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPhraseRowFragment_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPhraseRowFragment_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPhraseRowFragment_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPhraseRowFragment_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPhraseRowFragment_GdContentPromotionAd_typedCreative = adsPhraseRowFragment_GdContentPromotionAd_typedCreative_GdSmartCreative | adsPhraseRowFragment_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsPhraseRowFragment_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPhraseRowFragment_GdContentPromotionAd_recommendations = adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsPhraseRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsPhraseRowFragment_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPhraseRowFragment_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPhraseRowFragment_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPhraseRowFragment_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsPhraseRowFragment_GdContentPromotionAd_image | null;
  bannerImage: adsPhraseRowFragment_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsPhraseRowFragment_GdContentPromotionAd_typedCreative | null;
  status: adsPhraseRowFragment_GdContentPromotionAd_status;
  goalStats: adsPhraseRowFragment_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsPhraseRowFragment_GdContentPromotionAd_recommendations[] | null;
  stats: adsPhraseRowFragment_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPhraseRowFragment_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsPhraseRowFragment = adsPhraseRowFragment_GdCPCVideoAd | adsPhraseRowFragment_GdContentPromotionAd;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adPreviewFragment
// ====================================================

export interface adPreviewFragment_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adPreviewFragment_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adPreviewFragment_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adPreviewFragment_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adPreviewFragment_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adPreviewFragment_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adPreviewFragment_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adPreviewFragment_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adPreviewFragment_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adPreviewFragment_GdCPCVideoAd_image_formats[] | null;
}

export interface adPreviewFragment_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adPreviewFragment_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adPreviewFragment_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adPreviewFragment_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adPreviewFragment_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adPreviewFragment_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adPreviewFragment_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adPreviewFragment_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adPreviewFragment_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adPreviewFragment_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adPreviewFragment_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adPreviewFragment_GdCPCVideoAd_typedCreative = adPreviewFragment_GdCPCVideoAd_typedCreative_GdSmartCreative | adPreviewFragment_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adPreviewFragment_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adPreviewFragment_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adPreviewFragment_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adPreviewFragment_GdCPCVideoAd_image | null;
  bannerImage: adPreviewFragment_GdCPCVideoAd_bannerImage | null;
  typedCreative: adPreviewFragment_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adPreviewFragment_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adPreviewFragment_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adPreviewFragment_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adPreviewFragment_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adPreviewFragment_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adPreviewFragment_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adPreviewFragment_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adPreviewFragment_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adPreviewFragment_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adPreviewFragment_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adPreviewFragment_GdContentPromotionAd_image_formats[] | null;
}

export interface adPreviewFragment_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adPreviewFragment_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adPreviewFragment_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adPreviewFragment_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adPreviewFragment_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adPreviewFragment_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adPreviewFragment_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adPreviewFragment_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adPreviewFragment_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adPreviewFragment_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adPreviewFragment_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adPreviewFragment_GdContentPromotionAd_typedCreative = adPreviewFragment_GdContentPromotionAd_typedCreative_GdSmartCreative | adPreviewFragment_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adPreviewFragment_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adPreviewFragment_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adPreviewFragment_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adPreviewFragment_GdContentPromotionAd_image | null;
  bannerImage: adPreviewFragment_GdContentPromotionAd_bannerImage | null;
  typedCreative: adPreviewFragment_GdContentPromotionAd_typedCreative | null;
  contentPromotionPreviewUrl: string | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adPreviewFragment_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
}

export type adPreviewFragment = adPreviewFragment_GdCPCVideoAd | adPreviewFragment_GdContentPromotionAd;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdGroupTruncatedFragment
// ====================================================

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign = AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdTextCampaign | AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd = AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface AdGroupTruncatedFragment_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: AdGroupTruncatedFragment_GdContentPromotionAdGroup_campaign;
  access: AdGroupTruncatedFragment_GdContentPromotionAdGroup_access;
  mainAd: AdGroupTruncatedFragment_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: AdGroupTruncatedFragment_GdContentPromotionAdGroup_regionsInfo;
  status: AdGroupTruncatedFragment_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_campaign = AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdTextCampaign | AdGroupTruncatedFragment_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd = AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdCPCVideoAd | AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface AdGroupTruncatedFragment_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: AdGroupTruncatedFragment_GdDynamicAdGroup_campaign;
  mainDomain: string | null;
  access: AdGroupTruncatedFragment_GdDynamicAdGroup_access;
  mainAd: AdGroupTruncatedFragment_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: AdGroupTruncatedFragment_GdDynamicAdGroup_regionsInfo;
  status: AdGroupTruncatedFragment_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign = AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdTextCampaign | AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd = AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface AdGroupTruncatedFragment_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: AdGroupTruncatedFragment_GdMobileContentAdGroup_campaign;
  storeHref: string;
  access: AdGroupTruncatedFragment_GdMobileContentAdGroup_access;
  mainAd: AdGroupTruncatedFragment_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: AdGroupTruncatedFragment_GdMobileContentAdGroup_regionsInfo;
  status: AdGroupTruncatedFragment_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_strategy = AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_campaign = AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdContentPromotionCampaign | AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdTextCampaign | AdGroupTruncatedFragment_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type AdGroupTruncatedFragment_GdSmartAdGroup_mainAd = AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdCPCVideoAd | AdGroupTruncatedFragment_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface AdGroupTruncatedFragment_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface AdGroupTruncatedFragment_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: AdGroupTruncatedFragment_GdSmartAdGroup_campaign;
  feedId: GraphQlLong;
  access: AdGroupTruncatedFragment_GdSmartAdGroup_access;
  mainAd: AdGroupTruncatedFragment_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: AdGroupTruncatedFragment_GdSmartAdGroup_regionsInfo;
  status: AdGroupTruncatedFragment_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export type AdGroupTruncatedFragment = AdGroupTruncatedFragment_GdContentPromotionAdGroup | AdGroupTruncatedFragment_GdDynamicAdGroup | AdGroupTruncatedFragment_GdMobileContentAdGroup | AdGroupTruncatedFragment_GdSmartAdGroup;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adsRowFragment
// ====================================================

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign = adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd = adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd = adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd = adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd = adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragment_GdCPCVideoAd_adGroup = adsRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup | adsRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup | adsRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup | adsRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup;

export interface adsRowFragment_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPCVideoAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
}

export interface adsRowFragment_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: adsRowFragment_GdCPCVideoAd_typedCreative_GdSmartCreative_layout | null;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPCVideoAd_typedCreative = adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdCpcVideoCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmVideoCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmAudioCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative | adsRowFragment_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPCVideoAd_aggregatedStatusInfo {
  __typename: "GdAdAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface adsRowFragment_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPCVideoAd_recommendations = adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  hasCallouts: boolean;
  hasSitelink: boolean;
  hasTurboGallery: boolean;
  hasTurbolanding: boolean;
  hasVideo: boolean;
  adGroup: adsRowFragment_GdCPCVideoAd_adGroup;
  body: string | null;
  access: adsRowFragment_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  turbolanding: adsRowFragment_GdCPCVideoAd_turbolanding | null;
  image: adsRowFragment_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPCVideoAd_typedCreative | null;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: adsRowFragment_GdCPCVideoAd_aggregatedStatusInfo | null;
  status: adsRowFragment_GdCPCVideoAd_status;
  recommendations: adsRowFragment_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdCPCVideoAd_stats;
  goalStats: adsRowFragment_GdCPCVideoAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign = adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd = adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd = adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd = adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd = adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragment_GdTextAd_adGroup = adsRowFragment_GdTextAd_adGroup_GdContentPromotionAdGroup | adsRowFragment_GdTextAd_adGroup_GdDynamicAdGroup | adsRowFragment_GdTextAd_adGroup_GdMobileContentAdGroup | adsRowFragment_GdTextAd_adGroup_GdSmartAdGroup;

export interface adsRowFragment_GdTextAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdTextAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
}

export interface adsRowFragment_GdTextAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_image_formats[] | null;
}

export interface adsRowFragment_GdTextAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdTextAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdTextAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdTextAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdTextAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdTextAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdTextAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdTextAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: adsRowFragment_GdTextAd_typedCreative_GdSmartCreative_layout | null;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdTextAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdTextAd_typedCreative = adsRowFragment_GdTextAd_typedCreative_GdCpmGeoproductCreative | adsRowFragment_GdTextAd_typedCreative_GdSmartCreative | adsRowFragment_GdTextAd_typedCreative_GdCpcVideoCreative | adsRowFragment_GdTextAd_typedCreative_GdVideoAdditionCreative | adsRowFragment_GdTextAd_typedCreative_GdCpmVideoCreative | adsRowFragment_GdTextAd_typedCreative_GdCpmAudioCreative | adsRowFragment_GdTextAd_typedCreative_GdCpmOutdoorCreative | adsRowFragment_GdTextAd_typedCreative_GdCpmIndoorCreative | adsRowFragment_GdTextAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdTextAd_aggregatedStatusInfo {
  __typename: "GdAdAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface adsRowFragment_GdTextAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdTextAd_recommendations = adsRowFragment_GdTextAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdTextAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdTextAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdTextAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdTextAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdTextAd_bannerPrice {
  __typename: "GdAdPrice";
  currency: GdAdPriceCurrency | null;
  prefix: GdAdPricePrefix | null;
  price: string | null;
  priceOld: string | null;
}

export interface adsRowFragment_GdTextAd {
  __typename: "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  hasCallouts: boolean;
  hasSitelink: boolean;
  hasTurboGallery: boolean;
  hasTurbolanding: boolean;
  hasVideo: boolean;
  adGroup: adsRowFragment_GdTextAd_adGroup;
  body: string | null;
  access: adsRowFragment_GdTextAd_access;
  domain: string | null;
  href: string | null;
  turbolanding: adsRowFragment_GdTextAd_turbolanding | null;
  image: adsRowFragment_GdTextAd_image | null;
  bannerImage: adsRowFragment_GdTextAd_bannerImage | null;
  typedCreative: adsRowFragment_GdTextAd_typedCreative | null;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: adsRowFragment_GdTextAd_aggregatedStatusInfo | null;
  status: adsRowFragment_GdTextAd_status;
  recommendations: adsRowFragment_GdTextAd_recommendations[] | null;
  stats: adsRowFragment_GdTextAd_stats;
  goalStats: adsRowFragment_GdTextAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdTextAd_sitelinks[] | null;
  flags: string[] | null;
  turboGalleryHref: string | null;
  bannerPrice: adsRowFragment_GdTextAd_bannerPrice | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign = adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd = adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd = adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd = adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd = adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragment_GdInternalAd_adGroup = adsRowFragment_GdInternalAd_adGroup_GdContentPromotionAdGroup | adsRowFragment_GdInternalAd_adGroup_GdDynamicAdGroup | adsRowFragment_GdInternalAd_adGroup_GdMobileContentAdGroup | adsRowFragment_GdInternalAd_adGroup_GdSmartAdGroup;

export interface adsRowFragment_GdInternalAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdInternalAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
}

export interface adsRowFragment_GdInternalAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_image_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdInternalAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdInternalAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdInternalAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdInternalAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdInternalAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdInternalAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdInternalAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: adsRowFragment_GdInternalAd_typedCreative_GdSmartCreative_layout | null;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdInternalAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdInternalAd_typedCreative = adsRowFragment_GdInternalAd_typedCreative_GdCpmGeoproductCreative | adsRowFragment_GdInternalAd_typedCreative_GdSmartCreative | adsRowFragment_GdInternalAd_typedCreative_GdCpcVideoCreative | adsRowFragment_GdInternalAd_typedCreative_GdVideoAdditionCreative | adsRowFragment_GdInternalAd_typedCreative_GdCpmVideoCreative | adsRowFragment_GdInternalAd_typedCreative_GdCpmAudioCreative | adsRowFragment_GdInternalAd_typedCreative_GdCpmOutdoorCreative | adsRowFragment_GdInternalAd_typedCreative_GdCpmIndoorCreative | adsRowFragment_GdInternalAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdInternalAd_aggregatedStatusInfo {
  __typename: "GdAdAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface adsRowFragment_GdInternalAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdInternalAd_recommendations = adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdInternalAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdInternalAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdInternalAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdInternalAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdInternalAd {
  __typename: "GdInternalAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  hasCallouts: boolean;
  hasSitelink: boolean;
  hasTurboGallery: boolean;
  hasTurbolanding: boolean;
  hasVideo: boolean;
  adGroup: adsRowFragment_GdInternalAd_adGroup;
  body: string | null;
  access: adsRowFragment_GdInternalAd_access;
  domain: string | null;
  href: string | null;
  turbolanding: adsRowFragment_GdInternalAd_turbolanding | null;
  image: adsRowFragment_GdInternalAd_image | null;
  bannerImage: adsRowFragment_GdInternalAd_bannerImage | null;
  typedCreative: adsRowFragment_GdInternalAd_typedCreative | null;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: adsRowFragment_GdInternalAd_aggregatedStatusInfo | null;
  status: adsRowFragment_GdInternalAd_status;
  recommendations: adsRowFragment_GdInternalAd_recommendations[] | null;
  stats: adsRowFragment_GdInternalAd_stats;
  goalStats: adsRowFragment_GdInternalAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdInternalAd_sitelinks[] | null;
  flags: string[] | null;
  description: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_adGroup = adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup | adsRowFragment_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup;

export interface adsRowFragment_GdCPMOutdoorBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_image_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdCPMOutdoorBannerAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_typedCreative = adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative | adsRowFragment_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdCPMOutdoorBannerAd_aggregatedStatusInfo {
  __typename: "GdAdAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdCPMOutdoorBannerAd_recommendations = adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdCPMOutdoorBannerAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdCPMOutdoorBannerAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd_placementPages {
  __typename: "GdPlacementPageModerationResult";
  bannerId: GraphQlLong;
  comment: string | null;
  createTime: GraphQlLocalDateTime;
  id: GraphQlLong;
  pageId: GraphQlLong;
  statusModerate: StatusModerateBannerPage;
  statusModerateOperator: StatusModerateOperator;
  version: GraphQlLong;
}

export interface adsRowFragment_GdCPMOutdoorBannerAd {
  __typename: "GdCPMOutdoorBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  hasCallouts: boolean;
  hasSitelink: boolean;
  hasTurboGallery: boolean;
  hasTurbolanding: boolean;
  hasVideo: boolean;
  adGroup: adsRowFragment_GdCPMOutdoorBannerAd_adGroup;
  body: string | null;
  access: adsRowFragment_GdCPMOutdoorBannerAd_access;
  domain: string | null;
  href: string | null;
  turbolanding: adsRowFragment_GdCPMOutdoorBannerAd_turbolanding | null;
  image: adsRowFragment_GdCPMOutdoorBannerAd_image | null;
  bannerImage: adsRowFragment_GdCPMOutdoorBannerAd_bannerImage | null;
  typedCreative: adsRowFragment_GdCPMOutdoorBannerAd_typedCreative | null;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: adsRowFragment_GdCPMOutdoorBannerAd_aggregatedStatusInfo | null;
  status: adsRowFragment_GdCPMOutdoorBannerAd_status;
  recommendations: adsRowFragment_GdCPMOutdoorBannerAd_recommendations[] | null;
  stats: adsRowFragment_GdCPMOutdoorBannerAd_stats;
  goalStats: adsRowFragment_GdCPMOutdoorBannerAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdCPMOutdoorBannerAd_sitelinks[] | null;
  flags: string[] | null;
  placementPages: adsRowFragment_GdCPMOutdoorBannerAd_placementPages[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign = adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd = adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd = adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd = adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign = adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd = adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragment_GdContentPromotionAd_adGroup = adsRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup | adsRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup | adsRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup | adsRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup;

export interface adsRowFragment_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragment_GdContentPromotionAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
}

export interface adsRowFragment_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragment_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragment_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragment_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragment_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragment_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragment_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragment_GdContentPromotionAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdHtml5Creative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragment_GdContentPromotionAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragment_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  layout: adsRowFragment_GdContentPromotionAd_typedCreative_GdSmartCreative_layout | null;
}

export interface adsRowFragment_GdContentPromotionAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdContentPromotionAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdContentPromotionAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdContentPromotionAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragment_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdContentPromotionAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  livePreviewUrl: string;
}

export interface adsRowFragment_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragment_GdContentPromotionAd_typedCreative = adsRowFragment_GdContentPromotionAd_typedCreative_GdCpmGeoproductCreative | adsRowFragment_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragment_GdContentPromotionAd_typedCreative_GdCpcVideoCreative | adsRowFragment_GdContentPromotionAd_typedCreative_GdVideoAdditionCreative | adsRowFragment_GdContentPromotionAd_typedCreative_GdCpmVideoCreative | adsRowFragment_GdContentPromotionAd_typedCreative_GdCpmAudioCreative | adsRowFragment_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative | adsRowFragment_GdContentPromotionAd_typedCreative_GdCpmIndoorCreative | adsRowFragment_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragment_GdContentPromotionAd_aggregatedStatusInfo {
  __typename: "GdAdAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface adsRowFragment_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
  placementPagesRequired: boolean;
  hasInactiveResources: (GdAdResources | null)[];
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragment_GdContentPromotionAd_recommendations = adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragment_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragment_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragment_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragment_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragment_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  isAimingAllowed: boolean;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  hasCallouts: boolean;
  hasSitelink: boolean;
  hasTurboGallery: boolean;
  hasTurbolanding: boolean;
  hasVideo: boolean;
  adGroup: adsRowFragment_GdContentPromotionAd_adGroup;
  body: string | null;
  access: adsRowFragment_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  turbolanding: adsRowFragment_GdContentPromotionAd_turbolanding | null;
  image: adsRowFragment_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragment_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragment_GdContentPromotionAd_typedCreative | null;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: adsRowFragment_GdContentPromotionAd_aggregatedStatusInfo | null;
  status: adsRowFragment_GdContentPromotionAd_status;
  recommendations: adsRowFragment_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragment_GdContentPromotionAd_stats;
  goalStats: adsRowFragment_GdContentPromotionAd_goalStats[] | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragment_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionId: GraphQlLong;
  contentPromotionUrl: string;
  contentPromotionType: GdContentPromotionType;
  contentPromotionVisitUrl: string | null;
  contentPromotionPreviewUrl: string | null;
}

export type adsRowFragment = adsRowFragment_GdCPCVideoAd | adsRowFragment_GdTextAd | adsRowFragment_GdInternalAd | adsRowFragment_GdCPMOutdoorBannerAd | adsRowFragment_GdContentPromotionAd;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: showConditionsRowFragment
// ====================================================

export interface showConditionsRowFragment_GdKeyword_aggregatedStatusInfo {
  __typename: "GdKeywordAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface showConditionsRowFragment_GdKeyword_status {
  __typename: "GdShowConditionStatus";
  suspended: boolean;
  primaryStatus: GdShowConditionPrimaryStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign = showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd = showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_access;
  mainAd: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd = showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_access;
  mainAd: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd = showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_access;
  mainAd: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd = showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign;
  access: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_access;
  mainAd: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type showConditionsRowFragment_GdKeyword_adGroup = showConditionsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup | showConditionsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup | showConditionsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup | showConditionsRowFragment_GdKeyword_adGroup_GdSmartAdGroup;

export interface showConditionsRowFragment_GdKeyword_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_typedCreative = showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations = showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_image | null;
  bannerImage: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_typedCreative | null;
  status: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_status;
  goalStats: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_typedCreative = showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations = showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_image | null;
  bannerImage: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_typedCreative | null;
  status: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_status;
  goalStats: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type showConditionsRowFragment_GdKeyword_mainAd = showConditionsRowFragment_GdKeyword_mainAd_GdCPCVideoAd | showConditionsRowFragment_GdKeyword_mainAd_GdContentPromotionAd;

export interface showConditionsRowFragment_GdKeyword_pokazometerData_allCostsAndClicks {
  __typename: "GdPokazometerCostsAndClicksItem";
  clicks: number;
  price: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_pokazometerData_priceForCoverage {
  __typename: "GdPokazometerPriceForCoverageItem";
  coverage: number;
  price: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdKeyword_pokazometerData {
  __typename: "GdPokazometerData";
  allCostsAndClicks: showConditionsRowFragment_GdKeyword_pokazometerData_allCostsAndClicks[];
  priceForCoverage: showConditionsRowFragment_GdKeyword_pokazometerData_priceForCoverage[];
  maxShows: number | null;
}

export interface showConditionsRowFragment_GdKeyword_auctionData_auctionDataItems {
  __typename: "GdAuctionDataItem";
  bid: GraphQlBigDecimal;
  amnestyPrice: GraphQlBigDecimal;
  trafficVolume: GraphQlLong;
  showInTable: boolean | null;
}

export interface showConditionsRowFragment_GdKeyword_auctionData {
  __typename: "GdAuctionData";
  auctionDataItems: showConditionsRowFragment_GdKeyword_auctionData_auctionDataItems[];
}

export interface showConditionsRowFragment_GdKeyword_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdKeyword_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdKeyword {
  __typename: "GdKeyword";
  id: GraphQlLong;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: showConditionsRowFragment_GdKeyword_aggregatedStatusInfo | null;
  status: showConditionsRowFragment_GdKeyword_status;
  adGroup: showConditionsRowFragment_GdKeyword_adGroup;
  access: showConditionsRowFragment_GdKeyword_access;
  adsInAdGroupCount: number;
  mainAd: showConditionsRowFragment_GdKeyword_mainAd | null;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  index: number;
  type: GdShowConditionType;
  priceContext: GraphQlBigDecimal | null;
  weightedCtr: GraphQlBigDecimal;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  showsForecast: GraphQlLong | null;
  price: GraphQlBigDecimal | null;
  usePhraseTrafaretAuction: boolean;
  minusKeywords: string[];
  pokazometerData: showConditionsRowFragment_GdKeyword_pokazometerData | null;
  keyword: string;
  auctionData: showConditionsRowFragment_GdKeyword_auctionData | null;
  stats: showConditionsRowFragment_GdKeyword_stats;
  goalStats: showConditionsRowFragment_GdKeyword_goalStats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_aggregatedStatusInfo {
  __typename: "GdKeywordAggregatedStatusInfo";
  status: GdSelfStatusEnum;
  reasons: (GdSelfStatusReason | null)[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_status {
  __typename: "GdShowConditionStatus";
  suspended: boolean;
  primaryStatus: GdShowConditionPrimaryStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_access;
  mainAd: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access;
  mainAd: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access;
  mainAd: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign;
  access: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_access;
  mainAd: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo;
  status: showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type showConditionsRowFragment_GdRelevanceMatch_adGroup = showConditionsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup | showConditionsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup;

export interface showConditionsRowFragment_GdRelevanceMatch_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_typedCreative = showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations = showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_image | null;
  bannerImage: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_typedCreative | null;
  status: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_status;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_typedCreative = showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations = showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_image | null;
  bannerImage: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_typedCreative | null;
  status: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_status;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type showConditionsRowFragment_GdRelevanceMatch_mainAd = showConditionsRowFragment_GdRelevanceMatch_mainAd_GdCPCVideoAd | showConditionsRowFragment_GdRelevanceMatch_mainAd_GdContentPromotionAd;

export interface showConditionsRowFragment_GdRelevanceMatch_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface showConditionsRowFragment_GdRelevanceMatch_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface showConditionsRowFragment_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
  id: GraphQlLong;
  aggregatedStatus: string | null;
  aggregatedStatusInfo: showConditionsRowFragment_GdRelevanceMatch_aggregatedStatusInfo | null;
  status: showConditionsRowFragment_GdRelevanceMatch_status;
  adGroup: showConditionsRowFragment_GdRelevanceMatch_adGroup;
  access: showConditionsRowFragment_GdRelevanceMatch_access;
  adsInAdGroupCount: number;
  mainAd: showConditionsRowFragment_GdRelevanceMatch_mainAd | null;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  index: number;
  type: GdShowConditionType;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  price: GraphQlBigDecimal | null;
  priceContext: GraphQlBigDecimal | null;
  stats: showConditionsRowFragment_GdRelevanceMatch_stats;
  goalStats: showConditionsRowFragment_GdRelevanceMatch_goalStats[] | null;
}

export type showConditionsRowFragment = showConditionsRowFragment_GdKeyword | showConditionsRowFragment_GdRelevanceMatch;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: autotargetingsRowFragment
// ====================================================

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign = autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd = autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_campaign;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_access;
  mainAd: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd = autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_campaign;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_access;
  mainAd: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd = autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_campaign;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_access;
  mainAd: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd = autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_campaign;
  access: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_access;
  mainAd: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type autotargetingsRowFragment_GdKeyword_adGroup = autotargetingsRowFragment_GdKeyword_adGroup_GdContentPromotionAdGroup | autotargetingsRowFragment_GdKeyword_adGroup_GdDynamicAdGroup | autotargetingsRowFragment_GdKeyword_adGroup_GdMobileContentAdGroup | autotargetingsRowFragment_GdKeyword_adGroup_GdSmartAdGroup;

export interface autotargetingsRowFragment_GdKeyword_status {
  __typename: "GdShowConditionStatus";
  primaryStatus: GdShowConditionPrimaryStatus;
  deleted: boolean;
  suspended: boolean;
  statusModerate: GdShowConditionStatusModerate;
}

export interface autotargetingsRowFragment_GdKeyword_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdKeyword_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdKeyword {
  __typename: "GdKeyword";
  id: GraphQlLong;
  adGroupId: GraphQlLong;
  adGroup: autotargetingsRowFragment_GdKeyword_adGroup;
  status: autotargetingsRowFragment_GdKeyword_status;
  access: autotargetingsRowFragment_GdKeyword_access;
  stats: autotargetingsRowFragment_GdKeyword_stats;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_campaign;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_access;
  mainAd: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_campaign;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_access;
  mainAd: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_campaign;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_access;
  mainAd: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_campaign;
  access: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_access;
  mainAd: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_regionsInfo;
  status: autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type autotargetingsRowFragment_GdRelevanceMatch_adGroup = autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdContentPromotionAdGroup | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdDynamicAdGroup | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdMobileContentAdGroup | autotargetingsRowFragment_GdRelevanceMatch_adGroup_GdSmartAdGroup;

export interface autotargetingsRowFragment_GdRelevanceMatch_status {
  __typename: "GdShowConditionStatus";
  primaryStatus: GdShowConditionPrimaryStatus;
  deleted: boolean;
  suspended: boolean;
  statusModerate: GdShowConditionStatusModerate;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_access {
  __typename: "GdShowConditionAccess";
  canEdit: boolean;
}

export interface autotargetingsRowFragment_GdRelevanceMatch_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface autotargetingsRowFragment_GdRelevanceMatch {
  __typename: "GdRelevanceMatch";
  id: GraphQlLong;
  adGroupId: GraphQlLong;
  price: GraphQlBigDecimal | null;
  autobudgetPriority: GdShowConditionAutobudgetPriority | null;
  adGroup: autotargetingsRowFragment_GdRelevanceMatch_adGroup;
  status: autotargetingsRowFragment_GdRelevanceMatch_status;
  access: autotargetingsRowFragment_GdRelevanceMatch_access;
  stats: autotargetingsRowFragment_GdRelevanceMatch_stats;
}

export type autotargetingsRowFragment = autotargetingsRowFragment_GdKeyword | autotargetingsRowFragment_GdRelevanceMatch;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: retargetingsRowFragment
// ====================================================

export interface retargetingsRowFragment_access {
  __typename: "GdRetargetingAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_retargetingCondition_conditionRules_goals {
  __typename: "GdGoal";
  id: GraphQlLong;
  type: GdGoalType;
  time: number | null;
}

export interface retargetingsRowFragment_retargetingCondition_conditionRules {
  __typename: "GdRetargetingConditionRuleItem";
  type: GdRetargetingConditionRuleType;
  interestType: CryptaInterestType | null;
  goals: retargetingsRowFragment_retargetingCondition_conditionRules_goals[];
}

export interface retargetingsRowFragment_retargetingCondition {
  __typename: "GdRetargetingCondition";
  name: string;
  description: string | null;
  conditionRules: retargetingsRowFragment_retargetingCondition_conditionRules[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign = retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd = retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface retargetingsRowFragment_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_campaign;
  access: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_access;
  mainAd: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: retargetingsRowFragment_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign = retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd = retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface retargetingsRowFragment_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: retargetingsRowFragment_adGroup_GdDynamicAdGroup_campaign;
  access: retargetingsRowFragment_adGroup_GdDynamicAdGroup_access;
  mainAd: retargetingsRowFragment_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: retargetingsRowFragment_adGroup_GdDynamicAdGroup_regionsInfo;
  status: retargetingsRowFragment_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd = retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface retargetingsRowFragment_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_campaign;
  access: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_access;
  mainAd: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: retargetingsRowFragment_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign = retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd = retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface retargetingsRowFragment_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: retargetingsRowFragment_adGroup_GdSmartAdGroup_campaign;
  access: retargetingsRowFragment_adGroup_GdSmartAdGroup_access;
  mainAd: retargetingsRowFragment_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: retargetingsRowFragment_adGroup_GdSmartAdGroup_regionsInfo;
  status: retargetingsRowFragment_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type retargetingsRowFragment_adGroup = retargetingsRowFragment_adGroup_GdContentPromotionAdGroup | retargetingsRowFragment_adGroup_GdDynamicAdGroup | retargetingsRowFragment_adGroup_GdMobileContentAdGroup | retargetingsRowFragment_adGroup_GdSmartAdGroup;

export interface retargetingsRowFragment_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface retargetingsRowFragment {
  __typename: "GdRetargeting";
  access: retargetingsRowFragment_access;
  retargetingId: GraphQlLong;
  isSuspended: boolean;
  priceContext: GraphQlBigDecimal;
  retargetingCondition: retargetingsRowFragment_retargetingCondition | null;
  adGroup: retargetingsRowFragment_adGroup;
  stats: retargetingsRowFragment_stats;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adsPreviewRowFragment
// ====================================================

export interface adsPreviewRowFragment_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign;
  access: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsPreviewRowFragment_GdCPCVideoAd_adGroup = adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdDynamicAdGroup | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdMobileContentAdGroup | adsPreviewRowFragment_GdCPCVideoAd_adGroup_GdSmartAdGroup;

export interface adsPreviewRowFragment_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdCPCVideoAd_typedCreative = adsPreviewRowFragment_GdCPCVideoAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  domain: string | null;
  dynamicDisclaimer: string | null;
  linkTail: string | null;
  type: GdAdType;
  href: string | null;
  access: adsPreviewRowFragment_GdCPCVideoAd_access;
  status: adsPreviewRowFragment_GdCPCVideoAd_status;
  adGroup: adsPreviewRowFragment_GdCPCVideoAd_adGroup;
  image: adsPreviewRowFragment_GdCPCVideoAd_image | null;
  bannerImage: adsPreviewRowFragment_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdCPCVideoAd_typedCreative | null;
  sitelinks: adsPreviewRowFragment_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign;
  access: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsPreviewRowFragment_GdContentPromotionAd_adGroup = adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdDynamicAdGroup | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdMobileContentAdGroup | adsPreviewRowFragment_GdContentPromotionAd_adGroup_GdSmartAdGroup;

export interface adsPreviewRowFragment_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_image_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsPreviewRowFragment_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsPreviewRowFragment_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsPreviewRowFragment_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsPreviewRowFragment_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsPreviewRowFragment_GdContentPromotionAd_typedCreative = adsPreviewRowFragment_GdContentPromotionAd_typedCreative_GdSmartCreative | adsPreviewRowFragment_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsPreviewRowFragment_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsPreviewRowFragment_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  domain: string | null;
  dynamicDisclaimer: string | null;
  linkTail: string | null;
  type: GdAdType;
  href: string | null;
  access: adsPreviewRowFragment_GdContentPromotionAd_access;
  status: adsPreviewRowFragment_GdContentPromotionAd_status;
  adGroup: adsPreviewRowFragment_GdContentPromotionAd_adGroup;
  image: adsPreviewRowFragment_GdContentPromotionAd_image | null;
  bannerImage: adsPreviewRowFragment_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsPreviewRowFragment_GdContentPromotionAd_typedCreative | null;
  sitelinks: adsPreviewRowFragment_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionUrl: string;
  contentPromotionType: GdContentPromotionType;
  contentPromotionVisitUrl: string | null;
  contentPromotionPreviewUrl: string | null;
}

export type adsPreviewRowFragment = adsPreviewRowFragment_GdCPCVideoAd | adsPreviewRowFragment_GdContentPromotionAd;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adConstantsFragment
// ====================================================

export interface adConstantsFragment {
  __typename: "GdDirectConstantsAdValidationData";
  maxLengthTitle: number;
  maxLengthTitleWord: number;
  maxLengthTitleExtension: number;
  maxLengthBody: number;
  maxLengthBodyWord: number;
  narrowSymbols: string;
  maxNumberOfNarrowCharacters: number;
  allowAdLetters: string;
  maxLengthHref: number;
  maxLengthTurboGalleryHref: number;
  maxLengthDisplayHref: number;
  allowAdDisplayHrefLetters: string;
  aggregationDomains: string[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: calloutsConstantsFragment
// ====================================================

export interface calloutsConstantsFragment {
  __typename: "GdDirectConstantsCalloutValidationData";
  calloutLettersAllowed: string;
  calloutTextMaxLength: number;
  calloutsOnClientMaxCount: number;
  calloutsOnClientMaxCountWithDeleted: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: sitelinkConstantsFragment
// ====================================================

export interface sitelinkConstantsFragment {
  __typename: "GdDirectConstantsSitelinkValidationData";
  allowLetters: string;
  maxDescriptionLength: number;
  maxHrefLength: number;
  maxTitleLength: number;
  sitelinkMaxCount: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: calloutFragment
// ====================================================

export interface calloutFragment {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: imageFragment
// ====================================================

export interface imageFragment_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface imageFragment_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface imageFragment_formats {
  __typename: "GdImageFormat";
  imageSize: imageFragment_formats_imageSize;
  path: string;
  smartCenters: imageFragment_formats_smartCenters[] | null;
}

export interface imageFragment_imageSize {
  __typename: "GdImageSize";
  width: number;
  height: number;
}

export interface imageFragment {
  __typename: "GdImage";
  avatarsHost: GdAdImageAvatarsHost;
  createTime: GraphQlLocalDateTime;
  imageHash: string;
  mdsGroupId: GraphQlLong | null;
  name: string | null;
  namespace: GdAdImageNamespace;
  type: GdAdImageType;
  formats: imageFragment_formats[] | null;
  imageSize: imageFragment_imageSize;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adsRowFragmentForEdit
// ====================================================

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_adGroup = adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdContentPromotionAdGroup | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdDynamicAdGroup | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdMobileContentAdGroup | adsRowFragmentForEdit_GdCPCVideoAd_adGroup_GdSmartAdGroup;

export interface adsRowFragmentForEdit_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmGeoproductCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdVideoAdditionCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmAudioCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdHtml5Creative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmOutdoorCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmIndoorCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpcVideoCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCpmVideoCreative | adsRowFragmentForEdit_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: adsRowFragmentForEdit_GdCPCVideoAd_sitelinks_turbolanding | null;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: adsRowFragmentForEdit_GdCPCVideoAd_adGroup;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: adsRowFragmentForEdit_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPCVideoAd_bannerImage | null;
  callouts: adsRowFragmentForEdit_GdCPCVideoAd_callouts[] | null;
  typedCreative: adsRowFragmentForEdit_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPCVideoAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: adsRowFragmentForEdit_GdCPCVideoAd_sitelinks[] | null;
  turbolanding: adsRowFragmentForEdit_GdCPCVideoAd_turbolanding | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign = adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd = adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd = adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd = adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd = adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragmentForEdit_GdTextAd_adGroup = adsRowFragmentForEdit_GdTextAd_adGroup_GdContentPromotionAdGroup | adsRowFragmentForEdit_GdTextAd_adGroup_GdDynamicAdGroup | adsRowFragmentForEdit_GdTextAd_adGroup_GdMobileContentAdGroup | adsRowFragmentForEdit_GdTextAd_adGroup_GdSmartAdGroup;

export interface adsRowFragmentForEdit_GdTextAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface adsRowFragmentForEdit_GdTextAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdTextAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdTextAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdTextAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdTextAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdTextAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdTextAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: adsRowFragmentForEdit_GdTextAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdTextAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdTextAd_typedCreative = adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmGeoproductCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdVideoAdditionCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmAudioCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdHtml5Creative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmOutdoorCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmIndoorCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpcVideoCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdCpmVideoCreative | adsRowFragmentForEdit_GdTextAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdTextAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdTextAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface adsRowFragmentForEdit_GdTextAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: adsRowFragmentForEdit_GdTextAd_sitelinks_turbolanding | null;
}

export interface adsRowFragmentForEdit_GdTextAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface adsRowFragmentForEdit_GdTextAd_bannerPrice {
  __typename: "GdAdPrice";
  currency: GdAdPriceCurrency | null;
  prefix: GdAdPricePrefix | null;
  price: string | null;
  priceOld: string | null;
}

export interface adsRowFragmentForEdit_GdTextAd {
  __typename: "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: adsRowFragmentForEdit_GdTextAd_adGroup;
  body: string | null;
  access: adsRowFragmentForEdit_GdTextAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: adsRowFragmentForEdit_GdTextAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdTextAd_bannerImage | null;
  callouts: adsRowFragmentForEdit_GdTextAd_callouts[] | null;
  typedCreative: adsRowFragmentForEdit_GdTextAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdTextAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: adsRowFragmentForEdit_GdTextAd_sitelinks[] | null;
  turbolanding: adsRowFragmentForEdit_GdTextAd_turbolanding | null;
  turboGalleryHref: string | null;
  bannerPrice: adsRowFragmentForEdit_GdTextAd_bannerPrice | null;
  permalinkId: GraphQlLong | null;
  permalinkAssignType: GdAdPermalinkAssignType | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_adGroup = adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdContentPromotionAdGroup | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdDynamicAdGroup | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdMobileContentAdGroup | adsRowFragmentForEdit_GdCPMBannerAd_adGroup_GdSmartAdGroup;

export interface adsRowFragmentForEdit_GdCPMBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMBannerAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMBannerAd_typedCreative = adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmGeoproductCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdVideoAdditionCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmAudioCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdHtml5Creative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmOutdoorCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmIndoorCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpcVideoCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCpmVideoCreative | adsRowFragmentForEdit_GdCPMBannerAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: adsRowFragmentForEdit_GdCPMBannerAd_sitelinks_turbolanding | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_pixels {
  __typename: "GdPixel";
  kind: GdPixelKind;
  url: string;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd_measurers {
  __typename: "GdBannerMeasurer";
  measurerSystem: GdBannerMeasurerSystem;
  params: string;
  hasIntegration: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMBannerAd {
  __typename: "GdCPMBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: adsRowFragmentForEdit_GdCPMBannerAd_adGroup;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMBannerAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: adsRowFragmentForEdit_GdCPMBannerAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMBannerAd_bannerImage | null;
  callouts: adsRowFragmentForEdit_GdCPMBannerAd_callouts[] | null;
  typedCreative: adsRowFragmentForEdit_GdCPMBannerAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMBannerAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: adsRowFragmentForEdit_GdCPMBannerAd_sitelinks[] | null;
  turbolanding: adsRowFragmentForEdit_GdCPMBannerAd_turbolanding | null;
  pixels: adsRowFragmentForEdit_GdCPMBannerAd_pixels[];
  measurers: adsRowFragmentForEdit_GdCPMBannerAd_measurers[] | null;
  tnsId: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_adGroup = adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdContentPromotionAdGroup | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdDynamicAdGroup | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdMobileContentAdGroup | adsRowFragmentForEdit_GdContentPromotionAd_adGroup_GdSmartAdGroup;

export interface adsRowFragmentForEdit_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpmGeoproductCreative | adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdVideoAdditionCreative | adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpmAudioCreative | adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdHtml5Creative | adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpmOutdoorCreative | adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpmIndoorCreative | adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpcVideoCreative | adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCpmVideoCreative | adsRowFragmentForEdit_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: adsRowFragmentForEdit_GdContentPromotionAd_sitelinks_turbolanding | null;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface adsRowFragmentForEdit_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: adsRowFragmentForEdit_GdContentPromotionAd_adGroup;
  body: string | null;
  access: adsRowFragmentForEdit_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: adsRowFragmentForEdit_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdContentPromotionAd_bannerImage | null;
  callouts: adsRowFragmentForEdit_GdContentPromotionAd_callouts[] | null;
  typedCreative: adsRowFragmentForEdit_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdContentPromotionAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: adsRowFragmentForEdit_GdContentPromotionAd_sitelinks[] | null;
  turbolanding: adsRowFragmentForEdit_GdContentPromotionAd_turbolanding | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
  contentPromotionId: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdContentPromotionAdGroup | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdDynamicAdGroup | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdMobileContentAdGroup | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup_GdSmartAdGroup;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative = adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmGeoproductCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdVideoAdditionCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmAudioCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdHtml5Creative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmOutdoorCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmIndoorCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpcVideoCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCpmVideoCreative | adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_sitelinks_turbolanding | null;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_pixels {
  __typename: "GdPixel";
  kind: GdPixelKind;
  url: string;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd_placementPages {
  __typename: "GdPlacementPageModerationResult";
  bannerId: GraphQlLong;
  comment: string | null;
  createTime: GraphQlLocalDateTime;
  id: GraphQlLong;
  pageId: GraphQlLong;
  statusModerate: StatusModerateBannerPage;
  statusModerateOperator: StatusModerateOperator;
  version: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMOutdoorBannerAd {
  __typename: "GdCPMOutdoorBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_adGroup;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_bannerImage | null;
  callouts: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_callouts[] | null;
  typedCreative: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_sitelinks[] | null;
  turbolanding: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_turbolanding | null;
  pixels: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_pixels[];
  placementPages: adsRowFragmentForEdit_GdCPMOutdoorBannerAd_placementPages[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdTextAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup {
  __typename: "GdDynamicAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  mainDomain: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup {
  __typename: "GdMobileContentAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  storeHref: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  hasAds: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign {
  __typename: "GdTextCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign_commonVcard | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status_timeTargetStatus;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyAvgClick | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdCampaignStrategyManual | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_startTime;
  endTime: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes_endTime;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address_pointOnMap | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard {
  __typename: "GdCampaignVcard";
  id: GraphQlLong | null;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_instantMessenger | null;
  workTimes: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_workTimes[];
  phone: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_phone;
  address: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard_address;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign {
  __typename: "GdDynamicCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_status;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_access;
  strategy: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_strategy;
  hasAds: boolean;
  lastChangedVcardId: GraphQlLong | null;
  commonVcard: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign_commonVcard | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdContentPromotionCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdTextCampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign_GdDynamicCampaign;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats {
  __typename: "GdGoalStats";
  conversionRate: GraphQlBigDecimal;
  costPerAction: GraphQlBigDecimal;
  goalId: GraphQlLong;
  goals: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite {
  __typename: "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite_graph;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign {
  __typename: "GdRecommendationKpiRemovePagesFromBlackListOfACampaign";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign_graph;
  pageNames: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
  formats: string[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList {
  __typename: "GdRecommendationPlacementRatioInfo";
  creativesCount: number;
  videoFormat: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList_videoFormat;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_videoFormats[] | null;
  ratioInfoList: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup_ratioInfoList[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph_points[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats {
  __typename: "GdOutdoorVideoFormat";
  width: number;
  height: number;
  duration: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner {
  __typename: "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiUploadAppropriateCreatives";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_graph;
  videoFormats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner_videoFormats[] | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddTurboWebSite | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackListOfACampaign | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForAdGroup | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiChooseAppropriatePlacementsForBanner;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_keys[];
  kpi: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi_kpi;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithoutKpi | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations_GdRecommendationWithKpi;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats {
  __typename: "GdEntityStats";
  ctr: GraphQlBigDecimal | null;
  cpmPrice: GraphQlBigDecimal | null;
  profitability: GraphQlBigDecimal | null;
  cost: GraphQlBigDecimal | null;
  avgClickPosition: GraphQlBigDecimal | null;
  conversionRate: GraphQlBigDecimal | null;
  bounceRate: GraphQlBigDecimal | null;
  revenue: GraphQlBigDecimal | null;
  shows: GraphQlLong | null;
  avgClickCost: GraphQlBigDecimal | null;
  avgShowPosition: GraphQlBigDecimal | null;
  avgDepth: GraphQlBigDecimal | null;
  clicks: GraphQlLong | null;
  avgGoalCost: GraphQlBigDecimal | null;
  goals: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_status;
  goalStats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_goalStats[] | null;
  recommendations: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_recommendations[] | null;
  stats: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_stats;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
  contentPromotionVisitUrl: string | null;
  contentPromotionUrl: string;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdCPCVideoAd | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  campaign: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_campaign;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_access;
  mainAd: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_mainAd | null;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_regionsInfo;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup_status;
  adsCount: number;
  type: GdAdGroupType;
  feedId: GraphQlLong;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup = adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdContentPromotionAdGroup | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdDynamicAdGroup | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdMobileContentAdGroup | adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup_GdSmartAdGroup;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_image_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_image_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_image_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_formats_smartCenters[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage_formats[] | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_callouts {
  __typename: "GdCallout";
  clientId: GraphQlLong;
  id: GraphQlLong;
  flags: (string | null)[] | null;
  text: string;
  statusModerate: GdCalloutStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmGeoproductCreative {
  __typename: "GdCpmGeoproductCreative" | "GdOverlayCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdVideoAdditionCreative {
  __typename: "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmAudioCreative {
  __typename: "GdCpmAudioCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isImage: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats {
  __typename: "GdVideoFormat";
  height: number;
  width: number;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData {
  __typename: "GdAdditionalData";
  formats: adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData_formats[];
  duration: GraphQlBigDecimal | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative {
  __typename: "GdCpmOutdoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
  duration: GraphQlLong;
  additionalData: adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative_additionalData;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmIndoorCreative {
  __typename: "GdCpmIndoorCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdSmartCreative_layout {
  __typename: "GdCreativeLayout";
  name: string | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  layout: adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdSmartCreative_layout | null;
  groupName: string | null;
  groupId: GraphQlLong | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpcVideoCreative {
  __typename: "GdCpcVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmVideoCreative {
  __typename: "GdCpmVideoCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  livePreviewUrl: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  width: GraphQlLong | null;
  previewUrl: string;
  isAdaptive: boolean | null;
}

export type adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative = adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmGeoproductCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdVideoAdditionCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmAudioCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdHtml5Creative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmOutdoorCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmIndoorCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdSmartCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpcVideoCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCpmVideoCreative | adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative_GdCanvasCreative;

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_sitelinks_turbolanding {
  __typename: "GdSitelinkTurbolanding";
  href: string;
  id: GraphQlLong;
  name: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_sitelinks {
  __typename: "GdSitelink";
  description: string | null;
  href: string | null;
  title: string;
  turbolanding: adsRowFragmentForEdit_GdCPMAudioBannerAd_sitelinks_turbolanding | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_turbolanding {
  __typename: "GdBannerTurbolanding";
  href: string;
  hrefParams: string | null;
  id: GraphQlLong;
  name: string;
  statusModerate: GdBannerTurbolandingStatusModerate;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_pixels {
  __typename: "GdPixel";
  kind: GdPixelKind;
  url: string;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd_measurers {
  __typename: "GdBannerMeasurer";
  measurerSystem: GdBannerMeasurerSystem;
  params: string;
  hasIntegration: boolean | null;
}

export interface adsRowFragmentForEdit_GdCPMAudioBannerAd {
  __typename: "GdCPMAudioBannerAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  exportId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  adGroup: adsRowFragmentForEdit_GdCPMAudioBannerAd_adGroup;
  body: string | null;
  access: adsRowFragmentForEdit_GdCPMAudioBannerAd_access;
  domain: string | null;
  href: string | null;
  linkTail: string | null;
  vcardId: GraphQlLong | null;
  isMobile: boolean;
  dynamicDisclaimer: string | null;
  reverseDomain: string | null;
  optsGeoFlag: boolean | null;
  optsNoDisplayHref: boolean | null;
  phoneFlag: boolean | null;
  flags: string[] | null;
  image: adsRowFragmentForEdit_GdCPMAudioBannerAd_image | null;
  bannerImage: adsRowFragmentForEdit_GdCPMAudioBannerAd_bannerImage | null;
  callouts: adsRowFragmentForEdit_GdCPMAudioBannerAd_callouts[] | null;
  typedCreative: adsRowFragmentForEdit_GdCPMAudioBannerAd_typedCreative | null;
  status: adsRowFragmentForEdit_GdCPMAudioBannerAd_status;
  sitelinksSetId: GraphQlLong | null;
  sitelinks: adsRowFragmentForEdit_GdCPMAudioBannerAd_sitelinks[] | null;
  turbolanding: adsRowFragmentForEdit_GdCPMAudioBannerAd_turbolanding | null;
  pixels: adsRowFragmentForEdit_GdCPMAudioBannerAd_pixels[];
  measurers: adsRowFragmentForEdit_GdCPMAudioBannerAd_measurers[] | null;
}

export type adsRowFragmentForEdit = adsRowFragmentForEdit_GdCPCVideoAd | adsRowFragmentForEdit_GdTextAd | adsRowFragmentForEdit_GdCPMBannerAd | adsRowFragmentForEdit_GdContentPromotionAd | adsRowFragmentForEdit_GdCPMOutdoorBannerAd | adsRowFragmentForEdit_GdCPMAudioBannerAd;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: configurationFragment
// ====================================================

export interface configurationFragment {
  __typename: "GdConfigurationConstants";
  turbolandingUnifiedApiUrl: string;
  canvasUiDomain: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adsInternalRowFragmentForEdit
// ====================================================

export interface adsInternalRowFragmentForEdit_templateVars {
  __typename: "GdTemplateVariable";
  templateResourceId: GraphQlLong;
  value: string | null;
}

export interface adsInternalRowFragmentForEdit_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
  canBeDeleted: boolean | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_status_timeTargetStatus;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_strategy = adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyAvgClick | adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_strategy_GdCampaignStrategyManual | adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign {
  __typename: "GdInternalFreeCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  status: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_status;
  adsCount: number;
  access: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_access;
  strategy: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign_strategy;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_status_timeTargetStatus {
  __typename: "TimeTargetStatusInfo";
  activationTime: GraphQlOffsetDateTime | null;
  status: TimeTargetStatus | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_status {
  __typename: "GdCampaignStatus";
  over: boolean;
  draft: boolean;
  activating: boolean;
  primaryStatus: GdCampaignPrimaryStatus;
  primaryStatusDesc: GdCampaignPrimaryStatusDesc | null;
  needsNewPayment: boolean;
  moneyBlocked: boolean;
  timeTargetStatus: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_status_timeTargetStatus;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_access {
  __typename: "GdCampaignAccess";
  canEdit: boolean;
  actions: GdCampaignAction[];
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeInstalls";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick_budget | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions {
  __typename: "GdStrategyOptimizeConversions";
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
  platform: GdCampaignPlatform;
  budget: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions_budget | null;
  payForConversion: boolean | null;
}

export type adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_strategy = adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyAvgClick | adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_strategy_GdCampaignStrategyManual | adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_strategy_GdStrategyOptimizeConversions;

export interface adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign {
  __typename: "GdInternalDistribCampaign";
  id: GraphQlLong;
  isAimingAllowed: boolean;
  name: string;
  type: GdCampaignType;
  currency: CurrencyCode | null;
  placeId: GraphQlLong;
  adsCount: number;
  status: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_status;
  access: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_access;
  strategy: adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign_strategy;
}

export type adsInternalRowFragmentForEdit_adGroup_campaign = adsInternalRowFragmentForEdit_adGroup_campaign_GdContentPromotionCampaign | adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalFreeCampaign | adsInternalRowFragmentForEdit_adGroup_campaign_GdInternalDistribCampaign;

export interface adsInternalRowFragmentForEdit_adGroup_access {
  __typename: "GdAdGroupAccess";
  canEdit: boolean;
}

export interface adsInternalRowFragmentForEdit_adGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adsInternalRowFragmentForEdit_adGroup_status {
  __typename: "GdAdGroupStatus";
  bsEverSynced: boolean;
  blGenerationStatus: GdGroupBlGenerationStatus | null;
  moderationStatus: GdAdGroupModerationStatus;
  primaryStatus: GdAdGroupPrimaryStatus;
  primaryStatusDesc: GdAdGroupPrimaryStatusDesc | null;
}

export interface adsInternalRowFragmentForEdit_adGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  campaign: adsInternalRowFragmentForEdit_adGroup_campaign;
  access: adsInternalRowFragmentForEdit_adGroup_access;
  id: GraphQlLong;
  minusKeywords: string[];
  name: string;
  regionsInfo: adsInternalRowFragmentForEdit_adGroup_regionsInfo;
  status: adsInternalRowFragmentForEdit_adGroup_status;
  adsCount: number;
  type: GdAdGroupType;
}

export interface adsInternalRowFragmentForEdit_images_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsInternalRowFragmentForEdit_images_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adsInternalRowFragmentForEdit_images_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adsInternalRowFragmentForEdit_images_image_formats {
  __typename: "GdImageFormat";
  imageSize: adsInternalRowFragmentForEdit_images_image_formats_imageSize;
  path: string;
  smartCenters: adsInternalRowFragmentForEdit_images_image_formats_smartCenters[] | null;
}

export interface adsInternalRowFragmentForEdit_images_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adsInternalRowFragmentForEdit_images_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adsInternalRowFragmentForEdit_images_image_formats[] | null;
}

export interface adsInternalRowFragmentForEdit_images {
  __typename: "GdInternalAdImageResource";
  image: adsInternalRowFragmentForEdit_images_image;
  templateResourceId: string;
}

export interface adsInternalRowFragmentForEdit_status {
  __typename: "GdAdStatus";
  primaryStatus: GdAdPrimaryStatus;
  previousVersionShown: boolean;
  rejectedOnModeration: boolean;
}

export interface adsInternalRowFragmentForEdit {
  __typename: "GdInternalAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  description: string | null;
  templateId: GraphQlLong;
  templateVars: adsInternalRowFragmentForEdit_templateVars[];
  access: adsInternalRowFragmentForEdit_access;
  adGroup: adsInternalRowFragmentForEdit_adGroup;
  images: adsInternalRowFragmentForEdit_images[];
  status: adsInternalRowFragmentForEdit_status;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PointFragmet
// ====================================================

export interface PointFragmet {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: VCardDataFragment
// ====================================================

export interface VCardDataFragment_instantMessenger {
  __typename: "GdInstantMessenger";
  type: GdInstantMessengerType;
  login: string;
}

export interface VCardDataFragment_workTimes_startTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface VCardDataFragment_workTimes_endTime {
  __typename: "GdTime";
  hour: number;
  minute: number;
}

export interface VCardDataFragment_workTimes {
  __typename: "GdWorkTime";
  daysOfWeek: number[];
  startTime: VCardDataFragment_workTimes_startTime;
  endTime: VCardDataFragment_workTimes_endTime;
}

export interface VCardDataFragment_phone {
  __typename: "GdPhone";
  countryCode: string;
  cityCode: string;
  phoneNumber: string;
  extension: string | null;
}

export interface VCardDataFragment_address_pointOnMap {
  __typename: "GdPointOnMap";
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
}

export interface VCardDataFragment_address {
  __typename: "GdAddress";
  geoId: number;
  country: string;
  city: string;
  street: string | null;
  houseWithBuilding: string | null;
  apartment: string | null;
  metroStationId: number | null;
  metroStationName: string | null;
  pointPrecision: GdPointPrecision | null;
  pointOnMap: VCardDataFragment_address_pointOnMap | null;
}

export interface VCardDataFragment {
  __typename: "GdVcard";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  companyName: string;
  contactPerson: string | null;
  extraMessage: string | null;
  email: string | null;
  ogrn: string | null;
  instantMessenger: VCardDataFragment_instantMessenger | null;
  workTimes: VCardDataFragment_workTimes[];
  phone: VCardDataFragment_phone;
  address: VCardDataFragment_address;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MetroStationsFragment
// ====================================================

export interface MetroStationsFragment_rowset {
  __typename: "GdMetroStation";
  geoRegionId: number;
  metroStationId: number;
  metroStationName: string;
}

export interface MetroStationsFragment {
  __typename: "GdMetroStationsData";
  rowset: MetroStationsFragment_rowset[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: adGroupsRowFragmentForEdit
// ====================================================

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative = adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative = adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd = adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdCPCVideoAd | adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd_GdContentPromotionAd;

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign = adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdContentPromotionCampaign | adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign_GdPriceCampaign;

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments = adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers_adjustments[];
}

export interface adGroupsRowFragmentForEdit_GdContentPromotionAdGroup {
  __typename: "GdContentPromotionAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdTextAdGroup";
  access: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_access;
  regionsInfo: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_regionsInfo;
  mainAd: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_mainAd | null;
  campaign: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: adGroupsRowFragmentForEdit_GdContentPromotionAdGroup_bidModifiers[] | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative = adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative = adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd = adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdCPCVideoAd | adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd_GdContentPromotionAd;

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign = adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdContentPromotionCampaign | adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign_GdPriceCampaign;

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments = adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers_adjustments[];
}

export interface adGroupsRowFragmentForEdit_GdSmartAdGroup {
  __typename: "GdSmartAdGroup";
  access: adGroupsRowFragmentForEdit_GdSmartAdGroup_access;
  regionsInfo: adGroupsRowFragmentForEdit_GdSmartAdGroup_regionsInfo;
  mainAd: adGroupsRowFragmentForEdit_GdSmartAdGroup_mainAd | null;
  campaign: adGroupsRowFragmentForEdit_GdSmartAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: adGroupsRowFragmentForEdit_GdSmartAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  feedId: GraphQlLong;
  fieldToUseAsBody: string | null;
  fieldToUseAsName: string | null;
  trackingParams: string | null;
  bidModifiers: adGroupsRowFragmentForEdit_GdSmartAdGroup_bidModifiers[] | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_typedCreative = adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_typedCreative = adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd = adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdCPCVideoAd | adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd_GdContentPromotionAd;

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign = adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdContentPromotionCampaign | adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign_GdPriceCampaign;

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments = adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers_adjustments[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingInternalNetwork {
  __typename: "GdAdditionalTargetingInternalNetwork";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsBrowser {
  __typename: "GdAdditionalTargetingIsBrowser";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsTablet {
  __typename: "GdAdditionalTargetingIsTablet";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsMobile {
  __typename: "GdAdditionalTargetingIsMobile";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsTouch {
  __typename: "GdAdditionalTargetingIsTouch";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingUserAgents {
  __typename: "GdAdditionalTargetingUserAgents";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsNames_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsNames {
  __typename: "GdAdditionalTargetingOsNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsNames_value[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsFamilies_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
  minVersion: string | null;
  maxVersion: string | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsFamilies {
  __typename: "GdAdditionalTargetingOsFamilies";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsFamilies_value[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserNames_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
  minVersion: string | null;
  maxVersion: string | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserNames {
  __typename: "GdAdditionalTargetingBrowserNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserNames_value[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserEngines_value {
  __typename: "GdAdditionalTargetingVersioned";
  targetingValueEntryId: GraphQlLong;
  minVersion: string | null;
  maxVersion: string | null;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserEngines {
  __typename: "GdAdditionalTargetingBrowserEngines";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserEngines_value[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingDeviceVendors_value {
  __typename: "GdAdditionalTargetingUatraits";
  targetingValueEntryId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingDeviceVendors {
  __typename: "GdAdditionalTargetingDeviceVendors";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingDeviceVendors_value[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingDeviceNames {
  __typename: "GdAdditionalTargetingDeviceNames";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingInterfaceLangs {
  __typename: "GdAdditionalTargetingInterfaceLangs";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: InterfaceLang[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingQueryReferers {
  __typename: "GdAdditionalTargetingQueryReferers";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingYandexUids {
  __typename: "GdAdditionalTargetingYandexUids";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingShowDates {
  __typename: "GdAdditionalTargetingShowDates";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLocalDate[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingClidTypes {
  __typename: "GdAdditionalTargetingClidTypes";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingClids {
  __typename: "GdAdditionalTargetingClids";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingDesktopInstalledApps {
  __typename: "GdAdditionalTargetingDesktopInstalledApps";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingMobileInstalledApps {
  __typename: "GdAdditionalTargetingMobileInstalledApps";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingQueryOptions {
  __typename: "GdAdditionalTargetingQueryOptions";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingTestIds {
  __typename: "GdAdditionalTargetingTestIds";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: GraphQlLong[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingYsCookies {
  __typename: "GdAdditionalTargetingYsCookies";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
  value: string[];
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsYandexPlus {
  __typename: "GdAdditionalTargetingIsYandexPlus";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsVirused {
  __typename: "GdAdditionalTargetingIsVirused";
  targetingMode: GdAdditionalTargetingMode;
  joinType: GdAdditionalTargetingJoinType;
}

export interface adGroupsRowFragmentForEdit_GdInternalAdGroup {
  __typename: "GdInternalAdGroup";
  access: adGroupsRowFragmentForEdit_GdInternalAdGroup_access;
  regionsInfo: adGroupsRowFragmentForEdit_GdInternalAdGroup_regionsInfo;
  mainAd: adGroupsRowFragmentForEdit_GdInternalAdGroup_mainAd | null;
  campaign: adGroupsRowFragmentForEdit_GdInternalAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: adGroupsRowFragmentForEdit_GdInternalAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: adGroupsRowFragmentForEdit_GdInternalAdGroup_bidModifiers[] | null;
  level: GraphQlLong | null;
  targetingInternalNetwork: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingInternalNetwork | null;
  targetingIsBrowser: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsBrowser | null;
  targetingIsTablet: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsTablet | null;
  targetingIsMobile: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsMobile | null;
  targetingIsTouch: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsTouch | null;
  targetingUserAgents: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingUserAgents | null;
  targetingOsNames: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsNames | null;
  targetingOsFamilies: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingOsFamilies | null;
  targetingBrowserNames: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserNames | null;
  targetingBrowserEngines: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingBrowserEngines | null;
  targetingDeviceVendors: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingDeviceVendors | null;
  targetingDeviceNames: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingDeviceNames | null;
  targetingInterfaceLangs: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingInterfaceLangs | null;
  targetingQueryReferers: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingQueryReferers | null;
  targetingYandexUids: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingYandexUids | null;
  targetingShowDates: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingShowDates | null;
  targetingClidTypes: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingClidTypes | null;
  targetingClids: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingClids | null;
  targetingDesktopInstalledApps: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingDesktopInstalledApps | null;
  targetingMobileInstalledApps: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingMobileInstalledApps | null;
  targetingQueryOptions: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingQueryOptions | null;
  targetingTestIds: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingTestIds | null;
  targetingYsCookies: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingYsCookies | null;
  targetingIsYandexPlus: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsYandexPlus | null;
  targetingIsVirused: adGroupsRowFragmentForEdit_GdInternalAdGroup_targetingIsVirused | null;
  startTime: GraphQlLocalDateTime | null;
  finishTime: GraphQlLocalDateTime | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_typedCreative = adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_typedCreative = adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd = adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdCPCVideoAd | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd_GdContentPromotionAd;

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign = adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdContentPromotionCampaign | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign_GdPriceCampaign;

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments = adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers_adjustments[];
}

export interface adGroupsRowFragmentForEdit_GdCpmVideoAdGroup {
  __typename: "GdCpmVideoAdGroup";
  access: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_access;
  regionsInfo: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_regionsInfo;
  mainAd: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_mainAd | null;
  campaign: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: adGroupsRowFragmentForEdit_GdCpmVideoAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_typedCreative = adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_typedCreative = adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd = adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdCPCVideoAd | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd_GdContentPromotionAd;

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign = adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdContentPromotionCampaign | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign_GdPriceCampaign;

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments = adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers_adjustments[];
}

export interface adGroupsRowFragmentForEdit_GdCpmAudioAdGroup {
  __typename: "GdCpmAudioAdGroup";
  access: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_access;
  regionsInfo: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_regionsInfo;
  mainAd: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_mainAd | null;
  campaign: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: adGroupsRowFragmentForEdit_GdCpmAudioAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_typedCreative = adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_typedCreative = adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd = adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdCPCVideoAd | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd_GdContentPromotionAd;

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign = adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdContentPromotionCampaign | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign_GdPriceCampaign;

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments = adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers_adjustments[];
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_pageBlocks {
  __typename: "GdAdGroupPageBlock";
  impId: GraphQlLong;
  pageId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup {
  __typename: "GdCpmOutdoorAdGroup";
  access: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_access;
  regionsInfo: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_regionsInfo;
  mainAd: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_mainAd | null;
  campaign: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
  pageBlocks: adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup_pageBlocks[];
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_typedCreative = adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_typedCreative = adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd = adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdCPCVideoAd | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd_GdContentPromotionAd;

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign = adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdContentPromotionCampaign | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign_GdPriceCampaign;

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments = adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers_adjustments[];
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_pageBlocks {
  __typename: "GdAdGroupPageBlock";
  impId: GraphQlLong;
  pageId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup {
  __typename: "GdCpmIndoorAdGroup";
  access: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_access;
  regionsInfo: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_regionsInfo;
  mainAd: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_mainAd | null;
  campaign: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_bidModifiers[] | null;
  videoGoals: GdVideoGoalType[];
  pageBlocks: adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup_pageBlocks[];
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_access {
  __typename: "GdAdGroupAccess";
  showGeneralPriceOnEdit: boolean;
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_regionsInfo {
  __typename: "GdAdGroupRegionsInfo";
  regionIds: number[];
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_typedCreative = adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd {
  __typename: "GdCPCVideoAd" | "GdCPMAudioBannerAd" | "GdCPMBannerAd" | "GdCPMOutdoorBannerAd" | "GdDynamicAd" | "GdImageAd" | "GdInternalAd" | "GdMcBannerAd" | "GdMobileContentAd" | "GdSmartAd" | "GdTextAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd_sitelinks[] | null;
  flags: string[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_access {
  __typename: "GdAdAccess";
  canEdit: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize {
  __typename: "GdImageSize";
  height: number;
  width: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters {
  __typename: "GdImageSmartCenter";
  height: number;
  ratio: string;
  width: number;
  x: number;
  y: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats {
  __typename: "GdImageFormat";
  imageSize: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_imageSize;
  path: string;
  smartCenters: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats_smartCenters[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage {
  __typename: "GdImage";
  mdsGroupId: GraphQlLong | null;
  namespace: GdAdImageNamespace;
  imageSize: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_imageSize;
  name: string | null;
  imageHash: string;
  formats: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage_formats[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdHtml5Creative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  previewUrl: string;
  height: GraphQlLong | null;
  width: GraphQlLong | null;
  name: string;
  isAdaptive: boolean | null;
}

export type adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_typedCreative = adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdSmartCreative | adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_typedCreative_GdCanvasCreative;

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_sitelinks {
  __typename: "GdSitelink";
  href: string | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd {
  __typename: "GdContentPromotionAd";
  id: GraphQlLong;
  campaignId: GraphQlLong;
  adGroupId: GraphQlLong;
  type: GdAdType;
  title: string | null;
  titleExtension: string | null;
  body: string | null;
  access: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_access;
  domain: string | null;
  href: string | null;
  image: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_image | null;
  bannerImage: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_bannerImage | null;
  typedCreative: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_typedCreative | null;
  linkTail: string | null;
  dynamicDisclaimer: string | null;
  sitelinks: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd_sitelinks[] | null;
  flags: string[] | null;
  contentPromotionPreviewUrl: string | null;
}

export type adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd = adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdCPCVideoAd | adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd_GdContentPromotionAd;

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdContentPromotionCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdContentPromotionCampaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdContentPromotionCampaign_strategy;
  type: GdCampaignType;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdPriceCampaign_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  platform: GdCampaignPlatform;
  strategyType: GdStrategyType;
  isAutoBudget: boolean;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdPriceCampaign_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsFixed | null;
  targetingsCustom: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdPriceCampaign_pricePackage_targetingsCustom | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdPriceCampaign {
  __typename: "GdPriceCampaign";
  id: GraphQlLong;
  name: string;
  strategy: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdPriceCampaign_strategy;
  type: GdCampaignType;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  pricePackageId: GraphQlLong | null;
  flightTargetingsSnapshot: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdPriceCampaign_flightTargetingsSnapshot | null;
  pricePackage: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdPriceCampaign_pricePackage;
}

export type adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign = adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdContentPromotionCampaign | adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign_GdPriceCampaign;

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_libraryMinusKeywordsPacks {
  __typename: "GdMinusKeywordsPackInfo";
  id: GraphQlLong;
  name: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment {
  __typename: "GdBidModifierABSegmentAdjustment" | "GdBidModifierDesktopAdjustment" | "GdBidModifierRegionalAdjustment" | "GdBidModifierSmartTgoAdjustment" | "GdBidModifierVideoAdjustment";
  id: GraphQlLong;
  percent: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment {
  __typename: "GdBidModifierRetargetingAdjustment";
  id: GraphQlLong;
  percent: number;
  accessible: boolean;
  retargetingConditionId: GraphQlLong;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment {
  __typename: "GdBidModifierDemographicsAdjustment";
  id: GraphQlLong;
  percent: number;
  age: GdAgeType | null;
  gender: GdGenderType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment {
  __typename: "GdBidModifierMobileAdjustment";
  id: GraphQlLong;
  percent: number;
  osType: GdOsType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment {
  __typename: "GdBidModifierInventoryAdjustment";
  id: GraphQlLong;
  percent: number;
  inventoryType: GdInventoryType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment {
  __typename: "GdBidModifierAdTypeAdjustment";
  id: GraphQlLong;
  percent: number;
  adType: GdAdjustmentAdType | null;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression {
  __typename: "GdBidModifierWeatherExpression";
  operation: GdOperationType;
  parameter: GdWeatherType;
  value: number;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment {
  __typename: "GdBidModifierWeatherAdjustment";
  id: GraphQlLong;
  percent: number;
  expression: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment_expression[][];
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition {
  __typename: "GdBidModifierExpressLiteral";
  operation: BidModifierExpressionOperator;
  parameter: BidModifierExpressionParameter;
  value: string;
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment {
  __typename: "GdBidModifierExpressAdjustment";
  id: GraphQlLong;
  percent: number;
  condition: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment_condition[][];
}

export type adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments = adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierABSegmentAdjustment | adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierRetargetingAdjustment | adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierDemographicsAdjustment | adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierMobileAdjustment | adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierInventoryAdjustment | adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierAdTypeAdjustment | adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierWeatherAdjustment | adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments_GdBidModifierExpressAdjustment;

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers {
  __typename: "GdBidModifierABSegment" | "GdBidModifierAdType" | "GdBidModifierDemographics" | "GdBidModifierDesktop" | "GdBidModifierExpress" | "GdBidModifierGeo" | "GdBidModifierInventory" | "GdBidModifierMobile" | "GdBidModifierRetargeting" | "GdBidModifierSmartTgo" | "GdBidModifierVideo" | "GdBidModifierWeather";
  id: GraphQlLong;
  enabled: boolean;
  type: GdBidModifierType;
  adjustments: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers_adjustments[];
}

export interface adGroupsRowFragmentForEdit_GdCpmPriceAdGroup {
  __typename: "GdCpmPriceAdGroup";
  access: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_access;
  regionsInfo: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_regionsInfo;
  mainAd: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_mainAd | null;
  campaign: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_campaign;
  id: GraphQlLong;
  name: string;
  type: GdAdGroupType;
  adsCount: number;
  availableShowConditionTypes: GdShowConditionType[];
  productRestrictionId: GraphQlLong | null;
  pageGroupTags: string[] | null;
  targetTags: string[] | null;
  libraryMinusKeywordsPacks: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_libraryMinusKeywordsPacks[];
  minusKeywords: string[];
  bidModifiers: adGroupsRowFragmentForEdit_GdCpmPriceAdGroup_bidModifiers[] | null;
  priority: GraphQlLong;
}

export type adGroupsRowFragmentForEdit = adGroupsRowFragmentForEdit_GdContentPromotionAdGroup | adGroupsRowFragmentForEdit_GdSmartAdGroup | adGroupsRowFragmentForEdit_GdInternalAdGroup | adGroupsRowFragmentForEdit_GdCpmVideoAdGroup | adGroupsRowFragmentForEdit_GdCpmAudioAdGroup | adGroupsRowFragmentForEdit_GdCpmOutdoorAdGroup | adGroupsRowFragmentForEdit_GdCpmIndoorAdGroup | adGroupsRowFragmentForEdit_GdCpmPriceAdGroup;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: feedsFragment
// ====================================================

export interface feedsFragment_rowset_categories {
  __typename: "GdFeedCategory";
  categoryId: GraphQlBigInteger;
  offerCount: GraphQlLong | null;
  parentCategoryId: GraphQlBigInteger;
  name: string;
  isDeleted: boolean;
}

export interface feedsFragment_rowset {
  __typename: "GdFeed";
  id: GraphQlLong;
  name: string;
  updateStatus: GdUpdateStatus;
  businessType: GdBusinessType;
  categories: feedsFragment_rowset_categories[];
  feedType: GdFeedType | null;
}

export interface feedsFragment {
  __typename: "GdFeedsContext";
  rowset: feedsFragment_rowset[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PriceCampaignBasicDataFragment
// ====================================================

export interface PriceCampaignBasicDataFragment_flightTargetingsSnapshot {
  __typename: "GdPriceFlightTargetingsSnapshot";
  behaviors: GraphQlLong[];
  viewTypes: GdPriceFlightViewType[];
  geoExpanded: GraphQlLong[] | null;
}

export interface PriceCampaignBasicDataFragment_pricePackage_targetingsFixed {
  __typename: "GdTargetingsFixed";
  geo: GraphQlLong[] | null;
}

export interface PriceCampaignBasicDataFragment_pricePackage_targetingsCustom {
  __typename: "GdTargetingsCustom";
  geo: GraphQlLong[] | null;
}

export interface PriceCampaignBasicDataFragment_pricePackage {
  __typename: "GdPricePackage";
  id: GraphQlLong;
  title: string;
  targetingsFixed: PriceCampaignBasicDataFragment_pricePackage_targetingsFixed | null;
  targetingsCustom: PriceCampaignBasicDataFragment_pricePackage_targetingsCustom | null;
}

export interface PriceCampaignBasicDataFragment {
  __typename: "GdPriceCampaign";
  pricePackageId: GraphQlLong | null;
  startDate: GraphQlLocalDate;
  endDate: GraphQlLocalDate | null;
  flightOrderVolume: GraphQlLong | null;
  hasDefaultAdGroup: boolean;
  flightTargetingsSnapshot: PriceCampaignBasicDataFragment_flightTargetingsSnapshot | null;
  pricePackage: PriceCampaignBasicDataFragment_pricePackage;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: creativeFragment
// ====================================================

export interface creativeFragment_GdSmartCreative {
  __typename: "GdSmartCreative" | "GdCpcVideoCreative" | "GdCpmAudioCreative" | "GdCpmGeoproductCreative" | "GdCpmIndoorCreative" | "GdCpmOutdoorCreative" | "GdCpmVideoCreative" | "GdOverlayCreative" | "GdVideoAdditionCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  previewUrl: string;
  width: GraphQlLong | null;
}

export interface creativeFragment_GdCanvasCreative {
  __typename: "GdCanvasCreative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  previewUrl: string;
  width: GraphQlLong | null;
  isAdaptive: boolean | null;
}

export interface creativeFragment_GdHtml5Creative {
  __typename: "GdHtml5Creative";
  creativeId: GraphQlLong;
  creativeType: GdCreativeType;
  height: GraphQlLong | null;
  name: string;
  previewUrl: string;
  width: GraphQlLong | null;
  isImage: boolean;
}

export type creativeFragment = creativeFragment_GdSmartCreative | creativeFragment_GdCanvasCreative | creativeFragment_GdHtml5Creative;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FreelancerFeedbackQueryFragment
// ====================================================

export interface FreelancerFeedbackQueryFragment_authorInfo {
  __typename: "GdUserPublicInfo";
  avatarUrl: string;
  login: string;
  name: string;
  userId: GraphQlLong;
}

export interface FreelancerFeedbackQueryFragment {
  __typename: "GdFreelancerFeedback";
  authorInfo: FreelancerFeedbackQueryFragment_authorInfo | null;
  authorUid: GraphQlLong;
  createdTime: GraphQlLocalDateTime;
  feedbackId: string;
  feedbackText: string;
  freelancerId: GraphQlLong;
  overallMark: GraphQlLong;
  willRecommend: boolean | null;
  moderationStatus: GdFreelancerUgcModerationStatus;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FreelancerContactsFragment
// ====================================================

export interface FreelancerContactsFragment {
  __typename: "GdFreelancerContacts";
  siteUrl: string | null;
  whatsApp: string | null;
  phone: string;
  icq: string | null;
  telegram: string | null;
  email: string;
  viber: string | null;
  skype: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FreelancerServiceFragment
// ====================================================

export interface FreelancerServiceFragment {
  __typename: "GdFreelancerSkillType";
  name: string;
  skillCode: string;
  skillId: GraphQlLong;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FreelancerPrivateDataFragment
// ====================================================

export interface FreelancerPrivateDataFragment_newestCard_contacts {
  __typename: "GdFreelancerContacts";
  siteUrl: string | null;
  whatsApp: string | null;
  phone: string;
  icq: string | null;
  telegram: string | null;
  email: string;
  viber: string | null;
  skype: string | null;
}

export interface FreelancerPrivateDataFragment_newestCard {
  __typename: "GdFreelancerCard";
  statusModerate: GdFreelancersCardStatusModerate;
  briefInfo: string;
  avatarUrl: string;
  contacts: FreelancerPrivateDataFragment_newestCard_contacts;
}

export interface FreelancerPrivateDataFragment_advQuality {
  __typename: "GdFreelancerAdvQuality";
  advQualityRank: GraphQlLong | null;
  advQualityRating: GraphQlBigDecimal | null;
}

export interface FreelancerPrivateDataFragment {
  __typename: "GdFreelancerPrivateData";
  freelancerId: GraphQlLong;
  /**
   * Последняя версия карточки вне зависимости от статуса
   */
  newestCard: FreelancerPrivateDataFragment_newestCard | null;
  /**
   * ОКР-рейтинг специалиста.
   */
  advQuality: FreelancerPrivateDataFragment_advQuality | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: minusPhraseLibraryRowFragment
// ====================================================

export interface minusPhraseLibraryRowFragment {
  __typename: "GdGetMinusKeywordsPacksItem";
  id: GraphQlLong;
  linkedAdGroupsCount: GraphQlLong;
  minusKeywords: string[];
  name: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: minusPhraseLibraryConstantsFragment
// ====================================================

export interface minusPhraseLibraryConstantsFragment {
  __typename: "GdDirectConstantsMinusWordsLibValidationData";
  libMinusKeywordsTextMaxLength: number;
  maxLibraryPacksCount: number;
  maxLinkedPacksToOneAdGroup: number;
  maxNameLength: number;
  maxWordsInMinusPhrase: number;
  nameAllowLetters: string;
  textAllowLetters: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OutdoorPlacementBlock
// ====================================================

export interface OutdoorPlacementBlock_sizes {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface OutdoorPlacementBlock_photos_formats {
  __typename: "GdPlacementFormat";
  height: number;
  path: string;
  width: number;
}

export interface OutdoorPlacementBlock_photos {
  __typename: "GdPlacementPhoto";
  formats: OutdoorPlacementBlock_photos_formats[];
}

export interface OutdoorPlacementBlock_resolution {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface OutdoorPlacementBlock {
  __typename: "GdOutdoorPlacementBlock";
  blockCaption: string | null;
  blockId: GraphQlLong;
  isDeleted: boolean;
  lastChange: GraphQlLocalDateTime;
  pageId: GraphQlLong;
  sizes: OutdoorPlacementBlock_sizes[];
  address: string;
  coordinates: string;
  duration: number;
  direction: number;
  facilityType: number;
  geoId: GraphQlLong | null;
  height: number;
  hidden: boolean | null;
  photos: OutdoorPlacementBlock_photos[] | null;
  resolution: OutdoorPlacementBlock_resolution;
  width: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: IndoorPlacementBlock
// ====================================================

export interface IndoorPlacementBlock_sizes {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface IndoorPlacementBlock_photos_formats {
  __typename: "GdPlacementFormat";
  height: number;
  path: string;
  width: number;
}

export interface IndoorPlacementBlock_photos {
  __typename: "GdPlacementPhoto";
  formats: IndoorPlacementBlock_photos_formats[];
}

export interface IndoorPlacementBlock_resolution {
  __typename: "GdBlockSize";
  height: number | null;
  width: number | null;
}

export interface IndoorPlacementBlock {
  __typename: "GdIndoorPlacementBlock";
  blockCaption: string | null;
  blockId: GraphQlLong;
  isDeleted: boolean;
  lastChange: GraphQlLocalDateTime;
  pageId: GraphQlLong;
  sizes: IndoorPlacementBlock_sizes[];
  geoId: GraphQlLong | null;
  address: string;
  coordinates: string;
  facilityType: number;
  zoneCategory: number;
  aspectRatio: number[];
  hidden: boolean | null;
  photos: IndoorPlacementBlock_photos[] | null;
  resolution: IndoorPlacementBlock_resolution;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: allowedBidModifiersValuesFragment
// ====================================================

export interface allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesABSegment_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesABSegment {
  __typename: "GdAllowedBidModifierValuesABSegment" | "GdAllowedBidModifierValuesDemographics" | "GdAllowedBidModifierValuesDesktop" | "GdAllowedBidModifierValuesExpression" | "GdAllowedBidModifierValuesGeo" | "GdAllowedBidModifierValuesRetargeting" | "GdAllowedBidModifierValuesSmartTgo" | "GdAllowedBidModifierValuesVideo" | "GdAllowedBidModifierValuesWeather";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesABSegment_percentRange;
}

export interface allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesMobile_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesMobile {
  __typename: "GdAllowedBidModifierValuesMobile";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesMobile_percentRange;
  osTypes: GdOsType[];
}

export interface allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesInventory_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesInventory {
  __typename: "GdAllowedBidModifierValuesInventory";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesInventory_percentRange;
  inventoryTypes: GdInventoryType[];
}

export interface allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesAdType_percentRange {
  __typename: "GdIntRange";
  max: number;
  min: number;
  step: number;
}

export interface allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesAdType {
  __typename: "GdAllowedBidModifierValuesAdType";
  type: GdBidModifierType;
  maxConditions: number;
  percentRange: allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesAdType_percentRange;
  adTypes: GdAdjustmentAdType[];
}

export type allowedBidModifiersValuesFragment = allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesABSegment | allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesMobile | allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesInventory | allowedBidModifiersValuesFragment_GdAllowedBidModifierValuesAdType;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RecommendationsGridClientFeaturesFragment
// ====================================================

export interface RecommendationsGridClientFeaturesFragment {
  __typename: "GdClientFeatures";
  enabledRecommendationTypes: GdiRecommendationType[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: summaryRecommendationGraphFragment
// ====================================================

export interface summaryRecommendationGraphFragment_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface summaryRecommendationGraphFragment {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: summaryRecommendationGraphFragment_points[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: summaryRecommendationItemsFragment
// ====================================================

export interface summaryRecommendationItemsFragment_rowset {
  __typename: "GdRecommendationItem";
  clicks: GraphQlLong;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  name: string;
}

export interface summaryRecommendationItemsFragment {
  __typename: "GdRecommendationItems";
  rowset: summaryRecommendationItemsFragment_rowset[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: summaryRecommendationKpiFragment
// ====================================================

export interface summaryRecommendationKpiFragment_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface summaryRecommendationKpiFragment_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: summaryRecommendationKpiFragment_graph_points[];
}

export interface summaryRecommendationKpiFragment {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiDailyBudget" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: summaryRecommendationKpiFragment_graph;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: recommendationKeyFragment
// ====================================================

export interface recommendationKeyFragment {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: summaryRecommendationFragment
// ====================================================

export interface summaryRecommendationFragment_GdRecommendationSummaryWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithoutKpi {
  __typename: "GdRecommendationSummaryWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  campaignIds: GraphQlLong[];
  keys: summaryRecommendationFragment_GdRecommendationSummaryWithoutKpi_keys[];
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export type summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi = summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats | summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget;

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_items_rowset {
  __typename: "GdRecommendationItem";
  clicks: GraphQlLong;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  name: string;
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_items {
  __typename: "GdRecommendationItems";
  rowset: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_items_rowset[];
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface summaryRecommendationFragment_GdRecommendationSummaryWithKpi {
  __typename: "GdRecommendationSummaryWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  kpi: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_kpi;
  items: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_items;
  campaignIds: GraphQlLong[];
  keys: summaryRecommendationFragment_GdRecommendationSummaryWithKpi_keys[];
}

export type summaryRecommendationFragment = summaryRecommendationFragment_GdRecommendationSummaryWithoutKpi | summaryRecommendationFragment_GdRecommendationSummaryWithKpi;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RecommendationsDailyBudgetGridKpiItemsFragment
// ====================================================

export interface RecommendationsDailyBudgetGridKpiItemsFragment_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives" | "GdRecommendationKpiWeeklyBudget";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
}

export interface RecommendationsDailyBudgetGridKpiItemsFragment_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  recommendedDailyBudget: GraphQlBigDecimal;
  currentDailyBudget: GraphQlBigDecimal;
}

export type RecommendationsDailyBudgetGridKpiItemsFragment_kpi = RecommendationsDailyBudgetGridKpiItemsFragment_kpi_GdRecommendationKpiAddBannerFormats | RecommendationsDailyBudgetGridKpiItemsFragment_kpi_GdRecommendationKpiDailyBudget;

export interface RecommendationsDailyBudgetGridKpiItemsFragment {
  __typename: "GdRecommendationWithKpi";
  kpi: RecommendationsDailyBudgetGridKpiItemsFragment_kpi;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RecommendationsDailyBudgetCampaignsRowFragment
// ====================================================

export interface RecommendationsDailyBudgetCampaignsRowFragment_stats {
  __typename: "GdEntityStats";
  clicks: GraphQlLong | null;
  cost: GraphQlBigDecimal | null;
}

export interface RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives" | "GdRecommendationKpiWeeklyBudget";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
}

export interface RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  recommendedDailyBudget: GraphQlBigDecimal;
  currentDailyBudget: GraphQlBigDecimal;
}

export type RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_kpi = RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiDailyBudget;

export interface RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  kpi: RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_kpi;
  keys: RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi_keys[];
}

export type RecommendationsDailyBudgetCampaignsRowFragment_recommendations = RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithoutKpi | RecommendationsDailyBudgetCampaignsRowFragment_recommendations_GdRecommendationWithKpi;

export interface RecommendationsDailyBudgetCampaignsRowFragment_strategy_budget {
  __typename: "GdCampaignBudget";
  sum: GraphQlBigDecimal;
  showMode: GdCampaignBudgetShowMode;
  period: GdCampaignBudgetPeriod;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
}

export interface RecommendationsDailyBudgetCampaignsRowFragment_strategy {
  __typename: "GdCampaignStrategyAvgClick" | "GdCampaignStrategyAvgCpa" | "GdCampaignStrategyAvgCpaPerCamp" | "GdCampaignStrategyAvgCpaPerFilter" | "GdCampaignStrategyAvgCpcPerCamp" | "GdCampaignStrategyAvgCpcPerFilter" | "GdCampaignStrategyAvgCpi" | "GdCampaignStrategyAvgCpm" | "GdCampaignStrategyManual" | "GdCampaignStrategyPeriodFixBid" | "GdCampaignStrategyRoi" | "GdCampaignStrategyWeekBudget" | "GdCampaignStrategyWeekBundle" | "GdStrategyOptimizeClicks" | "GdStrategyOptimizeConversions" | "GdStrategyOptimizeInstalls";
  budget: RecommendationsDailyBudgetCampaignsRowFragment_strategy_budget | null;
}

export interface RecommendationsDailyBudgetCampaignsRowFragment {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  stats: RecommendationsDailyBudgetCampaignsRowFragment_stats;
  recommendations: RecommendationsDailyBudgetCampaignsRowFragment_recommendations[] | null;
  strategy: RecommendationsDailyBudgetCampaignsRowFragment_strategy;
  type: GdCampaignType;
  name: string;
  id: GraphQlLong;
  currency: CurrencyCode | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RemoveFromBlackListRecommendationKpiFragment
// ====================================================

export interface RemoveFromBlackListRecommendationKpiFragment {
  __typename: "GdRecommendationKpiRemovePagesFromBlackList";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  pageName: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RemoveFromBlackListRecommendationsGridRowFragment
// ====================================================

export interface RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiDailyBudget" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives" | "GdRecommendationKpiWeeklyBudget";
}

export interface RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackList {
  __typename: "GdRecommendationKpiRemovePagesFromBlackList";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  currency: CurrencyCode;
  pageName: string;
}

export type RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi = RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiAddBannerFormats | RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi_GdRecommendationKpiRemovePagesFromBlackList;

export interface RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_keys[];
  kpi: RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi;
}

export type RemoveFromBlackListRecommendationsGridRowFragment_recommendations = RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi | RemoveFromBlackListRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi;

export interface RemoveFromBlackListRecommendationsGridRowFragment {
  __typename: "GdPage";
  name: string;
  recommendations: RemoveFromBlackListRecommendationsGridRowFragment_recommendations[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SwitchOnAutotargetingRecommendationsGridRowFragment
// ====================================================

export interface SwitchOnAutotargetingRecommendationsGridRowFragment_stats {
  __typename: "GdEntityStats";
  clicks: GraphQlLong | null;
  cost: GraphQlBigDecimal | null;
}

export interface SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi {
  __typename: "GdRecommendationWithoutKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  keys: SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi_keys[];
}

export interface SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiDailyBudget" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives" | "GdRecommendationKpiWeeklyBudget";
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
}

export interface SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi {
  __typename: "GdRecommendationWithKpi";
  status: GdRecommendationStatus;
  isApplicable: boolean;
  kpi: SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_kpi;
  keys: SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi_keys[];
}

export type SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations = SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithoutKpi | SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations_GdRecommendationWithKpi;

export interface SwitchOnAutotargetingRecommendationsGridRowFragment_campaign {
  __typename: "GdContentPromotionCampaign" | "GdCpmBannerCampaign" | "GdCpmDealsCampaign" | "GdCpmYndxFrontpageCampaign" | "GdDynamicCampaign" | "GdInternalAutobudgetCampaign" | "GdInternalDistribCampaign" | "GdInternalFreeCampaign" | "GdMcBannerCampaign" | "GdMobileContentCampaign" | "GdPriceCampaign" | "GdSmartCampaign" | "GdTextCampaign";
  id: GraphQlLong;
  name: string;
}

export interface SwitchOnAutotargetingRecommendationsGridRowFragment {
  __typename: "GdContentPromotionAdGroup" | "GdCpmAudioAdGroup" | "GdCpmBannerAdGroup" | "GdCpmGeoproductAdGroup" | "GdCpmIndoorAdGroup" | "GdCpmOutdoorAdGroup" | "GdCpmPriceAdGroup" | "GdCpmVideoAdGroup" | "GdCpmYndxFrontpageAdGroup" | "GdDynamicAdGroup" | "GdInternalAdGroup" | "GdMcBannerAdGroup" | "GdMobileContentAdGroup" | "GdSmartAdGroup" | "GdTextAdGroup";
  stats: SwitchOnAutotargetingRecommendationsGridRowFragment_stats;
  recommendations: SwitchOnAutotargetingRecommendationsGridRowFragment_recommendations[] | null;
  name: string;
  id: GraphQlLong;
  campaign: SwitchOnAutotargetingRecommendationsGridRowFragment_campaign;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: recommendationsGridSummaryRowFragment
// ====================================================

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithoutKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithoutKpi {
  __typename: "GdRecommendationSummaryWithoutKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  keys: recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithoutKpi_keys[];
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_keys {
  __typename: "GdRecommendationKey";
  userKey1: string;
  userKey2: string;
  userKey3: string;
  pid: GraphQlLong;
  bid: GraphQlLong;
  cid: GraphQlLong;
  timestamp: GraphQlLong;
  type: GdiRecommendationType;
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph_points[];
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats {
  __typename: "GdRecommendationKpiAddBannerFormats" | "GdRecommendationKpiAddTurboWebSite" | "GdRecommendationKpiChooseAppropriatePlacementsForAdGroup" | "GdRecommendationKpiChooseAppropriatePlacementsForBanner" | "GdRecommendationKpiRemovePagesFromBlackList" | "GdRecommendationKpiRemovePagesFromBlackListOfACampaign" | "GdRecommendationKpiSwitchOnAutotargeting" | "GdRecommendationKpiUploadAppropriateCreatives" | "GdRecommendationKpiWeeklyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats_graph;
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points {
  __typename: "GdRecommendationKpiGraphPoint";
  valueX: string;
  typeValueX: string;
  profitValue: GraphQlBigDecimal;
  currentValue: GraphQlBigDecimal;
  holiday: string;
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph {
  __typename: "GdRecommendationKpiGraph";
  typeY: string;
  typeX: string;
  points: recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph_points[];
}

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget {
  __typename: "GdRecommendationKpiDailyBudget";
  sign: GdRecommendationSign;
  clicks: GraphQlBigDecimal;
  cost: GraphQlBigDecimal;
  period: number;
  currency: CurrencyCode;
  graph: recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget_graph;
  recommendedDailyBudget: GraphQlBigDecimal;
}

export type recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi = recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiAddBannerFormats | recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi_GdRecommendationKpiDailyBudget;

export interface recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi {
  __typename: "GdRecommendationSummaryWithKpi";
  type: GdiRecommendationType;
  status: GdRecommendationStatus;
  isApplicable: boolean;
  totalCount: number;
  keys: recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_keys[];
  kpi: recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi_kpi;
}

export type recommendationsGridSummaryRowFragment = recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithoutKpi | recommendationsGridSummaryRowFragment_GdRecommendationSummaryWithKpi;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ValidationErrorGroup
// ====================================================

export interface ValidationErrorGroup {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ValidationWarningGroup
// ====================================================

export interface ValidationWarningGroup {
  __typename: "GdDefect";
  code: string;
  params: GraphQlObjectScalar | null;
  path: string;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum BidModifierExpressionOperator {
  EQ = "EQ",
  GE = "GE",
  LE = "LE",
  MATCH_GOAL_CONTEXT = "MATCH_GOAL_CONTEXT",
  NE = "NE",
}

export enum BidModifierExpressionOperatorInput {
  EQ = "EQ",
  GE = "GE",
  LE = "LE",
  MATCH_GOAL_CONTEXT = "MATCH_GOAL_CONTEXT",
  NE = "NE",
}

export enum BidModifierExpressionParameter {
  CLOUDNESS = "CLOUDNESS",
  PREC_STRENGTH = "PREC_STRENGTH",
  TEMP = "TEMP",
  TRAFFIC_JAM = "TRAFFIC_JAM",
}

export enum BidModifierExpressionParameterInput {
  CLOUDNESS = "CLOUDNESS",
  PREC_STRENGTH = "PREC_STRENGTH",
  TEMP = "TEMP",
  TRAFFIC_JAM = "TRAFFIC_JAM",
}

export enum ChangeModeInput {
  POSTFIX = "POSTFIX",
  PREFIX = "PREFIX",
  REPLACE = "REPLACE",
}

export enum CompleteReason {
  BY_CLIENT = "BY_CLIENT",
  BY_DATE = "BY_DATE",
  BY_PUBLISHER = "BY_PUBLISHER",
}

export enum CompleteReasonInput {
  BY_CLIENT = "BY_CLIENT",
  BY_DATE = "BY_DATE",
  BY_PUBLISHER = "BY_PUBLISHER",
}

export enum CryptaInterestType {
  all = "all",
  long_term = "long_term",
  short_term = "short_term",
}

export enum CryptaInterestTypeWeb {
  all = "all",
  long_term = "long_term",
  short_term = "short_term",
}

export enum CryptaInterestTypeWebInput {
  all = "all",
  long_term = "long_term",
  short_term = "short_term",
}

export enum CurrencyCode {
  BYN = "BYN",
  CHF = "CHF",
  EUR = "EUR",
  KZT = "KZT",
  RUB = "RUB",
  TRY = "TRY",
  UAH = "UAH",
  USD = "USD",
  UZS = "UZS",
  YND_FIXED = "YND_FIXED",
}

export enum CurrencyCodeInput {
  BYN = "BYN",
  CHF = "CHF",
  EUR = "EUR",
  KZT = "KZT",
  RUB = "RUB",
  TRY = "TRY",
  UAH = "UAH",
  USD = "USD",
  UZS = "UZS",
  YND_FIXED = "YND_FIXED",
}

export enum DealType {
  PREFERRED_DEAL = "PREFERRED_DEAL",
  PRIVATE_MARKETPLACE = "PRIVATE_MARKETPLACE",
}

export enum DealTypeInput {
  PREFERRED_DEAL = "PREFERRED_DEAL",
  PRIVATE_MARKETPLACE = "PRIVATE_MARKETPLACE",
}

export enum GdAdGroupModerationStatus {
  ACCEPTED = "ACCEPTED",
  DRAFT = "DRAFT",
  MODERATION = "MODERATION",
  PREACCEPTED = "PREACCEPTED",
  REJECTED = "REJECTED",
}

export enum GdAdGroupOrderByFieldInput {
  CAMPAIGN_ID = "CAMPAIGN_ID",
  CLICKS_FORECAST = "CLICKS_FORECAST",
  COST_FORECAST = "COST_FORECAST",
  ID = "ID",
  NAME = "NAME",
  STAT_AVG_CLICK_COST = "STAT_AVG_CLICK_COST",
  STAT_AVG_CLICK_POSITION = "STAT_AVG_CLICK_POSITION",
  STAT_AVG_DEPTH = "STAT_AVG_DEPTH",
  STAT_AVG_GOAL_COST = "STAT_AVG_GOAL_COST",
  STAT_AVG_SHOW_POSITION = "STAT_AVG_SHOW_POSITION",
  STAT_BOUNCE_RATE = "STAT_BOUNCE_RATE",
  STAT_CLICKS = "STAT_CLICKS",
  STAT_CONVERSION_RATE = "STAT_CONVERSION_RATE",
  STAT_COST = "STAT_COST",
  STAT_COST_PER_ACTION = "STAT_COST_PER_ACTION",
  STAT_CPM_PRICE = "STAT_CPM_PRICE",
  STAT_CTR = "STAT_CTR",
  STAT_GOALS = "STAT_GOALS",
  STAT_PROFITABILITY = "STAT_PROFITABILITY",
  STAT_REVENUE = "STAT_REVENUE",
  STAT_SHOWS = "STAT_SHOWS",
  TYPE = "TYPE",
}

export enum GdAdGroupPrimaryStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MODERATION = "MODERATION",
  REJECTED = "REJECTED",
  STOPPED = "STOPPED",
}

export enum GdAdGroupPrimaryStatusDesc {
  PREVIOUS_VERSION_SHOWING = "PREVIOUS_VERSION_SHOWING",
  SHOWING = "SHOWING",
}

export enum GdAdGroupPrimaryStatusInput {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MODERATION = "MODERATION",
  REJECTED = "REJECTED",
  STOPPED = "STOPPED",
}

export enum GdAdGroupType {
  CONTENT_PROMOTION = "CONTENT_PROMOTION",
  CONTENT_PROMOTION_COLLECTION = "CONTENT_PROMOTION_COLLECTION",
  CONTENT_PROMOTION_VIDEO = "CONTENT_PROMOTION_VIDEO",
  CPM_AUDIO = "CPM_AUDIO",
  CPM_BANNER = "CPM_BANNER",
  CPM_GEOPRODUCT = "CPM_GEOPRODUCT",
  CPM_INDOOR = "CPM_INDOOR",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_PRICE = "CPM_PRICE",
  CPM_VIDEO = "CPM_VIDEO",
  CPM_YNDX_FRONTPAGE = "CPM_YNDX_FRONTPAGE",
  DYNAMIC = "DYNAMIC",
  INTERNAL = "INTERNAL",
  MCBANNER = "MCBANNER",
  MOBILE_CONTENT = "MOBILE_CONTENT",
  PERFORMANCE = "PERFORMANCE",
  TEXT = "TEXT",
}

export enum GdAdGroupTypeInput {
  CONTENT_PROMOTION = "CONTENT_PROMOTION",
  CONTENT_PROMOTION_COLLECTION = "CONTENT_PROMOTION_COLLECTION",
  CONTENT_PROMOTION_VIDEO = "CONTENT_PROMOTION_VIDEO",
  CPM_AUDIO = "CPM_AUDIO",
  CPM_BANNER = "CPM_BANNER",
  CPM_GEOPRODUCT = "CPM_GEOPRODUCT",
  CPM_INDOOR = "CPM_INDOOR",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_PRICE = "CPM_PRICE",
  CPM_VIDEO = "CPM_VIDEO",
  CPM_YNDX_FRONTPAGE = "CPM_YNDX_FRONTPAGE",
  DYNAMIC = "DYNAMIC",
  INTERNAL = "INTERNAL",
  MCBANNER = "MCBANNER",
  MOBILE_CONTENT = "MOBILE_CONTENT",
  PERFORMANCE = "PERFORMANCE",
  TEXT = "TEXT",
}

export enum GdAdImageAvatarsHost {
  AVATARS_MDST_YANDEX_NET = "AVATARS_MDST_YANDEX_NET",
  AVATARS_MDS_YANDEX_NET = "AVATARS_MDS_YANDEX_NET",
}

export enum GdAdImageNamespace {
  DIRECT = "DIRECT",
  DIRECT_PICTURE = "DIRECT_PICTURE",
}

export enum GdAdImageType {
  IMAGE_AD = "IMAGE_AD",
  REGULAR = "REGULAR",
  SMALL = "SMALL",
  WIDE = "WIDE",
}

export enum GdAdOrderByFieldInput {
  BANNER_TYPE = "BANNER_TYPE",
  CAMPAIGN_ID = "CAMPAIGN_ID",
  DOMAIN = "DOMAIN",
  GROUP_ID = "GROUP_ID",
  HREF = "HREF",
  ID = "ID",
  LAST_CHANGE = "LAST_CHANGE",
  PRIMARY_STATUS = "PRIMARY_STATUS",
  STATUS = "STATUS",
  STAT_AVG_CLICK_COST = "STAT_AVG_CLICK_COST",
  STAT_AVG_CLICK_POSITION = "STAT_AVG_CLICK_POSITION",
  STAT_AVG_DEPTH = "STAT_AVG_DEPTH",
  STAT_AVG_GOAL_COST = "STAT_AVG_GOAL_COST",
  STAT_AVG_SHOW_POSITION = "STAT_AVG_SHOW_POSITION",
  STAT_BOUNCE_RATE = "STAT_BOUNCE_RATE",
  STAT_CLICKS = "STAT_CLICKS",
  STAT_CONVERSION_RATE = "STAT_CONVERSION_RATE",
  STAT_COST = "STAT_COST",
  STAT_COST_PER_ACTION = "STAT_COST_PER_ACTION",
  STAT_CPM_PRICE = "STAT_CPM_PRICE",
  STAT_CTR = "STAT_CTR",
  STAT_GOALS = "STAT_GOALS",
  STAT_PROFITABILITY = "STAT_PROFITABILITY",
  STAT_REVENUE = "STAT_REVENUE",
  STAT_SHOWS = "STAT_SHOWS",
  TITLE = "TITLE",
  TITLE_EXTENSION = "TITLE_EXTENSION",
}

export enum GdAdPermalinkAssignType {
  AUTO = "AUTO",
  MANUAL = "MANUAL",
}

export enum GdAdPriceCurrency {
  BYN = "BYN",
  CHF = "CHF",
  EUR = "EUR",
  KZT = "KZT",
  RUB = "RUB",
  TRY = "TRY",
  UAH = "UAH",
  USD = "USD",
  UZS = "UZS",
}

export enum GdAdPriceCurrencyInput {
  BYN = "BYN",
  CHF = "CHF",
  EUR = "EUR",
  KZT = "KZT",
  RUB = "RUB",
  TRY = "TRY",
  UAH = "UAH",
  USD = "USD",
  UZS = "UZS",
}

export enum GdAdPricePrefix {
  FROM = "FROM",
  TO = "TO",
}

export enum GdAdPricePrefixInput {
  FROM = "FROM",
  TO = "TO",
}

export enum GdAdPrimaryStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MANUALLY_SUSPENDED = "MANUALLY_SUSPENDED",
  MODERATION = "MODERATION",
  MODERATION_REJECTED = "MODERATION_REJECTED",
  TEMPORARILY_SUSPENDED = "TEMPORARILY_SUSPENDED",
}

export enum GdAdPrimaryStatusInput {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MANUALLY_SUSPENDED = "MANUALLY_SUSPENDED",
  MODERATION = "MODERATION",
  MODERATION_REJECTED = "MODERATION_REJECTED",
  TEMPORARILY_SUSPENDED = "TEMPORARILY_SUSPENDED",
}

export enum GdAdResources {
  BANNER_IMAGES = "BANNER_IMAGES",
  CALLOUTS = "CALLOUTS",
  CREATIVES = "CREATIVES",
  DISPLAY_HREF = "DISPLAY_HREF",
  IMAGES = "IMAGES",
  SITELINKS = "SITELINKS",
  TURBOLANDINGS = "TURBOLANDINGS",
  VCARD = "VCARD",
  VIDEO_ADDITIONS = "VIDEO_ADDITIONS",
}

export enum GdAdType {
  CONTENT_PROMOTION = "CONTENT_PROMOTION",
  CONTENT_PROMOTION_COLLECTION = "CONTENT_PROMOTION_COLLECTION",
  CONTENT_PROMOTION_VIDEO = "CONTENT_PROMOTION_VIDEO",
  CPC_VIDEO = "CPC_VIDEO",
  CPM_AUDIO = "CPM_AUDIO",
  CPM_BANNER = "CPM_BANNER",
  CPM_DEALS = "CPM_DEALS",
  CPM_GEOPRODUCT = "CPM_GEOPRODUCT",
  CPM_INDOOR = "CPM_INDOOR",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_PRICE = "CPM_PRICE",
  CPM_VIDEO = "CPM_VIDEO",
  CPM_YNDX_FRONTPAGE = "CPM_YNDX_FRONTPAGE",
  DYNAMIC = "DYNAMIC",
  IMAGE_AD = "IMAGE_AD",
  INTERNAL = "INTERNAL",
  MCBANNER = "MCBANNER",
  MOBILE_CONTENT = "MOBILE_CONTENT",
  PERFORMANCE = "PERFORMANCE",
  TEXT = "TEXT",
}

export enum GdAdTypeInput {
  CONTENT_PROMOTION = "CONTENT_PROMOTION",
  CONTENT_PROMOTION_COLLECTION = "CONTENT_PROMOTION_COLLECTION",
  CONTENT_PROMOTION_VIDEO = "CONTENT_PROMOTION_VIDEO",
  CPC_VIDEO = "CPC_VIDEO",
  CPM_AUDIO = "CPM_AUDIO",
  CPM_BANNER = "CPM_BANNER",
  CPM_DEALS = "CPM_DEALS",
  CPM_GEOPRODUCT = "CPM_GEOPRODUCT",
  CPM_INDOOR = "CPM_INDOOR",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_PRICE = "CPM_PRICE",
  CPM_VIDEO = "CPM_VIDEO",
  CPM_YNDX_FRONTPAGE = "CPM_YNDX_FRONTPAGE",
  DYNAMIC = "DYNAMIC",
  IMAGE_AD = "IMAGE_AD",
  INTERNAL = "INTERNAL",
  MCBANNER = "MCBANNER",
  MOBILE_CONTENT = "MOBILE_CONTENT",
  PERFORMANCE = "PERFORMANCE",
  TEXT = "TEXT",
}

export enum GdAdditionalTargetingJoinType {
  ALL = "ALL",
  ANY = "ANY",
}

export enum GdAdditionalTargetingJoinTypeInput {
  ALL = "ALL",
  ANY = "ANY",
}

export enum GdAdditionalTargetingMode {
  FILTERING = "FILTERING",
  TARGETING = "TARGETING",
}

export enum GdAdditionalTargetingModeInput {
  FILTERING = "FILTERING",
  TARGETING = "TARGETING",
}

export enum GdAdjustmentAdType {
  CPM_BANNER = "CPM_BANNER",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_VIDEO = "CPM_VIDEO",
}

export enum GdAdjustmentAdTypeInput {
  CPM_BANNER = "CPM_BANNER",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_VIDEO = "CPM_VIDEO",
}

export enum GdAgeType {
  _0_17 = "_0_17",
  _18_24 = "_18_24",
  _25_34 = "_25_34",
  _35_44 = "_35_44",
  _45_ = "_45_",
  _45_54 = "_45_54",
  _55_ = "_55_",
}

export enum GdAgeTypeInput {
  _0_17 = "_0_17",
  _18_24 = "_18_24",
  _25_34 = "_25_34",
  _35_44 = "_35_44",
  _45_ = "_45_",
  _45_54 = "_45_54",
  _55_ = "_55_",
}

export enum GdBannerMeasurerSystem {
  ADLOOX = "ADLOOX",
  ADMETRICA = "ADMETRICA",
  ADRIVER = "ADRIVER",
  DV = "DV",
  INTEGRAL_AD_SCIENCE = "INTEGRAL_AD_SCIENCE",
  MEDIASCOPE = "MEDIASCOPE",
  MOAT = "MOAT",
  SIZMEK = "SIZMEK",
  WEBORAMA = "WEBORAMA",
}

export enum GdBannerMeasurerSystemInput {
  ADLOOX = "ADLOOX",
  ADMETRICA = "ADMETRICA",
  ADRIVER = "ADRIVER",
  DV = "DV",
  INTEGRAL_AD_SCIENCE = "INTEGRAL_AD_SCIENCE",
  MEDIASCOPE = "MEDIASCOPE",
  MOAT = "MOAT",
  SIZMEK = "SIZMEK",
  WEBORAMA = "WEBORAMA",
}

export enum GdBannerTurbolandingStatusModerate {
  NEW = "NEW",
  NO = "NO",
  READY = "READY",
  SENDING = "SENDING",
  SENT = "SENT",
  YES = "YES",
}

export enum GdBidModifierType {
  AB_SEGMENT_MULTIPLIER = "AB_SEGMENT_MULTIPLIER",
  AD_TYPE_MULTIPLIER = "AD_TYPE_MULTIPLIER",
  DEMOGRAPHY_MULTIPLIER = "DEMOGRAPHY_MULTIPLIER",
  DESKTOP_MULTIPLIER = "DESKTOP_MULTIPLIER",
  DISTANCE_MULTIPLIER = "DISTANCE_MULTIPLIER",
  EXPRESS_TRAFFIC_MULTIPLIER = "EXPRESS_TRAFFIC_MULTIPLIER",
  GEO_MULTIPLIER = "GEO_MULTIPLIER",
  INVENTORY_MULTIPLIER = "INVENTORY_MULTIPLIER",
  MOBILE_MULTIPLIER = "MOBILE_MULTIPLIER",
  RETARGETING_MULTIPLIER = "RETARGETING_MULTIPLIER",
  SMART_TGO_MULTIPLIER = "SMART_TGO_MULTIPLIER",
  VIDEO_MULTIPLIER = "VIDEO_MULTIPLIER",
  WEATHER_MULTIPLIER = "WEATHER_MULTIPLIER",
}

export enum GdBidModifierTypeInput {
  AB_SEGMENT_MULTIPLIER = "AB_SEGMENT_MULTIPLIER",
  AD_TYPE_MULTIPLIER = "AD_TYPE_MULTIPLIER",
  DEMOGRAPHY_MULTIPLIER = "DEMOGRAPHY_MULTIPLIER",
  DESKTOP_MULTIPLIER = "DESKTOP_MULTIPLIER",
  DISTANCE_MULTIPLIER = "DISTANCE_MULTIPLIER",
  EXPRESS_TRAFFIC_MULTIPLIER = "EXPRESS_TRAFFIC_MULTIPLIER",
  GEO_MULTIPLIER = "GEO_MULTIPLIER",
  INVENTORY_MULTIPLIER = "INVENTORY_MULTIPLIER",
  MOBILE_MULTIPLIER = "MOBILE_MULTIPLIER",
  RETARGETING_MULTIPLIER = "RETARGETING_MULTIPLIER",
  SMART_TGO_MULTIPLIER = "SMART_TGO_MULTIPLIER",
  VIDEO_MULTIPLIER = "VIDEO_MULTIPLIER",
  WEATHER_MULTIPLIER = "WEATHER_MULTIPLIER",
}

export enum GdBrandSurveyStopReason {
  LOW_BUDGET = "LOW_BUDGET",
  LOW_REACH = "LOW_REACH",
}

export enum GdBusinessType {
  AUTO = "AUTO",
  FLIGHTS = "FLIGHTS",
  HOTELS = "HOTELS",
  NEWS = "NEWS",
  OTHER = "OTHER",
  REALTY = "REALTY",
  RETAIL = "RETAIL",
}

export enum GdBusinessTypeInput {
  AUTO = "AUTO",
  FLIGHTS = "FLIGHTS",
  HOTELS = "HOTELS",
  NEWS = "NEWS",
  OTHER = "OTHER",
  REALTY = "REALTY",
  RETAIL = "RETAIL",
}

export enum GdCalcTypeInput {
  CPC = "CPC",
  CPM = "CPM",
}

export enum GdCalloutStatusModerate {
  NEW = "NEW",
  NO = "NO",
  READY = "READY",
  SENDING = "SENDING",
  SENT = "SENT",
  YES = "YES",
}

export enum GdCampaignAction {
  ACCEPT_SERVICING = "ACCEPT_SERVICING",
  AGENCY_SERVICED = "AGENCY_SERVICED",
  AJAX_SET_AUTO_RESOURCES = "AJAX_SET_AUTO_RESOURCES",
  ALLOW_TRANSFER_MONEY_SUBCLIENT = "ALLOW_TRANSFER_MONEY_SUBCLIENT",
  ARCHIVE_CAMP = "ARCHIVE_CAMP",
  COPY_CAMP_CLIENT = "COPY_CAMP_CLIENT",
  DELETE_CAMP = "DELETE_CAMP",
  EDIT_CAMP = "EDIT_CAMP",
  EDIT_METRICA_COUNTERS = "EDIT_METRICA_COUNTERS",
  LOOKUP = "LOOKUP",
  OFFER_SERVICING = "OFFER_SERVICING",
  OTHER_MANAGER_SERVICED = "OTHER_MANAGER_SERVICED",
  PAY = "PAY",
  PAY_BY_CASH = "PAY_BY_CASH",
  REMODERATE_CAMP = "REMODERATE_CAMP",
  RESUME_CAMP = "RESUME_CAMP",
  SERVICED = "SERVICED",
  SET_AUTO_PRICE = "SET_AUTO_PRICE",
  SHOW_CAMP_SETTINGS = "SHOW_CAMP_SETTINGS",
  SHOW_CAMP_STAT = "SHOW_CAMP_STAT",
  STOP_CAMP = "STOP_CAMP",
  UNARCHIVE_CAMP = "UNARCHIVE_CAMP",
}

export enum GdCampaignAttributionModel {
  FIRST_CLICK = "FIRST_CLICK",
  LAST_CLICK = "LAST_CLICK",
  LAST_SIGNIFICANT_CLICK = "LAST_SIGNIFICANT_CLICK",
  LAST_YANDEX_DIRECT_CLICK = "LAST_YANDEX_DIRECT_CLICK",
}

export enum GdCampaignAttributionModelInput {
  FIRST_CLICK = "FIRST_CLICK",
  LAST_CLICK = "LAST_CLICK",
  LAST_SIGNIFICANT_CLICK = "LAST_SIGNIFICANT_CLICK",
  LAST_YANDEX_DIRECT_CLICK = "LAST_YANDEX_DIRECT_CLICK",
}

export enum GdCampaignBudgetPeriod {
  CUSTOM = "CUSTOM",
  DAY = "DAY",
  WEEK = "WEEK",
}

export enum GdCampaignBudgetShowMode {
  DEFAULT = "DEFAULT",
  STRETCHED = "STRETCHED",
}

export enum GdCampaignCheckPositionInterval {
  M_15 = "M_15",
  M_30 = "M_30",
  M_60 = "M_60",
}

export enum GdCampaignCheckPositionIntervalInput {
  M_15 = "M_15",
  M_30 = "M_30",
  M_60 = "M_60",
}

export enum GdCampaignEmailEvent {
  CHECK_POSITION = "CHECK_POSITION",
  SEND_ACCOUNT_NEWS = "SEND_ACCOUNT_NEWS",
  STOP_BY_REACH_DAILY_BUDGET = "STOP_BY_REACH_DAILY_BUDGET",
  WARNING_BALANCE = "WARNING_BALANCE",
  XLS_READY = "XLS_READY",
}

export enum GdCampaignOrderByFieldInput {
  ID = "ID",
  NAME = "NAME",
  RECOMMENDATIONS_CLICKS = "RECOMMENDATIONS_CLICKS",
  RECOMMENDATIONS_COST = "RECOMMENDATIONS_COST",
  STAT_AVG_CLICK_COST = "STAT_AVG_CLICK_COST",
  STAT_AVG_CLICK_POSITION = "STAT_AVG_CLICK_POSITION",
  STAT_AVG_DEPTH = "STAT_AVG_DEPTH",
  STAT_AVG_GOAL_COST = "STAT_AVG_GOAL_COST",
  STAT_AVG_SHOW_POSITION = "STAT_AVG_SHOW_POSITION",
  STAT_BOUNCE_RATE = "STAT_BOUNCE_RATE",
  STAT_CLICKS = "STAT_CLICKS",
  STAT_CONVERSION_RATE = "STAT_CONVERSION_RATE",
  STAT_COST = "STAT_COST",
  STAT_COST_PER_ACTION = "STAT_COST_PER_ACTION",
  STAT_CPM_PRICE = "STAT_CPM_PRICE",
  STAT_CTR = "STAT_CTR",
  STAT_GOALS = "STAT_GOALS",
  STAT_PROFITABILITY = "STAT_PROFITABILITY",
  STAT_REVENUE = "STAT_REVENUE",
  STAT_SHOWS = "STAT_SHOWS",
  SUM = "SUM",
  TYPE = "TYPE",
}

export enum GdCampaignPlatform {
  BOTH = "BOTH",
  CONTEXT = "CONTEXT",
  SEARCH = "SEARCH",
}

export enum GdCampaignPlatformInput {
  BOTH = "BOTH",
  CONTEXT = "CONTEXT",
  SEARCH = "SEARCH",
}

export enum GdCampaignPrimaryStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MODERATION = "MODERATION",
  MODERATION_DENIED = "MODERATION_DENIED",
  NO_MONEY = "NO_MONEY",
  STOPPED = "STOPPED",
  TEMPORARILY_PAUSED = "TEMPORARILY_PAUSED",
}

export enum GdCampaignPrimaryStatusDesc {
  ADD_MONEY = "ADD_MONEY",
  ADD_MONEY_TO_WALLET = "ADD_MONEY_TO_WALLET",
  IS_IN_PROGRESS = "IS_IN_PROGRESS",
  IS_NOT_RECOVERED = "IS_NOT_RECOVERED",
  IS_OVER = "IS_OVER",
  IS_PAUSED_BY_DAY_BUDGET = "IS_PAUSED_BY_DAY_BUDGET",
  IS_PAUSED_BY_TIMETARGETING = "IS_PAUSED_BY_TIMETARGETING",
  IS_PAUSED_BY_WALLET_DAY_BUDGET = "IS_PAUSED_BY_WALLET_DAY_BUDGET",
  IS_WAITING_START = "IS_WAITING_START",
  NO_ACTIVE_BANNERS = "NO_ACTIVE_BANNERS",
  WAIT_PAYMENT = "WAIT_PAYMENT",
}

export enum GdCampaignPrimaryStatusInput {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MODERATION = "MODERATION",
  MODERATION_DENIED = "MODERATION_DENIED",
  NO_MONEY = "NO_MONEY",
  STOPPED = "STOPPED",
  TEMPORARILY_PAUSED = "TEMPORARILY_PAUSED",
}

export enum GdCampaignSmsEvent {
  FINISHED = "FINISHED",
  MODERATION = "MODERATION",
  MONEY_IN = "MONEY_IN",
  MONEY_OUT = "MONEY_OUT",
  MONITORING = "MONITORING",
  STOP_BY_REACH_DAILY_BUDGET = "STOP_BY_REACH_DAILY_BUDGET",
}

export enum GdCampaignSmsEventInput {
  FINISHED = "FINISHED",
  MODERATION = "MODERATION",
  MONEY_IN = "MONEY_IN",
  MONEY_OUT = "MONEY_OUT",
  MONITORING = "MONITORING",
  STOP_BY_REACH_DAILY_BUDGET = "STOP_BY_REACH_DAILY_BUDGET",
}

export enum GdCampaignStatusModerate {
  MEDIAPLAN = "MEDIAPLAN",
  NEW = "NEW",
  NO = "NO",
  READY = "READY",
  SENT = "SENT",
  YES = "YES",
}

export enum GdCampaignStrategyInput {
  AUTOBUDGET_AVG_CPA_PER_CAMP = "AUTOBUDGET_AVG_CPA_PER_CAMP",
  AUTOBUDGET_AVG_CPA_PER_FILTER = "AUTOBUDGET_AVG_CPA_PER_FILTER",
  AUTOBUDGET_AVG_CPC_PER_CAMP = "AUTOBUDGET_AVG_CPC_PER_CAMP",
  AUTOBUDGET_AVG_CPC_PER_FILTER = "AUTOBUDGET_AVG_CPC_PER_FILTER",
  DIFFERENT_PLACES = "DIFFERENT_PLACES",
}

export enum GdCampaignStrategyNameInput {
  AUTOBUDGET = "AUTOBUDGET",
  AUTOBUDGET_AVG_CLICK = "AUTOBUDGET_AVG_CLICK",
  AUTOBUDGET_AVG_CPA = "AUTOBUDGET_AVG_CPA",
  AUTOBUDGET_AVG_CPA_PER_CAMP = "AUTOBUDGET_AVG_CPA_PER_CAMP",
  AUTOBUDGET_AVG_CPA_PER_FILTER = "AUTOBUDGET_AVG_CPA_PER_FILTER",
  AUTOBUDGET_AVG_CPC_PER_CAMP = "AUTOBUDGET_AVG_CPC_PER_CAMP",
  AUTOBUDGET_AVG_CPC_PER_FILTER = "AUTOBUDGET_AVG_CPC_PER_FILTER",
  AUTOBUDGET_AVG_CPI = "AUTOBUDGET_AVG_CPI",
  AUTOBUDGET_MAX_IMPRESSIONS = "AUTOBUDGET_MAX_IMPRESSIONS",
  AUTOBUDGET_MAX_IMPRESSIONS_CUSTOM_PERIOD = "AUTOBUDGET_MAX_IMPRESSIONS_CUSTOM_PERIOD",
  AUTOBUDGET_MAX_REACH = "AUTOBUDGET_MAX_REACH",
  AUTOBUDGET_MAX_REACH_CUSTOM_PERIOD = "AUTOBUDGET_MAX_REACH_CUSTOM_PERIOD",
  AUTOBUDGET_MEDIA = "AUTOBUDGET_MEDIA",
  AUTOBUDGET_ROI = "AUTOBUDGET_ROI",
  AUTOBUDGET_WEEK_BUNDLE = "AUTOBUDGET_WEEK_BUNDLE",
  CPM_DEFAULT = "CPM_DEFAULT",
  DEFAULT_ = "DEFAULT_",
  MIN_PRICE = "MIN_PRICE",
  NO_PREMIUM = "NO_PREMIUM",
}

export enum GdCampaignStrategyTypeInput {
  AVG_CLICK = "AVG_CLICK",
  AVG_CPA = "AVG_CPA",
  AVG_CPA_PER_CAMP = "AVG_CPA_PER_CAMP",
  AVG_CPA_PER_FILTER = "AVG_CPA_PER_FILTER",
  AVG_CPC_PER_CAMP = "AVG_CPC_PER_CAMP",
  AVG_CPC_PER_FILTER = "AVG_CPC_PER_FILTER",
  AVG_CPI = "AVG_CPI",
  CPM_DEFAULT = "CPM_DEFAULT",
  CPM_MAX_IMPRESSIONS = "CPM_MAX_IMPRESSIONS",
  CPM_MAX_IMPRESSIONS_CUSTOM_PERIOD = "CPM_MAX_IMPRESSIONS_CUSTOM_PERIOD",
  CPM_MAX_REACH = "CPM_MAX_REACH",
  CPM_MAX_REACH_CUSTOM_PERIOD = "CPM_MAX_REACH_CUSTOM_PERIOD",
  DEFAULT = "DEFAULT",
  NO_PREMIUM = "NO_PREMIUM",
  PERIOD_FIX_BID = "PERIOD_FIX_BID",
  ROI = "ROI",
  WEEK_BUDGET = "WEEK_BUDGET",
  WEEK_BUNDLE = "WEEK_BUNDLE",
}

export enum GdCampaignType {
  CONTENT_PROMOTION = "CONTENT_PROMOTION",
  CPM_BANNER = "CPM_BANNER",
  CPM_DEALS = "CPM_DEALS",
  CPM_PRICE = "CPM_PRICE",
  CPM_YNDX_FRONTPAGE = "CPM_YNDX_FRONTPAGE",
  DYNAMIC = "DYNAMIC",
  INTERNAL_AUTOBUDGET = "INTERNAL_AUTOBUDGET",
  INTERNAL_DISTRIB = "INTERNAL_DISTRIB",
  INTERNAL_FREE = "INTERNAL_FREE",
  MCBANNER = "MCBANNER",
  MOBILE_CONTENT = "MOBILE_CONTENT",
  PERFORMANCE = "PERFORMANCE",
  TEXT = "TEXT",
}

export enum GdCampaignTypeInput {
  CONTENT_PROMOTION = "CONTENT_PROMOTION",
  CPM_BANNER = "CPM_BANNER",
  CPM_DEALS = "CPM_DEALS",
  CPM_PRICE = "CPM_PRICE",
  CPM_YNDX_FRONTPAGE = "CPM_YNDX_FRONTPAGE",
  DYNAMIC = "DYNAMIC",
  INTERNAL_AUTOBUDGET = "INTERNAL_AUTOBUDGET",
  INTERNAL_DISTRIB = "INTERNAL_DISTRIB",
  INTERNAL_FREE = "INTERNAL_FREE",
  MCBANNER = "MCBANNER",
  MOBILE_CONTENT = "MOBILE_CONTENT",
  PERFORMANCE = "PERFORMANCE",
  TEXT = "TEXT",
}

export enum GdCampaignsAvailableFields {
  ALLOWED_BRANDSAFETY_CATEGORIES_CPC = "ALLOWED_BRANDSAFETY_CATEGORIES_CPC",
  ALLOWED_BRANDSAFETY_CATEGORIES_CPM = "ALLOWED_BRANDSAFETY_CATEGORIES_CPM",
  ALLOWED_PAGE_IDS = "ALLOWED_PAGE_IDS",
  ATTRIBUTION_MODEL = "ATTRIBUTION_MODEL",
  CONTENT_LANGUAGE = "CONTENT_LANGUAGE",
}

export enum GdClientMeasurerSystem {
  MEDIASCOPE = "MEDIASCOPE",
}

export enum GdClientMeasurerSystemInput {
  MEDIASCOPE = "MEDIASCOPE",
}

export enum GdClientMutationState {
  NOT_SYNCED = "NOT_SYNCED",
  SYNCED = "SYNCED",
  UNKNOWN = "UNKNOWN",
}

export enum GdContentLanguage {
  BE = "BE",
  DE = "DE",
  EN = "EN",
  KZ = "KZ",
  RU = "RU",
  TR = "TR",
  UA = "UA",
  UZ = "UZ",
}

export enum GdContentLanguageInput {
  BE = "BE",
  DE = "DE",
  EN = "EN",
  KZ = "KZ",
  RU = "RU",
  TR = "TR",
  UA = "UA",
  UZ = "UZ",
}

export enum GdContentPromotionGroupTypeInput {
  COLLECTION = "COLLECTION",
  VIDEO = "VIDEO",
}

export enum GdContentPromotionType {
  COLLECTION = "COLLECTION",
  SERVICE = "SERVICE",
  VIDEO = "VIDEO",
}

export enum GdContentPromotionTypeInput {
  COLLECTION = "COLLECTION",
  SERVICE = "SERVICE",
  VIDEO = "VIDEO",
}

export enum GdCpmGroupTypeInput {
  CPM_AUDIO = "CPM_AUDIO",
  CPM_BANNER = "CPM_BANNER",
  CPM_GEOPRODUCT = "CPM_GEOPRODUCT",
  CPM_INDOOR = "CPM_INDOOR",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_PRICE = "CPM_PRICE",
  CPM_VIDEO = "CPM_VIDEO",
  CPM_YNDX_FRONTPAGE = "CPM_YNDX_FRONTPAGE",
}

export enum GdCreativeBusinessType {
  AUTO = "AUTO",
  FLIGHTS = "FLIGHTS",
  HOTELS = "HOTELS",
  NEWS = "NEWS",
  OTHER = "OTHER",
  REALTY = "REALTY",
  RETAIL = "RETAIL",
}

export enum GdCreativeBusinessTypeInput {
  AUTO = "AUTO",
  FLIGHTS = "FLIGHTS",
  HOTELS = "HOTELS",
  NEWS = "NEWS",
  OTHER = "OTHER",
  REALTY = "REALTY",
  RETAIL = "RETAIL",
}

export enum GdCreativeStatusModerate {
  ADMINREJECT = "ADMINREJECT",
  ERROR = "ERROR",
  NEW = "NEW",
  NO = "NO",
  READY = "READY",
  SENDING = "SENDING",
  SENT = "SENT",
  YES = "YES",
}

export enum GdCreativeType {
  CANVAS = "CANVAS",
  CPC_VIDEO_CREATIVE = "CPC_VIDEO_CREATIVE",
  CPM_AUDIO_CREATIVE = "CPM_AUDIO_CREATIVE",
  CPM_GEOPRODUCT_CREATIVE = "CPM_GEOPRODUCT_CREATIVE",
  CPM_INDOOR_CREATIVE = "CPM_INDOOR_CREATIVE",
  CPM_OUTDOOR_CREATIVE = "CPM_OUTDOOR_CREATIVE",
  CPM_VIDEO_CREATIVE = "CPM_VIDEO_CREATIVE",
  HTML5_CREATIVE = "HTML5_CREATIVE",
  OVERLAY_CREATIVE = "OVERLAY_CREATIVE",
  SMART = "SMART",
  VIDEO_ADDITION = "VIDEO_ADDITION",
}

export enum GdCreativeTypeInput {
  CANVAS = "CANVAS",
  CPC_VIDEO_CREATIVE = "CPC_VIDEO_CREATIVE",
  CPM_AUDIO_CREATIVE = "CPM_AUDIO_CREATIVE",
  CPM_GEOPRODUCT_CREATIVE = "CPM_GEOPRODUCT_CREATIVE",
  CPM_INDOOR_CREATIVE = "CPM_INDOOR_CREATIVE",
  CPM_OUTDOOR_CREATIVE = "CPM_OUTDOOR_CREATIVE",
  CPM_VIDEO_CREATIVE = "CPM_VIDEO_CREATIVE",
  HTML5_CREATIVE = "HTML5_CREATIVE",
  OVERLAY_CREATIVE = "OVERLAY_CREATIVE",
  SMART = "SMART",
  VIDEO_ADDITION = "VIDEO_ADDITION",
}

export enum GdDayBudgetShowMode {
  DEFAULT_ = "DEFAULT_",
  STRETCHED = "STRETCHED",
}

export enum GdDayBudgetShowModeInput {
  DEFAULT_ = "DEFAULT_",
  STRETCHED = "STRETCHED",
}

export enum GdFeedType {
  ALIBABA = "ALIBABA",
  ALIEXPRESS = "ALIEXPRESS",
  AUTO_RU = "AUTO_RU",
  CRITEO_TURKEY = "CRITEO_TURKEY",
  GOOGLE_CUSTOM = "GOOGLE_CUSTOM",
  GOOGLE_FLIGHTS = "GOOGLE_FLIGHTS",
  GOOGLE_HOTELS = "GOOGLE_HOTELS",
  GOOGLE_MERCHANT = "GOOGLE_MERCHANT",
  GOOGLE_TRAVEL = "GOOGLE_TRAVEL",
  TRAVEL_BOOKING = "TRAVEL_BOOKING",
  TURKEY_CLIENT_1 = "TURKEY_CLIENT_1",
  TURKEY_CLIENT_10 = "TURKEY_CLIENT_10",
  TURKEY_CLIENT_11 = "TURKEY_CLIENT_11",
  TURKEY_CLIENT_12 = "TURKEY_CLIENT_12",
  TURKEY_CLIENT_13 = "TURKEY_CLIENT_13",
  TURKEY_CLIENT_14 = "TURKEY_CLIENT_14",
  TURKEY_CLIENT_15 = "TURKEY_CLIENT_15",
  TURKEY_CLIENT_16 = "TURKEY_CLIENT_16",
  TURKEY_CLIENT_17 = "TURKEY_CLIENT_17",
  TURKEY_CLIENT_18 = "TURKEY_CLIENT_18",
  TURKEY_CLIENT_19 = "TURKEY_CLIENT_19",
  TURKEY_CLIENT_2 = "TURKEY_CLIENT_2",
  TURKEY_CLIENT_20 = "TURKEY_CLIENT_20",
  TURKEY_CLIENT_21 = "TURKEY_CLIENT_21",
  TURKEY_CLIENT_22 = "TURKEY_CLIENT_22",
  TURKEY_CLIENT_23 = "TURKEY_CLIENT_23",
  TURKEY_CLIENT_24 = "TURKEY_CLIENT_24",
  TURKEY_CLIENT_25 = "TURKEY_CLIENT_25",
  TURKEY_CLIENT_3 = "TURKEY_CLIENT_3",
  TURKEY_CLIENT_4 = "TURKEY_CLIENT_4",
  TURKEY_CLIENT_5 = "TURKEY_CLIENT_5",
  TURKEY_CLIENT_6 = "TURKEY_CLIENT_6",
  TURKEY_CLIENT_7 = "TURKEY_CLIENT_7",
  TURKEY_CLIENT_8 = "TURKEY_CLIENT_8",
  TURKEY_CLIENT_9 = "TURKEY_CLIENT_9",
  TURKEY_JOLLY_TUR = "TURKEY_JOLLY_TUR",
  TURKEY_TEKNOSA = "TURKEY_TEKNOSA",
  YANDEX_CUSTOM = "YANDEX_CUSTOM",
  YANDEX_MARKET = "YANDEX_MARKET",
  YANDEX_REALTY = "YANDEX_REALTY",
  YANDEX_ZEN = "YANDEX_ZEN",
}

export enum GdFeedTypeInput {
  ALIBABA = "ALIBABA",
  ALIEXPRESS = "ALIEXPRESS",
  AUTO_RU = "AUTO_RU",
  CRITEO_TURKEY = "CRITEO_TURKEY",
  GOOGLE_CUSTOM = "GOOGLE_CUSTOM",
  GOOGLE_FLIGHTS = "GOOGLE_FLIGHTS",
  GOOGLE_HOTELS = "GOOGLE_HOTELS",
  GOOGLE_MERCHANT = "GOOGLE_MERCHANT",
  GOOGLE_TRAVEL = "GOOGLE_TRAVEL",
  TRAVEL_BOOKING = "TRAVEL_BOOKING",
  TURKEY_CLIENT_1 = "TURKEY_CLIENT_1",
  TURKEY_CLIENT_10 = "TURKEY_CLIENT_10",
  TURKEY_CLIENT_11 = "TURKEY_CLIENT_11",
  TURKEY_CLIENT_12 = "TURKEY_CLIENT_12",
  TURKEY_CLIENT_13 = "TURKEY_CLIENT_13",
  TURKEY_CLIENT_14 = "TURKEY_CLIENT_14",
  TURKEY_CLIENT_15 = "TURKEY_CLIENT_15",
  TURKEY_CLIENT_16 = "TURKEY_CLIENT_16",
  TURKEY_CLIENT_17 = "TURKEY_CLIENT_17",
  TURKEY_CLIENT_18 = "TURKEY_CLIENT_18",
  TURKEY_CLIENT_19 = "TURKEY_CLIENT_19",
  TURKEY_CLIENT_2 = "TURKEY_CLIENT_2",
  TURKEY_CLIENT_20 = "TURKEY_CLIENT_20",
  TURKEY_CLIENT_21 = "TURKEY_CLIENT_21",
  TURKEY_CLIENT_22 = "TURKEY_CLIENT_22",
  TURKEY_CLIENT_23 = "TURKEY_CLIENT_23",
  TURKEY_CLIENT_24 = "TURKEY_CLIENT_24",
  TURKEY_CLIENT_25 = "TURKEY_CLIENT_25",
  TURKEY_CLIENT_3 = "TURKEY_CLIENT_3",
  TURKEY_CLIENT_4 = "TURKEY_CLIENT_4",
  TURKEY_CLIENT_5 = "TURKEY_CLIENT_5",
  TURKEY_CLIENT_6 = "TURKEY_CLIENT_6",
  TURKEY_CLIENT_7 = "TURKEY_CLIENT_7",
  TURKEY_CLIENT_8 = "TURKEY_CLIENT_8",
  TURKEY_CLIENT_9 = "TURKEY_CLIENT_9",
  TURKEY_JOLLY_TUR = "TURKEY_JOLLY_TUR",
  TURKEY_TEKNOSA = "TURKEY_TEKNOSA",
  YANDEX_CUSTOM = "YANDEX_CUSTOM",
  YANDEX_MARKET = "YANDEX_MARKET",
  YANDEX_REALTY = "YANDEX_REALTY",
  YANDEX_ZEN = "YANDEX_ZEN",
}

export enum GdFindAndReplaceKeywordFieldInput {
  KEYWORD = "KEYWORD",
  MINUS_KEYWORDS = "MINUS_KEYWORDS",
}

export enum GdFreelancerCertificateType {
  DIRECT = "DIRECT",
  DIRECT_PRO = "DIRECT_PRO",
  METRIKA = "METRIKA",
}

export enum GdFreelancerProjectStatus {
  CANCELLED_BY_CLIENT = "CANCELLED_BY_CLIENT",
  CANCELLED_BY_FREELANCER = "CANCELLED_BY_FREELANCER",
  IN_PROGRESS = "IN_PROGRESS",
  NEW = "NEW",
}

export enum GdFreelancerSkillOfferDuration {
  FROM_14_TO_28_DAYS = "FROM_14_TO_28_DAYS",
  FROM_1_TO_3_DAYS = "FROM_1_TO_3_DAYS",
  FROM_1_TO_3_MONTHS = "FROM_1_TO_3_MONTHS",
  FROM_3_TO_7_DAYS = "FROM_3_TO_7_DAYS",
  FROM_7_TO_14_DAYS = "FROM_7_TO_14_DAYS",
  MONTHLY = "MONTHLY",
  MORE_THAN_3_MONTHS = "MORE_THAN_3_MONTHS",
  NOT_DEFINED = "NOT_DEFINED",
}

export enum GdFreelancerSkillOfferDurationInput {
  FROM_14_TO_28_DAYS = "FROM_14_TO_28_DAYS",
  FROM_1_TO_3_DAYS = "FROM_1_TO_3_DAYS",
  FROM_1_TO_3_MONTHS = "FROM_1_TO_3_MONTHS",
  FROM_3_TO_7_DAYS = "FROM_3_TO_7_DAYS",
  FROM_7_TO_14_DAYS = "FROM_7_TO_14_DAYS",
  MONTHLY = "MONTHLY",
  MORE_THAN_3_MONTHS = "MORE_THAN_3_MONTHS",
  NOT_DEFINED = "NOT_DEFINED",
}

export enum GdFreelancerStatus {
  BUSY = "BUSY",
  FREE = "FREE",
}

export enum GdFreelancerStatusInput {
  BUSY = "BUSY",
  FREE = "FREE",
}

export enum GdFreelancerUgcModerationStatus {
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  IN_PROGRESS = "IN_PROGRESS",
}

export enum GdFreelancersCardStatusModerate {
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  DRAFT = "DRAFT",
  IN_PROGRESS = "IN_PROGRESS",
}

export enum GdGenderType {
  FEMALE = "FEMALE",
  MALE = "MALE",
}

export enum GdGenderTypeInput {
  FEMALE = "FEMALE",
  MALE = "MALE",
}

export enum GdGeotreeType {
  GLOBAL = "GLOBAL",
  RUSSIAN = "RUSSIAN",
}

export enum GdGoalType {
  AB_SEGMENT = "AB_SEGMENT",
  AUDIENCE = "AUDIENCE",
  AUDIO_GENRES = "AUDIO_GENRES",
  BEHAVIORS = "BEHAVIORS",
  BRANDSAFETY = "BRANDSAFETY",
  ECOMMERCE = "ECOMMERCE",
  FAMILY = "FAMILY",
  GOAL = "GOAL",
  INTERESTS = "INTERESTS",
  SEGMENT = "SEGMENT",
  SOCIAL_DEMO = "SOCIAL_DEMO",
}

export enum GdGoalTypeInput {
  AB_SEGMENT = "AB_SEGMENT",
  AUDIENCE = "AUDIENCE",
  AUDIO_GENRES = "AUDIO_GENRES",
  BEHAVIORS = "BEHAVIORS",
  BRANDSAFETY = "BRANDSAFETY",
  ECOMMERCE = "ECOMMERCE",
  FAMILY = "FAMILY",
  GOAL = "GOAL",
  INTERESTS = "INTERESTS",
  SEGMENT = "SEGMENT",
  SOCIAL_DEMO = "SOCIAL_DEMO",
}

export enum GdGroupBlGenerationStatus {
  INAPPLICABLE = "INAPPLICABLE",
  NO = "NO",
  PROCESSING = "PROCESSING",
  YES = "YES",
}

export enum GdInstantMessengerType {
  ICQ = "ICQ",
  JABBER = "JABBER",
  MAIL_AGENT = "MAIL_AGENT",
  MSN = "MSN",
  SKYPE = "SKYPE",
}

export enum GdInstantMessengerTypeInput {
  ICQ = "ICQ",
  JABBER = "JABBER",
  MAIL_AGENT = "MAIL_AGENT",
  MSN = "MSN",
  SKYPE = "SKYPE",
}

export enum GdInventoryType {
  INBANNER = "INBANNER",
  INPAGE = "INPAGE",
  INSTREAM_WEB = "INSTREAM_WEB",
  INTERSTITIAL = "INTERSTITIAL",
  REWARDED = "REWARDED",
}

export enum GdInventoryTypeInput {
  INBANNER = "INBANNER",
  INPAGE = "INPAGE",
  INSTREAM_WEB = "INSTREAM_WEB",
  INTERSTITIAL = "INTERSTITIAL",
  REWARDED = "REWARDED",
}

export enum GdLanguageInput {
  EN = "EN",
  RU = "RU",
  TR = "TR",
  UK = "UK",
}

export enum GdMenuItem {
  ADMIN = "ADMIN",
  ADMIN_AGENCY = "ADMIN_AGENCY",
  ADMIN_MANAGER = "ADMIN_MANAGER",
  ADVANCED_FORECAST = "ADVANCED_FORECAST",
  AGENCY_SEARCH = "AGENCY_SEARCH",
  CREATE = "CREATE",
  DEALS_LIST = "DEALS_LIST",
  INTERNAL_AD_MANAGE_MARKETERS = "INTERNAL_AD_MANAGE_MARKETERS",
  INTERNAL_AD_MANAGE_PRODUCTS = "INTERNAL_AD_MANAGE_PRODUCTS",
  INTERNAL_AD_SEARCH = "INTERNAL_AD_SEARCH",
  RECOMMENDATIONS = "RECOMMENDATIONS",
  SHOW_AGENCY_CLIENTS = "SHOW_AGENCY_CLIENTS",
  SHOW_CAMPS = "SHOW_CAMPS",
  SHOW_MANAGER_CLIENTS = "SHOW_MANAGER_CLIENTS",
  SHOW_MINUS_KEYWORDS_LIB = "SHOW_MINUS_KEYWORDS_LIB",
  SHOW_SEARCH_PAGE = "SHOW_SEARCH_PAGE",
  TURBO_LANDING_CONSTRUCTOR = "TURBO_LANDING_CONSTRUCTOR",
  WORDSTAT = "WORDSTAT",
}

export enum GdMetroCityInput {
  KYIV = "KYIV",
  MOSCOW = "MOSCOW",
  SAINT_PETERSBURG = "SAINT_PETERSBURG",
}

export enum GdMobileOsTypeInput {
  ANDROID = "ANDROID",
  IOS = "IOS",
}

export enum GdOperationType {
  EQ = "EQ",
  GE = "GE",
  LE = "LE",
}

export enum GdOperationTypeInput {
  EQ = "EQ",
  GE = "GE",
  LE = "LE",
}

export enum GdOperatorAction {
  ACCEPT_ADS_CALLOUTS_MODERATION = "ACCEPT_ADS_CALLOUTS_MODERATION",
  ACCEPT_MODERATION = "ACCEPT_MODERATION",
  APPROVE_PRICE_PACKAGES = "APPROVE_PRICE_PACKAGES",
  CAN_OPEN_PRICE_PACKAGE_GRID = "CAN_OPEN_PRICE_PACKAGE_GRID",
  COPY = "COPY",
  MANAGE_PRICE_PACKAGES = "MANAGE_PRICE_PACKAGES",
  REMODERATE_ADS_CALLOUTS = "REMODERATE_ADS_CALLOUTS",
  REMODERATE_CAMPAIGN = "REMODERATE_CAMPAIGN",
  SEND_TO_BS = "SEND_TO_BS",
  SEND_TO_MODERATION = "SEND_TO_MODERATION",
  SEND_TO_MODERATION_BY_CLIENT = "SEND_TO_MODERATION_BY_CLIENT",
  SEND_TO_REMODERATION = "SEND_TO_REMODERATION",
}

export enum GdOrganizationStatusPublish {
  PUBLISHED = "PUBLISHED",
  UNKNOWN = "UNKNOWN",
  UNPUBLISHED = "UNPUBLISHED",
}

export enum GdOsType {
  ANDROID = "ANDROID",
  IOS = "IOS",
}

export enum GdOsTypeInput {
  ANDROID = "ANDROID",
  IOS = "IOS",
}

export enum GdPageOrderByFieldInput {
  CLICKS = "CLICKS",
  COST = "COST",
}

export enum GdPixelKind {
  AUDIENCE = "AUDIENCE",
  AUDIT = "AUDIT",
}

export enum GdPixelKindInput {
  AUDIENCE = "AUDIENCE",
  AUDIT = "AUDIT",
}

export enum GdPointPrecision {
  EXACT = "EXACT",
  NEAR = "NEAR",
  NUMBER = "NUMBER",
  OTHER = "OTHER",
  RANGE = "RANGE",
  STREET = "STREET",
}

export enum GdPriceFlightStatusApprove {
  NEW = "NEW",
  NO = "NO",
  YES = "YES",
}

export enum GdPriceFlightStatusCorrect {
  NEW = "NEW",
  NO = "NO",
  YES = "YES",
}

export enum GdPriceFlightViewType {
  DESKTOP = "DESKTOP",
  MOBILE = "MOBILE",
  NEW_TAB = "NEW_TAB",
}

export enum GdPriceFlightViewTypeInput {
  DESKTOP = "DESKTOP",
  MOBILE = "MOBILE",
  NEW_TAB = "NEW_TAB",
}

export enum GdProductCalcTypeInput {
  CPC = "CPC",
  CPM = "CPM",
}

export enum GdProductType {
  ANTICONTEXT = "ANTICONTEXT",
  CPM_AUDIO = "CPM_AUDIO",
  CPM_BANNER = "CPM_BANNER",
  CPM_DEALS = "CPM_DEALS",
  CPM_INDOOR = "CPM_INDOOR",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_PRICE = "CPM_PRICE",
  CPM_VIDEO = "CPM_VIDEO",
  CPM_YNDX_FRONTPAGE = "CPM_YNDX_FRONTPAGE",
  GEO = "GEO",
  INTERNAL_AUTOBUDGET = "INTERNAL_AUTOBUDGET",
  INTERNAL_DISTRIB = "INTERNAL_DISTRIB",
  INTERNAL_FREE = "INTERNAL_FREE",
  MCB = "MCB",
  MCB_PKG = "MCB_PKG",
  MCB_REGIONAL = "MCB_REGIONAL",
  MCB_TURKISH = "MCB_TURKISH",
  SOCDEM = "SOCDEM",
  TEXT = "TEXT",
}

export enum GdProductTypeInput {
  ANTICONTEXT = "ANTICONTEXT",
  CPM_AUDIO = "CPM_AUDIO",
  CPM_BANNER = "CPM_BANNER",
  CPM_DEALS = "CPM_DEALS",
  CPM_INDOOR = "CPM_INDOOR",
  CPM_OUTDOOR = "CPM_OUTDOOR",
  CPM_PRICE = "CPM_PRICE",
  CPM_VIDEO = "CPM_VIDEO",
  CPM_YNDX_FRONTPAGE = "CPM_YNDX_FRONTPAGE",
  GEO = "GEO",
  INTERNAL_AUTOBUDGET = "INTERNAL_AUTOBUDGET",
  INTERNAL_DISTRIB = "INTERNAL_DISTRIB",
  INTERNAL_FREE = "INTERNAL_FREE",
  MCB = "MCB",
  MCB_PKG = "MCB_PKG",
  MCB_REGIONAL = "MCB_REGIONAL",
  MCB_TURKISH = "MCB_TURKISH",
  SOCDEM = "SOCDEM",
  TEXT = "TEXT",
}

export enum GdRecommendationSign {
  CPA = "CPA",
  CPC = "CPC",
  ROI = "ROI",
}

export enum GdRecommendationStatus {
  CANCELLED = "CANCELLED",
  DONE = "DONE",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  READY = "READY",
}

export enum GdResourceType {
  AGE = "AGE",
  IMAGE = "IMAGE",
  TEXT = "TEXT",
  URL = "URL",
}

export enum GdResourceValueRestrictionType {
  IMAGE_DIMENSIONS_EQ = "IMAGE_DIMENSIONS_EQ",
  IMAGE_DIMENSIONS_MAX = "IMAGE_DIMENSIONS_MAX",
  IMAGE_DIMENSIONS_MIN = "IMAGE_DIMENSIONS_MIN",
  IMAGE_FORMAT_IN = "IMAGE_FORMAT_IN",
  IMAGE_SIZE_KB_MAX = "IMAGE_SIZE_KB_MAX",
  TEXT_LENGTH_MAX = "TEXT_LENGTH_MAX",
  TEXT_LENGTH_MIN = "TEXT_LENGTH_MIN",
  URL_CORRECT = "URL_CORRECT",
}

export enum GdRestrictionImageFormat {
  GIF = "GIF",
  JPEG = "JPEG",
  PNG = "PNG",
  SVG = "SVG",
}

export enum GdRetargetingBaseStatusInput {
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
}

export enum GdRetargetingConditionRuleType {
  ALL = "ALL",
  NOT = "NOT",
  OR = "OR",
}

export enum GdRetargetingConditionRuleTypeInput {
  ALL = "ALL",
  NOT = "NOT",
  OR = "OR",
}

export enum GdRetargetingConditionTypeInput {
  AB_SEGMENTS = "AB_SEGMENTS",
  DMP = "DMP",
  INTERESTS = "INTERESTS",
  METRIKA_GOALS = "METRIKA_GOALS",
}

export enum GdRetargetingOrderByFieldInput {
  AUTOBUDGET_PRIORITY = "AUTOBUDGET_PRIORITY",
  BANNER_ID = "BANNER_ID",
  CAMPAIGN_ID = "CAMPAIGN_ID",
  GROUP_ID = "GROUP_ID",
  ID = "ID",
  NAME = "NAME",
  PRICE_CONTEXT = "PRICE_CONTEXT",
  RETARGETING_CONDITION_ID = "RETARGETING_CONDITION_ID",
  STAT_AVG_CLICK_COST = "STAT_AVG_CLICK_COST",
  STAT_AVG_CLICK_POSITION = "STAT_AVG_CLICK_POSITION",
  STAT_AVG_DEPTH = "STAT_AVG_DEPTH",
  STAT_AVG_GOAL_COST = "STAT_AVG_GOAL_COST",
  STAT_AVG_SHOW_POSITION = "STAT_AVG_SHOW_POSITION",
  STAT_BOUNCE_RATE = "STAT_BOUNCE_RATE",
  STAT_CLICKS = "STAT_CLICKS",
  STAT_CONVERSION_RATE = "STAT_CONVERSION_RATE",
  STAT_COST = "STAT_COST",
  STAT_CPM_PRICE = "STAT_CPM_PRICE",
  STAT_CTR = "STAT_CTR",
  STAT_GOALS = "STAT_GOALS",
  STAT_PROFITABILITY = "STAT_PROFITABILITY",
  STAT_REVENUE = "STAT_REVENUE",
  STAT_SHOWS = "STAT_SHOWS",
}

export enum GdSelfStatusEnum {
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  PAUSE_CRIT = "PAUSE_CRIT",
  PAUSE_OK = "PAUSE_OK",
  PAUSE_WARN = "PAUSE_WARN",
  RUN_OK = "RUN_OK",
  RUN_WARN = "RUN_WARN",
  STOP_CRIT = "STOP_CRIT",
  STOP_OK = "STOP_OK",
  STOP_WARN = "STOP_WARN",
}

export enum GdSelfStatusReason {
  ACTIVE = "ACTIVE",
  ADGROUP_HAS_NO_ADS_ELIGIBLE_FOR_SERVING = "ADGROUP_HAS_NO_ADS_ELIGIBLE_FOR_SERVING",
  ADGROUP_HAS_NO_SHOW_CONDITIONS_ELIGIBLE_FOR_SERVING = "ADGROUP_HAS_NO_SHOW_CONDITIONS_ELIGIBLE_FOR_SERVING",
  ADGROUP_SHOW_CONDITIONS_ON_MODERATION = "ADGROUP_SHOW_CONDITIONS_ON_MODERATION",
  ARCHIVED = "ARCHIVED",
  CAMPAIGN_ACTIVE = "CAMPAIGN_ACTIVE",
  CAMPAIGN_ADD_MONEY = "CAMPAIGN_ADD_MONEY",
  CAMPAIGN_ADD_MONEY_TO_WALLET = "CAMPAIGN_ADD_MONEY_TO_WALLET",
  CAMPAIGN_HAS_INACTIVE_BANNERS = "CAMPAIGN_HAS_INACTIVE_BANNERS",
  CAMPAIGN_HAS_NO_ADS_ELIGIBLE_FOR_SERVING = "CAMPAIGN_HAS_NO_ADS_ELIGIBLE_FOR_SERVING",
  CAMPAIGN_IS_IN_PROGRESS = "CAMPAIGN_IS_IN_PROGRESS",
  CAMPAIGN_IS_NOT_RECOVERABLE = "CAMPAIGN_IS_NOT_RECOVERABLE",
  CAMPAIGN_IS_OVER = "CAMPAIGN_IS_OVER",
  CAMPAIGN_IS_PAUSED_BY_DAY_BUDGET = "CAMPAIGN_IS_PAUSED_BY_DAY_BUDGET",
  CAMPAIGN_IS_PAUSED_BY_TIMETARGETING = "CAMPAIGN_IS_PAUSED_BY_TIMETARGETING",
  CAMPAIGN_IS_PAUSED_BY_WALLET_DAY_BUDGET = "CAMPAIGN_IS_PAUSED_BY_WALLET_DAY_BUDGET",
  CAMPAIGN_IS_WAITING_START = "CAMPAIGN_IS_WAITING_START",
  CAMPAIGN_NO_ACTIVE_BANNERS = "CAMPAIGN_NO_ACTIVE_BANNERS",
  CAMPAIGN_UNARCHIVING_IN_PROGRESS = "CAMPAIGN_UNARCHIVING_IN_PROGRESS",
  CAMPAIGN_WAIT_PAYMENT = "CAMPAIGN_WAIT_PAYMENT",
  DISPLAY_HREF_REJECTED_ON_MODERATION = "DISPLAY_HREF_REJECTED_ON_MODERATION",
  DRAFT = "DRAFT",
  HAS_REJECTED_CALLOUTS = "HAS_REJECTED_CALLOUTS",
  HAS_REJECTED_PLACEMENTS = "HAS_REJECTED_PLACEMENTS",
  HAS_REJECTED_SITELINKS = "HAS_REJECTED_SITELINKS",
  IMAGE_REJECTED_ON_MODERATION = "IMAGE_REJECTED_ON_MODERATION",
  INCOMPLETE_ADGROUP = "INCOMPLETE_ADGROUP",
  NOTHING = "NOTHING",
  NO_MONEY = "NO_MONEY",
  NO_SHOW_CONDITIONS = "NO_SHOW_CONDITIONS",
  OFF_BY_MONITORING = "OFF_BY_MONITORING",
  ON_MODERATION = "ON_MODERATION",
  ON_MODERATION_PREVIOUS_VERSION_SHOWN = "ON_MODERATION_PREVIOUS_VERSION_SHOWN",
  REJECTED_BUT_PREVIOUS_VERSION_SHOWN = "REJECTED_BUT_PREVIOUS_VERSION_SHOWN",
  REJECTED_ON_MODERATION = "REJECTED_ON_MODERATION",
  RELEVANCE_MATCH_SUSPENDED_BY_USER = "RELEVANCE_MATCH_SUSPENDED_BY_USER",
  SUSPENDED_BY_USER = "SUSPENDED_BY_USER",
  TURBOLANDING_REJECTED_ON_MODERATION = "TURBOLANDING_REJECTED_ON_MODERATION",
  VCARD_REJECTED_ON_MODERATION = "VCARD_REJECTED_ON_MODERATION",
  VIDEO_ADDITION_REJECTED_ON_MODERATION = "VIDEO_ADDITION_REJECTED_ON_MODERATION",
}

export enum GdShowConditionAutobudgetPriority {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export enum GdShowConditionAutobudgetPriorityInput {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export enum GdShowConditionBaseStatusInput {
  ACTIVE = "ACTIVE",
  DRAFT = "DRAFT",
  SUSPENDED = "SUSPENDED",
}

export enum GdShowConditionOrderByFieldInput {
  AUTOBUDGET_PRIORITY = "AUTOBUDGET_PRIORITY",
  CAMPAIGN_ID = "CAMPAIGN_ID",
  GROUP_ID = "GROUP_ID",
  ID = "ID",
  KEYWORD = "KEYWORD",
  PRICE = "PRICE",
  PRICE_CONTEXT = "PRICE_CONTEXT",
  STAT_AVG_CLICK_COST = "STAT_AVG_CLICK_COST",
  STAT_AVG_CLICK_POSITION = "STAT_AVG_CLICK_POSITION",
  STAT_AVG_DEPTH = "STAT_AVG_DEPTH",
  STAT_AVG_GOAL_COST = "STAT_AVG_GOAL_COST",
  STAT_AVG_SHOW_POSITION = "STAT_AVG_SHOW_POSITION",
  STAT_BOUNCE_RATE = "STAT_BOUNCE_RATE",
  STAT_CLICKS = "STAT_CLICKS",
  STAT_CONVERSION_RATE = "STAT_CONVERSION_RATE",
  STAT_COST = "STAT_COST",
  STAT_COST_PER_ACTION = "STAT_COST_PER_ACTION",
  STAT_CPM_PRICE = "STAT_CPM_PRICE",
  STAT_CTR = "STAT_CTR",
  STAT_GOALS = "STAT_GOALS",
  STAT_PROFITABILITY = "STAT_PROFITABILITY",
  STAT_REVENUE = "STAT_REVENUE",
  STAT_SHOWS = "STAT_SHOWS",
  TYPE = "TYPE",
}

export enum GdShowConditionPrimaryStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MODERATION_REJECTED = "MODERATION_REJECTED",
  STOPPED = "STOPPED",
}

export enum GdShowConditionPrimaryStatusInput {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  MODERATION_REJECTED = "MODERATION_REJECTED",
  STOPPED = "STOPPED",
}

export enum GdShowConditionStatusModerate {
  NEW = "NEW",
  NO = "NO",
  YES = "YES",
}

export enum GdShowConditionType {
  DYNAMIC_TARGETING = "DYNAMIC_TARGETING",
  FILTERS = "FILTERS",
  KEYWORD = "KEYWORD",
  MOBILE_INTERESTS = "MOBILE_INTERESTS",
  RELEVANCE_MATCH = "RELEVANCE_MATCH",
  RETARGETING = "RETARGETING",
  USER_PROFILE = "USER_PROFILE",
}

export enum GdShowConditionTypeInput {
  DYNAMIC_TARGETING = "DYNAMIC_TARGETING",
  FILTERS = "FILTERS",
  KEYWORD = "KEYWORD",
  MOBILE_INTERESTS = "MOBILE_INTERESTS",
  RELEVANCE_MATCH = "RELEVANCE_MATCH",
  RETARGETING = "RETARGETING",
  USER_PROFILE = "USER_PROFILE",
}

export enum GdSmartFilterBaseStatusInput {
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
}

export enum GdSmartFilterConditionOperator {
  CONTAINS_ANY = "CONTAINS_ANY",
  EQUALS_ANY = "EQUALS_ANY",
  EXISTS = "EXISTS",
  GREATER_THAN = "GREATER_THAN",
  LESS_THAN = "LESS_THAN",
  NOT_CONTAINS_ALL = "NOT_CONTAINS_ALL",
  RANGE = "RANGE",
}

export enum GdSmartFilterConditionOperatorInput {
  CONTAINS_ANY = "CONTAINS_ANY",
  EQUALS_ANY = "EQUALS_ANY",
  EXISTS = "EXISTS",
  GREATER_THAN = "GREATER_THAN",
  LESS_THAN = "LESS_THAN",
  NOT_CONTAINS_ALL = "NOT_CONTAINS_ALL",
  RANGE = "RANGE",
}

export enum GdSmartFilterOrderByFieldInput {
  AUTOBUDGET_PRIORITY = "AUTOBUDGET_PRIORITY",
  CAMPAIGN_ID = "CAMPAIGN_ID",
  FILTER_NAME = "FILTER_NAME",
  GROUP_ID = "GROUP_ID",
  ID = "ID",
  PRICE_CPA = "PRICE_CPA",
  PRICE_CPC = "PRICE_CPC",
  STAT_AVG_CLICK_COST = "STAT_AVG_CLICK_COST",
  STAT_AVG_CLICK_POSITION = "STAT_AVG_CLICK_POSITION",
  STAT_AVG_DEPTH = "STAT_AVG_DEPTH",
  STAT_AVG_GOAL_COST = "STAT_AVG_GOAL_COST",
  STAT_AVG_SHOW_POSITION = "STAT_AVG_SHOW_POSITION",
  STAT_BOUNCE_RATE = "STAT_BOUNCE_RATE",
  STAT_CLICKS = "STAT_CLICKS",
  STAT_CONVERSION_RATE = "STAT_CONVERSION_RATE",
  STAT_COST = "STAT_COST",
  STAT_COST_PER_ACTION = "STAT_COST_PER_ACTION",
  STAT_CPM_PRICE = "STAT_CPM_PRICE",
  STAT_CTR = "STAT_CTR",
  STAT_GOALS = "STAT_GOALS",
  STAT_PROFITABILITY = "STAT_PROFITABILITY",
  STAT_REVENUE = "STAT_REVENUE",
  STAT_SHOWS = "STAT_SHOWS",
}

export enum GdSmartFilterPrimaryStatus {
  ACTIVE = "ACTIVE",
  STOPPED = "STOPPED",
}

export enum GdSmartFilterTab {
  ALL_PRODUCTS = "ALL_PRODUCTS",
  CONDITION = "CONDITION",
  TREE = "TREE",
}

export enum GdSmartFilterTabInput {
  ALL_PRODUCTS = "ALL_PRODUCTS",
  CONDITION = "CONDITION",
  TREE = "TREE",
}

export enum GdSmartFilterTargetFunnel {
  NEW_AUDITORY = "NEW_AUDITORY",
  PRODUCT_PAGE_VISIT = "PRODUCT_PAGE_VISIT",
  SAME_PRODUCTS = "SAME_PRODUCTS",
}

export enum GdSmartFilterTargetFunnelInput {
  NEW_AUDITORY = "NEW_AUDITORY",
  PRODUCT_PAGE_VISIT = "PRODUCT_PAGE_VISIT",
  SAME_PRODUCTS = "SAME_PRODUCTS",
}

export enum GdStatPresetInput {
  CURRENT_MONTH = "CURRENT_MONTH",
  CURRENT_WEEK = "CURRENT_WEEK",
  LAST_30DAYS = "LAST_30DAYS",
  LAST_7DAYS = "LAST_7DAYS",
  PREVIOUS_MONTH = "PREVIOUS_MONTH",
  PREVIOUS_WEEK = "PREVIOUS_WEEK",
  RECOMMENDATIONS_PERIOD = "RECOMMENDATIONS_PERIOD",
  TODAY = "TODAY",
  YESTERDAY = "YESTERDAY",
}

export enum GdStatusApprove {
  NEW = "NEW",
  NO = "NO",
  WAITING = "WAITING",
  YES = "YES",
}

export enum GdStatusApproveInput {
  NEW = "NEW",
  NO = "NO",
  WAITING = "WAITING",
  YES = "YES",
}

export enum GdStrategyType {
  AVG_CLICK = "AVG_CLICK",
  AVG_CPA = "AVG_CPA",
  AVG_CPA_PER_CAMP = "AVG_CPA_PER_CAMP",
  AVG_CPA_PER_FILTER = "AVG_CPA_PER_FILTER",
  AVG_CPC_PER_CAMP = "AVG_CPC_PER_CAMP",
  AVG_CPC_PER_FILTER = "AVG_CPC_PER_FILTER",
  AVG_CPI = "AVG_CPI",
  CPM_DEFAULT = "CPM_DEFAULT",
  CPM_MAX_IMPRESSIONS = "CPM_MAX_IMPRESSIONS",
  CPM_MAX_IMPRESSIONS_CUSTOM_PERIOD = "CPM_MAX_IMPRESSIONS_CUSTOM_PERIOD",
  CPM_MAX_REACH = "CPM_MAX_REACH",
  CPM_MAX_REACH_CUSTOM_PERIOD = "CPM_MAX_REACH_CUSTOM_PERIOD",
  DEFAULT = "DEFAULT",
  NO_PREMIUM = "NO_PREMIUM",
  OPTIMIZE_CLICKS = "OPTIMIZE_CLICKS",
  OPTIMIZE_CONVERSIONS = "OPTIMIZE_CONVERSIONS",
  OPTIMIZE_INSTALLS = "OPTIMIZE_INSTALLS",
  PERIOD_FIX_BID = "PERIOD_FIX_BID",
  ROI = "ROI",
  WEEK_BUDGET = "WEEK_BUDGET",
  WEEK_BUNDLE = "WEEK_BUNDLE",
}

export enum GdStrategyTypeInput {
  AVG_CLICK = "AVG_CLICK",
  AVG_CPA = "AVG_CPA",
  AVG_CPA_PER_CAMP = "AVG_CPA_PER_CAMP",
  AVG_CPA_PER_FILTER = "AVG_CPA_PER_FILTER",
  AVG_CPC_PER_CAMP = "AVG_CPC_PER_CAMP",
  AVG_CPC_PER_FILTER = "AVG_CPC_PER_FILTER",
  AVG_CPI = "AVG_CPI",
  CPM_DEFAULT = "CPM_DEFAULT",
  CPM_MAX_IMPRESSIONS = "CPM_MAX_IMPRESSIONS",
  CPM_MAX_IMPRESSIONS_CUSTOM_PERIOD = "CPM_MAX_IMPRESSIONS_CUSTOM_PERIOD",
  CPM_MAX_REACH = "CPM_MAX_REACH",
  CPM_MAX_REACH_CUSTOM_PERIOD = "CPM_MAX_REACH_CUSTOM_PERIOD",
  DEFAULT = "DEFAULT",
  NO_PREMIUM = "NO_PREMIUM",
  OPTIMIZE_CLICKS = "OPTIMIZE_CLICKS",
  OPTIMIZE_CONVERSIONS = "OPTIMIZE_CONVERSIONS",
  OPTIMIZE_INSTALLS = "OPTIMIZE_INSTALLS",
  PERIOD_FIX_BID = "PERIOD_FIX_BID",
  ROI = "ROI",
  WEEK_BUDGET = "WEEK_BUDGET",
  WEEK_BUNDLE = "WEEK_BUNDLE",
}

export enum GdStringDictName {
  DISTRIB_SOFT = "DISTRIB_SOFT",
  UA_TRAITS_BROWSER_BASE = "UA_TRAITS_BROWSER_BASE",
  UA_TRAITS_BROWSER_ENGINE = "UA_TRAITS_BROWSER_ENGINE",
  UA_TRAITS_BROWSER_NAME = "UA_TRAITS_BROWSER_NAME",
  UA_TRAITS_DEVICE_VENDOR = "UA_TRAITS_DEVICE_VENDOR",
  UA_TRAITS_OS_FAMILY = "UA_TRAITS_OS_FAMILY",
  UA_TRAITS_OS_NAME = "UA_TRAITS_OS_NAME",
}

export enum GdStringDictNameInput {
  DISTRIB_SOFT = "DISTRIB_SOFT",
  UA_TRAITS_BROWSER_BASE = "UA_TRAITS_BROWSER_BASE",
  UA_TRAITS_BROWSER_ENGINE = "UA_TRAITS_BROWSER_ENGINE",
  UA_TRAITS_BROWSER_NAME = "UA_TRAITS_BROWSER_NAME",
  UA_TRAITS_DEVICE_VENDOR = "UA_TRAITS_DEVICE_VENDOR",
  UA_TRAITS_OS_FAMILY = "UA_TRAITS_OS_FAMILY",
  UA_TRAITS_OS_NAME = "UA_TRAITS_OS_NAME",
}

export enum GdSurveyStatus {
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  DRAFT = "DRAFT",
  MODERATION = "MODERATION",
  MODERATION_REJECTED = "MODERATION_REJECTED",
  UNFEASIBLE = "UNFEASIBLE",
}

export enum GdUpdateAdGroupMinusKeywordsActionInput {
  ADD = "ADD",
  REMOVE = "REMOVE",
}

export enum GdUpdateAdGroupRegionsActionInput {
  ADD = "ADD",
  REMOVE = "REMOVE",
  REPLACE = "REPLACE",
}

export enum GdUpdateStatus {
  DONE = "DONE",
  ERROR = "ERROR",
  NEW = "NEW",
  OUTDATED = "OUTDATED",
  UPDATING = "UPDATING",
}

export enum GdVideoGoalType {
  COMPLETE = "COMPLETE",
  FIRST_QUARTILE = "FIRST_QUARTILE",
  MIDPOINT = "MIDPOINT",
  START = "START",
  THIRD_QUARTILE = "THIRD_QUARTILE",
}

export enum GdVideoGoalTypeInput {
  COMPLETE = "COMPLETE",
  FIRST_QUARTILE = "FIRST_QUARTILE",
  MIDPOINT = "MIDPOINT",
  START = "START",
  THIRD_QUARTILE = "THIRD_QUARTILE",
}

export enum GdViewType {
  DESKTOP = "DESKTOP",
  MOBILE = "MOBILE",
  NEW_TAB = "NEW_TAB",
}

export enum GdViewTypeInput {
  DESKTOP = "DESKTOP",
  MOBILE = "MOBILE",
  NEW_TAB = "NEW_TAB",
}

export enum GdWalletAction {
  EDIT = "EDIT",
  PAY = "PAY",
}

export enum GdWalletBudgetShowMode {
  DEFAULT = "DEFAULT",
  STRETCHED = "STRETCHED",
}

export enum GdWalletBudgetType {
  DAY_BUDGET = "DAY_BUDGET",
  NO_BUDGET = "NO_BUDGET",
}

export enum GdWeatherType {
  CLOUDNESS = "CLOUDNESS",
  PREC_STRENGTH = "PREC_STRENGTH",
  TEMP = "TEMP",
}

export enum GdWeatherTypeInput {
  CLOUDNESS = "CLOUDNESS",
  PREC_STRENGTH = "PREC_STRENGTH",
  TEMP = "TEMP",
}

export enum GdiDealOrderByFieldInput {
  CLICKS = "CLICKS",
  COMPLETE_REASON = "COMPLETE_REASON",
  CPC = "CPC",
  CPM = "CPM",
  CTR = "CTR",
  DEAL_TYPE = "DEAL_TYPE",
  ID = "ID",
  MIN_PRICE = "MIN_PRICE",
  NAME = "NAME",
  SHOWS = "SHOWS",
  SPENT = "SPENT",
  STATUS = "STATUS",
}

export enum GdiRecommendationType {
  addAdditionItemCallouts = "addAdditionItemCallouts",
  addBannerDisplayHrefs = "addBannerDisplayHrefs",
  addBannerFormats = "addBannerFormats",
  addImageToBanner = "addImageToBanner",
  addMorePicturesToAdgroup = "addMorePicturesToAdgroup",
  addSiteLinks = "addSiteLinks",
  addTitleExtension = "addTitleExtension",
  addTurboWebSiteToBanner = "addTurboWebSiteToBanner",
  changeAdGroupForModeration = "changeAdGroupForModeration",
  changeAdGroupWithLowStat = "changeAdGroupWithLowStat",
  changeBannerForModeration = "changeBannerForModeration",
  chooseAppropriatePlacementsForAdGroup = "chooseAppropriatePlacementsForAdGroup",
  chooseAppropriatePlacementsForBanner = "chooseAppropriatePlacementsForBanner",
  dailyBudget = "dailyBudget",
  removePagesFromBlackList = "removePagesFromBlackList",
  removePagesFromBlackListOfACampaign = "removePagesFromBlackListOfACampaign",
  sendLicensesBanks = "sendLicensesBanks",
  sendLicensesMedServices = "sendLicensesMedServices",
  sendLicensesPharmacy = "sendLicensesPharmacy",
  strategryWeeklyBudget = "strategryWeeklyBudget",
  strategyROICoef = "strategyROICoef",
  strategyTargetCPA = "strategyTargetCPA",
  switchOnAutotargeting = "switchOnAutotargeting",
  uploadAppropriateCreatives = "uploadAppropriateCreatives",
  weeklyBudget = "weeklyBudget",
}

export enum GdiRecommendationTypeInput {
  addAdditionItemCallouts = "addAdditionItemCallouts",
  addBannerDisplayHrefs = "addBannerDisplayHrefs",
  addBannerFormats = "addBannerFormats",
  addImageToBanner = "addImageToBanner",
  addMorePicturesToAdgroup = "addMorePicturesToAdgroup",
  addSiteLinks = "addSiteLinks",
  addTitleExtension = "addTitleExtension",
  addTurboWebSiteToBanner = "addTurboWebSiteToBanner",
  changeAdGroupForModeration = "changeAdGroupForModeration",
  changeAdGroupWithLowStat = "changeAdGroupWithLowStat",
  changeBannerForModeration = "changeBannerForModeration",
  chooseAppropriatePlacementsForAdGroup = "chooseAppropriatePlacementsForAdGroup",
  chooseAppropriatePlacementsForBanner = "chooseAppropriatePlacementsForBanner",
  dailyBudget = "dailyBudget",
  removePagesFromBlackList = "removePagesFromBlackList",
  removePagesFromBlackListOfACampaign = "removePagesFromBlackListOfACampaign",
  sendLicensesBanks = "sendLicensesBanks",
  sendLicensesMedServices = "sendLicensesMedServices",
  sendLicensesPharmacy = "sendLicensesPharmacy",
  strategryWeeklyBudget = "strategryWeeklyBudget",
  strategyROICoef = "strategyROICoef",
  strategyTargetCPA = "strategyTargetCPA",
  switchOnAutotargeting = "switchOnAutotargeting",
  uploadAppropriateCreatives = "uploadAppropriateCreatives",
  weeklyBudget = "weeklyBudget",
}

export enum GoalSubtype {
  APPMETRICA_API_KEY = "APPMETRICA_API_KEY",
  APPMETRICA_SEGMENT_ID = "APPMETRICA_SEGMENT_ID",
  COMPOSITION_INTERSECT = "COMPOSITION_INTERSECT",
  COMPOSITION_SUBTRACT = "COMPOSITION_SUBTRACT",
  COMPOSITION_UNION = "COMPOSITION_UNION",
  GEO_CONDITION = "GEO_CONDITION",
  GEO_HOME = "GEO_HOME",
  GEO_LAST = "GEO_LAST",
  GEO_REGULAR = "GEO_REGULAR",
  GEO_WORK = "GEO_WORK",
  LOOKALIKE = "LOOKALIKE",
  METRIKA_COUNTER_ID = "METRIKA_COUNTER_ID",
  METRIKA_GOAL_ID = "METRIKA_GOAL_ID",
  METRIKA_SEGMENT_ID = "METRIKA_SEGMENT_ID",
  PIXEL = "PIXEL",
  UPLOADING_CLIENT_ID = "UPLOADING_CLIENT_ID",
  UPLOADING_CRM = "UPLOADING_CRM",
  UPLOADING_EMAIL = "UPLOADING_EMAIL",
  UPLOADING_IDFA_GAID = "UPLOADING_IDFA_GAID",
  UPLOADING_MAC = "UPLOADING_MAC",
  UPLOADING_PHONE = "UPLOADING_PHONE",
  UPLOADING_YUID = "UPLOADING_YUID",
  URL_EMAIL = "URL_EMAIL",
  URL_IDFA_GAID = "URL_IDFA_GAID",
  URL_PHONE = "URL_PHONE",
  URL_YUID = "URL_YUID",
}

export enum GroupTypeInput {
  AUDIO = "AUDIO",
  BANNER = "BANNER",
  BANNER_IN_METRO = "BANNER_IN_METRO",
  GEOPRODUCT = "GEOPRODUCT",
  INDOOR = "INDOOR",
  MAIN_PAGE = "MAIN_PAGE",
  OUTDOOR = "OUTDOOR",
  UNKNOWN = "UNKNOWN",
  VIDEO = "VIDEO",
}

export enum InterfaceLang {
  BY = "BY",
  EN = "EN",
  KZ = "KZ",
  RU = "RU",
  TR = "TR",
  TT = "TT",
  UK = "UK",
}

export enum InterfaceLangInput {
  BY = "BY",
  EN = "EN",
  KZ = "KZ",
  RU = "RU",
  TR = "TR",
  TT = "TT",
  UK = "UK",
}

export enum LanguageInput {
  AA = "AA",
  AB = "AB",
  AE = "AE",
  AF = "AF",
  AK = "AK",
  AM = "AM",
  AN = "AN",
  AR = "AR",
  AS = "AS",
  AV = "AV",
  AY = "AY",
  AZ = "AZ",
  BA = "BA",
  BE = "BE",
  BG = "BG",
  BH = "BH",
  BI = "BI",
  BM = "BM",
  BN = "BN",
  BO = "BO",
  BR = "BR",
  BS = "BS",
  CA = "CA",
  CE = "CE",
  CH = "CH",
  CO = "CO",
  CR = "CR",
  CS = "CS",
  CU = "CU",
  CV = "CV",
  CY = "CY",
  DA = "DA",
  DE = "DE",
  DV = "DV",
  DZ = "DZ",
  EE = "EE",
  EL = "EL",
  EN = "EN",
  EO = "EO",
  ES = "ES",
  ET = "ET",
  EU = "EU",
  FA = "FA",
  FF = "FF",
  FI = "FI",
  FJ = "FJ",
  FO = "FO",
  FR = "FR",
  FY = "FY",
  GA = "GA",
  GD = "GD",
  GL = "GL",
  GN = "GN",
  GU = "GU",
  GV = "GV",
  HA = "HA",
  HE = "HE",
  HI = "HI",
  HO = "HO",
  HR = "HR",
  HT = "HT",
  HU = "HU",
  HY = "HY",
  IA = "IA",
  ID = "ID",
  IE = "IE",
  IG = "IG",
  II = "II",
  IK = "IK",
  IN = "IN",
  IO = "IO",
  IS = "IS",
  IT = "IT",
  IU = "IU",
  IW = "IW",
  JA = "JA",
  JI = "JI",
  JV = "JV",
  JW = "JW",
  KA = "KA",
  KG = "KG",
  KI = "KI",
  KJ = "KJ",
  KK = "KK",
  KL = "KL",
  KM = "KM",
  KN = "KN",
  KO = "KO",
  KR = "KR",
  KS = "KS",
  KU = "KU",
  KV = "KV",
  KW = "KW",
  KY = "KY",
  LA = "LA",
  LB = "LB",
  LG = "LG",
  LI = "LI",
  LN = "LN",
  LO = "LO",
  LT = "LT",
  LU = "LU",
  LV = "LV",
  MG = "MG",
  MH = "MH",
  MI = "MI",
  MK = "MK",
  ML = "ML",
  MN = "MN",
  MO = "MO",
  MR = "MR",
  MS = "MS",
  MT = "MT",
  MY = "MY",
  NA = "NA",
  NB = "NB",
  ND = "ND",
  NE = "NE",
  NG = "NG",
  NL = "NL",
  NN = "NN",
  NO = "NO",
  NR = "NR",
  NV = "NV",
  NY = "NY",
  OC = "OC",
  OJ = "OJ",
  OM = "OM",
  OR = "OR",
  OS = "OS",
  PA = "PA",
  PI = "PI",
  PL = "PL",
  PS = "PS",
  PT = "PT",
  QU = "QU",
  RM = "RM",
  RN = "RN",
  RO = "RO",
  RU = "RU",
  RW = "RW",
  SA = "SA",
  SC = "SC",
  SD = "SD",
  SE = "SE",
  SG = "SG",
  SH = "SH",
  SI = "SI",
  SK = "SK",
  SL = "SL",
  SM = "SM",
  SN = "SN",
  SO = "SO",
  SQ = "SQ",
  SR = "SR",
  SS = "SS",
  ST = "ST",
  SU = "SU",
  SV = "SV",
  SW = "SW",
  TA = "TA",
  TE = "TE",
  TG = "TG",
  TH = "TH",
  TI = "TI",
  TK = "TK",
  TL = "TL",
  TN = "TN",
  TO = "TO",
  TR = "TR",
  TRANSLIT = "TRANSLIT",
  TS = "TS",
  TT = "TT",
  TW = "TW",
  TY = "TY",
  UG = "UG",
  UK = "UK",
  UNDEFINED = "UNDEFINED",
  UR = "UR",
  UZ = "UZ",
  VE = "VE",
  VI = "VI",
  VO = "VO",
  WA = "WA",
  WO = "WO",
  XH = "XH",
  YI = "YI",
  YO = "YO",
  ZA = "ZA",
  ZH = "ZH",
  ZU = "ZU",
}

export enum OfflineReportState {
  ERROR = "ERROR",
  NEW = "NEW",
  PROCESSING = "PROCESSING",
  READY = "READY",
}

export enum OfflineReportType {
  AGENCY = "AGENCY",
  DOMAINS = "DOMAINS",
}

export enum OfflineReportTypeInput {
  AGENCY = "AGENCY",
  DOMAINS = "DOMAINS",
}

export enum OrderInput {
  ASC = "ASC",
  DESC = "DESC",
}

export enum PlacementType {
  INDOOR = "INDOOR",
  OUTDOOR = "OUTDOOR",
}

export enum PlacementTypeInput {
  INDOOR = "INDOOR",
  OUTDOOR = "OUTDOOR",
}

export enum RbacRole {
  AGENCY = "AGENCY",
  CLIENT = "CLIENT",
  EMPTY = "EMPTY",
  INTERNAL_AD_ADMIN = "INTERNAL_AD_ADMIN",
  INTERNAL_AD_MANAGER = "INTERNAL_AD_MANAGER",
  MANAGER = "MANAGER",
  MEDIA = "MEDIA",
  PLACER = "PLACER",
  SUPER = "SUPER",
  SUPERREADER = "SUPERREADER",
  SUPPORT = "SUPPORT",
}

export enum RecommendationStatus {
  CANCELLED = "CANCELLED",
  DONE = "DONE",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
}

export enum StatusDirect {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  COMPLETED = "COMPLETED",
  RECEIVED = "RECEIVED",
}

export enum StatusDirectInput {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  COMPLETED = "COMPLETED",
  RECEIVED = "RECEIVED",
}

export enum StatusModerateBannerPage {
  MAYBE = "MAYBE",
  NO = "NO",
  READY = "READY",
  SENT = "SENT",
  YES = "YES",
}

export enum StatusModerateOperator {
  NO = "NO",
  NONE = "NONE",
  YES = "YES",
}

export enum TimeTargetStatus {
  ACTIVE = "ACTIVE",
  LATER_THAN_WEEK = "LATER_THAN_WEEK",
  THIS_WEEK = "THIS_WEEK",
  TODAY = "TODAY",
  TOMORROW = "TOMORROW",
}

export enum WebGoalType {
  ab_segment = "ab_segment",
  audience = "audience",
  audio_genres = "audio_genres",
  behaviors = "behaviors",
  brandsafety = "brandsafety",
  ecommerce = "ecommerce",
  family = "family",
  goal = "goal",
  interests = "interests",
  segment = "segment",
  social_demo = "social_demo",
}

export enum WebGoalTypeInput {
  ab_segment = "ab_segment",
  audience = "audience",
  audio_genres = "audio_genres",
  behaviors = "behaviors",
  brandsafety = "brandsafety",
  ecommerce = "ecommerce",
  family = "family",
  goal = "goal",
  interests = "interests",
  segment = "segment",
  social_demo = "social_demo",
}

export interface GdAcceptFlServiceByFreelancerRequestInput {
  clientId?: GraphQlLong | null;
  projectId?: GraphQlLong | null;
}

export interface GdAdFilterInput {
  campaignIdIn: GraphQlLong[];
  vcardExists?: boolean | null;
  bodyIn?: string[] | null;
  titleContains?: string | null;
  bodyNotContains?: string | null;
  primaryStatusContains?: GdAdPrimaryStatusInput[] | null;
  archived?: boolean | null;
  titleExtensionIn?: string[] | null;
  bodyNotIn?: string[] | null;
  adIdNotIn?: GraphQlLong[] | null;
  isTouch?: boolean | null;
  hrefContains?: string | null;
  typeIn?: GdAdTypeInput[] | null;
  adIdIn?: GraphQlLong[] | null;
  adGroupIdIn?: GraphQlLong[] | null;
  titleIn?: string[] | null;
  titleNotIn?: string[] | null;
  hrefNotContains?: string | null;
  hrefIn?: string[] | null;
  recommendations?: (GdiRecommendationTypeInput | null)[] | null;
  sitelinksExists?: boolean | null;
  titleNotContains?: string | null;
  goalStats?: GdGoalStatsFilterInput[] | null;
  imageExists?: boolean | null;
  titleExtensionNotContains?: string | null;
  stats?: GdEntityStatsFilterInput | null;
  titleExtensionContains?: string | null;
  turbolandingsExist?: boolean | null;
  titleExtensionNotIn?: string[] | null;
  bodyContains?: string | null;
  hrefNotIn?: string[] | null;
}

export interface GdAdGroupFilterInput {
  libraryMwIdIn?: GraphQlLong[] | null;
  adGroupIdIn?: GraphQlLong[] | null;
  showConditionTypeIn?: GdShowConditionTypeInput[] | null;
  nameNotContains?: string | null;
  archived?: boolean | null;
  mwPackNameContains?: string | null;
  campaignIdIn: GraphQlLong[];
  nameIn?: string[] | null;
  goalStats?: GdGoalStatsFilterInput[] | null;
  typeIn?: GdAdGroupTypeInput[] | null;
  stats?: GdEntityStatsFilterInput | null;
  nameNotIn?: string[] | null;
  mwPackNameNotContains?: string | null;
  nameContains?: string | null;
  adGroupIdNotIn?: GraphQlLong[] | null;
  primaryStatusIn?: GdAdGroupPrimaryStatusInput[] | null;
  recommendations?: (GdiRecommendationTypeInput | null)[] | null;
}

export interface GdAdGroupOrderByInput {
  order: OrderInput;
  field: GdAdGroupOrderByFieldInput;
  params?: GdOrderByParamsInput | null;
}

export interface GdAdGroupPageBlockInput {
  impId?: GraphQlLong | null;
  pageId?: GraphQlLong | null;
}

export interface GdAdGroupsContainerInput {
  statRequirements: GdStatRequirementsInput;
  cacheKey?: string | null;
  orderBy: GdAdGroupOrderByInput[];
  filter: GdAdGroupFilterInput;
  limitOffset: GdLimitOffsetInput;
}

export interface GdAdOrderByInput {
  order: OrderInput;
  params?: GdOrderByParamsInput | null;
  field: GdAdOrderByFieldInput;
}

export interface GdAdPriceInput {
  price: string;
  currency: GdAdPriceCurrencyInput;
  priceOld?: string | null;
  prefix?: GdAdPricePrefixInput | null;
}

export interface GdAddAdGroupMinusKeywordsInput {
  addItems: GdAddAdGroupMinusKeywordsItemInput[];
}

export interface GdAddAdGroupMinusKeywordsItemInput {
  minusKeywords: string[];
  adGroupId: GraphQlLong;
}

export interface GdAddAdInput {
  isMobile: boolean;
  adPrice?: GdAdPriceInput | null;
  displayHref?: string | null;
  calloutIds?: GraphQlLong[] | null;
  sitelinksSetId?: GraphQlLong | null;
  vcardId?: GraphQlLong | null;
  title: string;
  creativeId?: GraphQlLong | null;
  permalinkId?: GraphQlLong | null;
  domain?: string | null;
  adGroupId: GraphQlLong;
  textBannerImageHash?: string | null;
  adType: GdAdTypeInput;
  href?: string | null;
  imageCreativeHash?: string | null;
  turbolandingId?: GraphQlLong | null;
  titleExtension?: string | null;
  turboGalleryHref?: string | null;
  body: string;
  turbolandingHrefParams?: string | null;
}

export interface GdAddAddressInput {
  houseWithBuilding?: string | null;
  metroStationId?: number | null;
  pointOnMap?: GdPointOnMapInput | null;
  apartment?: string | null;
  city: string;
  street?: string | null;
  country: string;
}

export interface GdAddAdsInput {
  saveDraft: boolean;
  adAddItems: GdAddAdInput[];
}

export interface GdAddCampaignUnionInput {
  textCampaign?: GdAddTextCampaignInput | null;
  cpmPriceCampaign?: GdAddCpmPriceCampaignInput | null;
  internalAutobudgetCampaign?: GdAddInternalAutobudgetCampaignInput | null;
  contentPromotionCampaign?: GdAddContentPromotionCampaignInput | null;
}

export interface GdAddCampaignVcardInput {
  companyName: string;
  ogrn?: string | null;
  phone: GdAddPhoneInput;
  workTimes: GdAddWorkTimeInput[];
  instantMessenger?: GdAddInstantMessengerInput | null;
  address: GdAddAddressInput;
  email?: string | null;
  extraMessage?: string | null;
  contactPerson?: string | null;
}

export interface GdAddCampaignsInput {
  campaignAddItems: GdAddCampaignUnionInput[];
}

export interface GdAddClientMeasurerAccountInput {
  settings?: string | null;
  measurerSystem?: GdClientMeasurerSystemInput | null;
}

export interface GdAddContentPromotionAdGroupInput {
  addItems: GdAddContentPromotionAdGroupItemInput[];
}

export interface GdAddContentPromotionAdGroupItemInput {
  adGroupMinusKeywords: string[];
  regionIds: number[];
  bidModifiers: GdUpdateBidModifiersInput;
  keywords?: GdUpdateAdGroupKeywordItemInput[] | null;
  libraryMinusKeywordsIds: GraphQlLong[];
  generalPrice?: GraphQlBigDecimal | null;
  contentPromotionGroupType: GdContentPromotionGroupTypeInput;
  useBidModifiers?: boolean | null;
  targetTags?: string[] | null;
  name: string;
  relevanceMatch?: GdUpdateAdGroupRelevanceMatchItemInput | null;
  pageGroupTags?: string[] | null;
  campaignId: GraphQlLong;
}

export interface GdAddContentPromotionAdInput {
  adType: GdAdTypeInput;
  title?: string | null;
  visitUrl?: string | null;
  contentPromotion: GdContentPromotionInput;
  description?: string | null;
  adGroupId: GraphQlLong;
}

export interface GdAddContentPromotionAdsInput {
  adAddItems: GdAddContentPromotionAdInput[];
  saveDraft: boolean;
}

export interface GdAddContentPromotionCampaignInput {
  timeTarget: GdTimeTargetInput;
  notification: GdCampaignNotificationRequestInput;
  dayBudget: GraphQlBigDecimal;
  attributionModel: GdCampaignAttributionModelInput;
  brandSafetyCategories?: GraphQlLong[] | null;
  hasExtendedGeoTargeting: boolean;
  minusKeywords?: string[] | null;
  metrikaCounters?: number[] | null;
  contentLanguage?: GdContentLanguageInput | null;
  dayBudgetShowMode: GdDayBudgetShowModeInput;
  name: string;
  bidModifiers?: GdUpdateBidModifiersInput | null;
  endDate?: GraphQlLocalDate | null;
  disabledIps?: string[] | null;
  startDate: GraphQlLocalDate;
  biddingStategy: GdCampaignBiddingStrategyInput;
}

export interface GdAddCpmAdInput {
  turbolandingId?: GraphQlLong | null;
  creativeId?: GraphQlLong | null;
  turbolandingHrefParams?: string | null;
  adGroupId: GraphQlLong;
  href?: string | null;
  pixels?: GdPixelInput[] | null;
  tnsId?: string | null;
  measurers?: GdBannerMeasurerInput[] | null;
  adType: GdAdTypeInput;
}

export interface GdAddCpmAdsInput {
  adAddItems: GdAddCpmAdInput[];
  saveDraft: boolean;
}

export interface GdAddCpmPriceCampaignInput {
  minusKeywords?: string[] | null;
  flightTargetingsSnapshot: GdPriceFlightTargetingsSnapshotInput;
  brandSafetyCategories?: GraphQlLong[] | null;
  timeTarget: GdTimeTargetInput;
  metrikaCounters?: number[] | null;
  meaningfulGoals?: GdMeaningfulGoalRequestInput[] | null;
  hasAddOpenstatTagToUrl: boolean;
  pricePackageId: GraphQlLong;
  flightOrderVolume: GraphQlLong;
  contentLanguage?: GdContentLanguageInput | null;
  attributionModel: GdCampaignAttributionModelInput;
  hasAddMetrikaTagToUrl: boolean;
  notification: GdCampaignNotificationRequestInput;
  startDate: GraphQlLocalDate;
  name: string;
  endDate?: GraphQlLocalDate | null;
  disabledIps?: string[] | null;
}

export interface GdAddDialogRequestInput {
  skillId: string;
}

export interface GdAddFeedbackForFreelancerRequestInput {
  freelancerId: GraphQlLong;
  feedbackText: string;
  overallMark: GraphQlLong;
  willRecommend: boolean;
}

export interface GdAddInstantMessengerInput {
  login: string;
  type: GdInstantMessengerTypeInput;
}

export interface GdAddInternalAdGroupsInput {
  addItems: GdAddInternalAdGroupsItemInput[];
}

export interface GdAddInternalAdGroupsItemInput {
  targetingDeviceNames?: GdAdditionalTargetingDeviceNamesInput | null;
  targetingQueryReferers?: GdAdditionalTargetingQueryReferersInput | null;
  targetingDeviceVendors?: GdAdditionalTargetingDeviceVendorsInput | null;
  targetingShowDates?: GdAdditionalTargetingShowDatesInput | null;
  targetingTestIds?: GdAdditionalTargetingTestIdsInput | null;
  targetingInterfaceLangs?: GdAdditionalTargetingInterfaceLangsInput | null;
  targetingIsPPLoggedIn?: GdAdditionalTargetingIsPPLoggedInInput | null;
  targetingClidTypes?: GdAdditionalTargetingClidTypesInput | null;
  targetingInternalNetwork?: GdAdditionalTargetingInternalNetworkInput | null;
  targetingBrowserNames?: GdAdditionalTargetingBrowserNamesInput | null;
  rfReset?: number | null;
  targetingHasPassportId?: GdAdditionalTargetingHasPassportIdInput | null;
  targetingIsMobile?: GdAdditionalTargetingIsMobileInput | null;
  targetingDesktopInstalledApps?: GdAdditionalTargetingDesktopInstalledAppsInput | null;
  finishTime?: GraphQlLocalDateTime | null;
  targetingIsVirused?: GdAdditionalTargetingIsVirusedInput | null;
  targetingOsFamilies?: GdAdditionalTargetingOsFamiliesInput | null;
  targetingOsNames?: GdAdditionalTargetingOsNamesInput | null;
  targetingYandexUids?: GdAdditionalTargetingYandexUidsInput | null;
  targetingIsTouch?: GdAdditionalTargetingIsTouchInput | null;
  startTime?: GraphQlLocalDateTime | null;
  targetingQueryOptions?: GdAdditionalTargetingQueryOptionsInput | null;
  rf?: number | null;
  level?: GraphQlLong | null;
  targetingUserAgents?: GdAdditionalTargetingUserAgentsInput | null;
  targetingYsCookies?: GdAdditionalTargetingYsCookiesInput | null;
  targetingMobileInstalledApps?: GdAdditionalTargetingMobileInstalledAppsInput | null;
  targetingIsBrowser?: GdAdditionalTargetingIsBrowserInput | null;
  name: string;
  campaignId: GraphQlLong;
  regionIds: number[];
  targetingHasLCookie?: GdAdditionalTargetingHasLCookieInput | null;
  targetings?: GdAdditionalTargetingUnionInput[] | null;
  targetingIsTablet?: GdAdditionalTargetingIsTabletInput | null;
  targetingBrowserEngines?: GdAdditionalTargetingBrowserEnginesInput | null;
  targetingClids?: GdAdditionalTargetingClidsInput | null;
  targetingIsYandexPlus?: GdAdditionalTargetingIsYandexPlusInput | null;
}

export interface GdAddInternalAdsInput {
  adAddItems: GdAddInternalAdsItemInput[];
  saveDraft: boolean;
}

export interface GdAddInternalAdsItemInput {
  templateId: GraphQlLong;
  adGroupId: GraphQlLong;
  description: string;
  templateVars: GdTemplateVariableInput[];
}

export interface GdAddInternalAutobudgetCampaignInput {
  notification: GdCampaignNotificationRequestInput;
  name: string;
  endDate?: GraphQlLocalDate | null;
  meaningfulGoals?: GdMeaningfulGoalRequestInput[] | null;
  startDate: GraphQlLocalDate;
  biddingStategy: GdCampaignBiddingStrategyInput;
  metrikaCounters?: number[] | null;
  pageId: GraphQlLong;
  placeId: GraphQlLong;
  serviceId: GraphQlLong;
  disabledIps?: string[] | null;
  impressionFrequencyControl?: GdInternalCampaignImpressionFrequencyControlInput | null;
  isMobile: boolean;
  attributionModel: GdCampaignAttributionModelInput;
  brandSafetyCategories?: GraphQlLong[] | null;
  timeTarget: GdTimeTargetInput;
  minusKeywords?: string[] | null;
}

export interface GdAddKeywordsInput {
  addItems: GdAddKeywordsItemInput[];
}

export interface GdAddKeywordsItemInput {
  autobudgetPriority?: number | null;
  price?: GraphQlBigDecimal | null;
  priceContext?: GraphQlBigDecimal | null;
  adGroupId: GraphQlLong;
  keyword: string;
}

export interface GdAddMcBannerAdGroupItemInput {
  campaignId: GraphQlLong;
  name: string;
}

export interface GdAddMcBannerAdInput {
  adGroupId: GraphQlLong;
  adImageHash: string;
  href: string;
  adType: GdAdTypeInput;
}

export interface GdAddMcBannerAdsInput {
  adAddItems: GdAddMcBannerAdInput[];
  saveDraft: boolean;
}

export interface GdAddMinusKeywordsPacksInput {
  addItems: GdAddMinusKeywordsPacksItemInput[];
}

export interface GdAddMinusKeywordsPacksItemInput {
  minusKeywords: string[];
  name: string;
}

export interface GdAddPhoneInput {
  cityCode: string;
  countryCode: string;
  phoneNumber: string;
  extension?: string | null;
}

export interface GdAddPricePackageItemInput {
  trackerUrl: string;
  dateEnd: GraphQlLocalDate;
  price: GraphQlBigDecimal;
  orderVolumeMax: GraphQlLong;
  currency: CurrencyCodeInput;
  dateStart: GraphQlLocalDate;
  targetingsCustom: GdTargetingsCustomInput;
  orderVolumeMin: GraphQlLong;
  title: string;
  targetingsFixed: GdTargetingsFixedInput;
}

export interface GdAddPricePackagesInput {
  addItems: GdAddPricePackageItemInput[];
}

export interface GdAddSitelinkInput {
  title: string;
  description?: string | null;
  href?: string | null;
  turbolandingId?: GraphQlLong | null;
}

export interface GdAddSitelinkSetInput {
  sitelinks: GdAddSitelinkInput[];
}

export interface GdAddSitelinkSetsInput {
  sitelinkSetsAddItems: GdAddSitelinkSetInput[];
}

export interface GdAddSmartAdGroupItemInput {
  campaignId: GraphQlLong;
  feedId: GraphQlLong;
  name: string;
}

export interface GdAddSmartAdInput {
  creativeId: GraphQlLong;
  adGroupId: GraphQlLong;
}

export interface GdAddSmartAdsInput {
  adAddItems: GdAddSmartAdInput[];
  saveDraft: boolean;
}

export interface GdAddSmartFilterConditionInput {
  field: string;
  operator: GdSmartFilterConditionOperatorInput;
  stringValue: string;
}

export interface GdAddSmartFiltersInput {
  addItems: GdAddSmartFiltersItemInput[];
}

export interface GdAddSmartFiltersItemInput {
  priceCpc?: GraphQlBigDecimal | null;
  autobudgetPriority?: GdShowConditionAutobudgetPriorityInput | null;
  isSuspended: boolean;
  tab?: GdSmartFilterTabInput | null;
  conditions: GdAddSmartFilterConditionInput[];
  name: string;
  adGroupId: GraphQlLong;
  priceCpa?: GraphQlBigDecimal | null;
  targetFunnel: GdSmartFilterTargetFunnelInput;
}

export interface GdAddTextAdGroupItemInput {
  bidModifiers?: GdUpdateBidModifiersInput | null;
  generalPrice?: GraphQlBigDecimal | null;
  libraryMinusKeywordsIds?: GraphQlLong[] | null;
  useBidModifiers?: boolean | null;
  campaignId: GraphQlLong;
  adGroupMinusKeywords?: string[] | null;
  retargetings?: GdUpdateAdGroupRetargetingItemInput[] | null;
  regionIds?: number[] | null;
  retargetingCondition?: GdUpdateCpmRetargetingConditionItemInput | null;
  keywords?: GdUpdateAdGroupKeywordItemInput[] | null;
  targetTags?: string[] | null;
  relevanceMatch?: GdUpdateAdGroupRelevanceMatchItemInput | null;
  pageGroupTags?: string[] | null;
  name: string;
}

export interface GdAddTextCampaignInput {
  enableCpcHold: boolean;
  disabledIps?: string[] | null;
  hasExtendedGeoTargeting: boolean;
  abSegmentRetargetingConditionId?: GraphQlLong | null;
  vcard?: GdAddCampaignVcardInput | null;
  notification: GdCampaignNotificationRequestInput;
  brandSafetyCategories?: GraphQlLong[] | null;
  hasAddMetrikaTagToUrl: boolean;
  timeTarget: GdTimeTargetInput;
  disabledPlaces?: string[] | null;
  attributionModel: GdCampaignAttributionModelInput;
  contextLimit: number;
  hasSiteMonitoring: boolean;
  endDate?: GraphQlLocalDate | null;
  broadMatch: GdBroadMatchRequestInput;
  meaningfulGoals?: (GdMeaningfulGoalRequestInput | null)[] | null;
  enableCompanyInfo: boolean;
  isAloneTrafaretAllowed?: boolean | null;
  excludePausedCompetingAds: boolean;
  metrikaCounters?: number[] | null;
  biddingStategy: GdCampaignBiddingStrategyInput;
  hasAddOpenstatTagToUrl: boolean;
  hasTitleSubstitute: boolean;
  allowedPageIds?: GraphQlLong[] | null;
  minusKeywords?: string[] | null;
  defaultPermalinkId?: GraphQlLong | null;
  startDate: GraphQlLocalDate;
  clientDialogId?: GraphQlLong | null;
  bidModifiers?: GdUpdateBidModifiersInput | null;
  dayBudgetShowMode: GdDayBudgetShowModeInput;
  name: string;
  abSegmentStatisticRetargetingConditionId?: GraphQlLong | null;
  dayBudget: GraphQlBigDecimal;
  contentLanguage?: GdContentLanguageInput | null;
}

export interface GdAddVcardInput {
  campaignId: GraphQlLong;
  companyName: string;
  phone: GdAddPhoneInput;
  workTimes: GdAddWorkTimeInput[];
  instantMessenger?: GdAddInstantMessengerInput | null;
  email?: string | null;
  ogrn?: string | null;
  extraMessage?: string | null;
  contactPerson?: string | null;
  address: GdAddAddressInput;
}

export interface GdAddVcardsInput {
  vcardAddItems: GdAddVcardInput[];
}

export interface GdAddWorkTimeInput {
  daysOfWeek: number[];
  startTime: GdTimeInput;
  endTime: GdTimeInput;
}

export interface GdAdditionalTargetingBrowserEnginesInput {
  value: GdAdditionalTargetingVersionedInput[];
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingBrowserNamesInput {
  targetingMode: GdAdditionalTargetingModeInput;
  value: GdAdditionalTargetingVersionedInput[];
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingClidTypesInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  value: GraphQlLong[];
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingClidsInput {
  value: GraphQlLong[];
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingDesktopInstalledAppsInput {
  targetingMode: GdAdditionalTargetingModeInput;
  value: GraphQlLong[];
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingDeviceNamesInput {
  value: string[];
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingDeviceVendorsInput {
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
  value: GdAdditionalTargetingUatraitsInput[];
}

export interface GdAdditionalTargetingHasLCookieInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingHasPassportIdInput {
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingInterfaceLangsInput {
  targetingMode: GdAdditionalTargetingModeInput;
  value: InterfaceLangInput[];
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingInternalNetworkInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingIsBrowserInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingIsMobileInput {
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingIsPPLoggedInInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingIsTabletInput {
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingIsTouchInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingIsVirusedInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingIsYandexPlusInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingMobileInstalledAppsInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
  value: string[];
}

export interface GdAdditionalTargetingOsFamiliesInput {
  joinType: GdAdditionalTargetingJoinTypeInput;
  value: GdAdditionalTargetingVersionedInput[];
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingOsNamesInput {
  value: GdAdditionalTargetingUatraitsInput[];
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingQueryOptionsInput {
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
  value: string[];
}

export interface GdAdditionalTargetingQueryReferersInput {
  value: string[];
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingShowDatesInput {
  targetingMode: GdAdditionalTargetingModeInput;
  value: GraphQlLocalDate[];
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingTestIdsInput {
  value: GraphQlLong[];
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdditionalTargetingUatraitsInput {
  targetingValueEntryId: GraphQlLong;
}

export interface GdAdditionalTargetingUnionInput {
  targetingQueryOptions?: GdAdditionalTargetingQueryOptionsInput | null;
  targetingIsTablet?: GdAdditionalTargetingIsTabletInput | null;
  targetingYandexUids?: GdAdditionalTargetingYandexUidsInput | null;
  targetingBrowserEngines?: GdAdditionalTargetingBrowserEnginesInput | null;
  targetingClids?: GdAdditionalTargetingClidsInput | null;
  targetingQueryReferers?: GdAdditionalTargetingQueryReferersInput | null;
  targetingOsNames?: GdAdditionalTargetingOsNamesInput | null;
  targetingIsPPLoggedIn?: GdAdditionalTargetingIsPPLoggedInInput | null;
  targetingClidTypes?: GdAdditionalTargetingClidTypesInput | null;
  targetingYsCookies?: GdAdditionalTargetingYsCookiesInput | null;
  targetingHasPassportId?: GdAdditionalTargetingHasPassportIdInput | null;
  targetingIsTouch?: GdAdditionalTargetingIsTouchInput | null;
  targetingOsFamilies?: GdAdditionalTargetingOsFamiliesInput | null;
  targetingTestIds?: GdAdditionalTargetingTestIdsInput | null;
  targetingInternalNetwork?: GdAdditionalTargetingInternalNetworkInput | null;
  targetingHasLCookie?: GdAdditionalTargetingHasLCookieInput | null;
  targetingBrowserNames?: GdAdditionalTargetingBrowserNamesInput | null;
  targetingDeviceVendors?: GdAdditionalTargetingDeviceVendorsInput | null;
  targetingShowDates?: GdAdditionalTargetingShowDatesInput | null;
  targetingUserAgents?: GdAdditionalTargetingUserAgentsInput | null;
  targetingDeviceNames?: GdAdditionalTargetingDeviceNamesInput | null;
  targetingIsBrowser?: GdAdditionalTargetingIsBrowserInput | null;
  targetingIsMobile?: GdAdditionalTargetingIsMobileInput | null;
  targetingDesktopInstalledApps?: GdAdditionalTargetingDesktopInstalledAppsInput | null;
  targetingIsYandexPlus?: GdAdditionalTargetingIsYandexPlusInput | null;
  targetingIsVirused?: GdAdditionalTargetingIsVirusedInput | null;
  targetingMobileInstalledApps?: GdAdditionalTargetingMobileInstalledAppsInput | null;
  targetingInterfaceLangs?: GdAdditionalTargetingInterfaceLangsInput | null;
}

export interface GdAdditionalTargetingUserAgentsInput {
  value: string[];
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingVersionedInput {
  minVersion?: string | null;
  maxVersion?: string | null;
  targetingValueEntryId: GraphQlLong;
}

export interface GdAdditionalTargetingYandexUidsInput {
  value: string[];
  targetingMode: GdAdditionalTargetingModeInput;
  joinType: GdAdditionalTargetingJoinTypeInput;
}

export interface GdAdditionalTargetingYsCookiesInput {
  value: string[];
  joinType: GdAdditionalTargetingJoinTypeInput;
  targetingMode: GdAdditionalTargetingModeInput;
}

export interface GdAdsContainerInput {
  cacheKey?: string | null;
  statRequirements: GdStatRequirementsInput;
  filter: GdAdFilterInput;
  orderBy: GdAdOrderByInput[];
  limitOffset: GdLimitOffsetInput;
}

export interface GdAdsMassActionInput {
  adIds: GraphQlLong[];
}

export interface GdBannerMeasurerInput {
  measurerSystem?: GdBannerMeasurerSystemInput | null;
  params?: string | null;
  hasIntegration?: boolean | null;
}

export interface GdBidModifierDemographicInput {
  age?: string | null;
  multiplier?: number | null;
  gender?: string | null;
}

export interface GdBlockSizeInput {
  height?: number | null;
  width?: number | null;
}

export interface GdBroadMatchContainerInput {
  campaignId: GraphQlLong;
}

export interface GdBroadMatchRequestInput {
  broadMatchFlag?: boolean | null;
  broadMatchLimit?: number | null;
  broadMatchGoalId?: GraphQlLong | null;
}

export interface GdBroadMatchesContainerInput {
  broadMatchContainers: GdBroadMatchContainerInput[];
}

export interface GdCalloutFilterInput {
  deleted?: boolean | null;
}

export interface GdCampaignBiddingStrategyInput {
  strategyName: GdCampaignStrategyNameInput;
  strategyData: GdCampaignStrategyDataInput;
  strategy?: GdCampaignStrategyInput | null;
  platform: GdCampaignPlatformInput;
}

export interface GdCampaignEmailSettingsRequestInput {
  warningBalance?: number | null;
  sendAccountNews?: boolean | null;
  stopByReachDailyBudget?: boolean | null;
  email: string;
  checkPositionInterval?: GdCampaignCheckPositionIntervalInput | null;
  xlsReady?: boolean | null;
}

export interface GdCampaignFilterInput {
  stats?: GdEntityStatsFilterInput | null;
  maxFinishDate?: GraphQlLocalDate | null;
  hasBroadmatch?: boolean | null;
  calcType?: GdCalcTypeInput | null;
  strategyTypeIn?: GdCampaignStrategyTypeInput[] | null;
  campaignIdIn?: GraphQlLong[] | null;
  nameIn?: string[] | null;
  statusIn?: GdCampaignPrimaryStatusInput[] | null;
  minStartDate?: GraphQlLocalDate | null;
  typeIn?: GdCampaignTypeInput[] | null;
  nameNotContains?: string | null;
  platformIn?: GdCampaignPlatformInput[] | null;
  favorite?: boolean | null;
  recommendations?: (GdiRecommendationTypeInput | null)[] | null;
  currencyArchived?: boolean | null;
  hasSiteMonitoring?: boolean | null;
  goalStats?: GdGoalStatsFilterInput[] | null;
  hasBidModifiers?: boolean | null;
  minFinishDate?: GraphQlLocalDate | null;
  hasMetrika?: boolean | null;
  nameNotIn?: string[] | null;
  nameContains?: string | null;
  campaignStrategyTypeIn?: GdStrategyTypeInput[] | null;
  campaignIdNotIn?: GraphQlLong[] | null;
  archived?: boolean | null;
  maxStartDate?: GraphQlLocalDate | null;
}

export interface GdCampaignGoalFilterInput {
  campaignIdIn?: GraphQlLong[] | null;
}

export interface GdCampaignGoalsContainerInput {
  filter: GdCampaignGoalFilterInput;
}

export interface GdCampaignIdsListInput {
  campaignIds?: GraphQlLong[] | null;
}

export interface GdCampaignNotificationRequestInput {
  emailSettings: GdCampaignEmailSettingsRequestInput;
  smsSettings: GdCampaignSmsSettingsRequestInput;
}

export interface GdCampaignOrderByInput {
  order: OrderInput;
  params?: GdOrderByParamsInput | null;
  field: GdCampaignOrderByFieldInput;
}

export interface GdCampaignSmsSettingsRequestInput {
  smsTime: GdTimeIntervalInput;
  enableEvents: GdCampaignSmsEventInput[];
}

export interface GdCampaignStrategyDataInput {
  avgBid?: GraphQlBigDecimal | null;
  goalId?: GraphQlLong | null;
  roiCoef?: GraphQlBigDecimal | null;
  limitClicks?: GraphQlLong | null;
  bid?: GraphQlBigDecimal | null;
  avgCpa?: GraphQlBigDecimal | null;
  profitability?: GraphQlBigDecimal | null;
  sum?: GraphQlBigDecimal | null;
  payForConversion?: boolean | null;
  reserveReturn?: GraphQlLong | null;
}

export interface GdCampaignsContainerInput {
  limitOffset: GdLimitOffsetInput;
  cacheKey?: string | null;
  statRequirements: GdStatRequirementsInput;
  orderBy: GdCampaignOrderByInput[];
  filter: GdCampaignFilterInput;
}

export interface GdCancelFlServiceByClientRequestInput {
  projectId?: GraphQlLong | null;
  freelancerId?: GraphQlLong | null;
}

export interface GdCancelFlServiceByFreelancerRequestInput {
  projectId?: GraphQlLong | null;
  clientId?: GraphQlLong | null;
}

export interface GdCheckClientMutationStateInput {
  mutationId: string;
  login: string;
}

export interface GdClientSearchRequestInput {
  id?: GraphQlLong | null;
  login?: string | null;
  userId?: GraphQlLong | null;
}

export interface GdClientTopRegionsInput {
  searchRequest: GdClientSearchRequestInput;
  limitOffset: GdLimitOffsetInput;
}

export interface GdContentPromotionInput {
  contentPromotionId: GraphQlLong;
}

export interface GdCoordinatesInput {
  x: GraphQlBigDecimal;
  y: GraphQlBigDecimal;
}

export interface GdCopyAdGroupsInput {
  adGroupIds: GraphQlLong[];
  destinationCampaignId?: GraphQlLong | null;
}

export interface GdCreateRetargetingConditionForExperimentsInput {
  items: GdCreateRetargetingConditionForExperimentsItemInput[];
}

export interface GdCreateRetargetingConditionForExperimentsItemInput {
  sectionIds: GraphQlLong[];
  abSegmentGoalIds?: GraphQlLong[] | null;
}

export interface GdCreateRetargetingConditionItemInput {
  description?: string | null;
  type: GdRetargetingConditionTypeInput;
  name: string;
  conditionRules: GdRetargetingConditionRuleItemReqInput[];
}

export interface GdCreateRetargetingConditionsInput {
  retargetingConditions: GdCreateRetargetingConditionItemInput[];
}

export interface GdCreativeFilterInput {
  creativeTypeIn?: GdCreativeTypeInput[] | null;
  businessTypeIn?: GdCreativeBusinessTypeInput[] | null;
  creativeIdIn?: GraphQlLong[] | null;
}

export interface GdCreativesContainerInput {
  searchBy: GdClientSearchRequestInput;
  filter: GdCreativeFilterInput;
  limitOffset: GdLimitOffsetInput;
  cacheKey: string;
}

export interface GdCryptaSegmentFilterInput {
  name?: string | null;
  interestType?: CryptaInterestTypeWebInput | null;
  type?: WebGoalTypeInput[] | null;
}

export interface GdCryptaSegmentsContainerInput {
  filter: GdCryptaSegmentFilterInput;
}

export interface GdDealOrderByInput {
  field?: GdiDealOrderByFieldInput | null;
  order?: OrderInput | null;
}

export interface GdDeleteCalloutsInput {
  detachBeforeDelete?: boolean | null;
  calloutIds: GraphQlLong[];
}

export interface GdDeleteFreelancerFeedbackRequestInput {
  feedbackId: string;
  freelancerId: GraphQlLong;
}

export interface GdDeleteKeywordsInput {
  keywordIds: GraphQlLong[];
}

export interface GdDeleteMinusKeywordsPacksInput {
  minusKeywordPackIds: GraphQlLong[];
}

export interface GdDeleteRetargetingConditionsInput {
  retargetingConditionIds: GraphQlLong[];
}

export interface GdDeleteRetargetingsInput {
  retargetingIds: GraphQlLong[];
}

export interface GdDeleteSmartFilterInput {
  deleteItems: GdDeleteSmartFilterItemInput[];
}

export interface GdDeleteSmartFilterItemInput {
  id?: GraphQlLong | null;
}

export interface GdEntityStatsFilterInput {
  minShows?: GraphQlLong | null;
  maxAvgShowPosition?: GraphQlBigDecimal | null;
  maxBounceRate?: GraphQlBigDecimal | null;
  maxConversionRate?: GraphQlBigDecimal | null;
  maxRevenue?: GraphQlBigDecimal | null;
  minCtr?: GraphQlBigDecimal | null;
  maxAvgGoalCost?: GraphQlBigDecimal | null;
  minAvgDepth?: GraphQlBigDecimal | null;
  minRevenue?: GraphQlBigDecimal | null;
  maxAvgDepth?: GraphQlBigDecimal | null;
  minProfitability?: GraphQlBigDecimal | null;
  maxGoals?: GraphQlLong | null;
  maxCtr?: GraphQlBigDecimal | null;
  maxCpmPrice?: GraphQlBigDecimal | null;
  minCost?: GraphQlBigDecimal | null;
  minAvgClickCost?: GraphQlBigDecimal | null;
  minClicks?: GraphQlLong | null;
  maxAvgClickPosition?: GraphQlBigDecimal | null;
  minAvgShowPosition?: GraphQlBigDecimal | null;
  minGoals?: GraphQlLong | null;
  maxShows?: GraphQlLong | null;
  minCpmPrice?: GraphQlBigDecimal | null;
  minAvgClickPosition?: GraphQlBigDecimal | null;
  minConversionRate?: GraphQlBigDecimal | null;
  maxClicks?: GraphQlLong | null;
  maxCost?: GraphQlBigDecimal | null;
  maxAvgClickCost?: GraphQlBigDecimal | null;
  minBounceRate?: GraphQlBigDecimal | null;
  maxProfitability?: GraphQlBigDecimal | null;
  minAvgGoalCost?: GraphQlBigDecimal | null;
}

export interface GdEstimateRetargetingConditionContainerInput {
  conditionRules?: GdRetargetingConditionRuleItemReqInput[] | null;
}

export interface GdExecuteRecommedationsInput {
  items: GdRecommendationKeyInput[];
}

export interface GdFindAndReplaceKeywordsInput {
  limitOffset?: GdLimitOffsetInput | null;
  searchText: string;
  changeText: string;
  fields: GdFindAndReplaceKeywordFieldInput[];
  searchOptions: SearchOptionsInput;
  changeMode: ChangeModeInput;
  keywordIds: GraphQlLong[];
  cacheKey?: string | null;
}

export interface GdGenerateVideoAdditionInput {
  adGroupIds: GraphQlLong[];
}

export interface GdGeoToolsAddressInput {
  address: string;
}

export interface GdGetContentPromotionMetaInputInput {
  url: string;
  campaignId?: GraphQlLong | null;
  adGroupId?: GraphQlLong | null;
  contentPromotionType: GdContentPromotionTypeInput;
}

export interface GdGetMinusKeywordsPacksInput {
  packIdIn?: (GraphQlLong | null)[] | null;
  cacheKey?: string | null;
  limitOffset?: GdLimitOffsetInput | null;
}

export interface GdGetPricePackagesFilterInput {
  packageIdIn?: GraphQlLong[] | null;
}

export interface GdGetPricePackagesInput {
  filter: GdGetPricePackagesFilterInput;
  limitOffset?: GdLimitOffsetInput | null;
}

export interface GdGoalFilterInput {
  counterIdsIn?: GraphQlLong[] | null;
  goalTypeIn?: GdGoalTypeInput[] | null;
}

export interface GdGoalMinimalInput {
  id: GraphQlLong;
  time?: number | null;
}

export interface GdGoalStatsFilterInput {
  maxCostPerAction?: GraphQlBigDecimal | null;
  maxGoals?: GraphQlLong | null;
  goalId?: GraphQlLong | null;
  minCostPerAction?: GraphQlBigDecimal | null;
  maxConversionRate?: GraphQlBigDecimal | null;
  minGoals?: GraphQlLong | null;
  minConversionRate?: GraphQlBigDecimal | null;
}

export interface GdGoalsContainerInput {
  filter: GdGoalFilterInput;
}

export interface GdHolidaysSettingsInput {
  isShow?: boolean | null;
  startHour?: number | null;
  endHour?: number | null;
  rateCorrections?: number | null;
}

export interface GdImageFilterInput {
  height?: number | null;
  imageHashIn?: string[] | null;
  minCreatedDateTime?: GraphQlLocalDateTime | null;
  maxCreatedDateTime?: GraphQlLocalDateTime | null;
  forAdType?: GdAdTypeInput | null;
  width?: number | null;
}

export interface GdImageSmartCenterInput {
  width?: number | null;
  y?: number | null;
  height?: number | null;
  x?: number | null;
  ratio?: string | null;
}

export interface GdIndoorReachRequestInput {
  adGroupId?: GraphQlLong | null;
  campaignId?: GraphQlLong | null;
  pageBlocks?: GdPageBlockInput[] | null;
  videoCreativeIds?: GraphQlLong[] | null;
  bidModifierDemographic?: GdBidModifierDemographicInput[] | null;
}

export interface GdInternalCampaignImpressionFrequencyControlInput {
  days?: number | null;
  impressions?: number | null;
}

export interface GdInternalTemplateInfoRequestEntryInput {
  campaignId: string;
  templateIds: string[];
}

export interface GdLastChangedAdContainerInput {
  items: GdLastChangedAdContainerItemInput[];
}

export interface GdLastChangedAdContainerItemInput {
  campaignId: GraphQlLong;
  adType: GdAdTypeInput;
}

export interface GdLimitOffsetInput {
  offset: number;
  limit: number;
}

export interface GdMeaningfulGoalContainerInput {
  counterIds?: GraphQlLong[] | null;
  campaignId: GraphQlLong;
}

export interface GdMeaningfulGoalRequestInput {
  goalId: GraphQlLong;
  conversionValue?: GraphQlBigDecimal | null;
}

export interface GdMeaningfulGoalsContainerInput {
  meaningfulGoalContainers: GdMeaningfulGoalContainerInput[];
}

export interface GdMetrikaGoalsByCounterInput {
  campaignId?: GraphQlLong | null;
  counterIds?: GraphQlLong[] | null;
}

export interface GdOfflineReportResultRequestInput {
  reportType?: OfflineReportTypeInput | null;
  monthTo: string;
  monthFrom: string;
}

export interface GdOrderByParamsInput {
  goalId?: GraphQlLong | null;
}

export interface GdOrganizationsContainerInput {
  permalinkIds: (GraphQlLong | null)[];
  language?: LanguageInput | null;
}

export interface GdOutdoorReachRequestInput {
  adGroupId?: GraphQlLong | null;
  campaignId?: GraphQlLong | null;
  videoCreativeIds?: GraphQlLong[] | null;
  pageBlocks?: GdPageBlockInput[] | null;
}

export interface GdPageBlockInput {
  blockIds?: GraphQlLong[] | null;
  pageId?: GraphQlLong | null;
}

export interface GdPageOrderByInput {
  field?: GdPageOrderByFieldInput | null;
  order?: OrderInput | null;
}

export interface GdPixelInput {
  kind?: GdPixelKindInput | null;
  url?: string | null;
}

export interface GdPlacementFilterInput {
  adGroupIds?: GraphQlLong[] | null;
  placementType?: PlacementTypeInput | null;
  facilityType?: number | null;
  geoId?: GraphQlLong | null;
  zoneCategory?: number | null;
  pageIds?: GraphQlLong[] | null;
}

export interface GdPlatformCorrectionsWebInput {
  mobileOsType?: GdMobileOsTypeInput | null;
  desktop?: number | null;
  mobile?: number | null;
}

export interface GdPointOnMapInput {
  y: GraphQlBigDecimal;
  x: GraphQlBigDecimal;
  x2: GraphQlBigDecimal;
  y2: GraphQlBigDecimal;
  x1: GraphQlBigDecimal;
  y1: GraphQlBigDecimal;
}

export interface GdPriceFlightTargetingsSnapshotInput {
  geoExpanded?: GraphQlLong[] | null;
  viewTypes?: GdPriceFlightViewTypeInput[] | null;
  behaviors?: GraphQlLong[] | null;
  geoType?: number | null;
}

export interface GdProductContainerInput {
  filter: GdProductFilterInput;
}

export interface GdProductFilterInput {
  type?: GdProductTypeInput | null;
  campaignId?: GraphQlLong | null;
  calcType?: GdProductCalcTypeInput | null;
  id?: GraphQlLong | null;
  currency?: CurrencyCodeInput | null;
}

export interface GdReachRequestInput {
  campaignId?: GraphQlLong | null;
  videoCreatives?: GdVideoCreativeInput[] | null;
  blockSizes?: GdBlockSizeInput[] | null;
  conditions?: GdRetargetingConditionRuleItemReqInput[] | null;
  geo?: (number | null)[] | null;
  adgroupId?: GraphQlLong | null;
  platformCorrectionsWeb?: GdPlatformCorrectionsWebInput | null;
  groupType?: GroupTypeInput | null;
  excludedDomains?: (string | null)[] | null;
}

export interface GdRecommendationKeyInput {
  cid?: GraphQlLong | null;
  type?: GdiRecommendationTypeInput | null;
  userKey3?: string | null;
  userKey1?: string | null;
  userKey2?: string | null;
  bid?: GraphQlLong | null;
  pid?: GraphQlLong | null;
  timestamp?: GraphQlLong | null;
}

export interface GdRefineKeywordInput {
  keyword: string;
  geo: GraphQlLong[];
  minusWords?: string[] | null;
  adGroupType?: GdAdGroupTypeInput | null;
}

export interface GdRegionInput {
  regionId: number;
}

export interface GdRemoderateAdsCalloutsInput {
  adGroupIds: GraphQlLong[];
  moderateAccept: boolean;
}

export interface GdRequestFlServiceByClientRequestInput {
  freelancerId?: GraphQlLong | null;
}

export interface GdResumeRetargetingsInput {
  retargetingIds: GraphQlLong[];
}

export interface GdRetargetingConditionFilterInput {
  negative?: boolean | null;
  interest?: boolean | null;
  nameIn?: string[] | null;
  nameNotIn?: string[] | null;
  retargetingConditionIdNotIn?: GraphQlLong[] | null;
  retargetingConditionTypeIn?: GdRetargetingConditionTypeInput[] | null;
  retargetingConditionIdIn?: GraphQlLong[] | null;
}

export interface GdRetargetingConditionRuleItemReqInput {
  type: GdRetargetingConditionRuleTypeInput;
  interestType?: CryptaInterestTypeWebInput | null;
  goals: GdGoalMinimalInput[];
}

export interface GdRetargetingConditionsContainerInput {
  filter?: GdRetargetingConditionFilterInput | null;
}

export interface GdRetargetingFilterInput {
  nameNotContains?: string | null;
  retargetingConditionIdIn?: GraphQlLong[] | null;
  typeNotIn?: GdRetargetingConditionTypeInput[] | null;
  campaignIdIn?: GraphQlLong[] | null;
  retargetingConditionIdNotIn?: GraphQlLong[] | null;
  retargetingIdIn?: GraphQlLong[] | null;
  minPriceContext?: GraphQlBigDecimal | null;
  stats?: GdEntityStatsFilterInput | null;
  nameContains?: string | null;
  maxPriceContext?: GraphQlBigDecimal | null;
  interest?: boolean | null;
  adGroupIdIn?: GraphQlLong[] | null;
  statusIn?: GdRetargetingBaseStatusInput[] | null;
  typeIn?: GdRetargetingConditionTypeInput[] | null;
  retargetingIdNotIn?: GraphQlLong[] | null;
}

export interface GdRetargetingOrderByInput {
  order: OrderInput;
  field?: GdRetargetingOrderByFieldInput | null;
}

export interface GdRetargetingsContainerInput {
  orderBy: GdRetargetingOrderByInput[];
  filter?: GdRetargetingFilterInput | null;
  statRequirements: GdStatRequirementsInput;
  cacheKey?: string | null;
  limitOffset?: GdLimitOffsetInput | null;
}

export interface GdSaveCalloutsInput {
  saveItems: GdSaveCalloutsItemInput[];
}

export interface GdSaveCalloutsItemInput {
  text: string;
}

export interface GdSetAutoBidsInput {
  keywordIds: GraphQlLong[];
  searchByTrafficVolume?: GdSetAutoBidsSearchByTrafficVolumeInput | null;
  networkByCoverage?: GdSetAutoBidsNetworkByCoverageInput | null;
}

export interface GdSetAutoBidsNetworkByCoverageInput {
  maxBid: GraphQlBigDecimal;
  contextCoverage: number;
  increasePercent: number;
}

export interface GdSetAutoBidsSearchByTrafficVolumeInput {
  targetTrafficVolume: number;
  setMaximum: boolean;
  increasePercentage: number;
  maxBid: GraphQlBigDecimal;
}

export interface GdSetAutoOverdraftParamsInput {
  personId: GraphQlLong;
  paymentMethodCode: string;
  autoOverdraftLimit: GraphQlBigDecimal;
}

export interface GdSetBidsInput {
  exactPriceSearch?: GraphQlBigDecimal | null;
  showConditionIds?: GraphQlLong[] | null;
  exactPriceContext?: GraphQlBigDecimal | null;
  autobudgetPriority?: number | null;
}

export interface GdShowConditionFilterInput {
  minPriceContext?: GraphQlBigDecimal | null;
  showConditionStatusIn?: GdShowConditionPrimaryStatusInput[] | null;
  showConditionIdIn?: GraphQlLong[] | null;
  stats?: GdEntityStatsFilterInput | null;
  keywordNotContains?: string | null;
  keywordIn?: string[] | null;
  keywordNotIn?: string[] | null;
  minPrice?: GraphQlBigDecimal | null;
  typeIn?: GdShowConditionTypeInput[] | null;
  showConditionIdNotIn?: GraphQlLong[] | null;
  campaignIdIn: GraphQlLong[];
  keywordContains?: string | null;
  autobudgetPriorityIn?: GdShowConditionAutobudgetPriorityInput[] | null;
  maxPriceContext?: GraphQlBigDecimal | null;
  maxPrice?: GraphQlBigDecimal | null;
  adGroupIdIn?: GraphQlLong[] | null;
  goalStats?: GdGoalStatsFilterInput[] | null;
  statusIn?: GdShowConditionBaseStatusInput[] | null;
}

export interface GdShowConditionOrderByInput {
  order: OrderInput;
  field: GdShowConditionOrderByFieldInput;
  params?: GdOrderByParamsInput | null;
}

export interface GdShowConditionsContainerInput {
  orderBy: GdShowConditionOrderByInput[];
  filter: GdShowConditionFilterInput;
  statRequirements: GdStatRequirementsInput;
  limitOffset: GdLimitOffsetInput;
  cacheKey?: string | null;
}

export interface GdSmartFilterFilterInput {
  adGroupIdIn?: GraphQlLong[] | null;
  minPriceCpa?: GraphQlBigDecimal | null;
  autobudgetPriorityIn?: GdShowConditionAutobudgetPriorityInput[] | null;
  campaignIdIn: GraphQlLong[];
  nameContains?: string | null;
  goalStats?: GdGoalStatsFilterInput[] | null;
  nameNotContains?: string | null;
  minPriceCpc?: GraphQlBigDecimal | null;
  statusIn?: GdSmartFilterBaseStatusInput[] | null;
  stats?: GdEntityStatsFilterInput | null;
  targetFunnelIn?: GdSmartFilterTargetFunnelInput[] | null;
  maxPriceCpa?: GraphQlBigDecimal | null;
  smartFilterIdIn?: GraphQlLong[] | null;
  maxPriceCpc?: GraphQlBigDecimal | null;
}

export interface GdSmartFilterOrderByInput {
  order: OrderInput;
  field: GdSmartFilterOrderByFieldInput;
  params?: GdOrderByParamsInput | null;
}

export interface GdSmartFilterSchemaQueryInput {
  feedType?: GdFeedTypeInput | null;
  businessType?: GdBusinessTypeInput | null;
}

export interface GdSmartFiltersContainerInput {
  cacheKey?: string | null;
  limitOffset?: GdLimitOffsetInput | null;
  statRequirements?: GdStatRequirementsInput | null;
  orderBy?: GdSmartFilterOrderByInput[] | null;
  filter: GdSmartFilterFilterInput;
}

export interface GdStatRequirementsInput {
  goalIds?: GraphQlLong[] | null;
  to?: GraphQlLocalDate | null;
  from?: GraphQlLocalDate | null;
  preset?: GdStatPresetInput | null;
}

export interface GdSuspendKeywordsInput {
  keywordIds: GraphQlLong[];
}

export interface GdSuspendRetargetingsInput {
  retargetingIds: GraphQlLong[];
}

export interface GdTargetingsCustomInput {
  geoType?: number | null;
  geo?: GraphQlLong[] | null;
  behaviors?: GraphQlLong[] | null;
  geoExpanded?: GraphQlLong[] | null;
}

export interface GdTargetingsFixedInput {
  behaviors?: GraphQlLong[] | null;
  viewTypes?: GdViewTypeInput[] | null;
  geoType?: number | null;
  geoExpanded?: GraphQlLong[] | null;
  geo?: GraphQlLong[] | null;
}

export interface GdTemplateVariableInput {
  templateResourceId: GraphQlLong;
  value?: string | null;
}

export interface GdTimeInput {
  minute: number;
  hour: number;
}

export interface GdTimeIntervalInput {
  startTime: GdTimeInput;
  endTime: GdTimeInput;
}

export interface GdTimeTargetInput {
  enabledHolidaysMode?: boolean | null;
  timeBoard?: number[][] | null;
  useWorkingWeekends?: boolean | null;
  holidaysSettings?: GdHolidaysSettingsInput | null;
  idTimeZone?: GraphQlLong | null;
}

export interface GdTurboGalleryParamsInput {
  turboGalleryHref?: string | null;
}

export interface GdTurbolandingFilterInput {
  turbolandingIdIn?: GraphQlLong[] | null;
}

export interface GdUnsuspendKeywordsInput {
  keywordIds: GraphQlLong[];
}

export interface GdUpdateAdGroupKeywordItemInput {
  phrase?: string | null;
  id?: GraphQlLong | null;
}

export interface GdUpdateAdGroupMinusKeywordsInput {
  minusKeywordsPackIds: GraphQlLong[];
  adGroupIds: GraphQlLong[];
  action: GdUpdateAdGroupMinusKeywordsActionInput;
}

export interface GdUpdateAdGroupRegionsInput {
  adGroupIds?: GraphQlLong[] | null;
  regionIds: GraphQlLong[];
  action: GdUpdateAdGroupRegionsActionInput;
  campaignIds?: GraphQlLong[] | null;
}

export interface GdUpdateAdGroupRelevanceMatchItemInput {
  id?: GraphQlLong | null;
  isActive: boolean;
}

export interface GdUpdateAdGroupRetargetingItemInput {
  retCondId: GraphQlLong;
  id?: GraphQlLong | null;
}

export interface GdUpdateAdInput {
  displayHref?: string | null;
  body: string;
  calloutIds?: GraphQlLong[] | null;
  sitelinksSetId?: GraphQlLong | null;
  adType: GdAdTypeInput;
  textBannerImageHash?: string | null;
  permalinkId?: GraphQlLong | null;
  isMobile: boolean;
  turboGalleryParams?: GdTurboGalleryParamsInput | null;
  imageCreativeHash?: string | null;
  turbolandingId?: GraphQlLong | null;
  turbolandingHrefParams?: string | null;
  domain?: string | null;
  title: string;
  titleExtension?: string | null;
  adPrice?: GdAdPriceInput | null;
  creativeId?: GraphQlLong | null;
  href?: string | null;
  id: GraphQlLong;
  vcardId?: GraphQlLong | null;
}

export interface GdUpdateAdPriceInput {
  price?: GdAdPriceInput | null;
  id: GraphQlLong;
}

export interface GdUpdateAdsInput {
  adUpdateItems: GdUpdateAdInput[];
  saveDraft: boolean;
}

export interface GdUpdateBidModifierABSegmentAdjustmentItemInput {
  percent: number;
  segmentId?: GraphQlLong | null;
  sectionId?: GraphQlLong | null;
  id?: GraphQlLong | null;
  abSegmentRetargetingConditionId?: GraphQlLong | null;
}

export interface GdUpdateBidModifierABSegmentInput {
  id?: GraphQlLong | null;
  type: GdBidModifierTypeInput;
  campaignId: GraphQlLong;
  enabled: boolean;
  adjustments: GdUpdateBidModifierABSegmentAdjustmentItemInput[];
  adGroupId?: GraphQlLong | null;
}

export interface GdUpdateBidModifierAdTypeAdjustmentItemInput {
  adType?: GdAdjustmentAdTypeInput | null;
  percent: number;
  id?: GraphQlLong | null;
}

export interface GdUpdateBidModifierAdTypeInput {
  id?: GraphQlLong | null;
  enabled: boolean;
  campaignId: GraphQlLong;
  adGroupId?: GraphQlLong | null;
  type: GdBidModifierTypeInput;
  adjustments: GdUpdateBidModifierAdTypeAdjustmentItemInput[];
}

export interface GdUpdateBidModifierDemographicsAdjustmentItemInput {
  percent: number;
  id?: GraphQlLong | null;
  age?: GdAgeTypeInput | null;
  gender?: GdGenderTypeInput | null;
}

export interface GdUpdateBidModifierDemographicsInput {
  type: GdBidModifierTypeInput;
  adjustments: GdUpdateBidModifierDemographicsAdjustmentItemInput[];
  id?: GraphQlLong | null;
  adGroupId?: GraphQlLong | null;
  enabled: boolean;
  campaignId: GraphQlLong;
}

export interface GdUpdateBidModifierDesktopAdjustmentItemInput {
  id?: GraphQlLong | null;
  percent: number;
}

export interface GdUpdateBidModifierDesktopInput {
  id?: GraphQlLong | null;
  campaignId: GraphQlLong;
  type: GdBidModifierTypeInput;
  enabled: boolean;
  adjustment: GdUpdateBidModifierDesktopAdjustmentItemInput;
  adGroupId?: GraphQlLong | null;
}

export interface GdUpdateBidModifierExpressAdjustmentItemInput {
  id?: GraphQlLong | null;
  percent: number;
  condition: GdUpdateBidModifierExpressLiteralInput[][];
}

export interface GdUpdateBidModifierExpressInput {
  adjustments: GdUpdateBidModifierExpressAdjustmentItemInput[];
  adGroupId?: GraphQlLong | null;
  campaignId: GraphQlLong;
  id?: GraphQlLong | null;
  enabled: boolean;
  type: GdBidModifierTypeInput;
}

export interface GdUpdateBidModifierExpressLiteralInput {
  parameter: BidModifierExpressionParameterInput;
  operation: BidModifierExpressionOperatorInput;
  value: string;
}

export interface GdUpdateBidModifierGeoInput {
  id?: GraphQlLong | null;
  adjustments: GdUpdateBidModifierRegionalAdjustmentItemInput[];
  enabled: boolean;
  campaignId: GraphQlLong;
  adGroupId?: GraphQlLong | null;
  type: GdBidModifierTypeInput;
}

export interface GdUpdateBidModifierInventoryAdjustmentItemInput {
  inventoryType?: GdInventoryTypeInput | null;
  percent: number;
  id?: GraphQlLong | null;
}

export interface GdUpdateBidModifierInventoryInput {
  adjustments: GdUpdateBidModifierInventoryAdjustmentItemInput[];
  type: GdBidModifierTypeInput;
  id?: GraphQlLong | null;
  enabled: boolean;
  adGroupId?: GraphQlLong | null;
  campaignId: GraphQlLong;
}

export interface GdUpdateBidModifierMobileAdjustmentItemInput {
  percent: number;
  id?: GraphQlLong | null;
  osType?: GdOsTypeInput | null;
}

export interface GdUpdateBidModifierMobileInput {
  type: GdBidModifierTypeInput;
  enabled: boolean;
  adjustment: GdUpdateBidModifierMobileAdjustmentItemInput;
  id?: GraphQlLong | null;
  adGroupId?: GraphQlLong | null;
  campaignId: GraphQlLong;
}

export interface GdUpdateBidModifierRegionalAdjustmentItemInput {
  percent: number;
  hidden?: boolean | null;
  id?: GraphQlLong | null;
  regionId?: number | null;
}

export interface GdUpdateBidModifierRetargetingAdjustmentItemInput {
  percent: number;
  id?: GraphQlLong | null;
  retargetingConditionId?: GraphQlLong | null;
}

export interface GdUpdateBidModifierRetargetingInput {
  id?: GraphQlLong | null;
  type: GdBidModifierTypeInput;
  adjustments: GdUpdateBidModifierRetargetingAdjustmentItemInput[];
  adGroupId?: GraphQlLong | null;
  enabled: boolean;
  campaignId: GraphQlLong;
}

export interface GdUpdateBidModifierSmartTgoAdjustmentItemInput {
  percent: number;
  id?: GraphQlLong | null;
}

export interface GdUpdateBidModifierSmartTgoInput {
  adjustment: GdUpdateBidModifierSmartTgoAdjustmentItemInput;
  id?: GraphQlLong | null;
  enabled: boolean;
  campaignId: GraphQlLong;
  type: GdBidModifierTypeInput;
  adGroupId?: GraphQlLong | null;
}

export interface GdUpdateBidModifierVideoAdjustmentItemInput {
  id?: GraphQlLong | null;
  percent: number;
}

export interface GdUpdateBidModifierVideoInput {
  campaignId: GraphQlLong;
  id?: GraphQlLong | null;
  adGroupId?: GraphQlLong | null;
  enabled: boolean;
  type: GdBidModifierTypeInput;
  adjustment: GdUpdateBidModifierVideoAdjustmentItemInput;
}

export interface GdUpdateBidModifierWeatherAdjustmentItemInput {
  expression: GdUpdateBidModifierWeatherExpressionInput[][];
  id?: GraphQlLong | null;
  percent: number;
}

export interface GdUpdateBidModifierWeatherExpressionInput {
  value: number;
  parameter: GdWeatherTypeInput;
  operation: GdOperationTypeInput;
}

export interface GdUpdateBidModifierWeatherInput {
  enabled: boolean;
  id?: GraphQlLong | null;
  campaignId: GraphQlLong;
  type: GdBidModifierTypeInput;
  adGroupId?: GraphQlLong | null;
  adjustments: GdUpdateBidModifierWeatherAdjustmentItemInput[];
}

export interface GdUpdateBidModifiersInput {
  bidModifierAdType?: GdUpdateBidModifierAdTypeInput | null;
  bidModifierDesktop?: GdUpdateBidModifierDesktopInput | null;
  bidModifierInventory?: GdUpdateBidModifierInventoryInput | null;
  bidModifierVideo?: GdUpdateBidModifierVideoInput | null;
  bidModifierABSegment?: GdUpdateBidModifierABSegmentInput | null;
  bidModifierWeather?: GdUpdateBidModifierWeatherInput | null;
  bidModifierExpress?: GdUpdateBidModifierExpressInput[] | null;
  bidModifierDemographics?: GdUpdateBidModifierDemographicsInput | null;
  bidModifierRetargeting?: GdUpdateBidModifierRetargetingInput | null;
  bidModifierGeo?: GdUpdateBidModifierGeoInput | null;
  bidModifierMobile?: GdUpdateBidModifierMobileInput | null;
  bidModifierSmartTgo?: GdUpdateBidModifierSmartTgoInput | null;
}

export interface GdUpdateCampaignUnionInput {
  textCampaign?: GdUpdateTextCampaignInput | null;
  internalAutobudgetCampaign?: GdUpdateInternalAutobudgetCampaignInput | null;
  contentPromotionCampaign?: GdUpdateContentPromotionCampaignInput | null;
  cpmPriceCampaign?: GdUpdateCpmPriceCampaignInput | null;
}

export interface GdUpdateCampaignsInput {
  campaignUpdateItems: GdUpdateCampaignUnionInput[];
}

export interface GdUpdateContentPromotionAdGroupInput {
  updateItems: GdUpdateContentPromotionAdGroupItemInput[];
}

export interface GdUpdateContentPromotionAdGroupItemInput {
  adGroupId: GraphQlLong;
  regionIds: number[];
  generalPrice?: GraphQlBigDecimal | null;
  adGroupName: string;
  targetTags?: string[] | null;
  pageGroupTags?: string[] | null;
  adGroupMinusKeywords: string[];
  libraryMinusKeywordsIds: GraphQlLong[];
  relevanceMatch?: GdUpdateAdGroupRelevanceMatchItemInput | null;
  bidModifiers: GdUpdateBidModifiersInput;
  keywords?: GdUpdateAdGroupKeywordItemInput[] | null;
  useBidModifiers?: boolean | null;
}

export interface GdUpdateContentPromotionAdInput {
  contentPromotion: GdContentPromotionInput;
  id: GraphQlLong;
  visitUrl?: string | null;
  description?: string | null;
  title?: string | null;
}

export interface GdUpdateContentPromotionAdsInput {
  adUpdateItems: GdUpdateContentPromotionAdInput[];
  saveDraft: boolean;
}

export interface GdUpdateContentPromotionCampaignInput {
  minusKeywords?: string[] | null;
  attributionModel: GdCampaignAttributionModelInput;
  notification: GdCampaignNotificationRequestInput;
  biddingStategy: GdCampaignBiddingStrategyInput;
  startDate: GraphQlLocalDate;
  contentLanguage?: GdContentLanguageInput | null;
  name: string;
  bidModifiers?: GdUpdateBidModifiersInput | null;
  hasExtendedGeoTargeting: boolean;
  endDate?: GraphQlLocalDate | null;
  dayBudget: GraphQlBigDecimal;
  dayBudgetShowMode: GdDayBudgetShowModeInput;
  id: GraphQlLong;
  metrikaCounters?: number[] | null;
  disabledIps?: string[] | null;
  brandSafetyCategories?: GraphQlLong[] | null;
  timeTarget: GdTimeTargetInput;
}

export interface GdUpdateCpmAdGroupInput {
  isNewGroups: boolean;
  updateCpmAdGroupItems: GdUpdateCpmAdGroupItemInput[];
}

export interface GdUpdateCpmAdGroupItemInput {
  generalPrice?: GraphQlBigDecimal | null;
  pageBlocks?: GdAdGroupPageBlockInput[] | null;
  pageGroupTags?: string[] | null;
  bidModifiers?: GdUpdateBidModifiersInput | null;
  priority?: GraphQlLong | null;
  keywords?: GdUpdateAdGroupKeywordItemInput[] | null;
  type: GdCpmGroupTypeInput;
  regionIds: number[];
  adGroupName: string;
  retargetingCondition?: GdUpdateCpmRetargetingConditionItemInput | null;
  videoGoals?: GdVideoGoalTypeInput[] | null;
  campaignId?: GraphQlLong | null;
  adGroupId?: GraphQlLong | null;
  targetTags?: string[] | null;
}

export interface GdUpdateCpmAdInput {
  href?: string | null;
  pixels?: GdPixelInput[] | null;
  adType: GdAdTypeInput;
  creativeId?: GraphQlLong | null;
  tnsId?: string | null;
  id: GraphQlLong;
  turbolandingId?: GraphQlLong | null;
  turbolandingHrefParams?: string | null;
  measurers?: GdBannerMeasurerInput[] | null;
}

export interface GdUpdateCpmAdsInput {
  adUpdateItems: GdUpdateCpmAdInput[];
  saveDraft: boolean;
}

export interface GdUpdateCpmPriceCampaignInput {
  contentLanguage?: GdContentLanguageInput | null;
  hasAddOpenstatTagToUrl: boolean;
  name: string;
  startDate: GraphQlLocalDate;
  endDate?: GraphQlLocalDate | null;
  disabledIps?: string[] | null;
  metrikaCounters?: number[] | null;
  minusKeywords?: string[] | null;
  flightOrderVolume: GraphQlLong;
  id: GraphQlLong;
  meaningfulGoals?: GdMeaningfulGoalRequestInput[] | null;
  timeTarget: GdTimeTargetInput;
  attributionModel: GdCampaignAttributionModelInput;
  hasAddMetrikaTagToUrl: boolean;
  brandSafetyCategories?: GraphQlLong[] | null;
  notification: GdCampaignNotificationRequestInput;
}

export interface GdUpdateCpmRetargetingConditionItemInput {
  conditionRules: GdRetargetingConditionRuleItemReqInput[];
  name: string;
}

export interface GdUpdateFlStatusRequestInput {
  status?: GdFreelancerStatusInput | null;
}

export interface GdUpdateFreelancerCardInput {
  card?: GdUpdateFreelancerCardItemInput | null;
}

export interface GdUpdateFreelancerCardItemInput {
  briefInfo?: string | null;
  contacts?: GdUpdateFreelancerContactsItemInput | null;
  avatarId?: GraphQlLong | null;
}

export interface GdUpdateFreelancerContactsItemInput {
  phone: string;
  skype?: string | null;
  telegram?: string | null;
  town?: string | null;
  email: string;
  whatsApp?: string | null;
  icq?: string | null;
  siteUrl?: string | null;
  viber?: string | null;
}

export interface GdUpdateFreelancerFeedbackRequestInput {
  feedbackText?: string | null;
  feedbackId: string;
  overallMark?: GraphQlLong | null;
  freelancerId: GraphQlLong;
  willRecommend?: boolean | null;
}

export interface GdUpdateFreelancerInput {
  regionId?: GraphQlLong | null;
}

export interface GdUpdateFreelancerSkillInput {
  skills: GdUpdateFreelancerSkillItemInput[];
}

export interface GdUpdateFreelancerSkillItemInput {
  duration?: GdFreelancerSkillOfferDurationInput | null;
  skillId: GraphQlLong;
  days?: string | null;
  price: GraphQlLong;
}

export interface GdUpdateInternalAdGroupsInput {
  updateItems: GdUpdateInternalAdGroupsItemInput[];
}

export interface GdUpdateInternalAdGroupsItemInput {
  targetingClids?: GdAdditionalTargetingClidsInput | null;
  finishTime?: GraphQlLocalDateTime | null;
  targetingDeviceNames?: GdAdditionalTargetingDeviceNamesInput | null;
  targetings?: GdAdditionalTargetingUnionInput[] | null;
  targetingInternalNetwork?: GdAdditionalTargetingInternalNetworkInput | null;
  level?: GraphQlLong | null;
  startTime?: GraphQlLocalDateTime | null;
  targetingOsNames?: GdAdditionalTargetingOsNamesInput | null;
  targetingIsPPLoggedIn?: GdAdditionalTargetingIsPPLoggedInInput | null;
  targetingIsYandexPlus?: GdAdditionalTargetingIsYandexPlusInput | null;
  targetingQueryReferers?: GdAdditionalTargetingQueryReferersInput | null;
  targetingInterfaceLangs?: GdAdditionalTargetingInterfaceLangsInput | null;
  regionIds: number[];
  targetingIsVirused?: GdAdditionalTargetingIsVirusedInput | null;
  id: GraphQlLong;
  targetingHasPassportId?: GdAdditionalTargetingHasPassportIdInput | null;
  targetingYsCookies?: GdAdditionalTargetingYsCookiesInput | null;
  targetingUserAgents?: GdAdditionalTargetingUserAgentsInput | null;
  targetingHasLCookie?: GdAdditionalTargetingHasLCookieInput | null;
  targetingQueryOptions?: GdAdditionalTargetingQueryOptionsInput | null;
  rf?: number | null;
  targetingOsFamilies?: GdAdditionalTargetingOsFamiliesInput | null;
  name: string;
  targetingDesktopInstalledApps?: GdAdditionalTargetingDesktopInstalledAppsInput | null;
  targetingIsTouch?: GdAdditionalTargetingIsTouchInput | null;
  targetingYandexUids?: GdAdditionalTargetingYandexUidsInput | null;
  targetingShowDates?: GdAdditionalTargetingShowDatesInput | null;
  targetingClidTypes?: GdAdditionalTargetingClidTypesInput | null;
  rfReset?: number | null;
  targetingDeviceVendors?: GdAdditionalTargetingDeviceVendorsInput | null;
  targetingBrowserEngines?: GdAdditionalTargetingBrowserEnginesInput | null;
  targetingBrowserNames?: GdAdditionalTargetingBrowserNamesInput | null;
  targetingTestIds?: GdAdditionalTargetingTestIdsInput | null;
  targetingMobileInstalledApps?: GdAdditionalTargetingMobileInstalledAppsInput | null;
  targetingIsBrowser?: GdAdditionalTargetingIsBrowserInput | null;
  targetingIsMobile?: GdAdditionalTargetingIsMobileInput | null;
  targetingIsTablet?: GdAdditionalTargetingIsTabletInput | null;
}

export interface GdUpdateInternalAdsInput {
  saveDraft: boolean;
  adUpdateItems: GdUpdateInternalAdsItemInput[];
}

export interface GdUpdateInternalAdsItemInput {
  id: GraphQlLong;
  description: string;
  templateVars: GdTemplateVariableInput[];
}

export interface GdUpdateInternalAutobudgetCampaignInput {
  startDate: GraphQlLocalDate;
  pageId: GraphQlLong;
  brandSafetyCategories?: GraphQlLong[] | null;
  id: GraphQlLong;
  minusKeywords?: string[] | null;
  disabledIps?: string[] | null;
  endDate?: GraphQlLocalDate | null;
  notification: GdCampaignNotificationRequestInput;
  meaningfulGoals?: GdMeaningfulGoalRequestInput[] | null;
  isMobile: boolean;
  attributionModel: GdCampaignAttributionModelInput;
  name: string;
  timeTarget: GdTimeTargetInput;
  impressionFrequencyControl?: GdInternalCampaignImpressionFrequencyControlInput | null;
  metrikaCounters?: number[] | null;
  biddingStategy: GdCampaignBiddingStrategyInput;
}

export interface GdUpdateKeywordsInput {
  keywordUpdateItems: GdUpdateKeywordsItemInput[];
}

export interface GdUpdateKeywordsItemInput {
  id: GraphQlLong;
  keyword?: string | null;
  price?: GraphQlBigDecimal | null;
  autobudgetPriority?: number | null;
  priceContext?: GraphQlBigDecimal | null;
}

export interface GdUpdateMcBannerAdGroupItemInput {
  adGroupMinusKeywords: string[];
  bidModifiers?: GdUpdateBidModifiersInput | null;
  keywords?: GdUpdateAdGroupKeywordItemInput[] | null;
  adGroupId: GraphQlLong;
  generalPrice?: GraphQlBigDecimal | null;
  useBidModifiers?: boolean | null;
  libraryMinusKeywordsIds: GraphQlLong[];
  regionIds: number[];
  pageGroupTags?: string[] | null;
  adGroupName: string;
  targetTags?: string[] | null;
}

export interface GdUpdateMcBannerAdInput {
  adType: GdAdTypeInput;
  id: GraphQlLong;
  href: string;
  adImageHash: string;
}

export interface GdUpdateMcBannerAdsInput {
  adUpdateItems: GdUpdateMcBannerAdInput[];
  saveDraft: boolean;
}

export interface GdUpdateMinusKeywordsPacksInput {
  updateItems: GdUpdateMinusKeywordsPacksItemInput[];
}

export interface GdUpdateMinusKeywordsPacksItemInput {
  minusKeywords?: string[] | null;
  id: GraphQlLong;
  name?: string | null;
}

export interface GdUpdateOrganizationInput {
  bannerId: GraphQlLong;
  permalinkId?: GraphQlLong | null;
}

export interface GdUpdatePerformanceAdGroupItemInput {
  id: GraphQlLong;
  fieldToUseAsName?: string | null;
  fieldToUseAsBody?: string | null;
  bidModifiers?: GdUpdateBidModifiersInput | null;
  pageGroupTags?: string[] | null;
  name: string;
  libraryMinusKeywordsIds?: GraphQlLong[] | null;
  trackingParams?: string | null;
  minusKeywords: string[];
  regionIds: number[];
  targetTags?: string[] | null;
}

export interface GdUpdatePricePackagesInput {
  updateItems: GdUpdatePricePackagesItemInput[];
}

export interface GdUpdatePricePackagesItemInput {
  dateStart?: GraphQlLocalDate | null;
  trackerUrl?: string | null;
  dateEnd?: GraphQlLocalDate | null;
  price?: GraphQlBigDecimal | null;
  clientIds?: GraphQlLong[] | null;
  orderVolumeMin?: GraphQlLong | null;
  statusApprove?: GdStatusApproveInput | null;
  targetingsFixed?: GdTargetingsFixedInput | null;
  targetingsCustom?: GdTargetingsCustomInput | null;
  title?: string | null;
  orderVolumeMax?: GraphQlLong | null;
  id: GraphQlLong;
  lastSeenUpdateTime?: GraphQlLocalDateTime | null;
  currency?: CurrencyCodeInput | null;
}

export interface GdUpdateRetargetingConditionItemInput {
  retargetingConditionId: GraphQlLong;
  description?: string | null;
  name: string;
  type: GdRetargetingConditionTypeInput;
  conditionRules: GdRetargetingConditionRuleItemReqInput[];
}

export interface GdUpdateRetargetingConditionsInput {
  retargetingConditions?: GdUpdateRetargetingConditionItemInput[] | null;
}

export interface GdUpdateSmartAdInput {
  id: GraphQlLong;
  creativeId: GraphQlLong;
}

export interface GdUpdateSmartAdsInput {
  saveDraft: boolean;
  adUpdateItems: GdUpdateSmartAdInput[];
}

export interface GdUpdateSmartCentersInput {
  imageHash: string;
  smartCenters: GdUpdateSmartCentersItemInput[];
}

export interface GdUpdateSmartCentersItemInput {
  smartCenter: GdImageSmartCenterInput;
  size: string;
}

export interface GdUpdateSmartFilterConditionInput {
  stringValue: string;
  field: string;
  operator: GdSmartFilterConditionOperatorInput;
}

export interface GdUpdateSmartFiltersInput {
  updateItems: GdUpdateSmartFiltersItemInput[];
}

export interface GdUpdateSmartFiltersItemInput {
  priceCpa?: GraphQlBigDecimal | null;
  autobudgetPriority?: GdShowConditionAutobudgetPriorityInput | null;
  priceCpc?: GraphQlBigDecimal | null;
  isSuspended?: boolean | null;
  name?: string | null;
  tab?: GdSmartFilterTabInput | null;
  id: GraphQlLong;
  conditions?: GdUpdateSmartFilterConditionInput[] | null;
  targetFunnel?: GdSmartFilterTargetFunnelInput | null;
}

export interface GdUpdateTextAdGroupItemInput {
  relevanceMatch?: GdUpdateAdGroupRelevanceMatchItemInput | null;
  retargetingCondition?: GdUpdateCpmRetargetingConditionItemInput | null;
  targetTags?: string[] | null;
  pageGroupTags?: string[] | null;
  regionIds: number[];
  retargetings?: GdUpdateAdGroupRetargetingItemInput[] | null;
  adGroupName: string;
  generalPrice?: GraphQlBigDecimal | null;
  useBidModifiers?: boolean | null;
  libraryMinusKeywordsIds: GraphQlLong[];
  adGroupId: GraphQlLong;
  adGroupMinusKeywords: string[];
  keywords?: GdUpdateAdGroupKeywordItemInput[] | null;
  bidModifiers: GdUpdateBidModifiersInput;
}

export interface GdUpdateTextCampaignInput {
  hasExtendedGeoTargeting: boolean;
  clientDialogId?: GraphQlLong | null;
  abSegmentStatisticRetargetingConditionId?: GraphQlLong | null;
  broadMatch: GdBroadMatchRequestInput;
  hasSiteMonitoring: boolean;
  endDate?: GraphQlLocalDate | null;
  brandSafetyCategories?: GraphQlLong[] | null;
  disabledPlaces?: string[] | null;
  isAloneTrafaretAllowed?: boolean | null;
  hasTitleSubstitute: boolean;
  hasAddOpenstatTagToUrl: boolean;
  enableCompanyInfo: boolean;
  disabledIps?: string[] | null;
  contentLanguage?: GdContentLanguageInput | null;
  allowedPageIds?: GraphQlLong[] | null;
  minusKeywords?: string[] | null;
  notification: GdCampaignNotificationRequestInput;
  timeTarget: GdTimeTargetInput;
  contextLimit: number;
  id: GraphQlLong;
  dayBudget: GraphQlBigDecimal;
  excludePausedCompetingAds: boolean;
  startDate: GraphQlLocalDate;
  meaningfulGoals?: (GdMeaningfulGoalRequestInput | null)[] | null;
  dayBudgetShowMode: GdDayBudgetShowModeInput;
  vcard?: GdAddCampaignVcardInput | null;
  bidModifiers?: GdUpdateBidModifiersInput | null;
  name: string;
  attributionModel: GdCampaignAttributionModelInput;
  hasAddMetrikaTagToUrl: boolean;
  abSegmentRetargetingConditionId?: GraphQlLong | null;
  defaultPermalinkId?: GraphQlLong | null;
  metrikaCounters?: number[] | null;
  enableCpcHold: boolean;
  biddingStategy: GdCampaignBiddingStrategyInput;
}

export interface GdUpdateUserPhoneInput {
  phone: string;
}

export interface GdVideoCreativeInput {
  duration?: number | null;
}

export interface GdiDealFilterInput {
  maxSpent?: GraphQlBigDecimal | null;
  minClicks?: GraphQlLong | null;
  minMinPrice?: GraphQlBigDecimal | null;
  maxCpc?: GraphQlBigDecimal | null;
  nameNotIn?: (string | null)[] | null;
  maxClicks?: GraphQlLong | null;
  nameNotContains?: string | null;
  dealIdIncluded?: (GraphQlLong | null)[] | null;
  maxShows?: GraphQlLong | null;
  minCpc?: GraphQlBigDecimal | null;
  nameIn?: (string | null)[] | null;
  typeIn?: (DealTypeInput | null)[] | null;
  maxCpm?: GraphQlBigDecimal | null;
  minSpent?: GraphQlBigDecimal | null;
  minNumberOfLinkedCampaigns?: number | null;
  maxCtr?: GraphQlBigDecimal | null;
  statusContains?: (StatusDirectInput | null)[] | null;
  minCpm?: GraphQlBigDecimal | null;
  dealIdExcluded?: (GraphQlLong | null)[] | null;
  maxNumberOfLinkedCampaigns?: number | null;
  minCtr?: GraphQlBigDecimal | null;
  minShows?: GraphQlLong | null;
  completeReasonContains?: (CompleteReasonInput | null)[] | null;
  nameContains?: string | null;
  maxMinPrice?: GraphQlBigDecimal | null;
}

export interface SearchOptionsInput {
  onlyWholeWords: boolean;
  matchCase: boolean;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
